webpackJsonp([13],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

var _axiosM = __webpack_require__(65);

var _axiosM2 = _interopRequireDefault(_axiosM);

var _browser = __webpack_require__(1);

var _b2a = __webpack_require__(23);

var _sa = __webpack_require__(17);

var _sa2 = _interopRequireDefault(_sa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import cookie from 'js-cookie'
exports.default = function (options) {
  if (!(0, _browser.app)()) {
    var getUTMProp = _sa2.default.getUTMProp,
        getAnonymousID = _sa2.default.getAnonymousID,
        current_page_id = _sa2.default.current_page_id,
        current_page_name = _sa2.default.current_page_name,
        current_page_type = _sa2.default.current_page_type;


    var utmData = {};
    var cache_utm_source = null;

    try {
      utmData = getUTMProp();
      cache_utm_source = window.localStorage.getItem('the_utm_source') || null;
    } catch (err) {}

    utmData['theLatestUtmSource'] = cache_utm_source ? JSON.parse(cache_utm_source).value : '';
    // const userId = cookie.get('_b_m_c')
    var sensors = (0, _extends3.default)({
      // userId: userId || '',
      anonymousId: getAnonymousID(),
      currentPageType: current_page_type,
      currentPageName: current_page_name,
      currentPageId: current_page_id
    }, utmData);
    options.headers = {
      'TBS-Sensors': (0, _b2a.btoa)((0, _stringify2.default)(sensors))
    };
  }
  if ((0, _browser.android)()) {
    var url = options.url;
    options.url = url.replace('/app', 'app'); //兼容安卓
  }
  return (0, _axiosM2.default)(options);
};

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(60)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(62),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trackerM = __webpack_require__(144);

var _trackerM2 = _interopRequireDefault(_trackerM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _trackerM2.default;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(31)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(41),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(33)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(36),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(37)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(40),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(42);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sensors = window.sensorsDataAnalytic201505;
var is_production = "production" === 'production';
console.log(is_production, '###############');
var options = {
  // server_url: is_production?'https://datasink.thebeastshop.com/sa?project=production':'https://datasink.thebeastshop.com/sa?project=default',
  // server_url: 'https://datasink.thebeastshop.com/sa?project=default',
  server_url: 'https://datasink.thebeastshop.com/sa?project=production',
  platform_type: 'WAP'
};

var Sa = function () {
  function Sa(_ref) {
    var _ref$server_url = _ref.server_url,
        server_url = _ref$server_url === undefined ? '' : _ref$server_url,
        _ref$platform_type = _ref.platform_type,
        platform_type = _ref$platform_type === undefined ? '' : _ref$platform_type;
    (0, _classCallCheck3.default)(this, Sa);

    this.isSDKinit = false;
    this.server_url = server_url;

    // 公共属性
    this.is_login = false;
    this.vip_level = '';
    this.current_page_type = '';
    this.current_page_name = '';
    this.current_page_id = '';
    this.platform_type = platform_type;
    this.thelatest_utm_source = '';

    // 前向页面名称
    this.refer_page_name = '';
    this.refer_page_type = '';
    this.refer_page_id = '';
  }

  (0, _createClass3.default)(Sa, [{
    key: 'setParams',
    value: function setParams() {
      if (this.isSDKinit) return;

      this._setParam();
      this._registerApp();
    }
  }, {
    key: 'changeIdentify',
    value: function changeIdentify(distinctID) {
      sensors.identify(distinctID, true);
    }
  }, {
    key: 'track',
    value: function track() {
      return sensors.track.apply(sensors, arguments);
    }
  }, {
    key: 'addCart',
    value: function addCart(options) {
      var params = (0, _extends3.default)({}, this.getReferPageName(), options);

      this.track('AddToShoppingCart', params);
    }
  }, {
    key: 'registerButtonClick',
    value: function registerButtonClick(name) {
      this.track('RegisterButtonClick', {
        button_name: name
      });
    }
  }, {
    key: 'getUTMProp',
    value: function getUTMProp() {
      var _sensors$getPresetPro = sensors.getPresetProperties(),
          $latest_utm_campaign = _sensors$getPresetPro.$latest_utm_campaign,
          $latest_utm_content = _sensors$getPresetPro.$latest_utm_content,
          $latest_utm_source = _sensors$getPresetPro.$latest_utm_source,
          $latest_utm_term = _sensors$getPresetPro.$latest_utm_term;

      return {
        theLatestUtmCampaign: $latest_utm_campaign,
        theLatestUtmContent: $latest_utm_content,
        theLatestUtmSource: $latest_utm_source,
        theLatestUtmTerm: $latest_utm_term
      };
    }
  }, {
    key: 'sharePage',
    value: function sharePage(type, options) {
      var params = (0, _extends3.default)({}, this.getReferPageName());

      this.track('ShareClick', (0, _extends3.default)({
        share_type: type
      }, params, options));
    }
  }, {
    key: 'shareSave',
    value: function shareSave() {
      var params = (0, _extends3.default)({}, this.getReferPageName());

      this.track('MPShareSave', (0, _extends3.default)({}, params));
    }
  }, {
    key: 'editCart',
    value: function editCart(type) {
      this.track('EditShoppingCart', {
        shopping_cart_edit_type: type
      });
    }
  }, {
    key: 'buyNow',
    value: function buyNow(options) {
      var params = (0, _extends3.default)({}, this.getReferPageName(), options);

      this.track('buyNow', options);
    }
  }, {
    key: 'addIndex',
    value: function addIndex(index, num) {
      return index + num;
    }
  }, {
    key: 'setOpenid',
    value: function setOpenid(openId) {
      return sensors.setOpenid(openId);
    }
  }, {
    key: 'login',
    value: function login(id) {
      this.is_login = true;

      return sensors.login(id);
    }
  }, {
    key: 'setCurrentPageWithOutRefer',
    value: function setCurrentPageWithOutRefer(type, name, id, options) {
      // this.refer_page_name = this.current_page_name
      // this.refer_page_type = this.current_page_type
      // this.refer_page_id = this.current_page_id

      this.current_page_type = type || '';
      this.current_page_name = name || '';
      this.current_page_id = id || '';

      this.setReferPageNameByCache({
        current_page_name: name || '',
        current_page_id: id || '',
        current_page_type: type || ''
      });

      return (0, _extends3.default)({}, options);
    }

    // 设置每个页面的公共属性

  }, {
    key: 'setCurrentPage',
    value: function setCurrentPage(type, name, id, options) {
      // this.refer_page_name = this.current_page_name
      // this.refer_page_type = this.current_page_type
      // this.refer_page_id = this.current_page_id
      var referData = this.getReferPageNameByCache();

      if (referData) {
        this.refer_page_name = referData.current_page_name;
        this.refer_page_type = referData.current_page_type;
        this.refer_page_id = referData.current_page_id;
      }

      this.current_page_type = type || '';
      this.current_page_name = name || '';
      this.current_page_id = id || '';

      this.setReferPageNameByCache({
        current_page_name: name || '',
        current_page_id: id || '',
        current_page_type: type || ''
      });

      return (0, _extends3.default)({}, options);
    }

    // 获取前向页面名称

  }, {
    key: 'getReferPageName',
    value: function getReferPageName() {
      return {
        refer_page_name: this.refer_page_name,
        refer_page_id: this.refer_page_id,
        refer_page_type: this.refer_page_type
      };
    }
  }, {
    key: 'getReferPageNameByCache',
    value: function getReferPageNameByCache() {
      return JSON.parse(window.sessionStorage.getItem('_sa_refer')) || null;
    }
  }, {
    key: 'setReferPageNameByCache',
    value: function setReferPageNameByCache(data) {
      window.sessionStorage.setItem('_sa_refer', (0, _stringify2.default)(data));
    }
  }, {
    key: 'getActivity',
    value: function getActivity(labels) {
      var activity = [];
      labels.forEach(function (label) {
        activity.push(label.type);
      });

      return activity;
    }
  }, {
    key: 'getProp',
    value: function getProp() {
      return sensors.getPresetProperties();
    }
  }, {
    key: 'getAnonymousID',
    value: function getAnonymousID() {
      return sensors.quick('getAnonymousID');
    }
  }, {
    key: 'clickNavBar',
    value: function clickNavBar(name) {
      return this.track('NavigationBar', {
        button_name: name
      });
    }
  }, {
    key: 'clickPerson',
    value: function clickPerson(name) {
      return this.track('PersonalCenter', {
        button_name: name
      });
    }
  }, {
    key: '_autoQuick',
    value: function _autoQuick() {
      return sensors.quick('autoTrack');
    }
  }, {
    key: 'init',
    value: function init() {
      this._registerPage();
      // this._autoQuick()

      sensors.init({
        server_url: this.server_url,
        heatmap: {
          // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
          // 默认只有点击 a input button textarea 四种元素时，才会触发 $WebClick 元素点击事件
          clickmap: 'default'
        },
        show_log: true,
        use_client_time: true,
        app_js_bridge: true,
        send_type: 'beacon'
      });
    }
  }, {
    key: '_registerPage',
    value: function _registerPage() {
      var _this = this;

      sensors.registerPage({
        platform_type: this.platform_type,

        is_login: function is_login() {
          return _this.is_login;
        },

        vip_level: function vip_level() {
          return _this.vip_level;
        },

        current_page_type: function current_page_type() {
          return _this.current_page_type;
        },

        current_page_name: function current_page_name() {
          return _this.current_page_name;
        },

        current_page_id: function current_page_id() {
          return _this.current_page_id;
        },

        thelatest_utm_source: function thelatest_utm_source() {
          return _this.thelatest_utm_source;
        }
      });
    }
  }]);
  return Sa;
}();

module.exports = new Sa(options);

function loop() {}

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(66)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(69),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _events = __webpack_require__(52);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  function install(Vue) {
    var on = function on() {
      var _bevent$$on;

      for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {
        arg[_key] = arguments[_key];
      }

      (_bevent$$on = _events2.default.$on).call.apply(_bevent$$on, [_events2.default].concat(arg));
    };

    var emit = function emit() {
      var _bevent$$emit;

      for (var _len2 = arguments.length, arg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        arg[_key2] = arguments[_key2];
      }

      (_bevent$$emit = _events2.default.$emit).call.apply(_bevent$$emit, [_events2.default].concat(arg));
    };
    Vue.mixin({
      created: function created() {
        this._on = on;
        this._emit = emit;
      }
    });
  }

  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
    module.exports = install;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return install;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (window.Vue) {
    _vue2.default.use(install);
  }
})();

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _toast = __webpack_require__(47);

var _toast2 = _interopRequireDefault(_toast);

var _browser = __webpack_require__(1);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $vm = void 0;
var _resolve = void 0;
var _reject = void 0;

(function () {
  function install(Vue) {
    var Toast = Vue.extend(_toast2.default);
    var toast = function toast(content) {
      if ((0, _browser.app)()) {
        return _bridge2.default.toast(content);
      }
      if (!content) {
        throw new Error('Plugins $toast args must be \'String\' ');
      }
      if (!$vm) {
        $vm = new Toast({
          el: document.createElement('div')
        });
        document.body.appendChild($vm.$el);
      }
      $vm.show = true;
      $vm.mask = false;
      $vm.toast = true;
      $vm.autoClose = true;
      $vm.content = content;
      $vm.$on('toast-hide', function (msg) {
        _resolve();
      });
      return new _promise2.default(function (resolve) {
        _resolve = resolve;
      });
    };

    var alert = function alert(option) {
      if (!option) {
        throw new Error('Plugins $alert args must be \'String\' or \'Object\'');
      }
      if ((0, _browser.app)()) {
        return _bridge2.default.alert(option);
      }

      // if (!/^[\u4e00-\u9fa5_a-zA-Z0-9@()!：；:,。"'\[\]]+$/g.test(option)) {
      //   throw new Error(`Plugins $alert args must be 'String' or 'Object'`);
      // }

      if (!$vm) {
        $vm = new Toast({
          el: document.createElement('div')
        });
        document.body.appendChild($vm.$el);
      }
      $vm.show = true;
      $vm.maskTouchHide = true;
      $vm.alert = true;
      if ((typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) === 'object') {
        option.buttonText && ($vm.primary = option.buttonText);
        $vm.title = option.title;
        $vm.content = option.content;
        $vm.buttonEmphasize = option.buttonEmphasize;
      } else {
        $vm.content = option;
      }
      $vm.$on('alert-hide', function (msg) {
        _resolve();
      });
      return new _promise2.default(function (resolve) {
        _resolve = resolve;
      });
    };

    var confirm = function confirm(option) {
      if (!option) {
        throw new Error('Plugins $confirm args must be \'String\' or \'Object\'');
      }
      if ((0, _browser.app)() && (0, _browser.ios)()) {
        return _bridge2.default.confirm(option);
      }
      if (!$vm) {
        $vm = new Toast({
          el: document.createElement('div')
        });
        document.body.appendChild($vm.$el);
      }
      $vm.show = true;
      $vm.confirm = true;
      if ((typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) === 'object') {
        option.primaryButtonText && ($vm.primary = option.primaryButtonText);
        option.secondaryButtonText && ($vm.secondary = option.secondaryButtonText);
        $vm.content = option.content;
        $vm.title = option.title;
        $vm.primaryButtonEmphasize = option.primaryButtonEmphasize;
        $vm.secondaryButtonEmphasize = option.secondaryButtonEmphasize;
      } else {
        $vm.title = option;
      }
      $vm.$on('confirm-ensure', function () {
        _resolve();
      });
      $vm.$on('confirm-cancel', function () {
        _reject();
      });
      return new _promise2.default(function (resolve, reject) {
        _resolve = resolve;
        _reject = reject;
      });
    };
    // if (!Vue.$beast) {
    //   Vue.$beast = {}
    // }

    // Vue.$beast.toast = toast
    // Vue.$beast.alert = alert
    // Vue.$beast.confirm = confirm

    Vue.mixin({
      created: function created() {
        this.$toast = toast;
        this.$alert = alert;
        this.$confirm = confirm;
      }
    });
  }

  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
    module.exports = install;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return install;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (window.Vue) {
    Vue.use(install);
  }
})();

/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _loading = __webpack_require__(43);

var _loading2 = _interopRequireDefault(_loading);

var _browser = __webpack_require__(1);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $vm = void 0;
// let _resolve
// let _reject

(function () {
  function install(Vue) {
    var Loading = Vue.extend(_loading2.default);
    var showLoading = function showLoading(flag) {
      if ((0, _browser.app)()) {
        _bridge2.default.showLoading();
        return;
      }
      if (!$vm) {
        $vm = new Loading({
          el: document.createElement('div')
          // propsData: {
          //   mshow: true
          // }
        });
        document.body.appendChild($vm.$el);
      }
      $vm.white = flag ? true : false;
      $vm.mshow = true;
      $vm.$on('loading-hide', function (msg) {
        $vm.mshow = false;
      });
      // return new Promise((resolve) => {
      //   _resolve = resolve
      // })
    };

    var hideLoading = function hideLoading() {
      if ((0, _browser.app)()) {
        return _bridge2.default.hideLoading();
      }
      $vm && $vm.$emit('loading-hide');
    };

    Vue.mixin({
      created: function created() {
        this.$showLoading = showLoading;
        this.$hideLoading = hideLoading;
      }
    });
  }

  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
    module.exports = install;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return install;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (window.Vue) {
    Vue.use(install);
  }
})();

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _browser = __webpack_require__(1);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  function install(Vue) {
    var title = function title(_title) {
      var _this = this;

      if ((0, _browser.app)()) {
        _bridge2.default.setTitle(_title);
      }
      if ((typeof _title === 'undefined' ? 'undefined' : (0, _typeof3.default)(_title)) === 'object') {
        return;
      }
      document.title = _title;

      this.$nextTick(function () {
        _this._emit && _this._emit('change-title', _title);
      });
    };
    Vue.mixin({
      created: function created() {
        this.$setTitle = title;
      }
    });
  }

  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
    module.exports = install;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return install;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (window.Vue) {
    Vue.use(install);
  }
})();

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(16);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Masks: _index2.default,
    MaxZIndex: _index4.default
  },
  props: {
    mshow: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'beast-mask'
    },
    // maskStyle: {
    //   type: String,
    //   default: 'beast__mask'
    // },
    dialogTransition: {
      type: String,
      default: 'beast-dialog'
    },
    dialogStyle: {
      type: String,
      default: 'beast__dialog'
    },
    mask: {
      type: Boolean,
      default: true
    },
    maskTouchHide: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: Boolean,
      default: true
    },
    maskOpacity: {
      // type: Number,
      default: 0.4
    },
    maskBackground: {
      default: '#000000'
    },
    maskClass: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  created: function created() {
    if (typeof this.mshow !== 'undefined') {
      this.currentValue = this.mshow;
    }
  },
  data: function data() {
    return {
      currentValue: false
    };
  },


  computed: {
    mOpacity: function mOpacity() {
      return this.mask ? parseFloat(this.maskOpacity) : 0;
    },
    mBackground: function mBackground() {
      return this.mask ? this.maskBackground : '#000000';
    }
  },

  watch: {
    mshow: function mshow(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      val || this.$emit('mask-hide');
    }
  },
  methods: {
    onTouchMove: function onTouchMove(event) {
      !this.scroll && event.preventDefault();
    },
    maskHide: function maskHide() {
      this.mask && this.maskTouchHide && (this.currentValue = false);
    }
  }
};

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(35);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_STYLES = {
  height: '100%',
  width: '100%',
  position: 'fixed',
  zIndex: 1000,
  top: 0,
  left: 0,
  opacity: 0.4,
  background: '#000000'
}; //
//
//
//

var handler = function handler(e) {
  e.preventDefault();
  // e.stopPropagation()
};

exports.default = {
  name: 'mask',
  props: {
    mshow: Boolean,
    mopacity: Number,
    zIndex: Number,
    mbackground: String,
    mclass: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      maskStyles: '',
      isShow: false
    };
  },
  created: function created() {
    this.showChange();
  },

  watch: {
    'zIndex': function zIndex(val) {
      this.showChange();
    },
    'mshow': function mshow(val) {
      // if(!val) {
      //   return
      // }
      this.showChange();
    }
  },
  methods: {
    maskTap: function maskTap() {
      this.$emit('maskTap');
    },
    showChange: function showChange() {
      // if(this.mshow){
      //   this.$el && this.$el.addEventListener('touchmove', handler, false)
      // }else{
      //   this.$el && this.$el.removeEventListener('touchmove', handler, false)
      // }
      this.mbackground !== undefined && (DEFAULT_STYLES.background = this.mbackground);
      this.zIndex !== undefined && (DEFAULT_STYLES.zIndex = this.zIndex);
      this.mopacity !== undefined && (DEFAULT_STYLES.opacity = this.mopacity);
      this.maskStyles = _utils2.default.setStyle(DEFAULT_STYLES).join(';');
      this.isShow = this.mshow;
    }
  }
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(27);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  setStyle: function setStyle(opts) {
    var styles = [];
    (0, _keys2.default)(opts).forEach(function (style) {
      var origin = opts[style];
      styles.push(style + ':' + origin);
    });
    return styles;
  }
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "beast-mask",
    class: _vm.mclass,
    style: (_vm.maskStyles),
    on: {
      "click": _vm.maskTap
    }
  })
},staticRenderFns: []}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(39);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  props: {
    show: {
      type: Boolean,
      default: false
    },
    relative: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      ownZIndex: _index2.default.getZIndex()
    };
  },

  watch: {
    'show': function show(val) {
      val && (this.ownZIndex = _index2.default.getZIndex());
    }
  }
}; //
//
//
//
//
//

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base_index = 5000;
module.exports = {
  getZIndex: function getZIndex() {
    return base_index++;
  }
};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "j_max_index",
    class: {
      'relative-z-index': _vm.relative
    },
    style: ({
      zIndex: _vm.ownZIndex
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('max-z-index', {
    attrs: {
      "show": _vm.currentValue
    }
  }, [_c('div', {
    on: {
      "touchmove": _vm.onTouchMove
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('masks', {
    attrs: {
      "mshow": _vm.currentValue,
      "mopacity": _vm.mOpacity,
      "mbackground": _vm.mBackground,
      "mclass": _vm.maskClass
    },
    on: {
      "maskTap": _vm.maskHide
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    class: _vm.dialogStyle,
    staticStyle: {
      "z-index": "1001!important"
    }
  }, [_vm._t("default")], 2)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(44)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(46),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(10);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'loading',
  components: {
    dialogs: _index2.default
  },
  props: ['white'],
  data: function data() {
    return {
      mopacity: 0,
      mshow: false
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('dialogs', {
    attrs: {
      "mshow": _vm.mshow,
      "scroll": false,
      "mask": false
    }
  }, [_c('div', {
    staticClass: "beast-loading__icon",
    class: {
      'icon_white': _vm.white
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(48)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(50),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _dialog = __webpack_require__(10);

var _dialog2 = _interopRequireDefault(_dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _confirm_state = void 0; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _data = {
  show: false,
  time: 2000,
  autoClose: false,
  toast: false,
  alert: false,
  confirm: false,
  primary: "确定",
  secondary: "取消",
  title: '',
  content: '',
  myClass: 'beast__toast'
};
exports.default = {
  components: {
    BDialog: _dialog2.default
  },
  data: function data() {
    return JSON.parse((0, _stringify2.default)(_data));
  },

  watch: {
    content: function content(val) {
      if (val) {
        this.show = true;
      }
    },
    toast: function toast(val) {
      if (val) {
        this.myClass = 'beast__toast';
      }
    },
    alert: function alert(val) {
      if (val) {
        this.myClass = 'beast__alert';
      }
    },
    confirm: function confirm(val) {
      if (val) {
        this.myClass = 'beast__confirm';
      }
    },
    show: function show(val) {
      var _this = this;

      this.autoClose && clearTimeout(this.timeout);
      if (val) {
        this.autoClose && (this.timeout = setTimeout(function () {
          _this.show = false;
        }, this.time));
      } else {
        this.toast && this.$emit('toast-hide');
        this.alert && this.$emit('alert-hide');
        if (this.confirm) {
          _confirm_state ? this.$emit('confirm-ensure') : this.$emit('confirm-cancel');
        }

        for (var _key in _data) {
          this[_key] = _data[_key];
        }
      }
    }
  },
  methods: {
    close: function close(event) {
      this.show = false;
    },
    cancel: function cancel(event) {
      _confirm_state = false;
      this.show = false;
    },
    ensure: function ensure(event) {
      _confirm_state = true;
      this.show = false;
    }
  }
};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dialog', {
    attrs: {
      "mask": false,
      "mshow": _vm.show
    }
  }, [_c('div', {
    staticClass: "toast-wrap"
  }, [_c('div', {
    class: _vm.myClass
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")]), _vm._v(" "), _c('div', {
    class: {
      lighter: _vm.title
    }
  }, [_vm._v("\n            " + _vm._s(_vm.content) + "\n          ")])])]), _vm._v(" "), (_vm.alert) ? _c('div', {
    staticClass: "alert",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        " + _vm._s(_vm.primary) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.confirm) ? _c('div', {
    staticClass: "confirm"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.secondary))]), _vm._v(" "), _c('div', {
    staticClass: "ensure",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v(_vm._s(_vm.primary))])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _toast = __webpack_require__(26);

var _toast2 = _interopRequireDefault(_toast);

var _loading = __webpack_require__(28);

var _loading2 = _interopRequireDefault(_loading);

var _events = __webpack_require__(25);

var _events2 = _interopRequireDefault(_events);

var _setTitle = __webpack_require__(30);

var _setTitle2 = _interopRequireDefault(_setTitle);

var _sa = __webpack_require__(17);

var _sa2 = _interopRequireDefault(_sa);

var _browser = __webpack_require__(1);

var _queryString = __webpack_require__(13);

var _queryString2 = _interopRequireDefault(_queryString);

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _vconsole = __webpack_require__(72);

var _vconsole2 = _interopRequireDefault(_vconsole);

var _b2a = __webpack_require__(23);

var _jsCookie = __webpack_require__(58);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Raven from 'raven-js';
// import RavenVue from 'raven-js/plugins/vue';
var md5 = __webpack_require__(53);

var isDev = "production" == 'development';
var UA = typeof navigator !== 'undefined' && navigator ? navigator.userAgent || '' : '';
var appDebug = !!~UA.indexOf('BEAST_DEBUG');
var _search = _queryString2.default.parse(window.location.search);
var webDebug = 'beast_debug' in _search;
if (appDebug || webDebug) {
  new _vconsole2.default();
}
var utm_source = _search.utm_source || '';
var _cache_utm_source = window.localStorage.getItem('the_utm_source');
var cache_utm_source = _cache_utm_source ? JSON.parse(_cache_utm_source) : '';
var distinctID = _search.distinctID;
var userId = window.sessionStorage.getItem('_b_m');
var miniMember = _search._mini_m;

if (miniMember) {
  miniMember = JSON.parse(decodeURIComponent(miniMember));
}

if (utm_source) {
  updateUtmParam(utm_source);
  _sa2.default.thelatest_utm_source = utm_source;
} else if (!utm_source && cache_utm_source) {
  if (isMoreThanSevenDays(cache_utm_source.createTime)) {
    window.localStorage.removeItem('the_utm_source');
    _sa2.default.thelatest_utm_source = '';
  } else {
    _sa2.default.thelatest_utm_source = cache_utm_source.value;
  }
}

if (distinctID) {
  if (miniMember && (typeof miniMember === 'undefined' ? 'undefined' : (0, _typeof3.default)(miniMember)) === 'object') {
    _sa2.default.login(md5.hexMD5(miniMember.mobile));
  }
  _sa2.default.is_login = true;
  _sa2.default.platform_type = '微信小程序';
  _sa2.default.changeIdentify(distinctID, true);
} else if (userId) {
  userId = JSON.parse(userId);
  _sa2.default.is_login = true;
  _sa2.default.platform_type = 'WAP';
  _sa2.default.login(md5.hexMD5(userId.mobile));
}

_sa2.default.init();

window.sa = _sa2.default;

function isMoreThanSevenDays(time) {
  var curTime = new Date().getTime();
  return curTime - time > 7 * 24 * 3600 * 1000;
}

function updateUtmParam(value) {
  window.localStorage.setItem('the_utm_source', (0, _stringify2.default)({
    value: value,
    createTime: new Date().getTime()
  }));
}

_vue2.default.use(_toast2.default);
_vue2.default.use(_events2.default);
_vue2.default.use(_loading2.default);
_vue2.default.use(_setTitle2.default);
_vue2.default.config.productionTip = false;

exports.Page = function (page, options) {
  if (options.pageType) {
    _sa2.default.setCurrentPage(options.pageType);
  }
  _sa2.default._autoQuick();
  var vm = new _vue2.default(options);
  return vm;
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var events = new _vue2.default({
  name: 'events'
});
exports.default = events;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
 * Configurable variables. You may need to tweak these to be compatible with
 * the server-side, but the defaults work in most cases.
 */
var hexcase = 0; /* hex output format. 0 - lowercase; 1 - uppercase        */
var b64pad = ""; /* base-64 pad character. "=" for strict RFC compliance   */

/*
 * These are the functions you'll usually want to call
 * They take string arguments and return either hex or base-64 encoded strings
 */
function hex_md5(s) {
  return rstr2hex(rstr_md5(str2rstr_utf8(s)));
}
function b64_md5(s) {
  return rstr2b64(rstr_md5(str2rstr_utf8(s)));
}
function any_md5(s, e) {
  return rstr2any(rstr_md5(str2rstr_utf8(s)), e);
}
function hex_hmac_md5(k, d) {
  return rstr2hex(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
}
function b64_hmac_md5(k, d) {
  return rstr2b64(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
}
function any_hmac_md5(k, d, e) {
  return rstr2any(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)), e);
}

/*
 * Perform a simple self-test to see if the VM is working
 */
function md5_vm_test() {
  return hex_md5("abc").toLowerCase() == "900150983cd24fb0d6963f7d28e17f72";
}

/*
 * Calculate the MD5 of a raw string
 */
function rstr_md5(s) {
  return binl2rstr(binl_md5(rstr2binl(s), s.length * 8));
}

/*
 * Calculate the HMAC-MD5, of a key and some data (raw strings)
 */
function rstr_hmac_md5(key, data) {
  var bkey = rstr2binl(key);
  if (bkey.length > 16) bkey = binl_md5(bkey, key.length * 8);

  var ipad = Array(16),
      opad = Array(16);
  for (var i = 0; i < 16; i++) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5C5C5C5C;
  }

  var hash = binl_md5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binl_md5(opad.concat(hash), 512 + 128));
}

/*
 * Convert a raw string to a hex string
 */
function rstr2hex(input) {
  try {
    hexcase;
  } catch (e) {
    hexcase = 0;
  }
  var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
  var output = "";
  var x;
  for (var i = 0; i < input.length; i++) {
    x = input.charCodeAt(i);
    output += hex_tab.charAt(x >>> 4 & 0x0F) + hex_tab.charAt(x & 0x0F);
  }
  return output;
}

/*
 * Convert a raw string to a base-64 string
 */
function rstr2b64(input) {
  try {
    b64pad;
  } catch (e) {
    b64pad = '';
  }
  var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var output = "";
  var len = input.length;
  for (var i = 0; i < len; i += 3) {
    var triplet = input.charCodeAt(i) << 16 | (i + 1 < len ? input.charCodeAt(i + 1) << 8 : 0) | (i + 2 < len ? input.charCodeAt(i + 2) : 0);
    for (var j = 0; j < 4; j++) {
      if (i * 8 + j * 6 > input.length * 8) output += b64pad;else output += tab.charAt(triplet >>> 6 * (3 - j) & 0x3F);
    }
  }
  return output;
}

/*
 * Convert a raw string to an arbitrary string encoding
 */
function rstr2any(input, encoding) {
  var divisor = encoding.length;
  var i, j, q, x, quotient;

  /* Convert to an array of 16-bit big-endian values, forming the dividend */
  var dividend = Array(Math.ceil(input.length / 2));
  for (i = 0; i < dividend.length; i++) {
    dividend[i] = input.charCodeAt(i * 2) << 8 | input.charCodeAt(i * 2 + 1);
  }

  /*
   * Repeatedly perform a long division. The binary array forms the dividend,
   * the length of the encoding is the divisor. Once computed, the quotient
   * forms the dividend for the next step. All remainders are stored for later
   * use.
   */
  var full_length = Math.ceil(input.length * 8 / (Math.log(encoding.length) / Math.log(2)));
  var remainders = Array(full_length);
  for (j = 0; j < full_length; j++) {
    quotient = Array();
    x = 0;
    for (i = 0; i < dividend.length; i++) {
      x = (x << 16) + dividend[i];
      q = Math.floor(x / divisor);
      x -= q * divisor;
      if (quotient.length > 0 || q > 0) quotient[quotient.length] = q;
    }
    remainders[j] = x;
    dividend = quotient;
  }

  /* Convert the remainders to the output string */
  var output = "";
  for (i = remainders.length - 1; i >= 0; i--) {
    output += encoding.charAt(remainders[i]);
  }return output;
}

/*
 * Encode a string as utf-8.
 * For efficiency, this assumes the input is valid utf-16.
 */
function str2rstr_utf8(input) {
  var output = "";
  var i = -1;
  var x, y;

  while (++i < input.length) {
    /* Decode utf-16 surrogate pairs */
    x = input.charCodeAt(i);
    y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0;
    if (0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF) {
      x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
      i++;
    }

    /* Encode output as utf-8 */
    if (x <= 0x7F) output += String.fromCharCode(x);else if (x <= 0x7FF) output += String.fromCharCode(0xC0 | x >>> 6 & 0x1F, 0x80 | x & 0x3F);else if (x <= 0xFFFF) output += String.fromCharCode(0xE0 | x >>> 12 & 0x0F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);else if (x <= 0x1FFFFF) output += String.fromCharCode(0xF0 | x >>> 18 & 0x07, 0x80 | x >>> 12 & 0x3F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);
  }
  return output;
}

/*
 * Encode a string as utf-16
 */
function str2rstr_utf16le(input) {
  var output = "";
  for (var i = 0; i < input.length; i++) {
    output += String.fromCharCode(input.charCodeAt(i) & 0xFF, input.charCodeAt(i) >>> 8 & 0xFF);
  }return output;
}

function str2rstr_utf16be(input) {
  var output = "";
  for (var i = 0; i < input.length; i++) {
    output += String.fromCharCode(input.charCodeAt(i) >>> 8 & 0xFF, input.charCodeAt(i) & 0xFF);
  }return output;
}

/*
 * Convert a raw string to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */
function rstr2binl(input) {
  var output = Array(input.length >> 2);
  for (var i = 0; i < output.length; i++) {
    output[i] = 0;
  }for (var i = 0; i < input.length * 8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << i % 32;
  }return output;
}

/*
 * Convert an array of little-endian words to a string
 */
function binl2rstr(input) {
  var output = "";
  for (var i = 0; i < input.length * 32; i += 8) {
    output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xFF);
  }return output;
}

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */
function binl_md5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[(len + 64 >>> 9 << 4) + 14] = len;

  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;

    a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
    d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
    d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }
  return Array(a, b, c, d);
}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5_cmn(q, a, b, x, s, t) {
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
}
function md5_ff(a, b, c, d, x, s, t) {
  return md5_cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t) {
  return md5_cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t) {
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t) {
  return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y) {
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xFFFF;
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bit_rol(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
module.exports = {
  hexMD5: hex_md5
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(71),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformLink = transformLink;
exports.trackSkip = trackSkip;
exports.normalSkip = normalSkip;
exports.appSkip = appSkip;
exports.transformMLink = transformMLink;
exports.getToMiniLink = getToMiniLink;
exports.getLinkPageData = getLinkPageData;

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _queryString = __webpack_require__(13);

var _queryString2 = _interopRequireDefault(_queryString);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

var _simpleSemver = __webpack_require__(155);

var _miniprogram = __webpack_require__(142);

var _miniLink = __webpack_require__(145);

var _url = __webpack_require__(219);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var version = _browser2.default.app() ? _browser2.default.app().version : '';

var REG = /^beastapp:\/\/(\S+)[\?\/]([\S\s]+)/i;

// const route = {
//   'index': '/',
//   'shop': '/shop?shopId=',
//   'brand': '/product/list?',
//   'cate': '/product/list?',
//   'search': '/product/list?',
//   'retail': '/retail?',
//   'article': `/article?articleId=`,
//   'customization-list': `/customization/list?`,
//   'big-furniture-tips': '/furniture/tips?',
//   'shop-story': '/shop/story?',
//   'group-purchase': '/group/purchase?',
//   'points-benefit': '/points/benefit?',
//   'points-mall': '/member/day/points?',
//   'points-list': '/points/list?',
//   'points-detail': '/member/day/points/detail?',
//   'points-coupon': '/points/coupon?',
//   'category': '/category?',
//   'store': '/store?',
//   'cart': '/cart?',
//   'member': '/my?',
//   'my': '/my?',
//   'discovery': '/discovery?',
//   'funny': '/funny?',
//   'thh-page': '/ruler/thh',
//   'welfare': '/my/benefit/all?',
//   'benefit': '/my/benefit?',
//   'benefit-policy': '/benefit?',
//   'order-list': '/my/orderlist?',
//   'profile-setting': '/my/profile/edit',
//   'product': '/product/',
//   'shopping-fund': '/shopping/fund?',
//   'member-speed': '/member/speed?'
// }

var params = {
  'brand': 'brandId'
  // 'product': '*'
};

var route = {
  'index': {
    key: '/',
    type: '首页'
  },
  'shop': {
    key: '/shop?shopId=',
    type: '店铺页'
  },
  'brand': {
    key: '/product/list?',
    type: '商品列表页-品牌列表'
  },
  'cate': {
    key: '/product/list?',
    type: '商品列表页-分类列表'
  },
  'search': {
    key: '/product/list?',
    type: '商品列表页-搜索列表'
  },
  'retail': {
    key: '/retail?',
    type: ''
  },
  'article': {
    key: '/article?articleId=',
    type: '专题页'
  },
  'customization-list': {
    key: '/customization/list?',
    type: '商品列表页-定制列表'
  },
  'big-furniture-tips': {
    key: '/furniture/tips?',
    type: '大家具'
  },
  'shop-story': {
    key: '/shop/story?',
    type: '封面故事页'
  },
  'shop-story-all': {
    key: '/shop/story/all?',
    type: '全部封面故事页'
  },
  'group-purchase': {
    key: '/group/purchase?',
    type: '团购'
  },
  'points-benefit': {
    key: '/points/benefit?',
    type: '积分特权'
  },
  'points-mall': {
    key: '/member/day/points?',
    type: '积分商城'
  },
  'points-list': {
    key: '/points/list?',
    type: '积分列表'
  },
  'points-detail': {
    key: '/member/day/points/detail?',
    type: '积分详情页'
  },
  'points-coupon': {
    key: '/points/coupon?',
    type: '积分优惠券页'
  },
  'category': {
    key: '/category?',
    type: '选购'
  },
  'category-v2': {
    key: '/category/v2?',
    type: '选购'
  },
  'store': {
    key: '/store?',
    type: '门店'
  },
  'cart': {
    key: '/cart?',
    type: '购物车'
  },
  'member': {
    key: '/my?',
    type: '我的'
  },
  'my': {
    key: '/my?',
    type: '我的'
  },
  'discovery': {
    key: '/discovery?',
    type: '发现'
  },
  'funny': {
    key: '/funny?',
    type: '发现'
  },
  'thh-page': {
    key: '/ruler/thh',
    type: '退换货'
  },
  'welfare': {
    key: '/my/benefit/all?',
    type: '我的福利'
  },
  'benefit': {
    key: '/my/benefit?',
    type: '我的特权'
  },
  'benefit-policy': {
    key: '/benefit?',
    type: '特权政策'
  },
  'order-list': {
    key: '/my/orderlist?',
    type: '订单列表'
  },
  'profile-setting': {
    key: '/my/profile/edit',
    type: '个人信息设置'
  },
  'product': {
    key: '/product/',
    type: '商品详情页-普通商品'
  },
  'shopping-fund': {
    key: '/shopping/fund?',
    type: '购物基金'
  },
  'member-speed': {
    key: '/member/speed?',
    type: '会员等级'
  },
  'flower-list': {
    key: '/flower/list?',
    type: '花市列表'
  },
  'select-gift': {
    key: '/select/gift?',
    type: '选礼物'
  },
  'select-gift-result': {
    key: '/select/gift/result?',
    type: '选礼物结果'
  }
};

var app = _browser2.default.app();
var ios = _browser2.default.ios();
var android = _browser2.default.android();
var uniapp = _browser2.default.uniapp();

function transformLink(_ref) {
  var link = _ref.link,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      _ref$shopId = _ref.shopId,
      shopId = _ref$shopId === undefined ? '' : _ref$shopId,
      _ref$isMini = _ref.isMini,
      isMini = _ref$isMini === undefined ? false : _ref$isMini;

  var _link = isMini ? (0, _miniLink.transformMiniLink)({ link: link, title: title }) : transformMLink({ link: link, title: title, shopId: shopId });
  return _link;
}

function trackSkip(_ref2) {
  var _ref2$trackData = _ref2.trackData,
      trackData = _ref2$trackData === undefined ? {} : _ref2$trackData,
      _ref2$link = _ref2.link,
      link = _ref2$link === undefined ? '' : _ref2$link,
      _ref2$isMini = _ref2.isMini,
      isMini = _ref2$isMini === undefined ? false : _ref2$isMini,
      _ref2$toMiniProgram = _ref2.toMiniProgram,
      toMiniProgram = _ref2$toMiniProgram === undefined ? false : _ref2$toMiniProgram;

  if (!link || link === "#") {
    return;
  }

  (0, _track2.default)(trackData).then(function () {
    if (toMiniProgram) {
      //去小程序打开该页面
      openMiniProgram(link);
    } else if (isMini) {
      //小程序环境打开webview页面或者小程序内部页面
      (0, _miniprogram.navigateToMini)(link);
    } else {
      if (app) {
        _bridge2.default.open({
          url: link
        });
      } else {
        window.location.href = link;
      }
    }
  });
}

function normalSkip(_ref3) {
  var _ref3$link = _ref3.link,
      link = _ref3$link === undefined ? '' : _ref3$link,
      _ref3$isMini = _ref3.isMini,
      isMini = _ref3$isMini === undefined ? false : _ref3$isMini,
      _ref3$toMiniProgram = _ref3.toMiniProgram,
      toMiniProgram = _ref3$toMiniProgram === undefined ? false : _ref3$toMiniProgram;

  if (toMiniProgram) {
    //去小程序打开该页面
    openMiniProgram(link);
  } else if (isMini) {
    //小程序环境打开webview页面或者小程序内部页面
    (0, _miniprogram.navigateToMini)(link);
  } else {
    if (app) {
      _bridge2.default.open({
        url: link
      });
    } else {
      window.location.href = link;
    }
    // if(browser.app() && /^http/.test(link)) {
    //   bridge.open(link)
    // } else {
    //   window.location.href = link
    // }
  }
}

function openMiniProgram(link) {
  if ((0, _simpleSemver.lt)(version, '4.11.0')) {
    this.$alert({
      title: '请先去更新APP版本',
      content: '需要更新APP到最新版，才能进入查看哦！',
      buttonText: '知道了'
    }).then(function () {
      _bridge2.default.updateMobileVersion();
    });
  } else {
    _bridge2.default.openWXMiniProgram({
      path: link
    });
  }
}

function appSkip(link) {
  // if(uniapp) {
  //   bridge.open({
  //     url: link
  //   })
  // } else {
  //   window.location.href = link
  // }
  _bridge2.default.open({
    url: link
  });
}

// export function skip ({link='', isMini = false}) {
//   if(!link || link === "#") {
//     return 
//   }

//   if (isMini) {
//     navigateToMini(link)
//   }
//   else {
//     window.location.href = link
//   }
// }

function transformMLink(_ref4) {
  var link = _ref4.link,
      _ref4$title = _ref4.title,
      title = _ref4$title === undefined ? '' : _ref4$title,
      _ref4$shopId = _ref4.shopId,
      shopId = _ref4$shopId === undefined ? '' : _ref4$shopId;

  console.log('!!!!!!!!!!');
  if (!link.type) {
    return '';
  }
  var url = "";
  if (app) {
    url = 'beastapp://';
  }
  title = encodeURIComponent(title);
  switch (link.type) {
    case 'none':
      return '#';
      break;
    case 'product':
      app ? url += 'product/' + link.value : url = '/product/' + link.value;
      break;
    case 'article':
      app ? url += 'article/' + link.value : url = '/article?articleId=' + link.value;
      break;
    case 'shop-story':
      app ? url += 'entry?name=shop-story&shopId=' + link.value : url = '/shop/story?shopId=' + link.value;
      break;
    case 'shop-story-all':
      app ? url += 'entry?name=shop-story-all&shopId=' + link.value : url = '/shop/story/all?shopId=' + link.value;
      break;
    case 'shop':
      app ? url += 'shop/' + link.value : url = '/shop?shopId=' + link.value;
      break;
    case 'list':
      app ? url += 'search?listId=' + link.value + '&title=' + title : url = '/product/list?listId=' + link.value + '&title=' + title;
      break;
    case 'new':
      app ? shopId ? url += 'search?shopId=' + shopId + '&new=1&title=' + title : url += 'search?new=1&title=' + title : shopId ? url = '/product/list?shopId=' + shopId + '&new=1&title=' + title : url = '/product/list?new=1&title=' + title;
      break;
    case 'all':
      app ? shopId ? url += 'search?shopId=' + shopId + '&title=' + title : url += 'search?title=' + title : shopId ? url = '/product/list?shopId=' + shopId + '&title=' + title : url = '/product/list?title=' + title;
      break;
    case 'brand':
      // ? url += `search?brandId=${link.value}&title=${title}`
      app ? url += 'entry?name=product-list&brandId=' + link.value + '&title=' + title : url = '/product/list?brandId=' + link.value + '&title=' + title;
      break;
    case 'tag':
      app ? url += 'search?labelId=' + link.value + '&title=' + title : url = '/product/list?labelId=' + link.value + '&title=' + title;
      break;
    case 'bu':
      var query = "";
      var idArr = link.value.split("-");
      if (!idArr.length) {
        return;
      }
      if (idArr.length === 2 && idArr[1]) {
        query = 'buId=' + idArr[0] + '&categoryId=' + idArr[1] + '&title=' + title;
      } else {
        query = 'buId=' + idArr[0] + '&title=' + title;
      }

      app ? url += 'search?' + query : url = '/product/list?' + query;
      break;
    case 'category':
      var cateStrs = '';
      link.value.split(',').forEach(function (v, index) {
        cateStrs += 'categoryId=' + v + '&';
      });

      app ? url += 'search?' + cateStrs + 'title=' + title : url = '/product/list?' + cateStrs + 'title=' + title;
      break;
    case 'oversea':
      app ? shopId ? url += 'search?shopId=' + shopId + '&overseasOnly=true&title=' + title : url += 'search?overseasOnly=true&title=' + title : shopId ? url += '/product/list?shopId=' + shopId + '&overseasOnly=true&title=' + title : url += '/product/list?overseasOnly=true&title=' + title;
      break;
    case 'categoryOversea':
      var cateStrs1 = '';
      link.value.split(',').forEach(function (v, index) {
        cateStrs1 += 'categoryId=' + v + '&';
      });

      app ? shopId ? url += 'search?shopId=' + shopId + '&overseasOnly=true&' + cateStrs1 + 'title=' + title : url += 'search?overseasOnly=true&' + cateStrs1 + 'title=' + title : shopId ? url += '/product/list?shopId=' + shopId + '&overseasOnly=true&' + cateStrs1 + 'title=' + title : url += '/product/list?overseasOnly=true&' + cateStrs1 + 'title=' + title;
      break;
    case 'campaign':
      app ? url += 'search?campaignCode=' + link.value + '&title=' + title : url = '/product/list?campaignCode=' + link.value + '&title=' + title;
      break;
    case 'article-list':
      var idStrs = '';
      link.value.split(',').forEach(function (v, index) {
        idStrs += 'articleId=' + v + '&';
      });
      app ? url += 'entry?name=article-list&type=article-list&' + idStrs + 'title=' + title : url = '/article/list?type=article-list&' + idStrs + 'title=' + title;
      break;
    case 'lesson':
      app ? url += 'entry?name=article-list&type=LESSON&title=' + title : url = '/article/list?type=LESSON&title=' + title;
      break;
    case 'group':
      app ? url += 'entry?name=group-purchase&productId=' + link.value : url = '/group/purchase?productId=' + link.value;
      break;
    case 'customization-list':
      app ? url += 'entry?name=customization-list' : url = '/customization/list';
      break;
    case 'deeplink':
      app ? url = link.value : url = dealMLink(link.value);
      break;

    case 'custom':
      app ? url += 'entry?name=customization-list' : url = '';
      break;
    case 'discount':
      app ? url += 'search?param=discount&title=\u6298\u6263' : url = '/product/list?param=discount&title=\u6298\u6263';
      break;
    case 'retail':
      app ? url += 'entry?name=retail&title=\u5B9E\u4F53\u5E97' : url = '/retail';
      break;
    case 'index':
      app ? url += 'index' : url = '/';
      break;
    case 'program':
      url = '';
      break;
    case 'web':
      url = link.value;
      break;
    case 'selfdefine':
      app ? url = link.deeplink : url = link.waplink;
      break;
  }
  console.log(url, "$$$$$$$$$$");
  return url;
}

function dealMLink(link) {
  if (/^http/.test(link)) {
    //http
    return link;
  }
  if (link === 'beastapp://index') {
    link = '/';
  } else if (link === 'beastapp://my') {
    link = '/my';
  } else if (link === 'beastapp://profile-settings') {
    link = '/my/profile/edit';
  } else if (link === 'beastapp://order-list') {
    link = '/my/orderlist';
  } else if (link === 'beastapp://score') {
    link = '/my/score';
  } else if (link === 'beastapp://cart') {
    link = '/cart';
  } else if (link === 'beastapp://benefit') {
    link = '/my/benefit';
  } else {
    // link = splitQue(link)
    link = splitQue(link).que;
  }

  return link;
}

function dealMLinkPage(link) {
  var skip_page_type = '';

  if (/^http/.test(link)) {
    //http
    return {
      link: link,
      skip_page_type: skip_page_type
    };
  }
  if (link === 'beastapp://index') {
    skip_page_type = '首页';
    link = '/';
  } else if (link === 'beastapp://my') {
    skip_page_type = '我的';
    link = '/my';
  } else if (link === 'beastapp://profile-settings') {
    skip_page_type = '编辑个人信息';
    link = '/my/profile/edit';
  } else if (link === 'beastapp://order-list') {
    skip_page_type = '订单列表';
    link = '/my/orderlist';
  } else if (link === 'beastapp://score') {
    skip_page_type = '我的积分';
    link = '/my/score';
  } else if (link === 'beastapp://cart') {
    skip_page_type = '购物车';
    link = '/cart';
  } else if (link === 'beastapp://benefit') {
    skip_page_type = '我的特权';
    link = '/my/benefit';
  } else {
    skip_page_type = splitQue(link).trackType;
    link = splitQue(link).que;
  }

  return {
    link: link,
    skip_page_type: skip_page_type
  };
}

function splitQue(query) {
  var que = REG.exec(query);
  var type = que[1];
  var search = que[2];
  var name = '';
  var trackType = '';
  // entry
  if (type === 'entry') {
    type = _queryString2.default.parse(search).name;
  }

  // if (type && search) {
  //   que = matchQue(type, search)
  // }
  if (type && search) {
    var queObj = matchQue(type, search);
    que = queObj.que;
    trackType = queObj.trackType;
  }

  // return que
  return {
    que: que,
    trackType: trackType
  };
}

function matchQue(type, query) {
  var que = '';
  type = type.split('/');

  // const path = route[type[0]]
  // const pid = params[type[0]]
  if (route[type[0]]) {
    var path = route[type[0]].key;
    var trackType = route[type[0]].type || '';
    var pid = params[type[0]];

    if (path) {
      que = type[1] && pid ? pid === '*' ? '' + path + type[1] + '?' + query : '' + path + pid + '=' + type[1] + '&' + query : pid ? '' + path + pid + '=' + query : '' + path + query;
    } else {
      que = '/' + type[0].replace('-', '/');
    }

    // return que
    return {
      que: que,
      trackType: trackType
    };
  } else {
    return {
      que: '#',
      trackType: ''
    };
  }
}

function getToMiniLink(_ref5) {
  var link = _ref5.link,
      title = _ref5.title;

  var miniLink = (0, _miniLink.transformMiniLink)({ link: link, title: title });
  return miniLink.url;
}

function getLinkPageData(_ref6) {
  var link = _ref6.link,
      _ref6$title = _ref6.title,
      title = _ref6$title === undefined ? '' : _ref6$title;

  var skip_page_type = '',
      skip_page_name = '',
      skip_page_id = '';

  if (!link.type) {
    return {
      skip_page_type: skip_page_type,
      skip_page_name: skip_page_name,
      skip_page_id: skip_page_id
    };
  }

  switch (link.type) {
    case 'none':
      break;
    case 'product':
      skip_page_type = '商品详情页-普通商品';
      skip_page_id = link.value;
      break;
    case 'article':
      skip_page_type = '专题页';
      skip_page_id = link.value;
      break;
    case 'shop-story':
      skip_page_type = '封面故事页';
      skip_page_id = link.value;
      break;
    case 'shop':
      skip_page_type = '店铺主页';
      skip_page_id = link.value;
      break;
    case 'list':
      skip_page_type = '商品列表页-运营list';
      skip_page_name = title || '';
      skip_page_id = link.value;
      break;
    case 'new':
      skip_page_type = '商品列表页-新鲜上架';
      skip_page_name = title || '';
      break;
    case 'all':
      skip_page_type = '商品列表页-全部商品';
      skip_page_name = title || '';
      break;
    case 'brand':
      skip_page_type = '商品列表页-品牌列表';
      skip_page_name = title || '';
      skip_page_id = link.value;
      break;
    case 'tag':
      skip_page_type = '商品列表页-标签列表';
      skip_page_name = title || '';
      skip_page_id = link.value;
      break;
    case 'bu':
      skip_page_type = '商品列表页-BU商品列表';
      skip_page_name = title || '';

      var idArr = link.value.split("-");
      if (idArr.length) {
        skip_page_id = idArr[0] || '';
      }
      break;
    case 'category':
      var cateStrs = '';
      link.value.split(',').forEach(function (v, index) {
        cateStrs += 'categoryId=' + v + '&';
      });

      skip_page_type = '商品列表页-分类列表';
      skip_page_name = title || '';
      skip_page_id = cateStrs;
      break;
    case 'oversea':
      skip_page_type = '商品列表页-海淘列表';
      skip_page_name = title || '';
      break;
    case 'categoryOversea':
      var cateStrs1 = '';
      link.value.split(',').forEach(function (v, index) {
        cateStrs1 += 'categoryId=' + v + '&';
      });

      skip_page_type = '商品列表页-海淘分类列表';
      skip_page_name = title || '';
      skip_page_id = cateStrs1;
      break;
    case 'article-list':
      var idStrs = '';
      link.value.split(',').forEach(function (v, index) {
        idStrs += 'articleId=' + v + '&';
      });

      skip_page_type = '专题列表';
      skip_page_name = title || '';
      skip_page_id = idStrs;
      break;
    case 'lesson':
      skip_page_type = '野兽课堂列表页';
      skip_page_name = title || '';
      break;
    case 'group':
      skip_page_type = '商品详情页-团购商品';
      skip_page_id = link.value;
      break;
    case 'customization-list':
      skip_page_type = '商品列表页-定制列表';
      break;
    case 'deeplink':
      var dealLink = dealMLinkPage(link.value);
      skip_page_type = dealLink.skip_page_type;
      break;
    case 'custom':
      skip_page_type = '商品列表页-定制列表';
      break;
    case 'discount':
      skip_page_type = '商品列表页-折扣列表';
      skip_page_name = '折扣';
      break;
    case 'index':
      skip_page_type = '首页';
      break;
    case 'program':
      skip_page_type = '小程序页面';
      break;
    case 'web':
      skip_page_type = '网页';
      skip_page_name = link.value;
      break;
    case 'selfdefine':
      skip_page_type = '自定义页面';
      skip_page_name = app ? link.deeplink : link.waplink;
      break;
  }

  return {
    skip_page_type: skip_page_type,
    skip_page_id: skip_page_id,
    skip_page_name: skip_page_name
  };
}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// import $ from 'zepto'
// import util from 'util'

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(63);

var _from2 = _interopRequireDefault(_from);

var _getPrototypeOf = __webpack_require__(139);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(42);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(140);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(141);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.lazyload = lazyload;
exports.getDefaultImage = getDefaultImage;

var _events = __webpack_require__(146);

var _load = __webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import assets from 'assets'


var DEFAULT_OPITONS = {
  threshold: 400,
  attr: 'datalazy',
  isAnimation: true,
  isSlider: false,
  timeout: 1000,
  debounce: 50,
  loadFun: null

  // const defaultImage = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEXCwsK592mkAAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==`
};var defaultImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABGdBTUEAALGPC/xhBQAAAA1JREFUCB1jePv27X8ACVkDxyMHIvwAAAAASUVORK5CYII=';
var clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
var windowFlag = true;

function lazyload() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  options.threshold = options.threshold || DEFAULT_OPITONS.threshold;
  options.attr = options.attr || DEFAULT_OPITONS.attr;
  options.timeout = options.timeout || DEFAULT_OPITONS.timeout;
  options.isAnimation = options.isAnimation || DEFAULT_OPITONS.isAnimation;
  options.isSlider = options.isSlider || DEFAULT_OPITONS.isSlider;
  options.debounce = options.debounce || DEFAULT_OPITONS.debounce;

  if (!options.container) {
    options.container = window;
  } else {
    windowFlag = false;
    // options.container = document.querySelector(options.container)
    options.container = container;
  }

  return new LazyImage(options);
}

function getDefaultImage() {
  return defaultImage;
}

var LazyImage = function (_EventEmitter) {
  (0, _inherits3.default)(LazyImage, _EventEmitter);

  function LazyImage(options) {
    (0, _classCallCheck3.default)(this, LazyImage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LazyImage.__proto__ || (0, _getPrototypeOf2.default)(LazyImage)).call(this));
    // code


    _this.options = options;
    _this.nodes = [];
    if (document.body) {
      _this.bodyDom = document.body;
    }
    if (document.documentElement) {
      _this.documentDom = document.documentElement;
    }
    // this.bodyDom = document.documentElement || document.querySelector("body")
    // this._check = this._check.bind(this)
    _this._check = debounce(_this._check.bind(_this), _this.options.debounce);

    _this._bind();

    var images = null;
    try {
      // if(!selector) {
      images = document.querySelectorAll("img[datalazy]");
      // } else {
      //   images = document.querySelectorAll(selector)
      // }
    } catch (e) {}

    if (images && images.length > 0) {
      _this.add(images);
    }

    return _this;
  }

  (0, _createClass3.default)(LazyImage, [{
    key: '_bind',
    value: function _bind() {
      this.options.container.addEventListener('scroll', this._check);
      this.options.container.addEventListener('resize', this._check);
    }
  }, {
    key: 'add',
    value: function add(images) {
      var _this2 = this;

      // const eles = images
      var eles = (0, _from2.default)(images);
      // console.log(eles)
      eles.forEach(function (ele) {
        var eleNode = ele;
        // console.log(eleNode.getAttribute("defaultimg"))
        eleNode.getAttribute('src') || eleNode.setAttribute('src', eleNode.getAttribute("defaultimg") || defaultImage);
        // console.log(this.nodes)
        _this2.nodes.push(eleNode);
      });

      setTimeout(function () {
        _this2._check();
      });

      return this;
    }
  }, {
    key: '_check',
    value: function _check() {
      var _this3 = this;

      // console.log("_check function")

      clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      var top = 0;
      var container = this.options.container;
      if (this.options.isSlider) {
        // top = this.options.container.height() + this.options.container.offset().top
        if (windowFlag) {
          top = clientHeight + (this.bodyDom.scrollTop || this.documentDom.scrollTop);
        } else {
          top = container.offsetHeight + container.scrollTop + container.offsetTop;
        }
      } else {
        if (windowFlag) {
          top = clientHeight + (this.bodyDom.scrollTop || this.documentDom.scrollTop);
        } else {
          if (container.offsetHeight < clientHeight) {
            top = container.offsetHeight + container.scrollTop + container.offsetTop;
          } else {
            top = clientHeight + container.scrollTop + container.offsetTop;
          }
        }
        // if(container.offsetHeight < clientHeight) {
        //   // top = this.options.container.height() + this.options.container.scrollTop()
        // } else {
        //   // top = $(window).height() + this.options.container.scrollTop()
        // }
      }

      var nodes = this.nodes;
      this.nodes = nodes.filter(function (node) {
        // console.log(node)
        if (!_this3._in_viewport(node, top)) {
          return true;
        }

        var count = _this3.listenerCount('show');
        if (count > 0) {
          _this3.emit('show', node[0]);
          return;
        }

        _this3._reveal(node);
      });
    }
  }, {
    key: '_in_viewport',
    value: function _in_viewport(node, top) {
      // console.log(node.offsetTop - this.options.threshold, "offset top")
      // console.log(top, "top")
      // return node.offset().top - this.options.threshold < top
      return node.offsetTop - this.options.threshold < top;
    }
  }, {
    key: '_reveal',
    value: function _reveal(node) {
      var _this4 = this;

      node.getAttribute('src') || node.setAttribute('src', node.getAttribute("defaultimg") || defaultImage);
      var source = node.getAttribute(this.options.attr);
      var loaded = false;
      if (source) {
        var url = '';
        var tm = setTimeout(function () {
          loaded = true;
          _this4._dealImg(node, source);
        }, this.options.timeout);

        (0, _load.load_image)(source, function (err, imgObj) {
          if (loaded) {
            return;
          } else {
            clearTimeout(tm);
          }
          if (err || !imgObj || imgObj.length == 0) {
            url = node.getAttribute("defaultimg") || defaultImage;
          } else {
            url = imgObj.src;
          }

          _this4._dealImg(node, url);
        });
      }
    }
  }, {
    key: '_dealImg',
    value: function _dealImg(node, url) {
      node.setAttribute('src', url);
      node.removeAttribute('datalazy');
      // hasClass(node, 'lazy') && removeClass(node, 'lazy')
      // hasClass(node, 'lazy-loaded') || addClass(node, 'lazy-loaded')

      if (this.options.isAnimation) {
        this._addAnimation(node);
      }
    }
  }, {
    key: '_addAnimation',
    value: function _addAnimation(node) {
      hasClass(node, 'lazy-fadeIn') || addClass(node, 'lazy-fadeIn');
    }
  }]);
  return LazyImage;
}(_events.EventEmitter);

function hasClass(ele, cls) {
  return (' ' + ele.className + ' ').indexOf(' ' + cls + ' ') > -1;
}

function addClass(ele, cls) {
  ele.classList.add(cls);
}

function removeClass(ele, cls) {
  ele.classList.remove(cls);
}

function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;
  var later = function later() {
    var last = new Date().getTime() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function () {
    context = this;
    args = arguments;
    timestamp = new Date().getTime();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

exports.getEnv = getEnv;

var _sdk = __webpack_require__(147);

var _sdk2 = _interopRequireDefault(_sdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getEnv() {
  return new _promise2.default(function (resolve, reject) {
    _sdk2.default.adapter.invoke(function () {
      resolve(_sdk2.default);
    });
  });
}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(16);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Masks: _index2.default,
    MaxZIndex: _index4.default
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    from: {
      type: String,
      default: 'left'
    },
    zIndex: {
      default: 1001
    },
    height: {
      type: String,
      default: 'auto'
    },
    mask: {
      // type: Boolean,
      default: true
    },
    maskOpacity: {
      // type: Number,
      default: 0.4
    },
    slidecls: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isShow: false
    };
  },

  watch: {
    'show': function show(val) {
      this.showChange();
    }
  },
  created: function created() {
    this.showChange();
    // console.log(MaxZIndex.getZIndex());
  },

  computed: {
    mOpacity: function mOpacity() {
      return parseFloat(this.maskOpacity);
    },
    mfrom: function mfrom() {
      return 'beast_slide_from_' + this.from;
    }
  },
  methods: {
    showChange: function showChange() {
      var _show = this.show;
      // this.mfrom =  _show ? `` : ''
      this.isShow = _show;
    },

    // maskHide(){
    //   (this.mOpacity != 0) && this.mask && this.$emit('onHide')
    // },
    maskTap: function maskTap() {
      this.$emit('maskTap');
    }
  }
};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('max-z-index', {
    attrs: {
      "show": _vm.isShow
    }
  }, [(_vm.mask) ? _c('masks', {
    attrs: {
      "mshow": _vm.isShow,
      "mopacity": _vm.mOpacity
    },
    on: {
      "maskTap": _vm.maskTap
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "beast_slider",
    class: [_vm.mfrom, {
      beast_slide_from_reset: _vm.isShow
    }, _vm.slidecls],
    style: ({
      'z-index': _vm.zIndex,
      height: _vm.height
    })
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _urlUtil = __webpack_require__(21);

var _util = __webpack_require__(68);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//
//
//
//
//
//
//

exports.default = {
  name: 'beast-image',
  props: {
    src: {
      type: String,
      default: ''
    },
    image: {
      type: Object,
      default: null
    },
    containerWidth: {
      type: Number,
      default: 0
    },
    clipData: [String, Object],
    lazy: {
      type: Boolean,
      default: false
    },
    defaultImage: {
      type: String,
      default: ''
    },
    timeout: {
      type: Number,
      default: 100
    },
    load: {
      type: Boolean,
      default: true
    },
    suffix: {
      type: String,
      default: ""
    },
    fixWidth: {
      type: Number,
      default: 0
    },
    radius: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      imageLoad: false,
      imageData: {},
      imageSrc: null,
      imageWidth: "",
      imageHeight: "",
      lazyImage: null
    };
  },

  computed: {
    // imgSrc () {
    //   return ensure_protocol(this.src)
    // }
  },
  watch: {
    src: function src() {
      var _this = this;

      this.$nextTick(function () {
        // console.log(this.src, "watch src")
        _this.transform();
      });
    },
    image: function image() {
      var _this2 = this;

      this.$nextTick(function () {
        // console.log(this.image, "watch image")
        _this2.transform();
      });
    }
  },
  created: function created() {
    this.transform();
  },

  methods: {
    transform: function transform() {
      if (!this.src && !this.image) {
        return;
      }
      var formatData = util.transform({
        data: this.src || this.image,
        containerWidth: this.containerWidth,
        clipData: this.clipData,
        suffix: this.suffix,
        fixWidth: this.fixWidth
      });
      formatData.src = (0, _urlUtil.ensure_protocol)(formatData.src);
      // console.log(formatData)
      if (this.lazy) {
        this.imageData = formatData;
        this.imageSrc = this.imageData.src;
        this.imageWidth = this.imageData.width;
        this.imageHeight = this.imageData.height;
        // console.log(this.defaultImage, "defaultImage")
        if (this.defaultImage) {
          this.lazyImage = (0, _urlUtil.ensure_protocol)(this.defaultImage);
        }
      } else {
        var dataFlag = true;
        this.getImage(formatData, dataFlag);
      }
    },
    getImage: function getImage(formatImage, dataFlag) {
      var _this3 = this;

      // console.log("getImage")
      // console.log(formatImage)
      if (!this.load) {
        this.imageData = formatImage;
        this.setImage();
        this.imageLoad = true;
        return;
      }
      var tm = setTimeout(function () {
        // console.log("timeout")
        if (dataFlag) {
          _this3.imageData = formatImage;
          _this3.setImage();
          // this.imageSrc = this.imageData.src
          // this.imageWidth = this.imageData.width
          // this.imageHeight = this.imageData.height
        }
        _this3.imageLoad = true;
      }, this.timeout);
      this.loadImage(formatImage.src, function (err, imgObj) {
        if (_this3.imageLoad) {
          return;
        } else {
          clearTimeout(tm);
        }
        var src = formatImage.src;
        if (err || !imgObj) {
          return;
          // src = imgObj.src
        }
        if (dataFlag) {
          _this3.imageData = {
            src: imgObj.src,
            width: formatImage.width,
            height: formatImage.height
          };
          _this3.setImage();
          // this.imageSrc = this.imageData.src
          // this.imageWidth = this.imageData.width
          // this.imageHeight = this.imageData.height
        }
        _this3.imageLoad = true;
      });
    },
    setImage: function setImage() {
      this.imageSrc = this.imageData.src;
      this.imageWidth = this.imageData.width;
      this.imageHeight = this.imageData.height;
    },
    loadImage: function loadImage(src, callback) {
      // console.log("loadImage")
      var image = new Image();
      var doned = void 0;

      function done(err) {
        if (doned) {
          return;
        }
        doned = true;
        image.onload = image.onerror = image.onabort = null;

        if (err) {
          return callback(err);
        }

        var height = image.height,
            width = image.width,
            src = image.src;

        callback(null, {
          height: height,
          width: width,
          src: src
        });
      }

      image.onload = function () {
        done();
      };

      image.onabort = function () {
        done('abort');
      };

      image.onerror = function () {
        done('error');
      };

      image.src = src;
    }
  }
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transform = transform;
exports.formatZoom = formatZoom;
exports.formatStuff = formatStuff;

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLIP_MAP = {
  'product': {
    'width': 690,
    'height': 721
  },
  'simple-product': {
    'width': 330,
    'height': 345
  },
  'pack': {
    'width': 170,
    'height': 178
  },
  'addible-pack': {
    'width': 100,
    'height': 104
  },
  'package': {
    'width': 130,
    'height': 136
  }
};

var defaultImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABGdBTUEAALGPC/xhBQAAAA1JREFUCB1jePv27X8ACVkDxyMHIvwAAAAASUVORK5CYII=';

var clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

function transform(_ref) {
  var data = _ref.data,
      containerWidth = _ref.containerWidth,
      clipData = _ref.clipData,
      suffix = _ref.suffix,
      fixWidth = _ref.fixWidth;

  if (!data) {
    return {};
  }
  if (typeof data === 'string') {
    return {
      src: formatStuff({
        data: data,
        suffix: suffix,
        fixWidth: fixWidth
      }),
      width: "",
      height: ""
    };
  }

  var formatData = formatData = formatZoom(data.width, data.height, containerWidth);
  var url = formatStuff({
    data: data,
    formatData: formatData,
    clipData: clipData,
    suffix: suffix,
    fixWidth: fixWidth
  });
  formatData.src = url;
  return formatData;
}

function formatZoom(width, height, containerWidth) {
  if (!width || !height) {
    return {};
  }

  var zoomWidth = containerWidth ? containerWidth : clientWidth;
  var zoomHeight = parseFloat(zoomWidth / width * height);

  return {
    width: zoomWidth,
    height: zoomHeight
  };
}

function formatStuff(_ref2) {
  var data = _ref2.data,
      formatData = _ref2.formatData,
      clipData = _ref2.clipData,
      suffix = _ref2.suffix,
      fixWidth = _ref2.fixWidth;

  if (!data) {
    return "";
  }

  var url = '';
  var width = '';
  var height = '';

  if (typeof data === 'string') {
    url = decodeURIComponent(data);
  } else {
    url = decodeURIComponent(data.url || data.src);
    width = data.width;
    height = data.height;
  }

  var stuffIndex = url.lastIndexOf('.');
  var stuffMidIndex = url.lastIndexOf('@');
  var stuffAdditionIndex = url.lastIndexOf('|');
  var urlLen = url.length;

  if (!~stuffIndex) {
    return url;
  }

  var oldStuff = '';
  if (suffix) {
    oldStuff = '.' + suffix;
  } else {
    if (~stuffAdditionIndex) {
      oldStuff = url.substring(stuffIndex, stuffAdditionIndex);
    } else {
      oldStuff = url.substring(stuffIndex);
    }
    oldStuff = oldStuff.toLowerCase();
  }
  if (oldStuff !== ".jpg" && oldStuff !== ".jpeg" && oldStuff !== ".png" && oldStuff !== ".webp") {
    return url;
  }

  var stuff = '.webp';
  var newUrl = url;
  if (_browser2.default.ios() || !/i(?:pod|phone|pad)|android|micromessenger/i.test(navigator.userAgent)) {
    //webview ios || pc
    stuff = oldStuff === '.webp' ? '.jpg' : oldStuff;
  }

  var clipSize = {};

  if (clipData) {
    //'product' {'type':'product','width':'','height':''}
    if (typeof clipData === 'string') {
      if (CLIP_MAP[clipData]) {
        clipSize = CLIP_MAP[clipData];
      }
    } else {
      if (clipData['type'] && CLIP_MAP[clipData['type']]) {
        clipSize = CLIP_MAP[clipData['type']];
      } else {
        clipSize['width'] = clipData['width'];
        clipSize['height'] = clipData['height'];
      }
    }
  }

  if (clipSize['width'] && clipSize['height'] && !~stuffMidIndex) {
    newUrl = url + ('@4e_0o_0l_' + clipSize['height'] + 'h_' + clipSize['width'] + 'w_90q') + stuff;
    return newUrl;
  }

  if (!~stuffMidIndex || stuffMidIndex > stuffIndex) {
    // no @
    var formatObj = formatRangeSize(formatData);
    newUrl = url + formatRangeStuff({
      width: width,
      formatObj: formatObj,
      fixWidth: fixWidth
    }) + stuff;
    return newUrl;
  }

  //has @
  var stuffMidStr = url.substring(stuffMidIndex, stuffIndex);
  var stuffAdditionStr = '';
  if (~stuffAdditionIndex && stuffAdditionIndex > stuffMidIndex) {
    //has |
    stuffAdditionStr = url.substring(stuffAdditionIndex);
  }

  if (width && height) {
    // const whObj = this._formatStuffZoom(width, height)
    // stuffMidStr = `@4e_0o_0l_${whObj.height}h_${whObj.width}w_90q`
    var _formatObj = formatRangeSize(formatData);
    stuffMidStr = formatRangeStuff({
      width: width,
      formatObj: _formatObj,
      stuffMidStr: stuffMidStr,
      fixWidth: fixWidth
    });
  }
  newUrl = url.substring(0, stuffMidIndex) + stuffMidStr + stuff + stuffAdditionStr;

  return newUrl;
}

function formatRangeSize(formatData) {
  return {
    'width': 750
  };
}

function formatRangeStuff(_ref3) {
  var width = _ref3.width,
      formatObj = _ref3.formatObj,
      stuffMidStr = _ref3.stuffMidStr,
      fixWidth = _ref3.fixWidth;

  var midStuff = '';
  if (fixWidth) {
    midStuff = '@0o_0l_' + fixWidth + 'w_90q';
  } else {
    if (width && width >= formatObj.width) {
      midStuff = '@0o_0l_' + formatObj.width + 'w_90q';
    } else {
      if (stuffMidStr) {
        midStuff = stuffMidStr;
      } else {
        midStuff = '@90q';
      }
    }
  }
  return midStuff;
}

// export DEFAULT_IMAGE = defaultImage

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lazy) ? _c('img', {
    style: ({
      'border-radius': ((_vm.radius || 0) + "px")
    }),
    attrs: {
      "defaultimg": _vm.lazyImage,
      "datalazy": _vm.imageSrc,
      "width": _vm.imageWidth,
      "height": _vm.imageHeight
    }
  }) : (!_vm.lazy && _vm.imageLoad) ? _c('img', {
    style: ({
      'border-radius': ((_vm.radius || 0) + "px")
    }),
    attrs: {
      "src": _vm.imageSrc,
      "width": _vm.imageWidth,
      "height": _vm.imageHeight
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//

exports.default = {
  name: 'price',
  props: ['data', 'single', 'bit'],
  data: function data() {
    return {};
  },

  computed: {
    formatedPrice: function formatedPrice() {
      return this.formatPrice(this.data);
    }
  },
  methods: {
    formatPrice: function formatPrice(price) {
      var origin = price;
      var sign = '';

      if (price < 0) {
        price = Math.abs(price);
        sign = '-';
      }

      var int_number = (price * 100).toFixed(0);
      var decimal = String(int_number % 100);
      var int = String(parseInt(Number(price)));

      // 0.03 -> 3 -> 03
      if (decimal.length === 1) {
        decimal = '0' + decimal;
      }

      if (int.length > 3) {
        var remain = 3 - int.length % 3;

        switch (remain) {
          case 1:
            int = '0' + int;
            break;
          case 2:
            int = '00' + int;
            break;
        }

        var matches = int.match(/.{3}/g);

        if (remain !== 3) {
          matches[0] = matches[0].substring(remain);
        }

        int = matches.join(',');
      }

      return {
        int: int,
        decimal: this.single === 'false' ? decimal : decimal.substring(0, this.bit || 1),
        origin: origin,
        sign: sign,
        html: '<span class="sign">' + sign + '</span><span class="symbol">&yen;</span><span class="int">' + int + '</span><span class="decimal">.' + decimal + '</span>'
      };
    }
  }

};

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "sign"
  }, [_vm._v(_vm._s(_vm.formatedPrice.sign))]), _c('span', {
    staticClass: "symbol"
  }, [_vm._v("¥")]), _c('span', {
    staticClass: "int"
  }, [_vm._v(_vm._s(_vm.formatedPrice.int))]), _vm._v("."), _c('span', {
    staticClass: "decimal"
  }, [_vm._v(_vm._s(_vm.formatedPrice.decimal))])])
},staticRenderFns: []}

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(150)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(153),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(186)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(198),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(236);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _route;

exports.getLink = getLink;

var _queryString = __webpack_require__(13);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// beastapp://entry?
// beastapp://search?
// beastapp://store/shopId

var REG = /^beastapp:\/\/(\S+)[\?\/]([\S\s]+)/i;

var route = (_route = {
  'index': '/',
  'shop': '/shop?shopId=',
  'store': '/shop?shopId=',
  'brand': '/product/list?',
  'cate': '/product/list?',
  'search': '/product/list?',
  'retail': '/retail?',
  'article': '/article?articleId=',
  'customization-list': '/customization/list?',
  'big-furniture-tips': '/furniture/tips?',
  'shop-story': '/shop/story?',
  'group-purchase': '/group/purchase?',
  'points-benefit': '/points/benefit?',
  'points-mall': '/member/day/points?',
  'category': '/category?'
}, (0, _defineProperty3.default)(_route, 'store', '/store?'), (0, _defineProperty3.default)(_route, 'cart', '/cart?'), (0, _defineProperty3.default)(_route, 'member', '/my?'), _route);

var params = {
  'brand': 'brandId'
};

function getLink(link) {
  console.log(link);
  if (link === 'beastapp://index') {
    link = '/';
  } else {
    link = splitQue(link);
  }

  return link;
}

function splitQue(query) {
  var que = REG.exec(query);
  console.log(que, "que");
  var type = que[1];
  var search = que[2];
  var name = '';
  // entry
  if (type === 'entry') {
    type = _queryString2.default.parse(search).name;
  }

  if (type && search) {
    que = matchQue(type, search);
  }

  return que;
}

function matchQue(type, query) {
  var que = '';
  type = type.split('/');

  var path = route[type[0]];
  var pid = params[type[0]];

  if (path) {
    que = type[1] && pid ? '' + path + pid + '=' + type[1] + '&' + query : pid ? '' + path + pid + '=' + query : '' + path + query;
  } else {
    que = '/' + type[0].replace('-', '/');
  }

  return que;
}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'use strcit';

// const async = require('async')

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.load_image = load_image;
function NOOP() {}

// export function load_images (src, callback = NOOP) {
//   src = util.isArray(src)
//     ? src
//     : [src]

//   const tasks = src.map((src) => {
//     return (done) => {
//       load_one_image(src, done)
//     }
//   })

//   async.parallel(tasks, callback)
// }


function load_image(src, callback) {
  var image = new Image();
  var doned = void 0;

  function done(err) {
    if (doned) {
      return;
    }
    doned = true;
    image.onload = image.onerror = image.onabort = null;

    if (err) {
      return callback(err);
    }

    var height = image.height,
        width = image.width,
        src = image.src;


    callback(null, {
      height: height,
      width: width,
      src: src
    });
  }

  image.onload = function () {
    done();
  };

  image.onabort = function () {
    done('abort');
  };

  image.onerror = function () {
    done('error');
  };

  image.src = src;
}

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

exports.getMiniEnv = getMiniEnv;
exports.navigateToMini = navigateToMini;
exports.postMessageToMini = postMessageToMini;

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _wx$miniProgram = wx.miniProgram,
    getEnv = _wx$miniProgram.getEnv,
    navigateBack = _wx$miniProgram.navigateBack,
    navigateTo = _wx$miniProgram.navigateTo,
    postMessage = _wx$miniProgram.postMessage,
    reLaunch = _wx$miniProgram.reLaunch,
    redirectTo = _wx$miniProgram.redirectTo,
    switchTab = _wx$miniProgram.switchTab;
function getMiniEnv() {
  return new _promise2.default(function (resolve, reject) {
    if (_browser2.default.weixin()) {
      getEnv(function (res) {
        resolve(res.miniprogram);
      });
    } else {
      resolve(false);
    }
  });
}

function navigateToMini(_ref) {
  var url = _ref.url,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'navigate' : _ref$type;

  open({
    url: url,
    type: type
  });
}

function postMessageToMini(postData) {
  postMessage(postData);
}

var METHOD_MAP = {
  navigate: {
    delta: 1,
    method: 'navigateTo'
  },
  redirect: {
    delta: 0,
    method: 'redirectTo'
  },
  tab: {
    delta: 0,
    method: 'switchTab'
  }
};

var stack_await_resolves = [];

var stack_has_data = [];
var stack_data = [];

var stack_has_data_left = [];
var stack_data_left = [];
var stack_last_action = [];

function open(_ref2, i) {
  var url = _ref2.url,
      _ref2$type = _ref2.type,
      type = _ref2$type === undefined ? 'navigate' : _ref2$type,
      data = _ref2.data;

  var _ref3 = METHOD_MAP[type] || {},
      method = _ref3.method,
      delta = _ref3.delta;

  if (!method) {
    return _promise2.default.reject('unsupported open type "' + type + '"');
  }

  if (data !== undefined) {
    stack_has_data[i] = true;
    stack_data[i] = data;
  }

  stack_last_action[i + delta] = type;

  return new _promise2.default(function (resolve, reject) {
    stack_await_resolves[i] = resolve;

    wx.miniProgram[method]({
      url: url,
      fail: function fail(e) {
        clean(i);
        reject(e);
      }
    });
  });
}

function resolve_data(index) {
  var child_index = index + 1;
  var data_left = stack_has_data_left[child_index] ? stack_data_left[child_index] : undefined;

  clean_left(child_index);

  var resolve = stack_await_resolves[index];
  delete stack_await_resolves[index];

  if (!resolve) {
    return;
  }

  data_left === undefined ? resolve() : resolve(data_left);
}

function clean(i) {
  delete stack_await_resolves[i];
  clean_data(i);
}

function clean_data(i) {
  delete stack_has_data[i];
  delete stack_data[i];
}

function clean_left(i) {
  delete stack_has_data_left[i];
  delete stack_has_data[i];
}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(154);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(27);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

exports.axiosAction = axiosAction;
exports.clone = clone;
exports.getClientWidth = getClientWidth;
exports.getClientHeight = getClientHeight;
exports.getImages = getImages;
exports.getUrlParams = getUrlParams;
exports.checkAppType = checkAppType;
exports.isApp = isApp;
exports.invalidP = invalidP;
exports.invalid = invalid;
exports.scmAjax = scmAjax;
exports.formatModules = formatModules;
exports.getCountDown = getCountDown;
exports.login = login;
exports.colorToRgb = colorToRgb;
exports.formatProgramLink = formatProgramLink;
exports.formatTrackDataModules = formatTrackDataModules;
exports.getModuleName = getModuleName;
exports.trackAction = trackAction;

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

var _queryString = __webpack_require__(13);

var _queryString2 = _interopRequireDefault(_queryString);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _util = __webpack_require__(137);

var _link = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STR_UNKNOWN_ERROR = "出错啦！";
var clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
var urlParams = _queryString2.default.parse(location.search.slice(1));
var shopId = urlParams.shopId;
var app = _browser2.default.app();
var weixin = _browser2.default.weixin();

function axiosAction(_ref, sdk) {
  var url = _ref.url,
      _ref$method = _ref.method,
      method = _ref$method === undefined ? 'GET' : _ref$method,
      _ref$param = _ref.param,
      param = _ref$param === undefined ? {} : _ref$param;

  var request = _axiosMock2.default;
  if (sdk) {
    request = sdk.request;
  }

  return request({
    url: url,
    method: method,
    json: param
  }).then(function (_ref2) {
    var code = _ref2.code,
        data = _ref2.data;

    return _promise2.default.resolve(data);
  }).catch(function (err) {
    return _promise2.default.reject(err);
  });
}

function clone(data) {
  return JSON.parse((0, _stringify2.default)(data));
}

function getClientWidth() {
  return clientWidth;
}

function getClientHeight() {
  return clientHeight;
}

var images = {
  bottom: "http://img.thebeastshop.com/app/config/bottom.png",
  soldOutNIcon: "http://img.thebeastshop.com/app/product/list/sold-out-new.png",
  offShelfNIcon: "http://img.thebeastshop.com/app/product/list/off-shelf-new.png",
  vipOnlyIcon: "http://img.thebeastshop.com/app/product/list/vip-only.png",
  store: {
    listTitle: {
      width: 650,
      height: 94,
      src: "http://img.thebeastshop.com/app/config/store-list-title.png"
    }
  },
  border: "http://img.thebeastshop.com/app/shop/border.png",
  categoryTitle: {
    // src: "http://img.thebeastshop.com/apppictures/2017-06-02/ce1e11fded22772862f4c7ab879068d9.png",
    src: "http://img.thebeastshop.com/app/shop/category.png",
    width: 368,
    height: 52
  },
  latestTitle: {
    src: "http://img.thebeastshop.com/app/shop/latest.png",
    width: 368,
    height: 52
  },
  recommendTitle: {
    src: "http://img.thebeastshop.com/app/shop/recommend.png",
    width: 368,
    height: 52
  },
  reviewAll: {
    src: "http://img.thebeastshop.com/app/shop/review-all.png",
    width: 252,
    height: 354
  },
  article: {
    border: "http://img.thebeastshop.com/app/config/article/border.png",
    lineIcon: "http://img.thebeastshop.com/app/config/article/line-icon.png"
  },
  defaultImage: "http://img.thebeastshop.com/images/mcatlog/banner/p.png",
  special: {
    newCoupon: {
      text: "http://img.thebeastshop.com/app/article/special/text.png",
      rule: "http://img.thebeastshop.com/app/article/special/rule.png",
      coupon: "http://img.thebeastshop.com/app/article/special/coupon.png?ver=1"
    },
    memberSystem: {
      sshy: "http://img.thebeastshop.com/app/article/special/sshy.png",
      xmhy: "http://img.thebeastshop.com/app/article/special/xmhy.png",
      lhhy: "http://img.thebeastshop.com/app/article/special/lhhy.png",
      dxhy: "http://img.thebeastshop.com/app/article/special/dxhy.png"
    }
  },
  lottery: {
    couponThird: "https://img.thebeastshop.com/app/article/lottery/coupon-third.png",
    coupon: "https://img.thebeastshop.com/app/article/lottery/coupon.png",
    point: "https://img.thebeastshop.com/app/article/lottery/point.png",
    free: "https://img.thebeastshop.com/app/article/lottery/free.png",
    none: "https://img.thebeastshop.com/app/article/lottery/none.png",
    couponXwz: "https://img.thebeastshop.com/app/article/lottery/coupon-xwz.png",
    noneXwz: "https://img.thebeastshop.com/app/article/lottery/none-xwz.png",
    bgXwz: "https://img.thebeastshop.com/app/article/lottery/bg-xwz3.png",
    normalProd: "https://img.thebeastshop.com/app/article/lottery/normal-prod.png"
  },
  bigSmallImage: {
    arrow: "https://img.thebeastshop.com/app/article/big-small-image/arrow.png"
  }

  // const MODULE_MAP = {
  //   'image': '图片',
  //   'new-image': '新图片',
  //   'image-banner': '图片轮播',
  //   'new-banner': '新轮播',
  //   'image-index': '压字图片',
  //   'video': '视频',
  //   'text': '文本',
  //   'nav': '导航',
  //   'list': '商品列表',
  //   'new-list': '新商品列表',
  //   'ud-product': '上下单品',
  //   'product': '左右单品',
  //   'product-banner': '单品轮播',
  //   'product-horizon': '多品滑动',
  //   'rush-tab': '抢购Tab',
  //   'program-tab': '小程序Tab',
  //   'fix-tab': '可吸顶Tab',
  //   'new': '新品',
  //   'coupon': '优惠券',
  //   'time': '倒计时',
  //   'store': '门店',
  //   'new-line': '分割线',
  //   'special': '特殊模块',
  //   'lottery': '抽奖模块',
  //   'select-gift': '快速选礼',
  //   'nofix-nav': '不吸顶导航',
  //   'big-small-image': '大小图',
  //   'coupon-code': '优惠吗兑换',
  //   'new-time': '新倒计时',
  //   'get-point': '领取积分',
  //   'market-activity': '领营销奖励',
  //   'benefit-code': '特权码兑换',
  //   'voice-mod': '语音模块'

  //   // 'lesson-base-info': '',
  //   // 'lesson-link': '',
  //   // 'lesson-text': '',
  //   // 'line-title': '',

  // }
};var MODULE_MAP = {
  //图片/视频
  'image': '单图',
  'new-banner': '多图轮播',
  'new-image': '多图左右滑',
  'video': '视频',
  'buoy': '右下角浮标',

  //商品
  'new-list': '商品列表',
  'slide-product': '商品左右滑',
  'product': '左右单品',
  'ud-product': '上下单品',
  'new': '新鲜上架',
  'rush-tab': '抢购商品',

  //排版
  'nav': '导航',

  //营销
  'coupon': '领优惠券',
  'get-point': '领积分',
  'coupon-code': '优惠码兑换',
  'benefit-code': '特权码兑换',
  'lottery': '九宫格抽奖',
  'market-activity': '领营销奖励',
  'image-lottery': '图片抽奖',

  //其他
  'new-time': '倒计时',
  'select-gift': '快速选礼',
  'text': '文本',
  'voice': '语音',
  'new-line': '分割线',
  'special': '特殊模块',
  'paper': '壁纸下载'

  //废弃的老旧模块
  // 'image-banner': '图片轮播',
  // 'image-index': '压字图片',
  // 'list': '商品列表',
  // 'product-banner': '单品轮播',
  // 'product-horizon': '多品滑动',
  // 'program-tab': '小程序Tab',
  // 'fix-tab': '可吸顶Tab',
  // 'time': '倒计时',
  // 'store': '门店',
  // 'nofix-nav': '不吸顶导航',
  // 'big-small-image': '大小图',
  // 'voice-mod': '语音模块'

};

function getImages() {
  return images;
}

function getUrlParams() {
  var search = location.search.slice(1);
  var urlParams = _queryString2.default.parse(search);
  return urlParams;
}

function checkAppType() {
  if (app) {
    return "app";
  } else if (weixin) {
    return "m";
  } else {
    return "none";
  }
}

function isApp() {
  if (app) {
    return true;
  } else {
    return false;
  }
}

function invalidP(p) {
  return !p || p.invisible;
}

function invalid(p) {
  return !p || p.invisible || p.offShelf;
}

function createAjax(method, url) {
  var xhr = new XMLHttpRequest();
  if ('withCredentials' in xhr) {
    xhr.open(method, url, true);
  } else if (typeof XDomainRequest != 'undefined') {
    xhr = new XDomainRequest();
    xhr.open(method, url);
  } else {
    xhr = null;
  }
  return xhr;
}

function scmAjax(method, url, callback) {
  var xhr = createAjax("get", url);
  if (xhr) {
    xhr.send();
    xhr.onload = function () {
      var responseText = xhr.responseText;
      try {
        var json = JSON.parse(xhr.responseText);
        var responseCode = json.responseCode;
        if (responseCode === "000000") {
          if (json.obj) {
            if (json.obj.code === "200") {
              callback(null, json.obj.data);
            } else {
              callback(json.obj.message ? json.obj.message : STR_UNKNOWN_ERROR);
            }
          } else {
            callback(json.responseContent ? json.responseContent : STR_UNKNOWN_ERROR);
          }
        } else {
          callback(json.responseContent ? json.responseContent : STR_UNKNOWN_ERROR);
        }
      } catch (e) {
        callback(e);
      }
    };
  } else {
    callback(STR_UNKNOWN_ERROR);
  }
}

function formatModules(modules, memberTags) {
  var newMods = [];
  if (typeof modules === "string") {
    try {
      modules = JSON.parse(modules);
    } catch (e) {}
  }
  modules.forEach(function (m, index) {
    if (typeof m.data === 'string') {
      try {
        m.data = JSON.parse(m.data);
      } catch (e) {}
    }
    if (m.type === "image" || m.type === "image-index") {
      if (m.data.image && m.data.image.src) {
        var curM = getModule(m, index);
        m.showFlag = curM.showFlag;
        m.nav = curM.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "video") {
      if (m.data.poster && m.data.poster.src && m.data.src) {
        var _curM = getModule(m, index);
        m.showFlag = _curM.showFlag;
        m.nav = _curM.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "text-title" || m.type === "text-content") {
      if (m.data.text) {
        var _curM2 = getModule(m, index);
        m.showFlag = _curM2.showFlag;
        m.nav = _curM2.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "product" || m.type === "ud-product") {
      if (m.data.id) {
        var _curM3 = getModule(m, index);
        m.showFlag = _curM3.showFlag;
        m.nav = _curM3.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "image-banner" || m.type === "fix-tab" || m.type === "new-banner") {
      m.showFlag = false;
      var items = m.data.items;

      if (items && items.length > 0) {
        var newItems = [];
        items.forEach(function (i, index) {
          var image = i.image;
          if (m.type === "new-banner") {
            image = i.media;
          }
          if (image && image.src) {
            newItems.push(i);
          }
        });

        var memberItems = [];
        if (memberTags && memberTags.length && (m.type === "image-banner" || m.type === "new-banner")) {
          //需要校验新老客
          newItems && newItems.forEach(function (item) {
            if (item.customer === 'ALL' || memberTags.indexOf(item.customer) !== -1 || item.customer === 'DELINEATION' && memberTags.indexOf(item.customerCode) !== -1) {
              memberItems.push(item);
            }
          });
        } else {
          memberItems = newItems;
        }

        if (memberItems.length) {
          m.data.items = memberItems;
          var _curM4 = getModule(m, index);
          m.showFlag = _curM4.showFlag;
          m.nav = _curM4.nav;
        }
      }
    } else if (m.type === "product-banner") {
      if (m.data.ids && m.data.ids.length > 0) {
        var _curM5 = getModule(m, index);
        m.showFlag = _curM5.showFlag;
        m.nav = _curM5.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "article") {
      if (m.data.type === "image") {
        if (m.data.image && m.data.image.src) {
          var _curM6 = getModule(m, index);
          m.showFlag = _curM6.showFlag;
          m.nav = _curM6.nav;
        } else {
          m.showFlag = false;
        }
      } else if (m.data.type === "video") {
        if (m.data.source) {
          var _curM7 = getModule(m, index);
          m.showFlag = _curM7.showFlag;
          m.nav = _curM7.nav;
        } else {
          m.showFlag = false;
        }
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "categories") {
      if (m.data.items && m.data.items.length > 0) {
        var _curM8 = getModule(m, index);
        m.showFlag = _curM8.showFlag;
        m.nav = _curM8.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "list" || m.type === "shop-list" || m.type === "store-list" || m.type === "new-list") {
      if (m.data.ids && m.data.ids.length > 0) {
        var _curM9 = getModule(m, index);
        m.showFlag = _curM9.showFlag;
        m.nav = _curM9.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "nav") {
      var _curM10 = getModule(m, index);
      m.showFlag = _curM10.showFlag;
      m.nav = _curM10.nav;
    } else if (m.type === "rush-tab") {
      if (m.data.codes && m.data.codes.length > 0) {
        var _curM11 = getModule(m, index);
        m.showFlag = _curM11.showFlag;
        m.nav = _curM11.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "store") {
      if (m.data.image && m.data.image.src || m.data.storeId) {
        var _curM12 = getModule(m, index);
        m.showFlag = _curM12.showFlag;
        m.nav = _curM12.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "product-horizon") {
      if (m.data.id || m.data.ids && m.data.ids.length === 0) {
        var _curM13 = getModule(m, index);
        m.showFlag = _curM13.showFlag;
        m.nav = _curM13.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "new-image") {
      m.showFlag = false;
      var _items = m.data.items;

      if (_items && _items.length > 0) {
        var _newItems = [];
        _items.forEach(function (i, index) {
          if (i.media && i.media.src) {
            _newItems.push(i);
          }
        });

        if (memberTags && memberTags.length) {
          if (m.data.customer !== 'ALL' && m.data.customer !== 'DELINEATION' && memberTags.indexOf(m.data.customer) === -1 || m.data.customer === 'DELINEATION' && memberTags.indexOf(m.data.customerCode) === -1) {
            _newItems = [];
          }
        }

        if (_newItems.length) {
          m.data.items = _newItems;
          var _curM14 = getModule(m, index);
          m.showFlag = _curM14.showFlag;
          m.nav = _curM14.nav;
        }
      }
    } else if (m.type === "new-line") {
      if (m.data.lineHeight) {
        var _curM15 = getModule(m, index);
        m.showFlag = _curM15.showFlag;
        m.nav = _curM15.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "special") {
      var _curM16 = getModule(m, index);
      m.showFlag = _curM16.showFlag;
      m.nav = _curM16.nav;
    } else if (m.type === "lottery") {
      if (m.data.activityId) {
        var _curM17 = getModule(m, index);
        m.showFlag = _curM17.showFlag;
        m.nav = _curM17.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "select-gift") {
      m.showFlag = false;
      var _items2 = m.data.items;

      if (_items2 && _items2.length > 0) {
        var _newItems2 = [];
        _items2.forEach(function (i) {
          if (i.title) {
            _newItems2.push(i);
          }
        });

        if (_newItems2.length) {
          m.data.items = _newItems2;
          var _curM18 = getModule(m, index);
          m.showFlag = _curM18.showFlag;
          m.nav = _curM18.nav;
        }
      }
    } else if (m.type === "nofix-nav") {
      //不吸顶导航
      if (m.data.id) {
        var _curM19 = getModule(m, index);
        m.showFlag = _curM19.showFlag;
        m.nav = _curM19.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "big-small-image") {
      m.showFlag = false;
      var _items3 = m.data.items;

      if (_items3 && _items3.length > 0) {
        var _newItems3 = [];
        _items3.forEach(function (i, index) {
          if (i.bigImage && i.bigImage.src && i.smallImage && i.smallImage.src) {
            _newItems3.push(i);
          }
        });

        if (_newItems3.length) {
          m.data.items = _newItems3;
          var _curM20 = getModule(m, index);
          m.showFlag = _curM20.showFlag;
          m.nav = _curM20.nav;
        }
      }
    } else if (m.type === "coupon-code") {
      //优惠码兑换
      if (m.data.bgImage && m.data.bgImage.src) {
        var _curM21 = getModule(m, index);
        m.showFlag = _curM21.showFlag;
        m.nav = _curM21.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "new-time") {
      //新倒计时
      if (m.data.bgImage && m.data.bgImage.src) {
        var _curM22 = getModule(m, index);
        m.showFlag = _curM22.showFlag;
        m.nav = _curM22.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "market-activity") {
      //市场营销
      if (m.data.image && m.data.image.src) {
        if (!memberTags || !memberTags.length || !m.data.customerCode || memberTags.indexOf(m.data.customerCode) !== -1) {
          var _curM23 = getModule(m, index);
          m.showFlag = _curM23.showFlag;
          m.nav = _curM23.nav;
        }
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "benefit-code" || m.type === "voice") {
      //特权码兑换模块  语音模块
      if (m.data.bgImage && m.data.bgImage.src) {
        var _curM24 = getModule(m, index);
        m.showFlag = _curM24.showFlag;
        m.nav = _curM24.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "slide-product") {
      if (m.data.dataOriginType && m.data.dataOriginValue) {
        var _curM25 = getModule(m, index);
        m.showFlag = _curM25.showFlag;
        m.nav = _curM25.nav;
      } else {
        m.showFlag = false;
      }
    } else if (m.type === "buoy") {
      m.showFlag = false;
      var _m$data = m.data,
          image = _m$data.image,
          startTime = _m$data.startTime,
          endTime = _m$data.endTime;

      var curTime = new Date().getTime();

      if (image && image.src && curTime >= startTime && curTime <= endTime) {
        if (memberTags && memberTags.length) {
          if (m.data.customer === 'ALL' || memberTags.indexOf(m.data.customer) !== -1 || m.data.customer === 'DELINEATION' && memberTags.indexOf(m.data.customerCode) !== -1) {
            var _curM26 = getModule(m, index);
            m.showFlag = _curM26.showFlag;
            m.nav = _curM26.nav;
          }
        } else {
          var _curM27 = getModule(m, index);
          m.showFlag = _curM27.showFlag;
          m.nav = _curM27.nav;
        }
      }
    } else {
      var _curM28 = getModule(m, index);
      m.showFlag = _curM28.showFlag;
      // m.showFlag = true
      if (_curM28.nav) {
        m.nav = _curM28.nav;
      }
    }
    m.showFlag && newMods.push(m);
  });
  return newMods;
}

function getModule(m, index) {
  if (m.type === 'paper') {
    return {
      showFlag: false
    };
  } else {
    var nav = null;
    if (m.data.navName) {
      nav = {
        navName: m.data.navName,
        navIndex: index,
        curFlag: false
      };
    }
    return {
      showFlag: true,
      nav: nav
    };
  }
}

function getCountDown(time) {
  if (!time) {
    return null;
  }
  var endDate = new Date(time),
      _now = new Date();
  var leftTime = endDate.getTime() / 1000 - _now.getTime() / 1000,
      leftsecond = parseInt(leftTime),
      day1 = Math.floor(leftsecond / (60 * 60 * 24)),
      hour = Math.floor((leftsecond - day1 * 24 * 60 * 60) / 3600),
      minute = Math.floor((leftsecond - day1 * 24 * 60 * 60 - hour * 3600) / 60),
      second = Math.floor(leftsecond - day1 * 24 * 60 * 60 - hour * 3600 - minute * 60);
  // hour += day1 * 24
  return {
    day: day1,
    hour: hour,
    minute: minute,
    second: second
  };
}

function login(sdk) {
  return new _promise2.default(function (resolve, reject) {
    console.log(sdk, 'login sdk');
    sdk.ensureLogged().then(function (_ref3) {
      var member = _ref3.member;

      switch (sdk.adapter.env) {
        case 'app':
          _bridge2.default.getMember().then(function (member) {
            resolve(member);
          }).catch(function (err) {
            // pending = false
            reject(err);
          });
          break;
        case 'miniprogram':
          sdk.getMember().then(function (member) {
            resolve(member);
          }).catch(function (err) {
            // pending = false
            reject(err);
          });
          break;
        default:
          resolve(member);
      }
    }).catch(function (err) {
      // pending = false
      reject(err);
    });
  });
}

function colorToRgb(data, onlyColor) {
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  var sColor = data.toLowerCase();
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = "#";
      for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
      }
      sColor = sColorNew;
    }
    //处理六位的颜色值
    var sColorChange = [];
    for (var _i = 1; _i < 7; _i += 2) {
      sColorChange.push(parseInt("0x" + sColor.slice(_i, _i + 2)));
    }
    if (onlyColor) {
      return sColorChange;
    } else {
      return "RGB(" + sColorChange.join(",") + ")";
    }
  } else {
    return sColor;
  }
}

function formatProgramLink(link) {
  if (!link) {
    return '';
  }

  var path = ["pages/index/index", "pages/category-v2/index", "pages/funny/index", "pages/store/index", "pages/my/member"];

  var tabFlag = false;
  path.some(function (p) {
    if (link.indexOf(p) !== -1) {
      //存在
      tabFlag = true;
    }
  });

  return tabFlag;
}

function formatTrackDataModules(modules, pageType) {
  var indexTypes = ['image-banner', 'image-index', 'new', 'video', 'image', 'new-image', 'new-banner', 'new-line', 'new-list', 'new-time', 'buoy'];
  var checkMods = [];
  var newMods = [];

  if (pageType === 'index') {
    modules.forEach(function (m) {
      if (indexTypes.indexOf(m.type) !== -1) {
        checkMods.push(m);
      }
    });
  } else {
    checkMods = modules;
  }

  checkMods.forEach(function (m, index) {
    var type = m.type;
    var data = m.data;
    var pageObj = null;
    if (data.link) {
      pageObj = (0, _link.getLinkPageData)({
        link: data.link
      });
    }
    // console.log(pageObj, 'pageObj')
    var trackData = {
      // operation_module: getModuleName(pageType, type),
      operation_module: MODULE_MAP[type],
      operation_module_number: type === 'buoy' ? -1 : index - 0 + 1,
      module_number: 1,
      operation_name: data.trackTitle || '',
      operation_type: data.trackServiceType || '',
      skip_page_type: pageObj ? pageObj.skip_page_type : '',
      skip_page_name: pageObj ? pageObj.skip_page_name : '',
      skip_page_id: pageObj ? pageObj.skip_page_id : ''
    };

    if (type === 'image-banners' || type === 'product-banners' || type === 'new-image' || type === 'new-banner') {
      // trackData.module_number = 1
      if (data.items && data.items[0]) {
        trackData.operation_name = data.items[0].trackTitle || '';
        trackData.operation_type = data.items[0].trackServiceType || '';
      }
    }
    m.data.trackData = trackData;

    newMods.push(m);
  });
  return newMods;
}

function getModuleName(pageType, moduleType) {
  var pageName = '';
  if (pageType === 'index') {
    pageName = '首页';
  }
  if (pageType === 'article') {
    pageName = '专题页';
  }
  if (pageType === 'story') {
    pageName = '封面故事页';
  }

  var moduleName = '';
  (0, _keys2.default)(MODULE_MAP).forEach(function (key) {
    if (key === moduleType) {
      moduleName = '' + pageName + MODULE_MAP[key];
    }
  });

  return moduleName;
}

function trackAction(_ref4) {
  var trackData = _ref4.trackData,
      _ref4$pageObj = _ref4.pageObj,
      pageObj = _ref4$pageObj === undefined ? {} : _ref4$pageObj;

  var track_data = (0, _assign2.default)(trackData, pageObj);
  sa.track('OperationClick', track_data);
}

/***/ }),
/* 144 */,
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformMiniLink = transformMiniLink;

var _queryString = __webpack_require__(13);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REG = /^beastapp:\/\/(\S+)[\?\/]([\S\s]+)/i;

var route = {
  'index': '/pages/index/index',
  // 'shop': '/shop?shopId=',
  'brand': '/pages/list/index?',
  'cate': '/pages/list/index?',
  'search': '/pages/list/index?',
  // 'retail': '/retail?',
  'product': '/pages/product/detail/detail?code=',
  'article': '/pages/article/index?articleId=',
  // 'customization-list': `/customization/list?`,
  // 'big-furniture-tips': '/furniture/tips?',
  // 'shop-story': '/shop/story?',
  'group-purchase': '/pages/group-purchase/index?',
  'points-benefit': '/pages-two/points-benefit/index?',
  'points-mall': '/pages-two/points-list/index?',
  'points-list': '/pages-two/points-list/index?',
  'points-coupon': '/pages-two/points-coupon/index?',
  'points-detail': '/pages-two/points-product/detail/detail?productCode=',
  'category': '/pages/category/index?',
  'store': '/pages/store/index?',
  'cart': '/pages/cart/cart?',
  'member': '/pages/my/member?',
  'my': '/pages/my/member?',
  'member-speed': '/member/speed?',
  'flower-list': '/flower/list?'
};

var params = {
  'brand': 'brandId'
};

function transformMiniLink(_ref) {
  var _ref$link = _ref.link,
      link = _ref$link === undefined ? {} : _ref$link,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title;

  if (!link.type) {
    return '';
  }
  var url = "";
  var tabFlag = false;
  title = encodeURIComponent(title);
  switch (link.type) {
    case 'none':
      return '';
      break;
    case 'product':
      url = '/pages/product/detail/detail?code=' + link.value;
      break;
    case 'article':
      url = '/pages/article/index?articleId=' + link.value;
      break;
    case 'list':
      url = '/pages/list/index?listId=' + link.value + '&title=' + title;
      break;
    case 'new':
      url = '/pages/list/index?new=1&title=' + title;
      break;
    case 'all':
      url = '/pages/list/index?title=' + title;
      break;
    case 'oversea':
      url = '/pages/list/index?overseasOnly=true';
      break;
    case 'brand':
      url = '/pages/list/index?brandId=' + link.value + '&title=' + title;
      break;
    case 'tag':
      url = '/pages/list/index?labelId=' + link.value + '&title=' + title;
      break;
    case 'category':
      url = '/pages/list/index?categoryId=' + link.value;
      break;
    case 'discount':
      url = '/pages/list/index?param=discount&title=' + encodeURIComponent('折扣');
      break;
    case 'campaign':
      url = '/pages/list/index?campaignCode=' + link.value + '&title=' + title;
      break;
    case 'shop-story':
      url = '/pages/shop-story/index?shopId=' + link.value;
      break;
    case 'group':
      url = '/pages/group-purchase/index?productId=' + link.value;
      break;
    case 'bu':
      var query = "";
      var idArr = link.value.split("-");
      if (!idArr.length) {
        return;
      }
      if (idArr.length === 2 && idArr[1]) {
        query = 'buId=' + idArr[0] + '&categoryId=' + idArr[1] + '&title=' + title;
      } else {
        query = 'buId=' + idArr[0] + '&title=' + title;
      }

      url = '/pages/list/index?' + query;
      break;
    case 'program':
      url = link.value;
      tabFlag = formatProgramLink(url);
      break;
    case 'deeplink':
      // url = dealMLink(link.value)
      // tabFlag = formatProgramLink(url)
      url = link.value; //如果是/pages页面 要么直接跳转 要么小程序打开
      tabFlag = formatProgramLink(url);
      if (/^http/.test(url)) {
        // webview
        url = '/pages/web/index?url=' + btoa(encodeURIComponent(url));
      } else if (/^beastapp/.test(url)) {
        // webview
        // console.log(url, '#########')
        url = dealMLink(url);
        tabFlag = formatProgramLink(url);
      }
      break;
    case 'selfdefine':
      url = link.weapp;
      tabFlag = formatProgramLink(url);
      break;
  }

  console.log(url);
  if (tabFlag) {
    return {
      url: url,
      type: 'tab'
    };
  } else {
    return {
      url: url
    };
  }
}

function formatProgramLink(link) {
  if (!link) {
    return '';
  }

  var path = ["pages/index/index", "pages/category-v2/index", "pages/store/index", "pages/cart/cart", "pages/my/member/index", "pages/funny/index"];

  var tabFlag = false;
  path.some(function (p) {
    if (link.indexOf(p) !== -1) {
      //存在
      tabFlag = true;
    }
  });

  return tabFlag;

  // const FileSystemManager = wx.getFileSystemManager()
  // FileSystemManager.readFile({
  //   // filePath: '../app.json',
  //   filePath: wx.env.USER_DATA_PATH + '/app.json',
  //   success: function(res) {
  //     console.log(res, "**************")
  //   },
  //   fail: function(fail) {
  //     console.log(fail, "%%%%%%%%%%%%")
  //   }
  // })

}

function dealMLink(link) {
  console.log(link);
  if (link === 'beastapp://index') {
    link = '/pages/index/index';
  } else if (link === 'beastapp://my') {
    link = '/pages/my/member/index';
  } else {
    link = splitQue(link);
  }

  return link;
}

function splitQue(query) {
  var que = REG.exec(query);
  var type = que[1];
  var search = que[2];
  var name = '';
  // entry
  if (type === 'entry') {
    type = _queryString2.default.parse(search).name;
  }

  if (type && search) {
    que = matchQue(type, search);
  }

  return que;
}

function matchQue(type, query) {
  var que = '';
  type = type.split('/');

  var path = route[type[0]];
  var pid = params[type[0]];

  if (path) {
    que = type[1] && pid ? '' + path + pid + '=' + type[1] + '&' + query : pid ? '' + path + pid + '=' + query : '' + path + query;
  } else {
    que = '/' + type[0].replace('-', '/');
  }

  return que;
}

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

exports.getConfig = getConfig;
exports.getMember = getMember;

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getConfig() {
  return (0, _axiosMock2.default)({
    url: '/app/index/classifyData'
  }).then(function (_ref) {
    var code = _ref.code,
        data = _ref.data;

    return _promise2.default.resolve(data);
  }).catch(function (err) {
    return _promise2.default.reject(err);
  });
}

function getMember() {
  return (0, _axiosMock2.default)({
    url: '/app/member',
    method: 'GET'
  }).then(function (_ref2) {
    var code = _ref2.code,
        data = _ref2.data;

    return _promise2.default.resolve(data);
  }).catch(function (err) {
    return _promise2.default.reject(err);
  });
}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

exports.getFilter = getFilter;
exports.getMember = getMember;

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFilter(query) {
  return (0, _axiosMock2.default)({
    url: '/app/search/filter?' + query
  });
}

function getMember() {
  return (0, _axiosMock2.default)({
    url: '/app/member',
    method: 'GET'
  }).then(function (_ref) {
    var code = _ref.code,
        data = _ref.data;

    return _promise2.default.resolve(data);
  }).catch(function (err) {
    return _promise2.default.reject(err);
  });
}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(152);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    config: Object,
    showSinglePaginate: {
      default: false
    },
    paginateCls: {
      default: null
    },
    scrollbarCls: {
      type: Object,
      default: null
    },
    showPaginate: {
      type: Boolean,
      default: true
    },
    showScrollbar: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      // showPaginate: true
    };
  },
  mounted: function mounted() {
    this.swiper = new _index2.default(this.$el, this.config);
    this.$emit('swiper', this.getInstance());

    // const bullets = document.querySelectorAll('.swiper-pagination-bullet')
    // console.log(bullets, bullets.length, "swiper bullets")
    // if (!this.showSinglePaginate && bullets.length === 1) {
    //   this.showPaginate = false
    // }
  },

  methods: {
    getInstance: function getInstance() {
      // return this.swiper
      return this['swiper' + this.guid];
    }
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _create = __webpack_require__(221);

var _create2 = _interopRequireDefault(_create);

var _defineProperties = __webpack_require__(222);

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _getOwnPropertyDescriptor = __webpack_require__(223);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = __webpack_require__(27);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Swiper 4.4.6
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2018 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: December 19, 2018
 */
!function (e, t) {
    "object" == ( false ? "undefined" : (0, _typeof3.default)(exports)) && "undefined" != typeof module ? module.exports = t() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : e.Swiper = t();
}(undefined, function () {
    "use strict";

    var f = "undefined" == typeof document ? {
        body: {},
        addEventListener: function addEventListener() {},
        removeEventListener: function removeEventListener() {},
        activeElement: {
            blur: function blur() {},
            nodeName: ""
        },
        querySelector: function querySelector() {
            return null;
        },
        querySelectorAll: function querySelectorAll() {
            return [];
        },
        getElementById: function getElementById() {
            return null;
        },
        createEvent: function createEvent() {
            return {
                initEvent: function initEvent() {}
            };
        },
        createElement: function createElement() {
            return {
                children: [],
                childNodes: [],
                style: {},
                setAttribute: function setAttribute() {},
                getElementsByTagName: function getElementsByTagName() {
                    return [];
                }
            };
        },
        location: {
            hash: ""
        }
    } : document,
        J = "undefined" == typeof window ? {
        document: f,
        navigator: {
            userAgent: ""
        },
        location: {},
        history: {},
        CustomEvent: function CustomEvent() {
            return this;
        },
        addEventListener: function addEventListener() {},
        removeEventListener: function removeEventListener() {},
        getComputedStyle: function getComputedStyle() {
            return {
                getPropertyValue: function getPropertyValue() {
                    return "";
                }
            };
        },
        Image: function Image() {},
        Date: function Date() {},
        screen: {},
        setTimeout: function setTimeout() {},
        clearTimeout: function clearTimeout() {}
    } : window,
        l = function l(e) {
        for (var t = 0; t < e.length; t += 1) {
            this[t] = e[t];
        }return this.length = e.length, this;
    };
    function L(e, t) {
        var a = [],
            i = 0;
        if (e && !t && e instanceof l) return e;
        if (e) if ("string" == typeof e) {
            var s,
                r,
                n = e.trim();
            if (0 <= n.indexOf("<") && 0 <= n.indexOf(">")) {
                var o = "div";
                for (0 === n.indexOf("<li") && (o = "ul"), 0 === n.indexOf("<tr") && (o = "tbody"), 0 !== n.indexOf("<td") && 0 !== n.indexOf("<th") || (o = "tr"), 0 === n.indexOf("<tbody") && (o = "table"), 0 === n.indexOf("<option") && (o = "select"), (r = f.createElement(o)).innerHTML = n, i = 0; i < r.childNodes.length; i += 1) {
                    a.push(r.childNodes[i]);
                }
            } else for (s = t || "#" !== e[0] || e.match(/[ .<>:~]/) ? (t || f).querySelectorAll(e.trim()) : [f.getElementById(e.trim().split("#")[1])], i = 0; i < s.length; i += 1) {
                s[i] && a.push(s[i]);
            }
        } else if (e.nodeType || e === J || e === f) a.push(e);else if (0 < e.length && e[0].nodeType) for (i = 0; i < e.length; i += 1) {
            a.push(e[i]);
        }return new l(a);
    }
    function r(e) {
        for (var t = [], a = 0; a < e.length; a += 1) {
            -1 === t.indexOf(e[a]) && t.push(e[a]);
        }return t;
    }
    L.fn = l.prototype, L.Class = l, L.Dom7 = l;
    var t = {
        addClass: function addClass(e) {
            if (void 0 === e) return this;
            for (var t = e.split(" "), a = 0; a < t.length; a += 1) {
                for (var i = 0; i < this.length; i += 1) {
                    void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.add(t[a]);
                }
            }return this;
        },
        removeClass: function removeClass(e) {
            for (var t = e.split(" "), a = 0; a < t.length; a += 1) {
                for (var i = 0; i < this.length; i += 1) {
                    void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.remove(t[a]);
                }
            }return this;
        },
        hasClass: function hasClass(e) {
            return !!this[0] && this[0].classList.contains(e);
        },
        toggleClass: function toggleClass(e) {
            for (var t = e.split(" "), a = 0; a < t.length; a += 1) {
                for (var i = 0; i < this.length; i += 1) {
                    void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.toggle(t[a]);
                }
            }return this;
        },
        attr: function attr(e, t) {
            var a = arguments;
            if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;
            for (var i = 0; i < this.length; i += 1) {
                if (2 === a.length) this[i].setAttribute(e, t);else for (var s in e) {
                    this[i][s] = e[s], this[i].setAttribute(s, e[s]);
                }
            }return this;
        },
        removeAttr: function removeAttr(e) {
            for (var t = 0; t < this.length; t += 1) {
                this[t].removeAttribute(e);
            }return this;
        },
        data: function data(e, t) {
            var a;
            if (void 0 !== t) {
                for (var i = 0; i < this.length; i += 1) {
                    (a = this[i]).dom7ElementDataStorage || (a.dom7ElementDataStorage = {}), a.dom7ElementDataStorage[e] = t;
                }return this;
            }
            if (a = this[0]) {
                if (a.dom7ElementDataStorage && e in a.dom7ElementDataStorage) return a.dom7ElementDataStorage[e];
                var s = a.getAttribute("data-" + e);
                return s || void 0;
            }
        },
        transform: function transform(e) {
            for (var t = 0; t < this.length; t += 1) {
                var a = this[t].style;
                a.webkitTransform = e, a.transform = e;
            }
            return this;
        },
        transition: function transition(e) {
            "string" != typeof e && (e += "ms");
            for (var t = 0; t < this.length; t += 1) {
                var a = this[t].style;
                a.webkitTransitionDuration = e, a.transitionDuration = e;
            }
            return this;
        },
        on: function on() {
            for (var e, t = [], a = arguments.length; a--;) {
                t[a] = arguments[a];
            }var i = t[0],
                r = t[1],
                n = t[2],
                s = t[3];
            function o(e) {
                var t = e.target;
                if (t) {
                    var a = e.target.dom7EventData || [];
                    if (a.indexOf(e) < 0 && a.unshift(e), L(t).is(r)) n.apply(t, a);else for (var i = L(t).parents(), s = 0; s < i.length; s += 1) {
                        L(i[s]).is(r) && n.apply(i[s], a);
                    }
                }
            }
            function l(e) {
                var t = e && e.target && e.target.dom7EventData || [];
                t.indexOf(e) < 0 && t.unshift(e), n.apply(this, t);
            }
            "function" == typeof t[1] && (i = (e = t)[0], n = e[1], s = e[2], r = void 0), s || (s = !1);
            for (var d, p = i.split(" "), c = 0; c < this.length; c += 1) {
                var u = this[c];
                if (r) for (d = 0; d < p.length; d += 1) {
                    var h = p[d];
                    u.dom7LiveListeners || (u.dom7LiveListeners = {}), u.dom7LiveListeners[h] || (u.dom7LiveListeners[h] = []), u.dom7LiveListeners[h].push({
                        listener: n,
                        proxyListener: o
                    }), u.addEventListener(h, o, s);
                } else for (d = 0; d < p.length; d += 1) {
                    var v = p[d];
                    u.dom7Listeners || (u.dom7Listeners = {}), u.dom7Listeners[v] || (u.dom7Listeners[v] = []), u.dom7Listeners[v].push({
                        listener: n,
                        proxyListener: l
                    }), u.addEventListener(v, l, s);
                }
            }
            return this;
        },
        off: function off() {
            for (var e, t = [], a = arguments.length; a--;) {
                t[a] = arguments[a];
            }var i = t[0],
                s = t[1],
                r = t[2],
                n = t[3];
            "function" == typeof t[1] && (i = (e = t)[0], r = e[1], n = e[2], s = void 0), n || (n = !1);
            for (var o = i.split(" "), l = 0; l < o.length; l += 1) {
                for (var d = o[l], p = 0; p < this.length; p += 1) {
                    var c = this[p],
                        u = void 0;
                    if (!s && c.dom7Listeners ? u = c.dom7Listeners[d] : s && c.dom7LiveListeners && (u = c.dom7LiveListeners[d]), u && u.length) for (var h = u.length - 1; 0 <= h; h -= 1) {
                        var v = u[h];
                        r && v.listener === r ? (c.removeEventListener(d, v.proxyListener, n), u.splice(h, 1)) : r || (c.removeEventListener(d, v.proxyListener, n), u.splice(h, 1));
                    }
                }
            }return this;
        },
        trigger: function trigger() {
            for (var e = [], t = arguments.length; t--;) {
                e[t] = arguments[t];
            }for (var a = e[0].split(" "), i = e[1], s = 0; s < a.length; s += 1) {
                for (var r = a[s], n = 0; n < this.length; n += 1) {
                    var o = this[n],
                        l = void 0;
                    try {
                        l = new J.CustomEvent(r, {
                            detail: i,
                            bubbles: !0,
                            cancelable: !0
                        });
                    } catch (e) {
                        (l = f.createEvent("Event")).initEvent(r, !0, !0), l.detail = i;
                    }
                    o.dom7EventData = e.filter(function (e, t) {
                        return 0 < t;
                    }), o.dispatchEvent(l), o.dom7EventData = [], delete o.dom7EventData;
                }
            }return this;
        },
        transitionEnd: function transitionEnd(t) {
            var a,
                i = ["webkitTransitionEnd", "transitionend"],
                s = this;
            function r(e) {
                if (e.target === this) for (t.call(this, e), a = 0; a < i.length; a += 1) {
                    s.off(i[a], r);
                }
            }
            if (t) for (a = 0; a < i.length; a += 1) {
                s.on(i[a], r);
            }return this;
        },
        outerWidth: function outerWidth(e) {
            if (0 < this.length) {
                if (e) {
                    var t = this.styles();
                    return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"));
                }
                return this[0].offsetWidth;
            }
            return null;
        },
        outerHeight: function outerHeight(e) {
            if (0 < this.length) {
                if (e) {
                    var t = this.styles();
                    return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"));
                }
                return this[0].offsetHeight;
            }
            return null;
        },
        offset: function offset() {
            if (0 < this.length) {
                var e = this[0],
                    t = e.getBoundingClientRect(),
                    a = f.body,
                    i = e.clientTop || a.clientTop || 0,
                    s = e.clientLeft || a.clientLeft || 0,
                    r = e === J ? J.scrollY : e.scrollTop,
                    n = e === J ? J.scrollX : e.scrollLeft;
                return {
                    top: t.top + r - i,
                    left: t.left + n - s
                };
            }
            return null;
        },
        css: function css(e, t) {
            var a;
            if (1 === arguments.length) {
                if ("string" != typeof e) {
                    for (a = 0; a < this.length; a += 1) {
                        for (var i in e) {
                            this[a].style[i] = e[i];
                        }
                    }return this;
                }
                if (this[0]) return J.getComputedStyle(this[0], null).getPropertyValue(e);
            }
            if (2 === arguments.length && "string" == typeof e) {
                for (a = 0; a < this.length; a += 1) {
                    this[a].style[e] = t;
                }return this;
            }
            return this;
        },
        each: function each(e) {
            if (!e) return this;
            for (var t = 0; t < this.length; t += 1) {
                if (!1 === e.call(this[t], t, this[t])) return this;
            }return this;
        },
        html: function html(e) {
            if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;
            for (var t = 0; t < this.length; t += 1) {
                this[t].innerHTML = e;
            }return this;
        },
        text: function text(e) {
            if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
            for (var t = 0; t < this.length; t += 1) {
                this[t].textContent = e;
            }return this;
        },
        is: function is(e) {
            var t,
                a,
                i = this[0];
            if (!i || void 0 === e) return !1;
            if ("string" == typeof e) {
                if (i.matches) return i.matches(e);
                if (i.webkitMatchesSelector) return i.webkitMatchesSelector(e);
                if (i.msMatchesSelector) return i.msMatchesSelector(e);
                for (t = L(e), a = 0; a < t.length; a += 1) {
                    if (t[a] === i) return !0;
                }return !1;
            }
            if (e === f) return i === f;
            if (e === J) return i === J;
            if (e.nodeType || e instanceof l) {
                for (t = e.nodeType ? [e] : e, a = 0; a < t.length; a += 1) {
                    if (t[a] === i) return !0;
                }return !1;
            }
            return !1;
        },
        index: function index() {
            var e,
                t = this[0];
            if (t) {
                for (e = 0; null !== (t = t.previousSibling);) {
                    1 === t.nodeType && (e += 1);
                }return e;
            }
        },
        eq: function eq(e) {
            if (void 0 === e) return this;
            var t,
                a = this.length;
            return new l(a - 1 < e ? [] : e < 0 ? (t = a + e) < 0 ? [] : [this[t]] : [this[e]]);
        },
        append: function append() {
            for (var e, t = [], a = arguments.length; a--;) {
                t[a] = arguments[a];
            }for (var i = 0; i < t.length; i += 1) {
                e = t[i];
                for (var s = 0; s < this.length; s += 1) {
                    if ("string" == typeof e) {
                        var r = f.createElement("div");
                        for (r.innerHTML = e; r.firstChild;) {
                            this[s].appendChild(r.firstChild);
                        }
                    } else if (e instanceof l) for (var n = 0; n < e.length; n += 1) {
                        this[s].appendChild(e[n]);
                    } else this[s].appendChild(e);
                }
            }
            return this;
        },
        prepend: function prepend(e) {
            var t, a;
            for (t = 0; t < this.length; t += 1) {
                if ("string" == typeof e) {
                    var i = f.createElement("div");
                    for (i.innerHTML = e, a = i.childNodes.length - 1; 0 <= a; a -= 1) {
                        this[t].insertBefore(i.childNodes[a], this[t].childNodes[0]);
                    }
                } else if (e instanceof l) for (a = 0; a < e.length; a += 1) {
                    this[t].insertBefore(e[a], this[t].childNodes[0]);
                } else this[t].insertBefore(e, this[t].childNodes[0]);
            }return this;
        },
        next: function next(e) {
            return 0 < this.length ? e ? this[0].nextElementSibling && L(this[0].nextElementSibling).is(e) ? new l([this[0].nextElementSibling]) : new l([]) : this[0].nextElementSibling ? new l([this[0].nextElementSibling]) : new l([]) : new l([]);
        },
        nextAll: function nextAll(e) {
            var t = [],
                a = this[0];
            if (!a) return new l([]);
            for (; a.nextElementSibling;) {
                var i = a.nextElementSibling;
                e ? L(i).is(e) && t.push(i) : t.push(i), a = i;
            }
            return new l(t);
        },
        prev: function prev(e) {
            if (0 < this.length) {
                var t = this[0];
                return e ? t.previousElementSibling && L(t.previousElementSibling).is(e) ? new l([t.previousElementSibling]) : new l([]) : t.previousElementSibling ? new l([t.previousElementSibling]) : new l([]);
            }
            return new l([]);
        },
        prevAll: function prevAll(e) {
            var t = [],
                a = this[0];
            if (!a) return new l([]);
            for (; a.previousElementSibling;) {
                var i = a.previousElementSibling;
                e ? L(i).is(e) && t.push(i) : t.push(i), a = i;
            }
            return new l(t);
        },
        parent: function parent(e) {
            for (var t = [], a = 0; a < this.length; a += 1) {
                null !== this[a].parentNode && (e ? L(this[a].parentNode).is(e) && t.push(this[a].parentNode) : t.push(this[a].parentNode));
            }return L(r(t));
        },
        parents: function parents(e) {
            for (var t = [], a = 0; a < this.length; a += 1) {
                for (var i = this[a].parentNode; i;) {
                    e ? L(i).is(e) && t.push(i) : t.push(i), i = i.parentNode;
                }
            }return L(r(t));
        },
        closest: function closest(e) {
            var t = this;
            return void 0 === e ? new l([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
        },
        find: function find(e) {
            for (var t = [], a = 0; a < this.length; a += 1) {
                for (var i = this[a].querySelectorAll(e), s = 0; s < i.length; s += 1) {
                    t.push(i[s]);
                }
            }return new l(t);
        },
        children: function children(e) {
            for (var t = [], a = 0; a < this.length; a += 1) {
                for (var i = this[a].childNodes, s = 0; s < i.length; s += 1) {
                    e ? 1 === i[s].nodeType && L(i[s]).is(e) && t.push(i[s]) : 1 === i[s].nodeType && t.push(i[s]);
                }
            }return new l(r(t));
        },
        remove: function remove() {
            for (var e = 0; e < this.length; e += 1) {
                this[e].parentNode && this[e].parentNode.removeChild(this[e]);
            }return this;
        },
        add: function add() {
            for (var e = [], t = arguments.length; t--;) {
                e[t] = arguments[t];
            }var a, i;
            for (a = 0; a < e.length; a += 1) {
                var s = L(e[a]);
                for (i = 0; i < s.length; i += 1) {
                    this[this.length] = s[i], this.length += 1;
                }
            }
            return this;
        },
        styles: function styles() {
            return this[0] ? J.getComputedStyle(this[0], null) : {};
        }
    };
    (0, _keys2.default)(t).forEach(function (e) {
        L.fn[e] = t[e];
    });
    var e,
        a,
        i,
        ee = {
        deleteProps: function deleteProps(e) {
            var t = e;
            (0, _keys2.default)(t).forEach(function (e) {
                try {
                    t[e] = null;
                } catch (e) {}
                try {
                    delete t[e];
                } catch (e) {}
            });
        },
        nextTick: function nextTick(e, t) {
            return void 0 === t && (t = 0), setTimeout(e, t);
        },
        now: function now() {
            return Date.now();
        },
        getTranslate: function getTranslate(e, t) {
            var a, i, s;
            void 0 === t && (t = "x");
            var r = J.getComputedStyle(e, null);
            return J.WebKitCSSMatrix ? (6 < (i = r.transform || r.webkitTransform).split(",").length && (i = i.split(", ").map(function (e) {
                return e.replace(",", ".");
            }).join(", ")), s = new J.WebKitCSSMatrix("none" === i ? "" : i)) : a = (s = r.MozTransform || r.OTransform || r.MsTransform || r.msTransform || r.transform || r.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","), "x" === t && (i = J.WebKitCSSMatrix ? s.m41 : 16 === a.length ? parseFloat(a[12]) : parseFloat(a[4])), "y" === t && (i = J.WebKitCSSMatrix ? s.m42 : 16 === a.length ? parseFloat(a[13]) : parseFloat(a[5])), i || 0;
        },
        parseUrlQuery: function parseUrlQuery(e) {
            var t,
                a,
                i,
                s,
                r = {},
                n = e || J.location.href;
            if ("string" == typeof n && n.length) for (s = (a = (n = -1 < n.indexOf("?") ? n.replace(/\S*\?/, "") : "").split("&").filter(function (e) {
                return "" !== e;
            })).length, t = 0; t < s; t += 1) {
                i = a[t].replace(/#\S+/g, "").split("="), r[decodeURIComponent(i[0])] = void 0 === i[1] ? void 0 : decodeURIComponent(i[1]) || "";
            }return r;
        },
        isObject: function isObject(e) {
            return "object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) && null !== e && e.constructor && e.constructor === Object;
        },
        extend: function extend() {
            for (var e = [], t = arguments.length; t--;) {
                e[t] = arguments[t];
            }for (var a = Object(e[0]), i = 1; i < e.length; i += 1) {
                var s = e[i];
                if (null != s) for (var r = (0, _keys2.default)(Object(s)), n = 0, o = r.length; n < o; n += 1) {
                    var l = r[n],
                        d = (0, _getOwnPropertyDescriptor2.default)(s, l);
                    void 0 !== d && d.enumerable && (ee.isObject(a[l]) && ee.isObject(s[l]) ? ee.extend(a[l], s[l]) : !ee.isObject(a[l]) && ee.isObject(s[l]) ? (a[l] = {}, ee.extend(a[l], s[l])) : a[l] = s[l]);
                }
            }
            return a;
        }
    },
        te = (i = f.createElement("div"), {
        touch: J.Modernizr && !0 === J.Modernizr.touch || !!(0 < J.navigator.maxTouchPoints || "ontouchstart" in J || J.DocumentTouch && f instanceof J.DocumentTouch),
        pointerEvents: !!(J.navigator.pointerEnabled || J.PointerEvent || "maxTouchPoints" in J.navigator),
        prefixedPointerEvents: !!J.navigator.msPointerEnabled,
        transition: (a = i.style, "transition" in a || "webkitTransition" in a || "MozTransition" in a),
        transforms3d: J.Modernizr && !0 === J.Modernizr.csstransforms3d || (e = i.style, "webkitPerspective" in e || "MozPerspective" in e || "OPerspective" in e || "MsPerspective" in e || "perspective" in e),
        flexbox: function () {
            for (var e = i.style, t = "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" "), a = 0; a < t.length; a += 1) {
                if (t[a] in e) return !0;
            }return !1;
        }(),
        observer: "MutationObserver" in J || "WebkitMutationObserver" in J,
        passiveListener: function () {
            var e = !1;
            try {
                var t = Object.defineProperty({}, "passive", {
                    get: function get() {
                        e = !0;
                    }
                });
                J.addEventListener("testPassiveListener", null, t);
            } catch (e) {}
            return e;
        }(),
        gestures: "ongesturestart" in J
    }),
        s = function s(e) {
        void 0 === e && (e = {});
        var t = this;
        t.params = e, t.eventsListeners = {}, t.params && t.params.on && (0, _keys2.default)(t.params.on).forEach(function (e) {
            t.on(e, t.params.on[e]);
        });
    },
        n = {
        components: {
            configurable: !0
        }
    };
    s.prototype.on = function (e, t, a) {
        var i = this;
        if ("function" != typeof t) return i;
        var s = a ? "unshift" : "push";
        return e.split(" ").forEach(function (e) {
            i.eventsListeners[e] || (i.eventsListeners[e] = []), i.eventsListeners[e][s](t);
        }), i;
    }, s.prototype.once = function (i, s, e) {
        var r = this;
        if ("function" != typeof s) return r;
        return r.on(i, function e() {
            for (var t = [], a = arguments.length; a--;) {
                t[a] = arguments[a];
            }s.apply(r, t), r.off(i, e);
        }, e);
    }, s.prototype.off = function (e, i) {
        var s = this;
        return s.eventsListeners && e.split(" ").forEach(function (a) {
            void 0 === i ? s.eventsListeners[a] = [] : s.eventsListeners[a] && s.eventsListeners[a].length && s.eventsListeners[a].forEach(function (e, t) {
                e === i && s.eventsListeners[a].splice(t, 1);
            });
        }), s;
    }, s.prototype.emit = function () {
        for (var e = [], t = arguments.length; t--;) {
            e[t] = arguments[t];
        }var a,
            i,
            s,
            r = this;
        return r.eventsListeners && ("string" == typeof e[0] || Array.isArray(e[0]) ? (a = e[0], i = e.slice(1, e.length), s = r) : (a = e[0].events, i = e[0].data, s = e[0].context || r), (Array.isArray(a) ? a : a.split(" ")).forEach(function (e) {
            if (r.eventsListeners && r.eventsListeners[e]) {
                var t = [];
                r.eventsListeners[e].forEach(function (e) {
                    t.push(e);
                }), t.forEach(function (e) {
                    e.apply(s, i);
                });
            }
        })), r;
    }, s.prototype.useModulesParams = function (a) {
        var i = this;
        i.modules && (0, _keys2.default)(i.modules).forEach(function (e) {
            var t = i.modules[e];
            t.params && ee.extend(a, t.params);
        });
    }, s.prototype.useModules = function (i) {
        void 0 === i && (i = {});
        var s = this;
        s.modules && (0, _keys2.default)(s.modules).forEach(function (e) {
            var a = s.modules[e],
                t = i[e] || {};
            a.instance && (0, _keys2.default)(a.instance).forEach(function (e) {
                var t = a.instance[e];
                s[e] = "function" == typeof t ? t.bind(s) : t;
            }), a.on && s.on && (0, _keys2.default)(a.on).forEach(function (e) {
                s.on(e, a.on[e]);
            }), a.create && a.create.bind(s)(t);
        });
    }, n.components.set = function (e) {
        this.use && this.use(e);
    }, s.installModule = function (t) {
        for (var e = [], a = arguments.length - 1; 0 < a--;) {
            e[a] = arguments[a + 1];
        }var i = this;
        i.prototype.modules || (i.prototype.modules = {});
        var s = t.name || (0, _keys2.default)(i.prototype.modules).length + "_" + ee.now();
        return (i.prototype.modules[s] = t).proto && (0, _keys2.default)(t.proto).forEach(function (e) {
            i.prototype[e] = t.proto[e];
        }), t.static && (0, _keys2.default)(t.static).forEach(function (e) {
            i[e] = t.static[e];
        }), t.install && t.install.apply(i, e), i;
    }, s.use = function (e) {
        for (var t = [], a = arguments.length - 1; 0 < a--;) {
            t[a] = arguments[a + 1];
        }var i = this;
        return Array.isArray(e) ? (e.forEach(function (e) {
            return i.installModule(e);
        }), i) : i.installModule.apply(i, [e].concat(t));
    }, (0, _defineProperties2.default)(s, n);
    var o = {
        updateSize: function updateSize() {
            var e,
                t,
                a = this,
                i = a.$el;
            e = void 0 !== a.params.width ? a.params.width : i[0].clientWidth, t = void 0 !== a.params.height ? a.params.height : i[0].clientHeight, 0 === e && a.isHorizontal() || 0 === t && a.isVertical() || (e = e - parseInt(i.css("padding-left"), 10) - parseInt(i.css("padding-right"), 10), t = t - parseInt(i.css("padding-top"), 10) - parseInt(i.css("padding-bottom"), 10), ee.extend(a, {
                width: e,
                height: t,
                size: a.isHorizontal() ? e : t
            }));
        },
        updateSlides: function updateSlides() {
            var e = this,
                t = e.params,
                a = e.$wrapperEl,
                i = e.size,
                s = e.rtlTranslate,
                r = e.wrongRTL,
                n = e.virtual && t.virtual.enabled,
                o = n ? e.virtual.slides.length : e.slides.length,
                l = a.children("." + e.params.slideClass),
                d = n ? e.virtual.slides.length : l.length,
                p = [],
                c = [],
                u = [],
                h = t.slidesOffsetBefore;
            "function" == typeof h && (h = t.slidesOffsetBefore.call(e));
            var v = t.slidesOffsetAfter;
            "function" == typeof v && (v = t.slidesOffsetAfter.call(e));
            var f = e.snapGrid.length,
                m = e.snapGrid.length,
                g = t.spaceBetween,
                b = -h,
                w = 0,
                y = 0;
            if (void 0 !== i) {
                var x, T;
                "string" == typeof g && 0 <= g.indexOf("%") && (g = parseFloat(g.replace("%", "")) / 100 * i), e.virtualSize = -g, s ? l.css({
                    marginLeft: "",
                    marginTop: ""
                }) : l.css({
                    marginRight: "",
                    marginBottom: ""
                }), 1 < t.slidesPerColumn && (x = Math.floor(d / t.slidesPerColumn) === d / e.params.slidesPerColumn ? d : Math.ceil(d / t.slidesPerColumn) * t.slidesPerColumn, "auto" !== t.slidesPerView && "row" === t.slidesPerColumnFill && (x = Math.max(x, t.slidesPerView * t.slidesPerColumn)));
                for (var E, S = t.slidesPerColumn, C = x / S, M = Math.floor(d / t.slidesPerColumn), k = 0; k < d; k += 1) {
                    T = 0;
                    var P = l.eq(k);
                    if (1 < t.slidesPerColumn) {
                        var z = void 0,
                            $ = void 0,
                            L = void 0;
                        "column" === t.slidesPerColumnFill ? (L = k - ($ = Math.floor(k / S)) * S, (M < $ || $ === M && L === S - 1) && S <= (L += 1) && (L = 0, $ += 1), z = $ + L * x / S, P.css({
                            "-webkit-box-ordinal-group": z,
                            "-moz-box-ordinal-group": z,
                            "-ms-flex-order": z,
                            "-webkit-order": z,
                            order: z
                        })) : $ = k - (L = Math.floor(k / C)) * C, P.css("margin-" + (e.isHorizontal() ? "top" : "left"), 0 !== L && t.spaceBetween && t.spaceBetween + "px").attr("data-swiper-column", $).attr("data-swiper-row", L);
                    }
                    if ("none" !== P.css("display")) {
                        if ("auto" === t.slidesPerView) {
                            var I = J.getComputedStyle(P[0], null),
                                D = P[0].style.transform,
                                O = P[0].style.webkitTransform;
                            if (D && (P[0].style.transform = "none"), O && (P[0].style.webkitTransform = "none"), t.roundLengths) T = e.isHorizontal() ? P.outerWidth(!0) : P.outerHeight(!0);else if (e.isHorizontal()) {
                                var A = parseFloat(I.getPropertyValue("width")),
                                    N = parseFloat(I.getPropertyValue("padding-left")),
                                    H = parseFloat(I.getPropertyValue("padding-right")),
                                    G = parseFloat(I.getPropertyValue("margin-left")),
                                    B = parseFloat(I.getPropertyValue("margin-right")),
                                    X = I.getPropertyValue("box-sizing");
                                T = X && "border-box" === X ? A + G + B : A + N + H + G + B;
                            } else {
                                var Y = parseFloat(I.getPropertyValue("height")),
                                    V = parseFloat(I.getPropertyValue("padding-top")),
                                    F = parseFloat(I.getPropertyValue("padding-bottom")),
                                    R = parseFloat(I.getPropertyValue("margin-top")),
                                    q = parseFloat(I.getPropertyValue("margin-bottom")),
                                    W = I.getPropertyValue("box-sizing");
                                T = W && "border-box" === W ? Y + R + q : Y + V + F + R + q;
                            }
                            D && (P[0].style.transform = D), O && (P[0].style.webkitTransform = O), t.roundLengths && (T = Math.floor(T));
                        } else T = (i - (t.slidesPerView - 1) * g) / t.slidesPerView, t.roundLengths && (T = Math.floor(T)), l[k] && (e.isHorizontal() ? l[k].style.width = T + "px" : l[k].style.height = T + "px");
                        l[k] && (l[k].swiperSlideSize = T), u.push(T), t.centeredSlides ? (b = b + T / 2 + w / 2 + g, 0 === w && 0 !== k && (b = b - i / 2 - g), 0 === k && (b = b - i / 2 - g), Math.abs(b) < .001 && (b = 0), t.roundLengths && (b = Math.floor(b)), y % t.slidesPerGroup == 0 && p.push(b), c.push(b)) : (t.roundLengths && (b = Math.floor(b)), y % t.slidesPerGroup == 0 && p.push(b), c.push(b), b = b + T + g), e.virtualSize += T + g, w = T, y += 1;
                    }
                }
                if (e.virtualSize = Math.max(e.virtualSize, i) + v, s && r && ("slide" === t.effect || "coverflow" === t.effect) && a.css({
                    width: e.virtualSize + t.spaceBetween + "px"
                }), te.flexbox && !t.setWrapperSize || (e.isHorizontal() ? a.css({
                    width: e.virtualSize + t.spaceBetween + "px"
                }) : a.css({
                    height: e.virtualSize + t.spaceBetween + "px"
                })), 1 < t.slidesPerColumn && (e.virtualSize = (T + t.spaceBetween) * x, e.virtualSize = Math.ceil(e.virtualSize / t.slidesPerColumn) - t.spaceBetween, e.isHorizontal() ? a.css({
                    width: e.virtualSize + t.spaceBetween + "px"
                }) : a.css({
                    height: e.virtualSize + t.spaceBetween + "px"
                }), t.centeredSlides)) {
                    E = [];
                    for (var j = 0; j < p.length; j += 1) {
                        var U = p[j];
                        t.roundLengths && (U = Math.floor(U)), p[j] < e.virtualSize + p[0] && E.push(U);
                    }
                    p = E;
                }
                if (!t.centeredSlides) {
                    E = [];
                    for (var K = 0; K < p.length; K += 1) {
                        var _ = p[K];
                        t.roundLengths && (_ = Math.floor(_)), p[K] <= e.virtualSize - i && E.push(_);
                    }
                    p = E, 1 < Math.floor(e.virtualSize - i) - Math.floor(p[p.length - 1]) && p.push(e.virtualSize - i);
                }
                if (0 === p.length && (p = [0]), 0 !== t.spaceBetween && (e.isHorizontal() ? s ? l.css({
                    marginLeft: g + "px"
                }) : l.css({
                    marginRight: g + "px"
                }) : l.css({
                    marginBottom: g + "px"
                })), t.centerInsufficientSlides) {
                    var Z = 0;
                    if (u.forEach(function (e) {
                        Z += e + (t.spaceBetween ? t.spaceBetween : 0);
                    }), (Z -= t.spaceBetween) < i) {
                        var Q = (i - Z) / 2;
                        p.forEach(function (e, t) {
                            p[t] = e - Q;
                        }), c.forEach(function (e, t) {
                            c[t] = e + Q;
                        });
                    }
                }
                ee.extend(e, {
                    slides: l,
                    snapGrid: p,
                    slidesGrid: c,
                    slidesSizesGrid: u
                }), d !== o && e.emit("slidesLengthChange"), p.length !== f && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), c.length !== m && e.emit("slidesGridLengthChange"), (t.watchSlidesProgress || t.watchSlidesVisibility) && e.updateSlidesOffset();
            }
        },
        updateAutoHeight: function updateAutoHeight(e) {
            var t,
                a = this,
                i = [],
                s = 0;
            if ("number" == typeof e ? a.setTransition(e) : !0 === e && a.setTransition(a.params.speed), "auto" !== a.params.slidesPerView && 1 < a.params.slidesPerView) for (t = 0; t < Math.ceil(a.params.slidesPerView); t += 1) {
                var r = a.activeIndex + t;
                if (r > a.slides.length) break;
                i.push(a.slides.eq(r)[0]);
            } else i.push(a.slides.eq(a.activeIndex)[0]);
            for (t = 0; t < i.length; t += 1) {
                if (void 0 !== i[t]) {
                    var n = i[t].offsetHeight;
                    s = s < n ? n : s;
                }
            }s && a.$wrapperEl.css("height", s + "px");
        },
        updateSlidesOffset: function updateSlidesOffset() {
            for (var e = this.slides, t = 0; t < e.length; t += 1) {
                e[t].swiperSlideOffset = this.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop;
            }
        },
        updateSlidesProgress: function updateSlidesProgress(e) {
            void 0 === e && (e = this && this.translate || 0);
            var t = this,
                a = t.params,
                i = t.slides,
                s = t.rtlTranslate;
            if (0 !== i.length) {
                void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
                var r = -e;
                s && (r = e), i.removeClass(a.slideVisibleClass), t.visibleSlidesIndexes = [], t.visibleSlides = [];
                for (var n = 0; n < i.length; n += 1) {
                    var o = i[n],
                        l = (r + (a.centeredSlides ? t.minTranslate() : 0) - o.swiperSlideOffset) / (o.swiperSlideSize + a.spaceBetween);
                    if (a.watchSlidesVisibility) {
                        var d = -(r - o.swiperSlideOffset),
                            p = d + t.slidesSizesGrid[n];
                        (0 <= d && d < t.size || 0 < p && p <= t.size || d <= 0 && p >= t.size) && (t.visibleSlides.push(o), t.visibleSlidesIndexes.push(n), i.eq(n).addClass(a.slideVisibleClass));
                    }
                    o.progress = s ? -l : l;
                }
                t.visibleSlides = L(t.visibleSlides);
            }
        },
        updateProgress: function updateProgress(e) {
            void 0 === e && (e = this && this.translate || 0);
            var t = this,
                a = t.params,
                i = t.maxTranslate() - t.minTranslate(),
                s = t.progress,
                r = t.isBeginning,
                n = t.isEnd,
                o = r,
                l = n;
            0 === i ? n = r = !(s = 0) : (r = (s = (e - t.minTranslate()) / i) <= 0, n = 1 <= s), ee.extend(t, {
                progress: s,
                isBeginning: r,
                isEnd: n
            }), (a.watchSlidesProgress || a.watchSlidesVisibility) && t.updateSlidesProgress(e), r && !o && t.emit("reachBeginning toEdge"), n && !l && t.emit("reachEnd toEdge"), (o && !r || l && !n) && t.emit("fromEdge"), t.emit("progress", s);
        },
        updateSlidesClasses: function updateSlidesClasses() {
            var e,
                t = this,
                a = t.slides,
                i = t.params,
                s = t.$wrapperEl,
                r = t.activeIndex,
                n = t.realIndex,
                o = t.virtual && i.virtual.enabled;
            a.removeClass(i.slideActiveClass + " " + i.slideNextClass + " " + i.slidePrevClass + " " + i.slideDuplicateActiveClass + " " + i.slideDuplicateNextClass + " " + i.slideDuplicatePrevClass), (e = o ? t.$wrapperEl.find("." + i.slideClass + '[data-swiper-slide-index="' + r + '"]') : a.eq(r)).addClass(i.slideActiveClass), i.loop && (e.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + n + '"]').addClass(i.slideDuplicateActiveClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + n + '"]').addClass(i.slideDuplicateActiveClass));
            var l = e.nextAll("." + i.slideClass).eq(0).addClass(i.slideNextClass);
            i.loop && 0 === l.length && (l = a.eq(0)).addClass(i.slideNextClass);
            var d = e.prevAll("." + i.slideClass).eq(0).addClass(i.slidePrevClass);
            i.loop && 0 === d.length && (d = a.eq(-1)).addClass(i.slidePrevClass), i.loop && (l.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass), d.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + d.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + d.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass));
        },
        updateActiveIndex: function updateActiveIndex(e) {
            var t,
                a = this,
                i = a.rtlTranslate ? a.translate : -a.translate,
                s = a.slidesGrid,
                r = a.snapGrid,
                n = a.params,
                o = a.activeIndex,
                l = a.realIndex,
                d = a.snapIndex,
                p = e;
            if (void 0 === p) {
                for (var c = 0; c < s.length; c += 1) {
                    void 0 !== s[c + 1] ? i >= s[c] && i < s[c + 1] - (s[c + 1] - s[c]) / 2 ? p = c : i >= s[c] && i < s[c + 1] && (p = c + 1) : i >= s[c] && (p = c);
                }n.normalizeSlideIndex && (p < 0 || void 0 === p) && (p = 0);
            }
            if ((t = 0 <= r.indexOf(i) ? r.indexOf(i) : Math.floor(p / n.slidesPerGroup)) >= r.length && (t = r.length - 1), p !== o) {
                var u = parseInt(a.slides.eq(p).attr("data-swiper-slide-index") || p, 10);
                ee.extend(a, {
                    snapIndex: t,
                    realIndex: u,
                    previousIndex: o,
                    activeIndex: p
                }), a.emit("activeIndexChange"), a.emit("snapIndexChange"), l !== u && a.emit("realIndexChange"), a.emit("slideChange");
            } else t !== d && (a.snapIndex = t, a.emit("snapIndexChange"));
        },
        updateClickedSlide: function updateClickedSlide(e) {
            var t = this,
                a = t.params,
                i = L(e.target).closest("." + a.slideClass)[0],
                s = !1;
            if (i) for (var r = 0; r < t.slides.length; r += 1) {
                t.slides[r] === i && (s = !0);
            }if (!i || !s) return t.clickedSlide = void 0, void (t.clickedIndex = void 0);
            t.clickedSlide = i, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(L(i).attr("data-swiper-slide-index"), 10) : t.clickedIndex = L(i).index(), a.slideToClickedSlide && void 0 !== t.clickedIndex && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
        }
    };
    var d = {
        getTranslate: function getTranslate(e) {
            void 0 === e && (e = this.isHorizontal() ? "x" : "y");
            var t = this.params,
                a = this.rtlTranslate,
                i = this.translate,
                s = this.$wrapperEl;
            if (t.virtualTranslate) return a ? -i : i;
            var r = ee.getTranslate(s[0], e);
            return a && (r = -r), r || 0;
        },
        setTranslate: function setTranslate(e, t) {
            var a = this,
                i = a.rtlTranslate,
                s = a.params,
                r = a.$wrapperEl,
                n = a.progress,
                o = 0,
                l = 0;
            a.isHorizontal() ? o = i ? -e : e : l = e, s.roundLengths && (o = Math.floor(o), l = Math.floor(l)), s.virtualTranslate || (te.transforms3d ? r.transform("translate3d(" + o + "px, " + l + "px, 0px)") : r.transform("translate(" + o + "px, " + l + "px)")), a.previousTranslate = a.translate, a.translate = a.isHorizontal() ? o : l;
            var d = a.maxTranslate() - a.minTranslate();
            (0 === d ? 0 : (e - a.minTranslate()) / d) !== n && a.updateProgress(e), a.emit("setTranslate", a.translate, t);
        },
        minTranslate: function minTranslate() {
            return -this.snapGrid[0];
        },
        maxTranslate: function maxTranslate() {
            return -this.snapGrid[this.snapGrid.length - 1];
        }
    };
    var p = {
        setTransition: function setTransition(e, t) {
            this.$wrapperEl.transition(e), this.emit("setTransition", e, t);
        },
        transitionStart: function transitionStart(e, t) {
            void 0 === e && (e = !0);
            var a = this,
                i = a.activeIndex,
                s = a.params,
                r = a.previousIndex;
            s.autoHeight && a.updateAutoHeight();
            var n = t;
            if (n || (n = r < i ? "next" : i < r ? "prev" : "reset"), a.emit("transitionStart"), e && i !== r) {
                if ("reset" === n) return void a.emit("slideResetTransitionStart");
                a.emit("slideChangeTransitionStart"), "next" === n ? a.emit("slideNextTransitionStart") : a.emit("slidePrevTransitionStart");
            }
        },
        transitionEnd: function transitionEnd(e, t) {
            void 0 === e && (e = !0);
            var a = this,
                i = a.activeIndex,
                s = a.previousIndex;
            a.animating = !1, a.setTransition(0);
            var r = t;
            if (r || (r = s < i ? "next" : i < s ? "prev" : "reset"), a.emit("transitionEnd"), e && i !== s) {
                if ("reset" === r) return void a.emit("slideResetTransitionEnd");
                a.emit("slideChangeTransitionEnd"), "next" === r ? a.emit("slideNextTransitionEnd") : a.emit("slidePrevTransitionEnd");
            }
        }
    };
    var c = {
        slideTo: function slideTo(e, t, a, i) {
            void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === a && (a = !0);
            var s = this,
                r = e;
            r < 0 && (r = 0);
            var n = s.params,
                o = s.snapGrid,
                l = s.slidesGrid,
                d = s.previousIndex,
                p = s.activeIndex,
                c = s.rtlTranslate;
            if (s.animating && n.preventInteractionOnTransition) return !1;
            var u = Math.floor(r / n.slidesPerGroup);
            u >= o.length && (u = o.length - 1), (p || n.initialSlide || 0) === (d || 0) && a && s.emit("beforeSlideChangeStart");
            var h,
                v = -o[u];
            if (s.updateProgress(v), n.normalizeSlideIndex) for (var f = 0; f < l.length; f += 1) {
                -Math.floor(100 * v) >= Math.floor(100 * l[f]) && (r = f);
            }if (s.initialized && r !== p) {
                if (!s.allowSlideNext && v < s.translate && v < s.minTranslate()) return !1;
                if (!s.allowSlidePrev && v > s.translate && v > s.maxTranslate() && (p || 0) !== r) return !1;
            }
            return h = p < r ? "next" : r < p ? "prev" : "reset", c && -v === s.translate || !c && v === s.translate ? (s.updateActiveIndex(r), n.autoHeight && s.updateAutoHeight(), s.updateSlidesClasses(), "slide" !== n.effect && s.setTranslate(v), "reset" !== h && (s.transitionStart(a, h), s.transitionEnd(a, h)), !1) : (0 !== t && te.transition ? (s.setTransition(t), s.setTranslate(v), s.updateActiveIndex(r), s.updateSlidesClasses(), s.emit("beforeTransitionStart", t, i), s.transitionStart(a, h), s.animating || (s.animating = !0, s.onSlideToWrapperTransitionEnd || (s.onSlideToWrapperTransitionEnd = function (e) {
                s && !s.destroyed && e.target === this && (s.$wrapperEl[0].removeEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].removeEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd), s.onSlideToWrapperTransitionEnd = null, delete s.onSlideToWrapperTransitionEnd, s.transitionEnd(a, h));
            }), s.$wrapperEl[0].addEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].addEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd))) : (s.setTransition(0), s.setTranslate(v), s.updateActiveIndex(r), s.updateSlidesClasses(), s.emit("beforeTransitionStart", t, i), s.transitionStart(a, h), s.transitionEnd(a, h)), !0);
        },
        slideToLoop: function slideToLoop(e, t, a, i) {
            void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === a && (a = !0);
            var s = e;
            return this.params.loop && (s += this.loopedSlides), this.slideTo(s, t, a, i);
        },
        slideNext: function slideNext(e, t, a) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var i = this,
                s = i.params,
                r = i.animating;
            return s.loop ? !r && (i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft, i.slideTo(i.activeIndex + s.slidesPerGroup, e, t, a)) : i.slideTo(i.activeIndex + s.slidesPerGroup, e, t, a);
        },
        slidePrev: function slidePrev(e, t, a) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var i = this,
                s = i.params,
                r = i.animating,
                n = i.snapGrid,
                o = i.slidesGrid,
                l = i.rtlTranslate;
            if (s.loop) {
                if (r) return !1;
                i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft;
            }
            function d(e) {
                return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
            }
            var p,
                c = d(l ? i.translate : -i.translate),
                u = n.map(function (e) {
                return d(e);
            }),
                h = (o.map(function (e) {
                return d(e);
            }), n[u.indexOf(c)], n[u.indexOf(c) - 1]);
            return void 0 !== h && (p = o.indexOf(h)) < 0 && (p = i.activeIndex - 1), i.slideTo(p, e, t, a);
        },
        slideReset: function slideReset(e, t, a) {
            return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, a);
        },
        slideToClosest: function slideToClosest(e, t, a) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var i = this,
                s = i.activeIndex,
                r = Math.floor(s / i.params.slidesPerGroup);
            if (r < i.snapGrid.length - 1) {
                var n = i.rtlTranslate ? i.translate : -i.translate,
                    o = i.snapGrid[r];
                (i.snapGrid[r + 1] - o) / 2 < n - o && (s = i.params.slidesPerGroup);
            }
            return i.slideTo(s, e, t, a);
        },
        slideToClickedSlide: function slideToClickedSlide() {
            var e,
                t = this,
                a = t.params,
                i = t.$wrapperEl,
                s = "auto" === a.slidesPerView ? t.slidesPerViewDynamic() : a.slidesPerView,
                r = t.clickedIndex;
            if (a.loop) {
                if (t.animating) return;
                e = parseInt(L(t.clickedSlide).attr("data-swiper-slide-index"), 10), a.centeredSlides ? r < t.loopedSlides - s / 2 || r > t.slides.length - t.loopedSlides + s / 2 ? (t.loopFix(), r = i.children("." + a.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + a.slideDuplicateClass + ")").eq(0).index(), ee.nextTick(function () {
                    t.slideTo(r);
                })) : t.slideTo(r) : r > t.slides.length - s ? (t.loopFix(), r = i.children("." + a.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + a.slideDuplicateClass + ")").eq(0).index(), ee.nextTick(function () {
                    t.slideTo(r);
                })) : t.slideTo(r);
            } else t.slideTo(r);
        }
    };
    var u = {
        loopCreate: function loopCreate() {
            var i = this,
                e = i.params,
                t = i.$wrapperEl;
            t.children("." + e.slideClass + "." + e.slideDuplicateClass).remove();
            var s = t.children("." + e.slideClass);
            if (e.loopFillGroupWithBlank) {
                var a = e.slidesPerGroup - s.length % e.slidesPerGroup;
                if (a !== e.slidesPerGroup) {
                    for (var r = 0; r < a; r += 1) {
                        var n = L(f.createElement("div")).addClass(e.slideClass + " " + e.slideBlankClass);
                        t.append(n);
                    }
                    s = t.children("." + e.slideClass);
                }
            }
            "auto" !== e.slidesPerView || e.loopedSlides || (e.loopedSlides = s.length), i.loopedSlides = parseInt(e.loopedSlides || e.slidesPerView, 10), i.loopedSlides += e.loopAdditionalSlides, i.loopedSlides > s.length && (i.loopedSlides = s.length);
            var o = [],
                l = [];
            s.each(function (e, t) {
                var a = L(t);
                e < i.loopedSlides && l.push(t), e < s.length && e >= s.length - i.loopedSlides && o.push(t), a.attr("data-swiper-slide-index", e);
            });
            for (var d = 0; d < l.length; d += 1) {
                t.append(L(l[d].cloneNode(!0)).addClass(e.slideDuplicateClass));
            }for (var p = o.length - 1; 0 <= p; p -= 1) {
                t.prepend(L(o[p].cloneNode(!0)).addClass(e.slideDuplicateClass));
            }
        },
        loopFix: function loopFix() {
            var e,
                t = this,
                a = t.params,
                i = t.activeIndex,
                s = t.slides,
                r = t.loopedSlides,
                n = t.allowSlidePrev,
                o = t.allowSlideNext,
                l = t.snapGrid,
                d = t.rtlTranslate;
            t.allowSlidePrev = !0, t.allowSlideNext = !0;
            var p = -l[i] - t.getTranslate();
            i < r ? (e = s.length - 3 * r + i, e += r, t.slideTo(e, 0, !1, !0) && 0 !== p && t.setTranslate((d ? -t.translate : t.translate) - p)) : ("auto" === a.slidesPerView && 2 * r <= i || i >= s.length - r) && (e = -s.length + i + r, e += r, t.slideTo(e, 0, !1, !0) && 0 !== p && t.setTranslate((d ? -t.translate : t.translate) - p));
            t.allowSlidePrev = n, t.allowSlideNext = o;
        },
        loopDestroy: function loopDestroy() {
            var e = this.$wrapperEl,
                t = this.params,
                a = this.slides;
            e.children("." + t.slideClass + "." + t.slideDuplicateClass + ",." + t.slideClass + "." + t.slideBlankClass).remove(), a.removeAttr("data-swiper-slide-index");
        }
    };
    var h = {
        setGrabCursor: function setGrabCursor(e) {
            if (!(te.touch || !this.params.simulateTouch || this.params.watchOverflow && this.isLocked)) {
                var t = this.el;
                t.style.cursor = "move", t.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab", t.style.cursor = e ? "-moz-grabbin" : "-moz-grab", t.style.cursor = e ? "grabbing" : "grab";
            }
        },
        unsetGrabCursor: function unsetGrabCursor() {
            te.touch || this.params.watchOverflow && this.isLocked || (this.el.style.cursor = "");
        }
    };
    var v = {
        appendSlide: function appendSlide(e) {
            var t = this,
                a = t.$wrapperEl,
                i = t.params;
            if (i.loop && t.loopDestroy(), "object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) && "length" in e) for (var s = 0; s < e.length; s += 1) {
                e[s] && a.append(e[s]);
            } else a.append(e);
            i.loop && t.loopCreate(), i.observer && te.observer || t.update();
        },
        prependSlide: function prependSlide(e) {
            var t = this,
                a = t.params,
                i = t.$wrapperEl,
                s = t.activeIndex;
            a.loop && t.loopDestroy();
            var r = s + 1;
            if ("object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) && "length" in e) {
                for (var n = 0; n < e.length; n += 1) {
                    e[n] && i.prepend(e[n]);
                }r = s + e.length;
            } else i.prepend(e);
            a.loop && t.loopCreate(), a.observer && te.observer || t.update(), t.slideTo(r, 0, !1);
        },
        addSlide: function addSlide(e, t) {
            var a = this,
                i = a.$wrapperEl,
                s = a.params,
                r = a.activeIndex;
            s.loop && (r -= a.loopedSlides, a.loopDestroy(), a.slides = i.children("." + s.slideClass));
            var n = a.slides.length;
            if (e <= 0) a.prependSlide(t);else if (n <= e) a.appendSlide(t);else {
                for (var o = e < r ? r + 1 : r, l = [], d = n - 1; e <= d; d -= 1) {
                    var p = a.slides.eq(d);
                    p.remove(), l.unshift(p);
                }
                if ("object" == (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) && "length" in t) {
                    for (var c = 0; c < t.length; c += 1) {
                        t[c] && i.append(t[c]);
                    }o = e < r ? r + t.length : r;
                } else i.append(t);
                for (var u = 0; u < l.length; u += 1) {
                    i.append(l[u]);
                }s.loop && a.loopCreate(), s.observer && te.observer || a.update(), s.loop ? a.slideTo(o + a.loopedSlides, 0, !1) : a.slideTo(o, 0, !1);
            }
        },
        removeSlide: function removeSlide(e) {
            var t = this,
                a = t.params,
                i = t.$wrapperEl,
                s = t.activeIndex;
            a.loop && (s -= t.loopedSlides, t.loopDestroy(), t.slides = i.children("." + a.slideClass));
            var r,
                n = s;
            if ("object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) && "length" in e) {
                for (var o = 0; o < e.length; o += 1) {
                    r = e[o], t.slides[r] && t.slides.eq(r).remove(), r < n && (n -= 1);
                }n = Math.max(n, 0);
            } else r = e, t.slides[r] && t.slides.eq(r).remove(), r < n && (n -= 1), n = Math.max(n, 0);
            a.loop && t.loopCreate(), a.observer && te.observer || t.update(), a.loop ? t.slideTo(n + t.loopedSlides, 0, !1) : t.slideTo(n, 0, !1);
        },
        removeAllSlides: function removeAllSlides() {
            for (var e = [], t = 0; t < this.slides.length; t += 1) {
                e.push(t);
            }this.removeSlide(e);
        }
    },
        m = function () {
        var e = J.navigator.userAgent,
            t = {
            ios: !1,
            android: !1,
            androidChrome: !1,
            desktop: !1,
            windows: !1,
            iphone: !1,
            ipod: !1,
            ipad: !1,
            cordova: J.cordova || J.phonegap,
            phonegap: J.cordova || J.phonegap
        },
            a = e.match(/(Windows Phone);?[\s\/]+([\d.]+)?/),
            i = e.match(/(Android);?[\s\/]+([\d.]+)?/),
            s = e.match(/(iPad).*OS\s([\d_]+)/),
            r = e.match(/(iPod)(.*OS\s([\d_]+))?/),
            n = !s && e.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
        if (a && (t.os = "windows", t.osVersion = a[2], t.windows = !0), i && !a && (t.os = "android", t.osVersion = i[2], t.android = !0, t.androidChrome = 0 <= e.toLowerCase().indexOf("chrome")), (s || n || r) && (t.os = "ios", t.ios = !0), n && !r && (t.osVersion = n[2].replace(/_/g, "."), t.iphone = !0), s && (t.osVersion = s[2].replace(/_/g, "."), t.ipad = !0), r && (t.osVersion = r[3] ? r[3].replace(/_/g, ".") : null, t.iphone = !0), t.ios && t.osVersion && 0 <= e.indexOf("Version/") && "10" === t.osVersion.split(".")[0] && (t.osVersion = e.toLowerCase().split("version/")[1].split(" ")[0]), t.desktop = !(t.os || t.android || t.webView), t.webView = (n || s || r) && e.match(/.*AppleWebKit(?!.*Safari)/i), t.os && "ios" === t.os) {
            var o = t.osVersion.split("."),
                l = f.querySelector('meta[name="viewport"]');
            t.minimalUi = !t.webView && (r || n) && (1 * o[0] == 7 ? 1 <= 1 * o[1] : 7 < 1 * o[0]) && l && 0 <= l.getAttribute("content").indexOf("minimal-ui");
        }
        return t.pixelRatio = J.devicePixelRatio || 1, t;
    }();
    function g() {
        var e = this,
            t = e.params,
            a = e.el;
        if (!a || 0 !== a.offsetWidth) {
            t.breakpoints && e.setBreakpoint();
            var i = e.allowSlideNext,
                s = e.allowSlidePrev,
                r = e.snapGrid;
            if (e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), t.freeMode) {
                var n = Math.min(Math.max(e.translate, e.maxTranslate()), e.minTranslate());
                e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses(), t.autoHeight && e.updateAutoHeight();
            } else e.updateSlidesClasses(), ("auto" === t.slidesPerView || 1 < t.slidesPerView) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0);
            e.allowSlidePrev = s, e.allowSlideNext = i, e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow();
        }
    }
    var b = {
        attachEvents: function attachEvents() {
            var e = this,
                t = e.params,
                a = e.touchEvents,
                i = e.el,
                s = e.wrapperEl;
            e.onTouchStart = function (e) {
                var t = this,
                    a = t.touchEventsData,
                    i = t.params,
                    s = t.touches;
                if (!t.animating || !i.preventInteractionOnTransition) {
                    var r = e;
                    if (r.originalEvent && (r = r.originalEvent), a.isTouchEvent = "touchstart" === r.type, (a.isTouchEvent || !("which" in r) || 3 !== r.which) && !(!a.isTouchEvent && "button" in r && 0 < r.button || a.isTouched && a.isMoved)) if (i.noSwiping && L(r.target).closest(i.noSwipingSelector ? i.noSwipingSelector : "." + i.noSwipingClass)[0]) t.allowClick = !0;else if (!i.swipeHandler || L(r).closest(i.swipeHandler)[0]) {
                        s.currentX = "touchstart" === r.type ? r.targetTouches[0].pageX : r.pageX, s.currentY = "touchstart" === r.type ? r.targetTouches[0].pageY : r.pageY;
                        var n = s.currentX,
                            o = s.currentY,
                            l = i.edgeSwipeDetection || i.iOSEdgeSwipeDetection,
                            d = i.edgeSwipeThreshold || i.iOSEdgeSwipeThreshold;
                        if (!l || !(n <= d || n >= J.screen.width - d)) {
                            if (ee.extend(a, {
                                isTouched: !0,
                                isMoved: !1,
                                allowTouchCallbacks: !0,
                                isScrolling: void 0,
                                startMoving: void 0
                            }), s.startX = n, s.startY = o, a.touchStartTime = ee.now(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, 0 < i.threshold && (a.allowThresholdMove = !1), "touchstart" !== r.type) {
                                var p = !0;
                                L(r.target).is(a.formElements) && (p = !1), f.activeElement && L(f.activeElement).is(a.formElements) && f.activeElement !== r.target && f.activeElement.blur();
                                var c = p && t.allowTouchMove && i.touchStartPreventDefault;
                                (i.touchStartForcePreventDefault || c) && r.preventDefault();
                            }
                            t.emit("touchStart", r);
                        }
                    }
                }
            }.bind(e), e.onTouchMove = function (e) {
                var t = this,
                    a = t.touchEventsData,
                    i = t.params,
                    s = t.touches,
                    r = t.rtlTranslate,
                    n = e;
                if (n.originalEvent && (n = n.originalEvent), a.isTouched) {
                    if (!a.isTouchEvent || "mousemove" !== n.type) {
                        var o = "touchmove" === n.type ? n.targetTouches[0].pageX : n.pageX,
                            l = "touchmove" === n.type ? n.targetTouches[0].pageY : n.pageY;
                        if (n.preventedByNestedSwiper) return s.startX = o, void (s.startY = l);
                        if (!t.allowTouchMove) return t.allowClick = !1, void (a.isTouched && (ee.extend(s, {
                            startX: o,
                            startY: l,
                            currentX: o,
                            currentY: l
                        }), a.touchStartTime = ee.now()));
                        if (a.isTouchEvent && i.touchReleaseOnEdges && !i.loop) if (t.isVertical()) {
                            if (l < s.startY && t.translate <= t.maxTranslate() || l > s.startY && t.translate >= t.minTranslate()) return a.isTouched = !1, void (a.isMoved = !1);
                        } else if (o < s.startX && t.translate <= t.maxTranslate() || o > s.startX && t.translate >= t.minTranslate()) return;
                        if (a.isTouchEvent && f.activeElement && n.target === f.activeElement && L(n.target).is(a.formElements)) return a.isMoved = !0, void (t.allowClick = !1);
                        if (a.allowTouchCallbacks && t.emit("touchMove", n), !(n.targetTouches && 1 < n.targetTouches.length)) {
                            s.currentX = o, s.currentY = l;
                            var d,
                                p = s.currentX - s.startX,
                                c = s.currentY - s.startY;
                            if (!(t.params.threshold && Math.sqrt(Math.pow(p, 2) + Math.pow(c, 2)) < t.params.threshold)) if (void 0 === a.isScrolling && (t.isHorizontal() && s.currentY === s.startY || t.isVertical() && s.currentX === s.startX ? a.isScrolling = !1 : 25 <= p * p + c * c && (d = 180 * Math.atan2(Math.abs(c), Math.abs(p)) / Math.PI, a.isScrolling = t.isHorizontal() ? d > i.touchAngle : 90 - d > i.touchAngle)), a.isScrolling && t.emit("touchMoveOpposite", n), void 0 === a.startMoving && (s.currentX === s.startX && s.currentY === s.startY || (a.startMoving = !0)), a.isScrolling) a.isTouched = !1;else if (a.startMoving) {
                                t.allowClick = !1, n.preventDefault(), i.touchMoveStopPropagation && !i.nested && n.stopPropagation(), a.isMoved || (i.loop && t.loopFix(), a.startTranslate = t.getTranslate(), t.setTransition(0), t.animating && t.$wrapperEl.trigger("webkitTransitionEnd transitionend"), a.allowMomentumBounce = !1, !i.grabCursor || !0 !== t.allowSlideNext && !0 !== t.allowSlidePrev || t.setGrabCursor(!0), t.emit("sliderFirstMove", n)), t.emit("sliderMove", n), a.isMoved = !0;
                                var u = t.isHorizontal() ? p : c;
                                s.diff = u, u *= i.touchRatio, r && (u = -u), t.swipeDirection = 0 < u ? "prev" : "next", a.currentTranslate = u + a.startTranslate;
                                var h = !0,
                                    v = i.resistanceRatio;
                                if (i.touchReleaseOnEdges && (v = 0), 0 < u && a.currentTranslate > t.minTranslate() ? (h = !1, i.resistance && (a.currentTranslate = t.minTranslate() - 1 + Math.pow(-t.minTranslate() + a.startTranslate + u, v))) : u < 0 && a.currentTranslate < t.maxTranslate() && (h = !1, i.resistance && (a.currentTranslate = t.maxTranslate() + 1 - Math.pow(t.maxTranslate() - a.startTranslate - u, v))), h && (n.preventedByNestedSwiper = !0), !t.allowSlideNext && "next" === t.swipeDirection && a.currentTranslate < a.startTranslate && (a.currentTranslate = a.startTranslate), !t.allowSlidePrev && "prev" === t.swipeDirection && a.currentTranslate > a.startTranslate && (a.currentTranslate = a.startTranslate), 0 < i.threshold) {
                                    if (!(Math.abs(u) > i.threshold || a.allowThresholdMove)) return void (a.currentTranslate = a.startTranslate);
                                    if (!a.allowThresholdMove) return a.allowThresholdMove = !0, s.startX = s.currentX, s.startY = s.currentY, a.currentTranslate = a.startTranslate, void (s.diff = t.isHorizontal() ? s.currentX - s.startX : s.currentY - s.startY);
                                }
                                i.followFinger && ((i.freeMode || i.watchSlidesProgress || i.watchSlidesVisibility) && (t.updateActiveIndex(), t.updateSlidesClasses()), i.freeMode && (0 === a.velocities.length && a.velocities.push({
                                    position: s[t.isHorizontal() ? "startX" : "startY"],
                                    time: a.touchStartTime
                                }), a.velocities.push({
                                    position: s[t.isHorizontal() ? "currentX" : "currentY"],
                                    time: ee.now()
                                })), t.updateProgress(a.currentTranslate), t.setTranslate(a.currentTranslate));
                            }
                        }
                    }
                } else a.startMoving && a.isScrolling && t.emit("touchMoveOpposite", n);
            }.bind(e), e.onTouchEnd = function (e) {
                var t = this,
                    a = t.touchEventsData,
                    i = t.params,
                    s = t.touches,
                    r = t.rtlTranslate,
                    n = t.$wrapperEl,
                    o = t.slidesGrid,
                    l = t.snapGrid,
                    d = e;
                if (d.originalEvent && (d = d.originalEvent), a.allowTouchCallbacks && t.emit("touchEnd", d), a.allowTouchCallbacks = !1, !a.isTouched) return a.isMoved && i.grabCursor && t.setGrabCursor(!1), a.isMoved = !1, void (a.startMoving = !1);
                i.grabCursor && a.isMoved && a.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
                var p,
                    c = ee.now(),
                    u = c - a.touchStartTime;
                if (t.allowClick && (t.updateClickedSlide(d), t.emit("tap", d), u < 300 && 300 < c - a.lastClickTime && (a.clickTimeout && clearTimeout(a.clickTimeout), a.clickTimeout = ee.nextTick(function () {
                    t && !t.destroyed && t.emit("click", d);
                }, 300)), u < 300 && c - a.lastClickTime < 300 && (a.clickTimeout && clearTimeout(a.clickTimeout), t.emit("doubleTap", d))), a.lastClickTime = ee.now(), ee.nextTick(function () {
                    t.destroyed || (t.allowClick = !0);
                }), !a.isTouched || !a.isMoved || !t.swipeDirection || 0 === s.diff || a.currentTranslate === a.startTranslate) return a.isTouched = !1, a.isMoved = !1, void (a.startMoving = !1);
                if (a.isTouched = !1, a.isMoved = !1, a.startMoving = !1, p = i.followFinger ? r ? t.translate : -t.translate : -a.currentTranslate, i.freeMode) {
                    if (p < -t.minTranslate()) return void t.slideTo(t.activeIndex);
                    if (p > -t.maxTranslate()) return void (t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1));
                    if (i.freeModeMomentum) {
                        if (1 < a.velocities.length) {
                            var h = a.velocities.pop(),
                                v = a.velocities.pop(),
                                f = h.position - v.position,
                                m = h.time - v.time;
                            t.velocity = f / m, t.velocity /= 2, Math.abs(t.velocity) < i.freeModeMinimumVelocity && (t.velocity = 0), (150 < m || 300 < ee.now() - h.time) && (t.velocity = 0);
                        } else t.velocity = 0;
                        t.velocity *= i.freeModeMomentumVelocityRatio, a.velocities.length = 0;
                        var g = 1e3 * i.freeModeMomentumRatio,
                            b = t.velocity * g,
                            w = t.translate + b;
                        r && (w = -w);
                        var y,
                            x,
                            T = !1,
                            E = 20 * Math.abs(t.velocity) * i.freeModeMomentumBounceRatio;
                        if (w < t.maxTranslate()) i.freeModeMomentumBounce ? (w + t.maxTranslate() < -E && (w = t.maxTranslate() - E), y = t.maxTranslate(), T = !0, a.allowMomentumBounce = !0) : w = t.maxTranslate(), i.loop && i.centeredSlides && (x = !0);else if (w > t.minTranslate()) i.freeModeMomentumBounce ? (w - t.minTranslate() > E && (w = t.minTranslate() + E), y = t.minTranslate(), T = !0, a.allowMomentumBounce = !0) : w = t.minTranslate(), i.loop && i.centeredSlides && (x = !0);else if (i.freeModeSticky) {
                            for (var S, C = 0; C < l.length; C += 1) {
                                if (l[C] > -w) {
                                    S = C;
                                    break;
                                }
                            }w = -(w = Math.abs(l[S] - w) < Math.abs(l[S - 1] - w) || "next" === t.swipeDirection ? l[S] : l[S - 1]);
                        }
                        if (x && t.once("transitionEnd", function () {
                            t.loopFix();
                        }), 0 !== t.velocity) g = r ? Math.abs((-w - t.translate) / t.velocity) : Math.abs((w - t.translate) / t.velocity);else if (i.freeModeSticky) return void t.slideToClosest();
                        i.freeModeMomentumBounce && T ? (t.updateProgress(y), t.setTransition(g), t.setTranslate(w), t.transitionStart(!0, t.swipeDirection), t.animating = !0, n.transitionEnd(function () {
                            t && !t.destroyed && a.allowMomentumBounce && (t.emit("momentumBounce"), t.setTransition(i.speed), t.setTranslate(y), n.transitionEnd(function () {
                                t && !t.destroyed && t.transitionEnd();
                            }));
                        })) : t.velocity ? (t.updateProgress(w), t.setTransition(g), t.setTranslate(w), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, n.transitionEnd(function () {
                            t && !t.destroyed && t.transitionEnd();
                        }))) : t.updateProgress(w), t.updateActiveIndex(), t.updateSlidesClasses();
                    } else if (i.freeModeSticky) return void t.slideToClosest();
                    (!i.freeModeMomentum || u >= i.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
                } else {
                    for (var M = 0, k = t.slidesSizesGrid[0], P = 0; P < o.length; P += i.slidesPerGroup) {
                        void 0 !== o[P + i.slidesPerGroup] ? p >= o[P] && p < o[P + i.slidesPerGroup] && (k = o[(M = P) + i.slidesPerGroup] - o[P]) : p >= o[P] && (M = P, k = o[o.length - 1] - o[o.length - 2]);
                    }var z = (p - o[M]) / k;
                    if (u > i.longSwipesMs) {
                        if (!i.longSwipes) return void t.slideTo(t.activeIndex);
                        "next" === t.swipeDirection && (z >= i.longSwipesRatio ? t.slideTo(M + i.slidesPerGroup) : t.slideTo(M)), "prev" === t.swipeDirection && (z > 1 - i.longSwipesRatio ? t.slideTo(M + i.slidesPerGroup) : t.slideTo(M));
                    } else {
                        if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
                        "next" === t.swipeDirection && t.slideTo(M + i.slidesPerGroup), "prev" === t.swipeDirection && t.slideTo(M);
                    }
                }
            }.bind(e), e.onClick = function (e) {
                this.allowClick || (this.params.preventClicks && e.preventDefault(), this.params.preventClicksPropagation && this.animating && (e.stopPropagation(), e.stopImmediatePropagation()));
            }.bind(e);
            var r = "container" === t.touchEventsTarget ? i : s,
                n = !!t.nested;
            if (te.touch || !te.pointerEvents && !te.prefixedPointerEvents) {
                if (te.touch) {
                    var o = !("touchstart" !== a.start || !te.passiveListener || !t.passiveListeners) && {
                        passive: !0,
                        capture: !1
                    };
                    r.addEventListener(a.start, e.onTouchStart, o), r.addEventListener(a.move, e.onTouchMove, te.passiveListener ? {
                        passive: !1,
                        capture: n
                    } : n), r.addEventListener(a.end, e.onTouchEnd, o);
                }
                (t.simulateTouch && !m.ios && !m.android || t.simulateTouch && !te.touch && m.ios) && (r.addEventListener("mousedown", e.onTouchStart, !1), f.addEventListener("mousemove", e.onTouchMove, n), f.addEventListener("mouseup", e.onTouchEnd, !1));
            } else r.addEventListener(a.start, e.onTouchStart, !1), f.addEventListener(a.move, e.onTouchMove, n), f.addEventListener(a.end, e.onTouchEnd, !1);
            (t.preventClicks || t.preventClicksPropagation) && r.addEventListener("click", e.onClick, !0), e.on(m.ios || m.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", g, !0);
        },
        detachEvents: function detachEvents() {
            var e = this,
                t = e.params,
                a = e.touchEvents,
                i = e.el,
                s = e.wrapperEl,
                r = "container" === t.touchEventsTarget ? i : s,
                n = !!t.nested;
            if (te.touch || !te.pointerEvents && !te.prefixedPointerEvents) {
                if (te.touch) {
                    var o = !("onTouchStart" !== a.start || !te.passiveListener || !t.passiveListeners) && {
                        passive: !0,
                        capture: !1
                    };
                    r.removeEventListener(a.start, e.onTouchStart, o), r.removeEventListener(a.move, e.onTouchMove, n), r.removeEventListener(a.end, e.onTouchEnd, o);
                }
                (t.simulateTouch && !m.ios && !m.android || t.simulateTouch && !te.touch && m.ios) && (r.removeEventListener("mousedown", e.onTouchStart, !1), f.removeEventListener("mousemove", e.onTouchMove, n), f.removeEventListener("mouseup", e.onTouchEnd, !1));
            } else r.removeEventListener(a.start, e.onTouchStart, !1), f.removeEventListener(a.move, e.onTouchMove, n), f.removeEventListener(a.end, e.onTouchEnd, !1);
            (t.preventClicks || t.preventClicksPropagation) && r.removeEventListener("click", e.onClick, !0), e.off(m.ios || m.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", g);
        }
    };
    var w,
        y = {
        setBreakpoint: function setBreakpoint() {
            var e = this,
                t = e.activeIndex,
                a = e.initialized,
                i = e.loopedSlides;
            void 0 === i && (i = 0);
            var s = e.params,
                r = s.breakpoints;
            if (r && (!r || 0 !== (0, _keys2.default)(r).length)) {
                var n = e.getBreakpoint(r);
                if (n && e.currentBreakpoint !== n) {
                    var o = n in r ? r[n] : void 0;
                    o && ["slidesPerView", "spaceBetween", "slidesPerGroup"].forEach(function (e) {
                        var t = o[e];
                        void 0 !== t && (o[e] = "slidesPerView" !== e || "AUTO" !== t && "auto" !== t ? "slidesPerView" === e ? parseFloat(t) : parseInt(t, 10) : "auto");
                    });
                    var l = o || e.originalParams,
                        d = s.loop && l.slidesPerView !== s.slidesPerView;
                    ee.extend(e.params, l), ee.extend(e, {
                        allowTouchMove: e.params.allowTouchMove,
                        allowSlideNext: e.params.allowSlideNext,
                        allowSlidePrev: e.params.allowSlidePrev
                    }), e.currentBreakpoint = n, d && a && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - i + e.loopedSlides, 0, !1)), e.emit("breakpoint", l);
                }
            }
        },
        getBreakpoint: function getBreakpoint(e) {
            if (e) {
                var t = !1,
                    a = [];
                (0, _keys2.default)(e).forEach(function (e) {
                    a.push(e);
                }), a.sort(function (e, t) {
                    return parseInt(e, 10) - parseInt(t, 10);
                });
                for (var i = 0; i < a.length; i += 1) {
                    var s = a[i];
                    this.params.breakpointsInverse ? s <= J.innerWidth && (t = s) : s >= J.innerWidth && !t && (t = s);
                }
                return t || "max";
            }
        }
    },
        I = {
        isIE: !!J.navigator.userAgent.match(/Trident/g) || !!J.navigator.userAgent.match(/MSIE/g),
        isEdge: !!J.navigator.userAgent.match(/Edge/g),
        isSafari: (w = J.navigator.userAgent.toLowerCase(), 0 <= w.indexOf("safari") && w.indexOf("chrome") < 0 && w.indexOf("android") < 0),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(J.navigator.userAgent)
    };
    var x = {
        init: !0,
        direction: "horizontal",
        touchEventsTarget: "container",
        initialSlide: 0,
        speed: 300,
        preventInteractionOnTransition: !1,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        freeMode: !1,
        freeModeMomentum: !0,
        freeModeMomentumRatio: 1,
        freeModeMomentumBounce: !0,
        freeModeMomentumBounceRatio: 1,
        freeModeMomentumVelocityRatio: 1,
        freeModeSticky: !1,
        freeModeMinimumVelocity: .02,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: "slide",
        breakpoints: void 0,
        breakpointsInverse: !1,
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerColumnFill: "column",
        slidesPerGroup: 1,
        centeredSlides: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !1,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: .5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 0,
        touchMoveStopPropagation: !0,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: .85,
        watchSlidesProgress: !1,
        watchSlidesVisibility: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        preloadImages: !0,
        updateOnImagesReady: !0,
        loop: !1,
        loopAdditionalSlides: 0,
        loopedSlides: null,
        loopFillGroupWithBlank: !1,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "swiper-no-swiping",
        noSwipingSelector: null,
        passiveListeners: !0,
        containerModifierClass: "swiper-container-",
        slideClass: "swiper-slide",
        slideBlankClass: "swiper-slide-invisible-blank",
        slideActiveClass: "swiper-slide-active",
        slideDuplicateActiveClass: "swiper-slide-duplicate-active",
        slideVisibleClass: "swiper-slide-visible",
        slideDuplicateClass: "swiper-slide-duplicate",
        slideNextClass: "swiper-slide-next",
        slideDuplicateNextClass: "swiper-slide-duplicate-next",
        slidePrevClass: "swiper-slide-prev",
        slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
        wrapperClass: "swiper-wrapper",
        runCallbacksOnInit: !0
    },
        T = {
        update: o,
        translate: d,
        transition: p,
        slide: c,
        loop: u,
        grabCursor: h,
        manipulation: v,
        events: b,
        breakpoints: y,
        checkOverflow: {
            checkOverflow: function checkOverflow() {
                var e = this,
                    t = e.isLocked;
                e.isLocked = 1 === e.snapGrid.length, e.allowSlideNext = !e.isLocked, e.allowSlidePrev = !e.isLocked, t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"), t && t !== e.isLocked && (e.isEnd = !1, e.navigation.update());
            }
        },
        classes: {
            addClasses: function addClasses() {
                var t = this.classNames,
                    a = this.params,
                    e = this.rtl,
                    i = this.$el,
                    s = [];
                s.push(a.direction), a.freeMode && s.push("free-mode"), te.flexbox || s.push("no-flexbox"), a.autoHeight && s.push("autoheight"), e && s.push("rtl"), 1 < a.slidesPerColumn && s.push("multirow"), m.android && s.push("android"), m.ios && s.push("ios"), (I.isIE || I.isEdge) && (te.pointerEvents || te.prefixedPointerEvents) && s.push("wp8-" + a.direction), s.forEach(function (e) {
                    t.push(a.containerModifierClass + e);
                }), i.addClass(t.join(" "));
            },
            removeClasses: function removeClasses() {
                var e = this.$el,
                    t = this.classNames;
                e.removeClass(t.join(" "));
            }
        },
        images: {
            loadImage: function loadImage(e, t, a, i, s, r) {
                var n;
                function o() {
                    r && r();
                }
                e.complete && s ? o() : t ? ((n = new J.Image()).onload = o, n.onerror = o, i && (n.sizes = i), a && (n.srcset = a), t && (n.src = t)) : o();
            },
            preloadImages: function preloadImages() {
                var e = this;
                function t() {
                    null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
                }
                e.imagesToLoad = e.$el.find("img");
                for (var a = 0; a < e.imagesToLoad.length; a += 1) {
                    var i = e.imagesToLoad[a];
                    e.loadImage(i, i.currentSrc || i.getAttribute("src"), i.srcset || i.getAttribute("srcset"), i.sizes || i.getAttribute("sizes"), !0, t);
                }
            }
        }
    },
        E = {},
        S = function (u) {
        function h() {
            for (var e, t, s, a = [], i = arguments.length; i--;) {
                a[i] = arguments[i];
            }1 === a.length && a[0].constructor && a[0].constructor === Object ? s = a[0] : (t = (e = a)[0], s = e[1]), s || (s = {}), s = ee.extend({}, s), t && !s.el && (s.el = t), u.call(this, s), (0, _keys2.default)(T).forEach(function (t) {
                (0, _keys2.default)(T[t]).forEach(function (e) {
                    h.prototype[e] || (h.prototype[e] = T[t][e]);
                });
            });
            var r = this;
            void 0 === r.modules && (r.modules = {}), (0, _keys2.default)(r.modules).forEach(function (e) {
                var t = r.modules[e];
                if (t.params) {
                    var a = (0, _keys2.default)(t.params)[0],
                        i = t.params[a];
                    if ("object" != (typeof i === "undefined" ? "undefined" : (0, _typeof3.default)(i)) || null === i) return;
                    if (!(a in s && "enabled" in i)) return;
                    !0 === s[a] && (s[a] = {
                        enabled: !0
                    }), "object" != (0, _typeof3.default)(s[a]) || "enabled" in s[a] || (s[a].enabled = !0), s[a] || (s[a] = {
                        enabled: !1
                    });
                }
            });
            var n = ee.extend({}, x);
            r.useModulesParams(n), r.params = ee.extend({}, n, E, s), r.originalParams = ee.extend({}, r.params), r.passedParams = ee.extend({}, s);
            var o = (r.$ = L)(r.params.el);
            if (t = o[0]) {
                if (1 < o.length) {
                    var l = [];
                    return o.each(function (e, t) {
                        var a = ee.extend({}, s, {
                            el: t
                        });
                        l.push(new h(a));
                    }), l;
                }
                t.swiper = r, o.data("swiper", r);
                var d,
                    p,
                    c = o.children("." + r.params.wrapperClass);
                return ee.extend(r, {
                    $el: o,
                    el: t,
                    $wrapperEl: c,
                    wrapperEl: c[0],
                    classNames: [],
                    slides: L(),
                    slidesGrid: [],
                    snapGrid: [],
                    slidesSizesGrid: [],
                    isHorizontal: function isHorizontal() {
                        return "horizontal" === r.params.direction;
                    },
                    isVertical: function isVertical() {
                        return "vertical" === r.params.direction;
                    },
                    rtl: "rtl" === t.dir.toLowerCase() || "rtl" === o.css("direction"),
                    rtlTranslate: "horizontal" === r.params.direction && ("rtl" === t.dir.toLowerCase() || "rtl" === o.css("direction")),
                    wrongRTL: "-webkit-box" === c.css("display"),
                    activeIndex: 0,
                    realIndex: 0,
                    isBeginning: !0,
                    isEnd: !1,
                    translate: 0,
                    previousTranslate: 0,
                    progress: 0,
                    velocity: 0,
                    animating: !1,
                    allowSlideNext: r.params.allowSlideNext,
                    allowSlidePrev: r.params.allowSlidePrev,
                    touchEvents: (d = ["touchstart", "touchmove", "touchend"], p = ["mousedown", "mousemove", "mouseup"], te.pointerEvents ? p = ["pointerdown", "pointermove", "pointerup"] : te.prefixedPointerEvents && (p = ["MSPointerDown", "MSPointerMove", "MSPointerUp"]), r.touchEventsTouch = {
                        start: d[0],
                        move: d[1],
                        end: d[2]
                    }, r.touchEventsDesktop = {
                        start: p[0],
                        move: p[1],
                        end: p[2]
                    }, te.touch || !r.params.simulateTouch ? r.touchEventsTouch : r.touchEventsDesktop),
                    touchEventsData: {
                        isTouched: void 0,
                        isMoved: void 0,
                        allowTouchCallbacks: void 0,
                        touchStartTime: void 0,
                        isScrolling: void 0,
                        currentTranslate: void 0,
                        startTranslate: void 0,
                        allowThresholdMove: void 0,
                        formElements: "input, select, option, textarea, button, video",
                        lastClickTime: ee.now(),
                        clickTimeout: void 0,
                        velocities: [],
                        allowMomentumBounce: void 0,
                        isTouchEvent: void 0,
                        startMoving: void 0
                    },
                    allowClick: !0,
                    allowTouchMove: r.params.allowTouchMove,
                    touches: {
                        startX: 0,
                        startY: 0,
                        currentX: 0,
                        currentY: 0,
                        diff: 0
                    },
                    imagesToLoad: [],
                    imagesLoaded: 0
                }), r.useModules(), r.params.init && r.init(), r;
            }
        }
        u && (h.__proto__ = u);
        var e = {
            extendedDefaults: {
                configurable: !0
            },
            defaults: {
                configurable: !0
            },
            Class: {
                configurable: !0
            },
            $: {
                configurable: !0
            }
        };
        return ((h.prototype = (0, _create2.default)(u && u.prototype)).constructor = h).prototype.slidesPerViewDynamic = function () {
            var e = this,
                t = e.params,
                a = e.slides,
                i = e.slidesGrid,
                s = e.size,
                r = e.activeIndex,
                n = 1;
            if (t.centeredSlides) {
                for (var o, l = a[r].swiperSlideSize, d = r + 1; d < a.length; d += 1) {
                    a[d] && !o && (n += 1, s < (l += a[d].swiperSlideSize) && (o = !0));
                }for (var p = r - 1; 0 <= p; p -= 1) {
                    a[p] && !o && (n += 1, s < (l += a[p].swiperSlideSize) && (o = !0));
                }
            } else for (var c = r + 1; c < a.length; c += 1) {
                i[c] - i[r] < s && (n += 1);
            }return n;
        }, h.prototype.update = function () {
            var a = this;
            if (a && !a.destroyed) {
                var e = a.snapGrid,
                    t = a.params;
                t.breakpoints && a.setBreakpoint(), a.updateSize(), a.updateSlides(), a.updateProgress(), a.updateSlidesClasses(), a.params.freeMode ? (i(), a.params.autoHeight && a.updateAutoHeight()) : (("auto" === a.params.slidesPerView || 1 < a.params.slidesPerView) && a.isEnd && !a.params.centeredSlides ? a.slideTo(a.slides.length - 1, 0, !1, !0) : a.slideTo(a.activeIndex, 0, !1, !0)) || i(), t.watchOverflow && e !== a.snapGrid && a.checkOverflow(), a.emit("update");
            }
            function i() {
                var e = a.rtlTranslate ? -1 * a.translate : a.translate,
                    t = Math.min(Math.max(e, a.maxTranslate()), a.minTranslate());
                a.setTranslate(t), a.updateActiveIndex(), a.updateSlidesClasses();
            }
        }, h.prototype.init = function () {
            var e = this;
            e.initialized || (e.emit("beforeInit"), e.params.breakpoints && e.setBreakpoint(), e.addClasses(), e.params.loop && e.loopCreate(), e.updateSize(), e.updateSlides(), e.params.watchOverflow && e.checkOverflow(), e.params.grabCursor && e.setGrabCursor(), e.params.preloadImages && e.preloadImages(), e.params.loop ? e.slideTo(e.params.initialSlide + e.loopedSlides, 0, e.params.runCallbacksOnInit) : e.slideTo(e.params.initialSlide, 0, e.params.runCallbacksOnInit), e.attachEvents(), e.initialized = !0, e.emit("init"));
        }, h.prototype.destroy = function (e, t) {
            void 0 === e && (e = !0), void 0 === t && (t = !0);
            var a = this,
                i = a.params,
                s = a.$el,
                r = a.$wrapperEl,
                n = a.slides;
            return void 0 === a.params || a.destroyed || (a.emit("beforeDestroy"), a.initialized = !1, a.detachEvents(), i.loop && a.loopDestroy(), t && (a.removeClasses(), s.removeAttr("style"), r.removeAttr("style"), n && n.length && n.removeClass([i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index").removeAttr("data-swiper-column").removeAttr("data-swiper-row")), a.emit("destroy"), (0, _keys2.default)(a.eventsListeners).forEach(function (e) {
                a.off(e);
            }), !1 !== e && (a.$el[0].swiper = null, a.$el.data("swiper", null), ee.deleteProps(a)), a.destroyed = !0), null;
        }, h.extendDefaults = function (e) {
            ee.extend(E, e);
        }, e.extendedDefaults.get = function () {
            return E;
        }, e.defaults.get = function () {
            return x;
        }, e.Class.get = function () {
            return u;
        }, e.$.get = function () {
            return L;
        }, (0, _defineProperties2.default)(h, e), h;
    }(s),
        C = {
        name: "device",
        proto: {
            device: m
        },
        static: {
            device: m
        }
    },
        M = {
        name: "support",
        proto: {
            support: te
        },
        static: {
            support: te
        }
    },
        k = {
        name: "browser",
        proto: {
            browser: I
        },
        static: {
            browser: I
        }
    },
        P = {
        name: "resize",
        create: function create() {
            var e = this;
            ee.extend(e, {
                resize: {
                    resizeHandler: function resizeHandler() {
                        e && !e.destroyed && e.initialized && (e.emit("beforeResize"), e.emit("resize"));
                    },
                    orientationChangeHandler: function orientationChangeHandler() {
                        e && !e.destroyed && e.initialized && e.emit("orientationchange");
                    }
                }
            });
        },
        on: {
            init: function init() {
                J.addEventListener("resize", this.resize.resizeHandler), J.addEventListener("orientationchange", this.resize.orientationChangeHandler);
            },
            destroy: function destroy() {
                J.removeEventListener("resize", this.resize.resizeHandler), J.removeEventListener("orientationchange", this.resize.orientationChangeHandler);
            }
        }
    },
        z = {
        func: J.MutationObserver || J.WebkitMutationObserver,
        attach: function attach(e, t) {
            void 0 === t && (t = {});
            var a = this,
                i = new z.func(function (e) {
                if (1 !== e.length) {
                    var t = function t() {
                        a.emit("observerUpdate", e[0]);
                    };
                    J.requestAnimationFrame ? J.requestAnimationFrame(t) : J.setTimeout(t, 0);
                } else a.emit("observerUpdate", e[0]);
            });
            i.observe(e, {
                attributes: void 0 === t.attributes || t.attributes,
                childList: void 0 === t.childList || t.childList,
                characterData: void 0 === t.characterData || t.characterData
            }), a.observer.observers.push(i);
        },
        init: function init() {
            var e = this;
            if (te.observer && e.params.observer) {
                if (e.params.observeParents) for (var t = e.$el.parents(), a = 0; a < t.length; a += 1) {
                    e.observer.attach(t[a]);
                }e.observer.attach(e.$el[0], {
                    childList: e.params.observeSlideChildren
                }), e.observer.attach(e.$wrapperEl[0], {
                    attributes: !1
                });
            }
        },
        destroy: function destroy() {
            this.observer.observers.forEach(function (e) {
                e.disconnect();
            }), this.observer.observers = [];
        }
    },
        $ = {
        name: "observer",
        params: {
            observer: !1,
            observeParents: !1,
            observeSlideChildren: !1
        },
        create: function create() {
            ee.extend(this, {
                observer: {
                    init: z.init.bind(this),
                    attach: z.attach.bind(this),
                    destroy: z.destroy.bind(this),
                    observers: []
                }
            });
        },
        on: {
            init: function init() {
                this.observer.init();
            },
            destroy: function destroy() {
                this.observer.destroy();
            }
        }
    },
        D = {
        update: function update(e) {
            var t = this,
                a = t.params,
                i = a.slidesPerView,
                s = a.slidesPerGroup,
                r = a.centeredSlides,
                n = t.params.virtual,
                o = n.addSlidesBefore,
                l = n.addSlidesAfter,
                d = t.virtual,
                p = d.from,
                c = d.to,
                u = d.slides,
                h = d.slidesGrid,
                v = d.renderSlide,
                f = d.offset;
            t.updateActiveIndex();
            var m,
                g,
                b,
                w = t.activeIndex || 0;
            m = t.rtlTranslate ? "right" : t.isHorizontal() ? "left" : "top", r ? (g = Math.floor(i / 2) + s + o, b = Math.floor(i / 2) + s + l) : (g = i + (s - 1) + o, b = s + l);
            var y = Math.max((w || 0) - b, 0),
                x = Math.min((w || 0) + g, u.length - 1),
                T = (t.slidesGrid[y] || 0) - (t.slidesGrid[0] || 0);
            function E() {
                t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.lazy && t.params.lazy.enabled && t.lazy.load();
            }
            if (ee.extend(t.virtual, {
                from: y,
                to: x,
                offset: T,
                slidesGrid: t.slidesGrid
            }), p === y && c === x && !e) return t.slidesGrid !== h && T !== f && t.slides.css(m, T + "px"), void t.updateProgress();
            if (t.params.virtual.renderExternal) return t.params.virtual.renderExternal.call(t, {
                offset: T,
                from: y,
                to: x,
                slides: function () {
                    for (var e = [], t = y; t <= x; t += 1) {
                        e.push(u[t]);
                    }return e;
                }()
            }), void E();
            var S = [],
                C = [];
            if (e) t.$wrapperEl.find("." + t.params.slideClass).remove();else for (var M = p; M <= c; M += 1) {
                (M < y || x < M) && t.$wrapperEl.find("." + t.params.slideClass + '[data-swiper-slide-index="' + M + '"]').remove();
            }for (var k = 0; k < u.length; k += 1) {
                y <= k && k <= x && (void 0 === c || e ? C.push(k) : (c < k && C.push(k), k < p && S.push(k)));
            }C.forEach(function (e) {
                t.$wrapperEl.append(v(u[e], e));
            }), S.sort(function (e, t) {
                return t - e;
            }).forEach(function (e) {
                t.$wrapperEl.prepend(v(u[e], e));
            }), t.$wrapperEl.children(".swiper-slide").css(m, T + "px"), E();
        },
        renderSlide: function renderSlide(e, t) {
            var a = this,
                i = a.params.virtual;
            if (i.cache && a.virtual.cache[t]) return a.virtual.cache[t];
            var s = i.renderSlide ? L(i.renderSlide.call(a, e, t)) : L('<div class="' + a.params.slideClass + '" data-swiper-slide-index="' + t + '">' + e + "</div>");
            return s.attr("data-swiper-slide-index") || s.attr("data-swiper-slide-index", t), i.cache && (a.virtual.cache[t] = s), s;
        },
        appendSlide: function appendSlide(e) {
            this.virtual.slides.push(e), this.virtual.update(!0);
        },
        prependSlide: function prependSlide(e) {
            var t = this;
            if (t.virtual.slides.unshift(e), t.params.virtual.cache) {
                var a = t.virtual.cache,
                    i = {};
                (0, _keys2.default)(a).forEach(function (e) {
                    i[e + 1] = a[e];
                }), t.virtual.cache = i;
            }
            t.virtual.update(!0), t.slideNext(0);
        }
    },
        O = {
        name: "virtual",
        params: {
            virtual: {
                enabled: !1,
                slides: [],
                cache: !0,
                renderSlide: null,
                renderExternal: null,
                addSlidesBefore: 0,
                addSlidesAfter: 0
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                virtual: {
                    update: D.update.bind(e),
                    appendSlide: D.appendSlide.bind(e),
                    prependSlide: D.prependSlide.bind(e),
                    renderSlide: D.renderSlide.bind(e),
                    slides: e.params.virtual.slides,
                    cache: {}
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                var e = this;
                if (e.params.virtual.enabled) {
                    e.classNames.push(e.params.containerModifierClass + "virtual");
                    var t = {
                        watchSlidesProgress: !0
                    };
                    ee.extend(e.params, t), ee.extend(e.originalParams, t), e.params.initialSlide || e.virtual.update();
                }
            },
            setTranslate: function setTranslate() {
                this.params.virtual.enabled && this.virtual.update();
            }
        }
    },
        A = {
        handle: function handle(e) {
            var t = this,
                a = t.rtlTranslate,
                i = e;
            i.originalEvent && (i = i.originalEvent);
            var s = i.keyCode || i.charCode;
            if (!t.allowSlideNext && (t.isHorizontal() && 39 === s || t.isVertical() && 40 === s)) return !1;
            if (!t.allowSlidePrev && (t.isHorizontal() && 37 === s || t.isVertical() && 38 === s)) return !1;
            if (!(i.shiftKey || i.altKey || i.ctrlKey || i.metaKey || f.activeElement && f.activeElement.nodeName && ("input" === f.activeElement.nodeName.toLowerCase() || "textarea" === f.activeElement.nodeName.toLowerCase()))) {
                if (t.params.keyboard.onlyInViewport && (37 === s || 39 === s || 38 === s || 40 === s)) {
                    var r = !1;
                    if (0 < t.$el.parents("." + t.params.slideClass).length && 0 === t.$el.parents("." + t.params.slideActiveClass).length) return;
                    var n = J.innerWidth,
                        o = J.innerHeight,
                        l = t.$el.offset();
                    a && (l.left -= t.$el[0].scrollLeft);
                    for (var d = [[l.left, l.top], [l.left + t.width, l.top], [l.left, l.top + t.height], [l.left + t.width, l.top + t.height]], p = 0; p < d.length; p += 1) {
                        var c = d[p];
                        0 <= c[0] && c[0] <= n && 0 <= c[1] && c[1] <= o && (r = !0);
                    }
                    if (!r) return;
                }
                t.isHorizontal() ? (37 !== s && 39 !== s || (i.preventDefault ? i.preventDefault() : i.returnValue = !1), (39 === s && !a || 37 === s && a) && t.slideNext(), (37 === s && !a || 39 === s && a) && t.slidePrev()) : (38 !== s && 40 !== s || (i.preventDefault ? i.preventDefault() : i.returnValue = !1), 40 === s && t.slideNext(), 38 === s && t.slidePrev()), t.emit("keyPress", s);
            }
        },
        enable: function enable() {
            this.keyboard.enabled || (L(f).on("keydown", this.keyboard.handle), this.keyboard.enabled = !0);
        },
        disable: function disable() {
            this.keyboard.enabled && (L(f).off("keydown", this.keyboard.handle), this.keyboard.enabled = !1);
        }
    },
        N = {
        name: "keyboard",
        params: {
            keyboard: {
                enabled: !1,
                onlyInViewport: !0
            }
        },
        create: function create() {
            ee.extend(this, {
                keyboard: {
                    enabled: !1,
                    enable: A.enable.bind(this),
                    disable: A.disable.bind(this),
                    handle: A.handle.bind(this)
                }
            });
        },
        on: {
            init: function init() {
                this.params.keyboard.enabled && this.keyboard.enable();
            },
            destroy: function destroy() {
                this.keyboard.enabled && this.keyboard.disable();
            }
        }
    };
    var H = {
        lastScrollTime: ee.now(),
        event: -1 < J.navigator.userAgent.indexOf("firefox") ? "DOMMouseScroll" : function () {
            var e = "onwheel",
                t = e in f;
            if (!t) {
                var a = f.createElement("div");
                a.setAttribute(e, "return;"), t = "function" == typeof a[e];
            }
            return !t && f.implementation && f.implementation.hasFeature && !0 !== f.implementation.hasFeature("", "") && (t = f.implementation.hasFeature("Events.wheel", "3.0")), t;
        }() ? "wheel" : "mousewheel",
        normalize: function normalize(e) {
            var t = 0,
                a = 0,
                i = 0,
                s = 0;
            return "detail" in e && (a = e.detail), "wheelDelta" in e && (a = -e.wheelDelta / 120), "wheelDeltaY" in e && (a = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (t = a, a = 0), i = 10 * t, s = 10 * a, "deltaY" in e && (s = e.deltaY), "deltaX" in e && (i = e.deltaX), (i || s) && e.deltaMode && (1 === e.deltaMode ? (i *= 40, s *= 40) : (i *= 800, s *= 800)), i && !t && (t = i < 1 ? -1 : 1), s && !a && (a = s < 1 ? -1 : 1), {
                spinX: t,
                spinY: a,
                pixelX: i,
                pixelY: s
            };
        },
        handleMouseEnter: function handleMouseEnter() {
            this.mouseEntered = !0;
        },
        handleMouseLeave: function handleMouseLeave() {
            this.mouseEntered = !1;
        },
        handle: function handle(e) {
            var t = e,
                a = this,
                i = a.params.mousewheel;
            if (!a.mouseEntered && !i.releaseOnEdges) return !0;
            t.originalEvent && (t = t.originalEvent);
            var s = 0,
                r = a.rtlTranslate ? -1 : 1,
                n = H.normalize(t);
            if (i.forceToAxis) {
                if (a.isHorizontal()) {
                    if (!(Math.abs(n.pixelX) > Math.abs(n.pixelY))) return !0;
                    s = n.pixelX * r;
                } else {
                    if (!(Math.abs(n.pixelY) > Math.abs(n.pixelX))) return !0;
                    s = n.pixelY;
                }
            } else s = Math.abs(n.pixelX) > Math.abs(n.pixelY) ? -n.pixelX * r : -n.pixelY;
            if (0 === s) return !0;
            if (i.invert && (s = -s), a.params.freeMode) {
                a.params.loop && a.loopFix();
                var o = a.getTranslate() + s * i.sensitivity,
                    l = a.isBeginning,
                    d = a.isEnd;
                if (o >= a.minTranslate() && (o = a.minTranslate()), o <= a.maxTranslate() && (o = a.maxTranslate()), a.setTransition(0), a.setTranslate(o), a.updateProgress(), a.updateActiveIndex(), a.updateSlidesClasses(), (!l && a.isBeginning || !d && a.isEnd) && a.updateSlidesClasses(), a.params.freeModeSticky && (clearTimeout(a.mousewheel.timeout), a.mousewheel.timeout = ee.nextTick(function () {
                    a.slideToClosest();
                }, 300)), a.emit("scroll", t), a.params.autoplay && a.params.autoplayDisableOnInteraction && a.autoplay.stop(), o === a.minTranslate() || o === a.maxTranslate()) return !0;
            } else {
                if (60 < ee.now() - a.mousewheel.lastScrollTime) if (s < 0) {
                    if (a.isEnd && !a.params.loop || a.animating) {
                        if (i.releaseOnEdges) return !0;
                    } else a.slideNext(), a.emit("scroll", t);
                } else if (a.isBeginning && !a.params.loop || a.animating) {
                    if (i.releaseOnEdges) return !0;
                } else a.slidePrev(), a.emit("scroll", t);
                a.mousewheel.lastScrollTime = new J.Date().getTime();
            }
            return t.preventDefault ? t.preventDefault() : t.returnValue = !1, !1;
        },
        enable: function enable() {
            var e = this;
            if (!H.event) return !1;
            if (e.mousewheel.enabled) return !1;
            var t = e.$el;
            return "container" !== e.params.mousewheel.eventsTarged && (t = L(e.params.mousewheel.eventsTarged)), t.on("mouseenter", e.mousewheel.handleMouseEnter), t.on("mouseleave", e.mousewheel.handleMouseLeave), t.on(H.event, e.mousewheel.handle), e.mousewheel.enabled = !0;
        },
        disable: function disable() {
            var e = this;
            if (!H.event) return !1;
            if (!e.mousewheel.enabled) return !1;
            var t = e.$el;
            return "container" !== e.params.mousewheel.eventsTarged && (t = L(e.params.mousewheel.eventsTarged)), t.off(H.event, e.mousewheel.handle), !(e.mousewheel.enabled = !1);
        }
    },
        G = {
        update: function update() {
            var e = this,
                t = e.params.navigation;
            if (!e.params.loop) {
                var a = e.navigation,
                    i = a.$nextEl,
                    s = a.$prevEl;
                s && 0 < s.length && (e.isBeginning ? s.addClass(t.disabledClass) : s.removeClass(t.disabledClass), s[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass)), i && 0 < i.length && (e.isEnd ? i.addClass(t.disabledClass) : i.removeClass(t.disabledClass), i[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass));
            }
        },
        onPrevClick: function onPrevClick(e) {
            e.preventDefault(), this.isBeginning && !this.params.loop || this.slidePrev();
        },
        onNextClick: function onNextClick(e) {
            e.preventDefault(), this.isEnd && !this.params.loop || this.slideNext();
        },
        init: function init() {
            var e,
                t,
                a = this,
                i = a.params.navigation;
            (i.nextEl || i.prevEl) && (i.nextEl && (e = L(i.nextEl), a.params.uniqueNavElements && "string" == typeof i.nextEl && 1 < e.length && 1 === a.$el.find(i.nextEl).length && (e = a.$el.find(i.nextEl))), i.prevEl && (t = L(i.prevEl), a.params.uniqueNavElements && "string" == typeof i.prevEl && 1 < t.length && 1 === a.$el.find(i.prevEl).length && (t = a.$el.find(i.prevEl))), e && 0 < e.length && e.on("click", a.navigation.onNextClick), t && 0 < t.length && t.on("click", a.navigation.onPrevClick), ee.extend(a.navigation, {
                $nextEl: e,
                nextEl: e && e[0],
                $prevEl: t,
                prevEl: t && t[0]
            }));
        },
        destroy: function destroy() {
            var e = this,
                t = e.navigation,
                a = t.$nextEl,
                i = t.$prevEl;
            a && a.length && (a.off("click", e.navigation.onNextClick), a.removeClass(e.params.navigation.disabledClass)), i && i.length && (i.off("click", e.navigation.onPrevClick), i.removeClass(e.params.navigation.disabledClass));
        }
    },
        B = {
        update: function update() {
            var e = this,
                t = e.rtl,
                s = e.params.pagination;
            if (s.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                var r,
                    a = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                    i = e.pagination.$el,
                    n = e.params.loop ? Math.ceil((a - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                if (e.params.loop ? ((r = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)) > a - 1 - 2 * e.loopedSlides && (r -= a - 2 * e.loopedSlides), n - 1 < r && (r -= n), r < 0 && "bullets" !== e.params.paginationType && (r = n + r)) : r = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0, "bullets" === s.type && e.pagination.bullets && 0 < e.pagination.bullets.length) {
                    var o,
                        l,
                        d,
                        p = e.pagination.bullets;
                    if (s.dynamicBullets && (e.pagination.bulletSize = p.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0), i.css(e.isHorizontal() ? "width" : "height", e.pagination.bulletSize * (s.dynamicMainBullets + 4) + "px"), 1 < s.dynamicMainBullets && void 0 !== e.previousIndex && (e.pagination.dynamicBulletIndex += r - e.previousIndex, e.pagination.dynamicBulletIndex > s.dynamicMainBullets - 1 ? e.pagination.dynamicBulletIndex = s.dynamicMainBullets - 1 : e.pagination.dynamicBulletIndex < 0 && (e.pagination.dynamicBulletIndex = 0)), o = r - e.pagination.dynamicBulletIndex, d = ((l = o + (Math.min(p.length, s.dynamicMainBullets) - 1)) + o) / 2), p.removeClass(s.bulletActiveClass + " " + s.bulletActiveClass + "-next " + s.bulletActiveClass + "-next-next " + s.bulletActiveClass + "-prev " + s.bulletActiveClass + "-prev-prev " + s.bulletActiveClass + "-main"), 1 < i.length) p.each(function (e, t) {
                        var a = L(t),
                            i = a.index();
                        i === r && a.addClass(s.bulletActiveClass), s.dynamicBullets && (o <= i && i <= l && a.addClass(s.bulletActiveClass + "-main"), i === o && a.prev().addClass(s.bulletActiveClass + "-prev").prev().addClass(s.bulletActiveClass + "-prev-prev"), i === l && a.next().addClass(s.bulletActiveClass + "-next").next().addClass(s.bulletActiveClass + "-next-next"));
                    });else if (p.eq(r).addClass(s.bulletActiveClass), s.dynamicBullets) {
                        for (var c = p.eq(o), u = p.eq(l), h = o; h <= l; h += 1) {
                            p.eq(h).addClass(s.bulletActiveClass + "-main");
                        }c.prev().addClass(s.bulletActiveClass + "-prev").prev().addClass(s.bulletActiveClass + "-prev-prev"), u.next().addClass(s.bulletActiveClass + "-next").next().addClass(s.bulletActiveClass + "-next-next");
                    }
                    if (s.dynamicBullets) {
                        var v = Math.min(p.length, s.dynamicMainBullets + 4),
                            f = (e.pagination.bulletSize * v - e.pagination.bulletSize) / 2 - d * e.pagination.bulletSize,
                            m = t ? "right" : "left";
                        p.css(e.isHorizontal() ? m : "top", f + "px");
                    }
                }
                if ("fraction" === s.type && (i.find("." + s.currentClass).text(s.formatFractionCurrent(r + 1)), i.find("." + s.totalClass).text(s.formatFractionTotal(n))), "progressbar" === s.type) {
                    var g;
                    g = s.progressbarOpposite ? e.isHorizontal() ? "vertical" : "horizontal" : e.isHorizontal() ? "horizontal" : "vertical";
                    var b = (r + 1) / n,
                        w = 1,
                        y = 1;
                    "horizontal" === g ? w = b : y = b, i.find("." + s.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + w + ") scaleY(" + y + ")").transition(e.params.speed);
                }
                "custom" === s.type && s.renderCustom ? (i.html(s.renderCustom(e, r + 1, n)), e.emit("paginationRender", e, i[0])) : e.emit("paginationUpdate", e, i[0]), i[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](s.lockClass);
            }
        },
        render: function render() {
            var e = this,
                t = e.params.pagination;
            if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                var a = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                    i = e.pagination.$el,
                    s = "";
                if ("bullets" === t.type) {
                    for (var r = e.params.loop ? Math.ceil((a - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length, n = 0; n < r; n += 1) {
                        t.renderBullet ? s += t.renderBullet.call(e, n, t.bulletClass) : s += "<" + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + ">";
                    }i.html(s), e.pagination.bullets = i.find("." + t.bulletClass);
                }
                "fraction" === t.type && (s = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>', i.html(s)), "progressbar" === t.type && (s = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>', i.html(s)), "custom" !== t.type && e.emit("paginationRender", e.pagination.$el[0]);
            }
        },
        init: function init() {
            var a = this,
                e = a.params.pagination;
            if (e.el) {
                var t = L(e.el);
                0 !== t.length && (a.params.uniqueNavElements && "string" == typeof e.el && 1 < t.length && 1 === a.$el.find(e.el).length && (t = a.$el.find(e.el)), "bullets" === e.type && e.clickable && t.addClass(e.clickableClass), t.addClass(e.modifierClass + e.type), "bullets" === e.type && e.dynamicBullets && (t.addClass("" + e.modifierClass + e.type + "-dynamic"), a.pagination.dynamicBulletIndex = 0, e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)), "progressbar" === e.type && e.progressbarOpposite && t.addClass(e.progressbarOppositeClass), e.clickable && t.on("click", "." + e.bulletClass, function (e) {
                    e.preventDefault();
                    var t = L(this).index() * a.params.slidesPerGroup;
                    a.params.loop && (t += a.loopedSlides), a.slideTo(t);
                }), ee.extend(a.pagination, {
                    $el: t,
                    el: t[0]
                }));
            }
        },
        destroy: function destroy() {
            var e = this,
                t = e.params.pagination;
            if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                var a = e.pagination.$el;
                a.removeClass(t.hiddenClass), a.removeClass(t.modifierClass + t.type), e.pagination.bullets && e.pagination.bullets.removeClass(t.bulletActiveClass), t.clickable && a.off("click", "." + t.bulletClass);
            }
        }
    },
        X = {
        setTranslate: function setTranslate() {
            var e = this;
            if (e.params.scrollbar.el && e.scrollbar.el) {
                var t = e.scrollbar,
                    a = e.rtlTranslate,
                    i = e.progress,
                    s = t.dragSize,
                    r = t.trackSize,
                    n = t.$dragEl,
                    o = t.$el,
                    l = e.params.scrollbar,
                    d = s,
                    p = (r - s) * i;
                a ? 0 < (p = -p) ? (d = s - p, p = 0) : r < -p + s && (d = r + p) : p < 0 ? (d = s + p, p = 0) : r < p + s && (d = r - p), e.isHorizontal() ? (te.transforms3d ? n.transform("translate3d(" + p + "px, 0, 0)") : n.transform("translateX(" + p + "px)"), n[0].style.width = d + "px") : (te.transforms3d ? n.transform("translate3d(0px, " + p + "px, 0)") : n.transform("translateY(" + p + "px)"), n[0].style.height = d + "px"), l.hide && (clearTimeout(e.scrollbar.timeout), o[0].style.opacity = 1, e.scrollbar.timeout = setTimeout(function () {
                    o[0].style.opacity = 0, o.transition(400);
                }, 1e3));
            }
        },
        setTransition: function setTransition(e) {
            this.params.scrollbar.el && this.scrollbar.el && this.scrollbar.$dragEl.transition(e);
        },
        updateSize: function updateSize() {
            var e = this;
            if (e.params.scrollbar.el && e.scrollbar.el) {
                var t = e.scrollbar,
                    a = t.$dragEl,
                    i = t.$el;
                a[0].style.width = "", a[0].style.height = "";
                var s,
                    r = e.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight,
                    n = e.size / e.virtualSize,
                    o = n * (r / e.size);
                s = "auto" === e.params.scrollbar.dragSize ? r * n : parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? a[0].style.width = s + "px" : a[0].style.height = s + "px", i[0].style.display = 1 <= n ? "none" : "", e.params.scrollbarHide && (i[0].style.opacity = 0), ee.extend(t, {
                    trackSize: r,
                    divider: n,
                    moveDivider: o,
                    dragSize: s
                }), t.$el[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](e.params.scrollbar.lockClass);
            }
        },
        setDragPosition: function setDragPosition(e) {
            var t,
                a = this,
                i = a.scrollbar,
                s = a.rtlTranslate,
                r = i.$el,
                n = i.dragSize,
                o = i.trackSize;
            t = ((a.isHorizontal() ? "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX || e.clientX : "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY || e.clientY) - r.offset()[a.isHorizontal() ? "left" : "top"] - n / 2) / (o - n), t = Math.max(Math.min(t, 1), 0), s && (t = 1 - t);
            var l = a.minTranslate() + (a.maxTranslate() - a.minTranslate()) * t;
            a.updateProgress(l), a.setTranslate(l), a.updateActiveIndex(), a.updateSlidesClasses();
        },
        onDragStart: function onDragStart(e) {
            var t = this,
                a = t.params.scrollbar,
                i = t.scrollbar,
                s = t.$wrapperEl,
                r = i.$el,
                n = i.$dragEl;
            t.scrollbar.isTouched = !0, e.preventDefault(), e.stopPropagation(), s.transition(100), n.transition(100), i.setDragPosition(e), clearTimeout(t.scrollbar.dragTimeout), r.transition(0), a.hide && r.css("opacity", 1), t.emit("scrollbarDragStart", e);
        },
        onDragMove: function onDragMove(e) {
            var t = this.scrollbar,
                a = this.$wrapperEl,
                i = t.$el,
                s = t.$dragEl;
            this.scrollbar.isTouched && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, t.setDragPosition(e), a.transition(0), i.transition(0), s.transition(0), this.emit("scrollbarDragMove", e));
        },
        onDragEnd: function onDragEnd(e) {
            var t = this,
                a = t.params.scrollbar,
                i = t.scrollbar.$el;
            t.scrollbar.isTouched && (t.scrollbar.isTouched = !1, a.hide && (clearTimeout(t.scrollbar.dragTimeout), t.scrollbar.dragTimeout = ee.nextTick(function () {
                i.css("opacity", 0), i.transition(400);
            }, 1e3)), t.emit("scrollbarDragEnd", e), a.snapOnRelease && t.slideToClosest());
        },
        enableDraggable: function enableDraggable() {
            var e = this;
            if (e.params.scrollbar.el) {
                var t = e.scrollbar,
                    a = e.touchEventsTouch,
                    i = e.touchEventsDesktop,
                    s = e.params,
                    r = t.$el[0],
                    n = !(!te.passiveListener || !s.passiveListeners) && {
                    passive: !1,
                    capture: !1
                },
                    o = !(!te.passiveListener || !s.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                te.touch ? (r.addEventListener(a.start, e.scrollbar.onDragStart, n), r.addEventListener(a.move, e.scrollbar.onDragMove, n), r.addEventListener(a.end, e.scrollbar.onDragEnd, o)) : (r.addEventListener(i.start, e.scrollbar.onDragStart, n), f.addEventListener(i.move, e.scrollbar.onDragMove, n), f.addEventListener(i.end, e.scrollbar.onDragEnd, o));
            }
        },
        disableDraggable: function disableDraggable() {
            var e = this;
            if (e.params.scrollbar.el) {
                var t = e.scrollbar,
                    a = e.touchEventsTouch,
                    i = e.touchEventsDesktop,
                    s = e.params,
                    r = t.$el[0],
                    n = !(!te.passiveListener || !s.passiveListeners) && {
                    passive: !1,
                    capture: !1
                },
                    o = !(!te.passiveListener || !s.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                te.touch ? (r.removeEventListener(a.start, e.scrollbar.onDragStart, n), r.removeEventListener(a.move, e.scrollbar.onDragMove, n), r.removeEventListener(a.end, e.scrollbar.onDragEnd, o)) : (r.removeEventListener(i.start, e.scrollbar.onDragStart, n), f.removeEventListener(i.move, e.scrollbar.onDragMove, n), f.removeEventListener(i.end, e.scrollbar.onDragEnd, o));
            }
        },
        init: function init() {
            var e = this;
            if (e.params.scrollbar.el) {
                var t = e.scrollbar,
                    a = e.$el,
                    i = e.params.scrollbar,
                    s = L(i.el);
                e.params.uniqueNavElements && "string" == typeof i.el && 1 < s.length && 1 === a.find(i.el).length && (s = a.find(i.el));
                var r = s.find("." + e.params.scrollbar.dragClass);
                0 === r.length && (r = L('<div class="' + e.params.scrollbar.dragClass + '"></div>'), s.append(r)), ee.extend(t, {
                    $el: s,
                    el: s[0],
                    $dragEl: r,
                    dragEl: r[0]
                }), i.draggable && t.enableDraggable();
            }
        },
        destroy: function destroy() {
            this.scrollbar.disableDraggable();
        }
    },
        Y = {
        setTransform: function setTransform(e, t) {
            var a = this.rtl,
                i = L(e),
                s = a ? -1 : 1,
                r = i.attr("data-swiper-parallax") || "0",
                n = i.attr("data-swiper-parallax-x"),
                o = i.attr("data-swiper-parallax-y"),
                l = i.attr("data-swiper-parallax-scale"),
                d = i.attr("data-swiper-parallax-opacity");
            if (n || o ? (n = n || "0", o = o || "0") : this.isHorizontal() ? (n = r, o = "0") : (o = r, n = "0"), n = 0 <= n.indexOf("%") ? parseInt(n, 10) * t * s + "%" : n * t * s + "px", o = 0 <= o.indexOf("%") ? parseInt(o, 10) * t + "%" : o * t + "px", null != d) {
                var p = d - (d - 1) * (1 - Math.abs(t));
                i[0].style.opacity = p;
            }
            if (null == l) i.transform("translate3d(" + n + ", " + o + ", 0px)");else {
                var c = l - (l - 1) * (1 - Math.abs(t));
                i.transform("translate3d(" + n + ", " + o + ", 0px) scale(" + c + ")");
            }
        },
        setTranslate: function setTranslate() {
            var i = this,
                e = i.$el,
                t = i.slides,
                s = i.progress,
                r = i.snapGrid;
            e.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function (e, t) {
                i.parallax.setTransform(t, s);
            }), t.each(function (e, t) {
                var a = t.progress;
                1 < i.params.slidesPerGroup && "auto" !== i.params.slidesPerView && (a += Math.ceil(e / 2) - s * (r.length - 1)), a = Math.min(Math.max(a, -1), 1), L(t).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function (e, t) {
                    i.parallax.setTransform(t, a);
                });
            });
        },
        setTransition: function setTransition(s) {
            void 0 === s && (s = this.params.speed);
            this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function (e, t) {
                var a = L(t),
                    i = parseInt(a.attr("data-swiper-parallax-duration"), 10) || s;
                0 === s && (i = 0), a.transition(i);
            });
        }
    },
        V = {
        getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
            if (e.targetTouches.length < 2) return 1;
            var t = e.targetTouches[0].pageX,
                a = e.targetTouches[0].pageY,
                i = e.targetTouches[1].pageX,
                s = e.targetTouches[1].pageY;
            return Math.sqrt(Math.pow(i - t, 2) + Math.pow(s - a, 2));
        },
        onGestureStart: function onGestureStart(e) {
            var t = this,
                a = t.params.zoom,
                i = t.zoom,
                s = i.gesture;
            if (i.fakeGestureTouched = !1, i.fakeGestureMoved = !1, !te.gestures) {
                if ("touchstart" !== e.type || "touchstart" === e.type && e.targetTouches.length < 2) return;
                i.fakeGestureTouched = !0, s.scaleStart = V.getDistanceBetweenTouches(e);
            }
            s.$slideEl && s.$slideEl.length || (s.$slideEl = L(e.target).closest(".swiper-slide"), 0 === s.$slideEl.length && (s.$slideEl = t.slides.eq(t.activeIndex)), s.$imageEl = s.$slideEl.find("img, svg, canvas"), s.$imageWrapEl = s.$imageEl.parent("." + a.containerClass), s.maxRatio = s.$imageWrapEl.attr("data-swiper-zoom") || a.maxRatio, 0 !== s.$imageWrapEl.length) ? (s.$imageEl.transition(0), t.zoom.isScaling = !0) : s.$imageEl = void 0;
        },
        onGestureChange: function onGestureChange(e) {
            var t = this.params.zoom,
                a = this.zoom,
                i = a.gesture;
            if (!te.gestures) {
                if ("touchmove" !== e.type || "touchmove" === e.type && e.targetTouches.length < 2) return;
                a.fakeGestureMoved = !0, i.scaleMove = V.getDistanceBetweenTouches(e);
            }
            i.$imageEl && 0 !== i.$imageEl.length && (a.scale = te.gestures ? e.scale * a.currentScale : i.scaleMove / i.scaleStart * a.currentScale, a.scale > i.maxRatio && (a.scale = i.maxRatio - 1 + Math.pow(a.scale - i.maxRatio + 1, .5)), a.scale < t.minRatio && (a.scale = t.minRatio + 1 - Math.pow(t.minRatio - a.scale + 1, .5)), i.$imageEl.transform("translate3d(0,0,0) scale(" + a.scale + ")"));
        },
        onGestureEnd: function onGestureEnd(e) {
            var t = this.params.zoom,
                a = this.zoom,
                i = a.gesture;
            if (!te.gestures) {
                if (!a.fakeGestureTouched || !a.fakeGestureMoved) return;
                if ("touchend" !== e.type || "touchend" === e.type && e.changedTouches.length < 2 && !m.android) return;
                a.fakeGestureTouched = !1, a.fakeGestureMoved = !1;
            }
            i.$imageEl && 0 !== i.$imageEl.length && (a.scale = Math.max(Math.min(a.scale, i.maxRatio), t.minRatio), i.$imageEl.transition(this.params.speed).transform("translate3d(0,0,0) scale(" + a.scale + ")"), a.currentScale = a.scale, a.isScaling = !1, 1 === a.scale && (i.$slideEl = void 0));
        },
        onTouchStart: function onTouchStart(e) {
            var t = this.zoom,
                a = t.gesture,
                i = t.image;
            a.$imageEl && 0 !== a.$imageEl.length && (i.isTouched || (m.android && e.preventDefault(), i.isTouched = !0, i.touchesStart.x = "touchstart" === e.type ? e.targetTouches[0].pageX : e.pageX, i.touchesStart.y = "touchstart" === e.type ? e.targetTouches[0].pageY : e.pageY));
        },
        onTouchMove: function onTouchMove(e) {
            var t = this,
                a = t.zoom,
                i = a.gesture,
                s = a.image,
                r = a.velocity;
            if (i.$imageEl && 0 !== i.$imageEl.length && (t.allowClick = !1, s.isTouched && i.$slideEl)) {
                s.isMoved || (s.width = i.$imageEl[0].offsetWidth, s.height = i.$imageEl[0].offsetHeight, s.startX = ee.getTranslate(i.$imageWrapEl[0], "x") || 0, s.startY = ee.getTranslate(i.$imageWrapEl[0], "y") || 0, i.slideWidth = i.$slideEl[0].offsetWidth, i.slideHeight = i.$slideEl[0].offsetHeight, i.$imageWrapEl.transition(0), t.rtl && (s.startX = -s.startX, s.startY = -s.startY));
                var n = s.width * a.scale,
                    o = s.height * a.scale;
                if (!(n < i.slideWidth && o < i.slideHeight)) {
                    if (s.minX = Math.min(i.slideWidth / 2 - n / 2, 0), s.maxX = -s.minX, s.minY = Math.min(i.slideHeight / 2 - o / 2, 0), s.maxY = -s.minY, s.touchesCurrent.x = "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX, s.touchesCurrent.y = "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY, !s.isMoved && !a.isScaling) {
                        if (t.isHorizontal() && (Math.floor(s.minX) === Math.floor(s.startX) && s.touchesCurrent.x < s.touchesStart.x || Math.floor(s.maxX) === Math.floor(s.startX) && s.touchesCurrent.x > s.touchesStart.x)) return void (s.isTouched = !1);
                        if (!t.isHorizontal() && (Math.floor(s.minY) === Math.floor(s.startY) && s.touchesCurrent.y < s.touchesStart.y || Math.floor(s.maxY) === Math.floor(s.startY) && s.touchesCurrent.y > s.touchesStart.y)) return void (s.isTouched = !1);
                    }
                    e.preventDefault(), e.stopPropagation(), s.isMoved = !0, s.currentX = s.touchesCurrent.x - s.touchesStart.x + s.startX, s.currentY = s.touchesCurrent.y - s.touchesStart.y + s.startY, s.currentX < s.minX && (s.currentX = s.minX + 1 - Math.pow(s.minX - s.currentX + 1, .8)), s.currentX > s.maxX && (s.currentX = s.maxX - 1 + Math.pow(s.currentX - s.maxX + 1, .8)), s.currentY < s.minY && (s.currentY = s.minY + 1 - Math.pow(s.minY - s.currentY + 1, .8)), s.currentY > s.maxY && (s.currentY = s.maxY - 1 + Math.pow(s.currentY - s.maxY + 1, .8)), r.prevPositionX || (r.prevPositionX = s.touchesCurrent.x), r.prevPositionY || (r.prevPositionY = s.touchesCurrent.y), r.prevTime || (r.prevTime = Date.now()), r.x = (s.touchesCurrent.x - r.prevPositionX) / (Date.now() - r.prevTime) / 2, r.y = (s.touchesCurrent.y - r.prevPositionY) / (Date.now() - r.prevTime) / 2, Math.abs(s.touchesCurrent.x - r.prevPositionX) < 2 && (r.x = 0), Math.abs(s.touchesCurrent.y - r.prevPositionY) < 2 && (r.y = 0), r.prevPositionX = s.touchesCurrent.x, r.prevPositionY = s.touchesCurrent.y, r.prevTime = Date.now(), i.$imageWrapEl.transform("translate3d(" + s.currentX + "px, " + s.currentY + "px,0)");
                }
            }
        },
        onTouchEnd: function onTouchEnd() {
            var e = this.zoom,
                t = e.gesture,
                a = e.image,
                i = e.velocity;
            if (t.$imageEl && 0 !== t.$imageEl.length) {
                if (!a.isTouched || !a.isMoved) return a.isTouched = !1, void (a.isMoved = !1);
                a.isTouched = !1, a.isMoved = !1;
                var s = 300,
                    r = 300,
                    n = i.x * s,
                    o = a.currentX + n,
                    l = i.y * r,
                    d = a.currentY + l;
                0 !== i.x && (s = Math.abs((o - a.currentX) / i.x)), 0 !== i.y && (r = Math.abs((d - a.currentY) / i.y));
                var p = Math.max(s, r);
                a.currentX = o, a.currentY = d;
                var c = a.width * e.scale,
                    u = a.height * e.scale;
                a.minX = Math.min(t.slideWidth / 2 - c / 2, 0), a.maxX = -a.minX, a.minY = Math.min(t.slideHeight / 2 - u / 2, 0), a.maxY = -a.minY, a.currentX = Math.max(Math.min(a.currentX, a.maxX), a.minX), a.currentY = Math.max(Math.min(a.currentY, a.maxY), a.minY), t.$imageWrapEl.transition(p).transform("translate3d(" + a.currentX + "px, " + a.currentY + "px,0)");
            }
        },
        onTransitionEnd: function onTransitionEnd() {
            var e = this.zoom,
                t = e.gesture;
            t.$slideEl && this.previousIndex !== this.activeIndex && (t.$imageEl.transform("translate3d(0,0,0) scale(1)"), t.$imageWrapEl.transform("translate3d(0,0,0)"), e.scale = 1, e.currentScale = 1, t.$slideEl = void 0, t.$imageEl = void 0, t.$imageWrapEl = void 0);
        },
        toggle: function toggle(e) {
            var t = this.zoom;
            t.scale && 1 !== t.scale ? t.out() : t.in(e);
        },
        in: function _in(e) {
            var t,
                a,
                i,
                s,
                r,
                n,
                o,
                l,
                d,
                p,
                c,
                u,
                h,
                v,
                f,
                m,
                g = this,
                b = g.zoom,
                w = g.params.zoom,
                y = b.gesture,
                x = b.image;
            (y.$slideEl || (y.$slideEl = g.clickedSlide ? L(g.clickedSlide) : g.slides.eq(g.activeIndex), y.$imageEl = y.$slideEl.find("img, svg, canvas"), y.$imageWrapEl = y.$imageEl.parent("." + w.containerClass)), y.$imageEl && 0 !== y.$imageEl.length) && (y.$slideEl.addClass("" + w.zoomedSlideClass), void 0 === x.touchesStart.x && e ? (t = "touchend" === e.type ? e.changedTouches[0].pageX : e.pageX, a = "touchend" === e.type ? e.changedTouches[0].pageY : e.pageY) : (t = x.touchesStart.x, a = x.touchesStart.y), b.scale = y.$imageWrapEl.attr("data-swiper-zoom") || w.maxRatio, b.currentScale = y.$imageWrapEl.attr("data-swiper-zoom") || w.maxRatio, e ? (f = y.$slideEl[0].offsetWidth, m = y.$slideEl[0].offsetHeight, i = y.$slideEl.offset().left + f / 2 - t, s = y.$slideEl.offset().top + m / 2 - a, o = y.$imageEl[0].offsetWidth, l = y.$imageEl[0].offsetHeight, d = o * b.scale, p = l * b.scale, h = -(c = Math.min(f / 2 - d / 2, 0)), v = -(u = Math.min(m / 2 - p / 2, 0)), (r = i * b.scale) < c && (r = c), h < r && (r = h), (n = s * b.scale) < u && (n = u), v < n && (n = v)) : n = r = 0, y.$imageWrapEl.transition(300).transform("translate3d(" + r + "px, " + n + "px,0)"), y.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + b.scale + ")"));
        },
        out: function out() {
            var e = this,
                t = e.zoom,
                a = e.params.zoom,
                i = t.gesture;
            i.$slideEl || (i.$slideEl = e.clickedSlide ? L(e.clickedSlide) : e.slides.eq(e.activeIndex), i.$imageEl = i.$slideEl.find("img, svg, canvas"), i.$imageWrapEl = i.$imageEl.parent("." + a.containerClass)), i.$imageEl && 0 !== i.$imageEl.length && (t.scale = 1, t.currentScale = 1, i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"), i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"), i.$slideEl.removeClass("" + a.zoomedSlideClass), i.$slideEl = void 0);
        },
        enable: function enable() {
            var e = this,
                t = e.zoom;
            if (!t.enabled) {
                t.enabled = !0;
                var a = !("touchstart" !== e.touchEvents.start || !te.passiveListener || !e.params.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                te.gestures ? (e.$wrapperEl.on("gesturestart", ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.on("gesturechange", ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.on("gestureend", ".swiper-slide", t.onGestureEnd, a)) : "touchstart" === e.touchEvents.start && (e.$wrapperEl.on(e.touchEvents.start, ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.on(e.touchEvents.move, ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.on(e.touchEvents.end, ".swiper-slide", t.onGestureEnd, a)), e.$wrapperEl.on(e.touchEvents.move, "." + e.params.zoom.containerClass, t.onTouchMove);
            }
        },
        disable: function disable() {
            var e = this,
                t = e.zoom;
            if (t.enabled) {
                e.zoom.enabled = !1;
                var a = !("touchstart" !== e.touchEvents.start || !te.passiveListener || !e.params.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                te.gestures ? (e.$wrapperEl.off("gesturestart", ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.off("gesturechange", ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.off("gestureend", ".swiper-slide", t.onGestureEnd, a)) : "touchstart" === e.touchEvents.start && (e.$wrapperEl.off(e.touchEvents.start, ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.off(e.touchEvents.move, ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.off(e.touchEvents.end, ".swiper-slide", t.onGestureEnd, a)), e.$wrapperEl.off(e.touchEvents.move, "." + e.params.zoom.containerClass, t.onTouchMove);
            }
        }
    },
        F = {
        loadInSlide: function loadInSlide(e, l) {
            void 0 === l && (l = !0);
            var d = this,
                p = d.params.lazy;
            if (void 0 !== e && 0 !== d.slides.length) {
                var c = d.virtual && d.params.virtual.enabled ? d.$wrapperEl.children("." + d.params.slideClass + '[data-swiper-slide-index="' + e + '"]') : d.slides.eq(e),
                    t = c.find("." + p.elementClass + ":not(." + p.loadedClass + "):not(." + p.loadingClass + ")");
                !c.hasClass(p.elementClass) || c.hasClass(p.loadedClass) || c.hasClass(p.loadingClass) || (t = t.add(c[0])), 0 !== t.length && t.each(function (e, t) {
                    var i = L(t);
                    i.addClass(p.loadingClass);
                    var s = i.attr("data-background"),
                        r = i.attr("data-src"),
                        n = i.attr("data-srcset"),
                        o = i.attr("data-sizes");
                    d.loadImage(i[0], r || s, n, o, !1, function () {
                        if (null != d && d && (!d || d.params) && !d.destroyed) {
                            if (s ? (i.css("background-image", 'url("' + s + '")'), i.removeAttr("data-background")) : (n && (i.attr("srcset", n), i.removeAttr("data-srcset")), o && (i.attr("sizes", o), i.removeAttr("data-sizes")), r && (i.attr("src", r), i.removeAttr("data-src"))), i.addClass(p.loadedClass).removeClass(p.loadingClass), c.find("." + p.preloaderClass).remove(), d.params.loop && l) {
                                var e = c.attr("data-swiper-slide-index");
                                if (c.hasClass(d.params.slideDuplicateClass)) {
                                    var t = d.$wrapperEl.children('[data-swiper-slide-index="' + e + '"]:not(.' + d.params.slideDuplicateClass + ")");
                                    d.lazy.loadInSlide(t.index(), !1);
                                } else {
                                    var a = d.$wrapperEl.children("." + d.params.slideDuplicateClass + '[data-swiper-slide-index="' + e + '"]');
                                    d.lazy.loadInSlide(a.index(), !1);
                                }
                            }
                            d.emit("lazyImageReady", c[0], i[0]);
                        }
                    }), d.emit("lazyImageLoad", c[0], i[0]);
                });
            }
        },
        load: function load() {
            var i = this,
                t = i.$wrapperEl,
                a = i.params,
                s = i.slides,
                e = i.activeIndex,
                r = i.virtual && a.virtual.enabled,
                n = a.lazy,
                o = a.slidesPerView;
            function l(e) {
                if (r) {
                    if (t.children("." + a.slideClass + '[data-swiper-slide-index="' + e + '"]').length) return !0;
                } else if (s[e]) return !0;
                return !1;
            }
            function d(e) {
                return r ? L(e).attr("data-swiper-slide-index") : L(e).index();
            }
            if ("auto" === o && (o = 0), i.lazy.initialImageLoaded || (i.lazy.initialImageLoaded = !0), i.params.watchSlidesVisibility) t.children("." + a.slideVisibleClass).each(function (e, t) {
                var a = r ? L(t).attr("data-swiper-slide-index") : L(t).index();
                i.lazy.loadInSlide(a);
            });else if (1 < o) for (var p = e; p < e + o; p += 1) {
                l(p) && i.lazy.loadInSlide(p);
            } else i.lazy.loadInSlide(e);
            if (n.loadPrevNext) if (1 < o || n.loadPrevNextAmount && 1 < n.loadPrevNextAmount) {
                for (var c = n.loadPrevNextAmount, u = o, h = Math.min(e + u + Math.max(c, u), s.length), v = Math.max(e - Math.max(u, c), 0), f = e + o; f < h; f += 1) {
                    l(f) && i.lazy.loadInSlide(f);
                }for (var m = v; m < e; m += 1) {
                    l(m) && i.lazy.loadInSlide(m);
                }
            } else {
                var g = t.children("." + a.slideNextClass);
                0 < g.length && i.lazy.loadInSlide(d(g));
                var b = t.children("." + a.slidePrevClass);
                0 < b.length && i.lazy.loadInSlide(d(b));
            }
        }
    },
        R = {
        LinearSpline: function LinearSpline(e, t) {
            var a,
                i,
                s,
                r,
                n,
                o = function o(e, t) {
                for (i = -1, a = e.length; 1 < a - i;) {
                    e[s = a + i >> 1] <= t ? i = s : a = s;
                }return a;
            };
            return this.x = e, this.y = t, this.lastIndex = e.length - 1, this.interpolate = function (e) {
                return e ? (n = o(this.x, e), r = n - 1, (e - this.x[r]) * (this.y[n] - this.y[r]) / (this.x[n] - this.x[r]) + this.y[r]) : 0;
            }, this;
        },
        getInterpolateFunction: function getInterpolateFunction(e) {
            var t = this;
            t.controller.spline || (t.controller.spline = t.params.loop ? new R.LinearSpline(t.slidesGrid, e.slidesGrid) : new R.LinearSpline(t.snapGrid, e.snapGrid));
        },
        setTranslate: function setTranslate(e, t) {
            var a,
                i,
                s = this,
                r = s.controller.control;
            function n(e) {
                var t = s.rtlTranslate ? -s.translate : s.translate;
                "slide" === s.params.controller.by && (s.controller.getInterpolateFunction(e), i = -s.controller.spline.interpolate(-t)), i && "container" !== s.params.controller.by || (a = (e.maxTranslate() - e.minTranslate()) / (s.maxTranslate() - s.minTranslate()), i = (t - s.minTranslate()) * a + e.minTranslate()), s.params.controller.inverse && (i = e.maxTranslate() - i), e.updateProgress(i), e.setTranslate(i, s), e.updateActiveIndex(), e.updateSlidesClasses();
            }
            if (Array.isArray(r)) for (var o = 0; o < r.length; o += 1) {
                r[o] !== t && r[o] instanceof S && n(r[o]);
            } else r instanceof S && t !== r && n(r);
        },
        setTransition: function setTransition(t, e) {
            var a,
                i = this,
                s = i.controller.control;
            function r(e) {
                e.setTransition(t, i), 0 !== t && (e.transitionStart(), e.params.autoHeight && ee.nextTick(function () {
                    e.updateAutoHeight();
                }), e.$wrapperEl.transitionEnd(function () {
                    s && (e.params.loop && "slide" === i.params.controller.by && e.loopFix(), e.transitionEnd());
                }));
            }
            if (Array.isArray(s)) for (a = 0; a < s.length; a += 1) {
                s[a] !== e && s[a] instanceof S && r(s[a]);
            } else s instanceof S && e !== s && r(s);
        }
    },
        q = {
        makeElFocusable: function makeElFocusable(e) {
            return e.attr("tabIndex", "0"), e;
        },
        addElRole: function addElRole(e, t) {
            return e.attr("role", t), e;
        },
        addElLabel: function addElLabel(e, t) {
            return e.attr("aria-label", t), e;
        },
        disableEl: function disableEl(e) {
            return e.attr("aria-disabled", !0), e;
        },
        enableEl: function enableEl(e) {
            return e.attr("aria-disabled", !1), e;
        },
        onEnterKey: function onEnterKey(e) {
            var t = this,
                a = t.params.a11y;
            if (13 === e.keyCode) {
                var i = L(e.target);
                t.navigation && t.navigation.$nextEl && i.is(t.navigation.$nextEl) && (t.isEnd && !t.params.loop || t.slideNext(), t.isEnd ? t.a11y.notify(a.lastSlideMessage) : t.a11y.notify(a.nextSlideMessage)), t.navigation && t.navigation.$prevEl && i.is(t.navigation.$prevEl) && (t.isBeginning && !t.params.loop || t.slidePrev(), t.isBeginning ? t.a11y.notify(a.firstSlideMessage) : t.a11y.notify(a.prevSlideMessage)), t.pagination && i.is("." + t.params.pagination.bulletClass) && i[0].click();
            }
        },
        notify: function notify(e) {
            var t = this.a11y.liveRegion;
            0 !== t.length && (t.html(""), t.html(e));
        },
        updateNavigation: function updateNavigation() {
            var e = this;
            if (!e.params.loop) {
                var t = e.navigation,
                    a = t.$nextEl,
                    i = t.$prevEl;
                i && 0 < i.length && (e.isBeginning ? e.a11y.disableEl(i) : e.a11y.enableEl(i)), a && 0 < a.length && (e.isEnd ? e.a11y.disableEl(a) : e.a11y.enableEl(a));
            }
        },
        updatePagination: function updatePagination() {
            var i = this,
                s = i.params.a11y;
            i.pagination && i.params.pagination.clickable && i.pagination.bullets && i.pagination.bullets.length && i.pagination.bullets.each(function (e, t) {
                var a = L(t);
                i.a11y.makeElFocusable(a), i.a11y.addElRole(a, "button"), i.a11y.addElLabel(a, s.paginationBulletMessage.replace(/{{index}}/, a.index() + 1));
            });
        },
        init: function init() {
            var e = this;
            e.$el.append(e.a11y.liveRegion);
            var t,
                a,
                i = e.params.a11y;
            e.navigation && e.navigation.$nextEl && (t = e.navigation.$nextEl), e.navigation && e.navigation.$prevEl && (a = e.navigation.$prevEl), t && (e.a11y.makeElFocusable(t), e.a11y.addElRole(t, "button"), e.a11y.addElLabel(t, i.nextSlideMessage), t.on("keydown", e.a11y.onEnterKey)), a && (e.a11y.makeElFocusable(a), e.a11y.addElRole(a, "button"), e.a11y.addElLabel(a, i.prevSlideMessage), a.on("keydown", e.a11y.onEnterKey)), e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.$el.on("keydown", "." + e.params.pagination.bulletClass, e.a11y.onEnterKey);
        },
        destroy: function destroy() {
            var e,
                t,
                a = this;
            a.a11y.liveRegion && 0 < a.a11y.liveRegion.length && a.a11y.liveRegion.remove(), a.navigation && a.navigation.$nextEl && (e = a.navigation.$nextEl), a.navigation && a.navigation.$prevEl && (t = a.navigation.$prevEl), e && e.off("keydown", a.a11y.onEnterKey), t && t.off("keydown", a.a11y.onEnterKey), a.pagination && a.params.pagination.clickable && a.pagination.bullets && a.pagination.bullets.length && a.pagination.$el.off("keydown", "." + a.params.pagination.bulletClass, a.a11y.onEnterKey);
        }
    },
        W = {
        init: function init() {
            var e = this;
            if (e.params.history) {
                if (!J.history || !J.history.pushState) return e.params.history.enabled = !1, void (e.params.hashNavigation.enabled = !0);
                var t = e.history;
                t.initialized = !0, t.paths = W.getPathValues(), (t.paths.key || t.paths.value) && (t.scrollToSlide(0, t.paths.value, e.params.runCallbacksOnInit), e.params.history.replaceState || J.addEventListener("popstate", e.history.setHistoryPopState));
            }
        },
        destroy: function destroy() {
            this.params.history.replaceState || J.removeEventListener("popstate", this.history.setHistoryPopState);
        },
        setHistoryPopState: function setHistoryPopState() {
            this.history.paths = W.getPathValues(), this.history.scrollToSlide(this.params.speed, this.history.paths.value, !1);
        },
        getPathValues: function getPathValues() {
            var e = J.location.pathname.slice(1).split("/").filter(function (e) {
                return "" !== e;
            }),
                t = e.length;
            return {
                key: e[t - 2],
                value: e[t - 1]
            };
        },
        setHistory: function setHistory(e, t) {
            if (this.history.initialized && this.params.history.enabled) {
                var a = this.slides.eq(t),
                    i = W.slugify(a.attr("data-history"));
                J.location.pathname.includes(e) || (i = e + "/" + i);
                var s = J.history.state;
                s && s.value === i || (this.params.history.replaceState ? J.history.replaceState({
                    value: i
                }, null, i) : J.history.pushState({
                    value: i
                }, null, i));
            }
        },
        slugify: function slugify(e) {
            return e.toString().toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
        },
        scrollToSlide: function scrollToSlide(e, t, a) {
            var i = this;
            if (t) for (var s = 0, r = i.slides.length; s < r; s += 1) {
                var n = i.slides.eq(s);
                if (W.slugify(n.attr("data-history")) === t && !n.hasClass(i.params.slideDuplicateClass)) {
                    var o = n.index();
                    i.slideTo(o, e, a);
                }
            } else i.slideTo(0, e, a);
        }
    },
        j = {
        onHashCange: function onHashCange() {
            var e = this,
                t = f.location.hash.replace("#", "");
            if (t !== e.slides.eq(e.activeIndex).attr("data-hash")) {
                var a = e.$wrapperEl.children("." + e.params.slideClass + '[data-hash="' + t + '"]').index();
                if (void 0 === a) return;
                e.slideTo(a);
            }
        },
        setHash: function setHash() {
            var e = this;
            if (e.hashNavigation.initialized && e.params.hashNavigation.enabled) if (e.params.hashNavigation.replaceState && J.history && J.history.replaceState) J.history.replaceState(null, null, "#" + e.slides.eq(e.activeIndex).attr("data-hash") || "");else {
                var t = e.slides.eq(e.activeIndex),
                    a = t.attr("data-hash") || t.attr("data-history");
                f.location.hash = a || "";
            }
        },
        init: function init() {
            var e = this;
            if (!(!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled)) {
                e.hashNavigation.initialized = !0;
                var t = f.location.hash.replace("#", "");
                if (t) for (var a = 0, i = e.slides.length; a < i; a += 1) {
                    var s = e.slides.eq(a);
                    if ((s.attr("data-hash") || s.attr("data-history")) === t && !s.hasClass(e.params.slideDuplicateClass)) {
                        var r = s.index();
                        e.slideTo(r, 0, e.params.runCallbacksOnInit, !0);
                    }
                }
                e.params.hashNavigation.watchState && L(J).on("hashchange", e.hashNavigation.onHashCange);
            }
        },
        destroy: function destroy() {
            this.params.hashNavigation.watchState && L(J).off("hashchange", this.hashNavigation.onHashCange);
        }
    },
        U = {
        run: function run() {
            var e = this,
                t = e.slides.eq(e.activeIndex),
                a = e.params.autoplay.delay;
            t.attr("data-swiper-autoplay") && (a = t.attr("data-swiper-autoplay") || e.params.autoplay.delay), e.autoplay.timeout = ee.nextTick(function () {
                e.params.autoplay.reverseDirection ? e.params.loop ? (e.loopFix(), e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay")) : e.isBeginning ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(e.slides.length - 1, e.params.speed, !0, !0), e.emit("autoplay")) : (e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay")) : e.params.loop ? (e.loopFix(), e.slideNext(e.params.speed, !0, !0), e.emit("autoplay")) : e.isEnd ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(0, e.params.speed, !0, !0), e.emit("autoplay")) : (e.slideNext(e.params.speed, !0, !0), e.emit("autoplay"));
            }, a);
        },
        start: function start() {
            var e = this;
            return void 0 === e.autoplay.timeout && !e.autoplay.running && (e.autoplay.running = !0, e.emit("autoplayStart"), e.autoplay.run(), !0);
        },
        stop: function stop() {
            var e = this;
            return !!e.autoplay.running && void 0 !== e.autoplay.timeout && (e.autoplay.timeout && (clearTimeout(e.autoplay.timeout), e.autoplay.timeout = void 0), e.autoplay.running = !1, e.emit("autoplayStop"), !0);
        },
        pause: function pause(e) {
            var t = this;
            t.autoplay.running && (t.autoplay.paused || (t.autoplay.timeout && clearTimeout(t.autoplay.timeout), t.autoplay.paused = !0, 0 !== e && t.params.autoplay.waitForTransition ? (t.$wrapperEl[0].addEventListener("transitionend", t.autoplay.onTransitionEnd), t.$wrapperEl[0].addEventListener("webkitTransitionEnd", t.autoplay.onTransitionEnd)) : (t.autoplay.paused = !1, t.autoplay.run())));
        }
    },
        K = {
        setTranslate: function setTranslate() {
            for (var e = this, t = e.slides, a = 0; a < t.length; a += 1) {
                var i = e.slides.eq(a),
                    s = -i[0].swiperSlideOffset;
                e.params.virtualTranslate || (s -= e.translate);
                var r = 0;
                e.isHorizontal() || (r = s, s = 0);
                var n = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(i[0].progress), 0) : 1 + Math.min(Math.max(i[0].progress, -1), 0);
                i.css({
                    opacity: n
                }).transform("translate3d(" + s + "px, " + r + "px, 0px)");
            }
        },
        setTransition: function setTransition(e) {
            var a = this,
                t = a.slides,
                i = a.$wrapperEl;
            if (t.transition(e), a.params.virtualTranslate && 0 !== e) {
                var s = !1;
                t.transitionEnd(function () {
                    if (!s && a && !a.destroyed) {
                        s = !0, a.animating = !1;
                        for (var e = ["webkitTransitionEnd", "transitionend"], t = 0; t < e.length; t += 1) {
                            i.trigger(e[t]);
                        }
                    }
                });
            }
        }
    },
        _ = {
        setTranslate: function setTranslate() {
            var e,
                t = this,
                a = t.$el,
                i = t.$wrapperEl,
                s = t.slides,
                r = t.width,
                n = t.height,
                o = t.rtlTranslate,
                l = t.size,
                d = t.params.cubeEffect,
                p = t.isHorizontal(),
                c = t.virtual && t.params.virtual.enabled,
                u = 0;
            d.shadow && (p ? (0 === (e = i.find(".swiper-cube-shadow")).length && (e = L('<div class="swiper-cube-shadow"></div>'), i.append(e)), e.css({
                height: r + "px"
            })) : 0 === (e = a.find(".swiper-cube-shadow")).length && (e = L('<div class="swiper-cube-shadow"></div>'), a.append(e)));
            for (var h = 0; h < s.length; h += 1) {
                var v = s.eq(h),
                    f = h;
                c && (f = parseInt(v.attr("data-swiper-slide-index"), 10));
                var m = 90 * f,
                    g = Math.floor(m / 360);
                o && (m = -m, g = Math.floor(-m / 360));
                var b = Math.max(Math.min(v[0].progress, 1), -1),
                    w = 0,
                    y = 0,
                    x = 0;
                f % 4 == 0 ? (w = 4 * -g * l, x = 0) : (f - 1) % 4 == 0 ? (w = 0, x = 4 * -g * l) : (f - 2) % 4 == 0 ? (w = l + 4 * g * l, x = l) : (f - 3) % 4 == 0 && (w = -l, x = 3 * l + 4 * l * g), o && (w = -w), p || (y = w, w = 0);
                var T = "rotateX(" + (p ? 0 : -m) + "deg) rotateY(" + (p ? m : 0) + "deg) translate3d(" + w + "px, " + y + "px, " + x + "px)";
                if (b <= 1 && -1 < b && (u = 90 * f + 90 * b, o && (u = 90 * -f - 90 * b)), v.transform(T), d.slideShadows) {
                    var E = p ? v.find(".swiper-slide-shadow-left") : v.find(".swiper-slide-shadow-top"),
                        S = p ? v.find(".swiper-slide-shadow-right") : v.find(".swiper-slide-shadow-bottom");
                    0 === E.length && (E = L('<div class="swiper-slide-shadow-' + (p ? "left" : "top") + '"></div>'), v.append(E)), 0 === S.length && (S = L('<div class="swiper-slide-shadow-' + (p ? "right" : "bottom") + '"></div>'), v.append(S)), E.length && (E[0].style.opacity = Math.max(-b, 0)), S.length && (S[0].style.opacity = Math.max(b, 0));
                }
            }
            if (i.css({
                "-webkit-transform-origin": "50% 50% -" + l / 2 + "px",
                "-moz-transform-origin": "50% 50% -" + l / 2 + "px",
                "-ms-transform-origin": "50% 50% -" + l / 2 + "px",
                "transform-origin": "50% 50% -" + l / 2 + "px"
            }), d.shadow) if (p) e.transform("translate3d(0px, " + (r / 2 + d.shadowOffset) + "px, " + -r / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + d.shadowScale + ")");else {
                var C = Math.abs(u) - 90 * Math.floor(Math.abs(u) / 90),
                    M = 1.5 - (Math.sin(2 * C * Math.PI / 360) / 2 + Math.cos(2 * C * Math.PI / 360) / 2),
                    k = d.shadowScale,
                    P = d.shadowScale / M,
                    z = d.shadowOffset;
                e.transform("scale3d(" + k + ", 1, " + P + ") translate3d(0px, " + (n / 2 + z) + "px, " + -n / 2 / P + "px) rotateX(-90deg)");
            }
            var $ = I.isSafari || I.isUiWebView ? -l / 2 : 0;
            i.transform("translate3d(0px,0," + $ + "px) rotateX(" + (t.isHorizontal() ? 0 : u) + "deg) rotateY(" + (t.isHorizontal() ? -u : 0) + "deg)");
        },
        setTransition: function setTransition(e) {
            var t = this.$el;
            this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), this.params.cubeEffect.shadow && !this.isHorizontal() && t.find(".swiper-cube-shadow").transition(e);
        }
    },
        Z = {
        setTranslate: function setTranslate() {
            for (var e = this, t = e.slides, a = e.rtlTranslate, i = 0; i < t.length; i += 1) {
                var s = t.eq(i),
                    r = s[0].progress;
                e.params.flipEffect.limitRotation && (r = Math.max(Math.min(s[0].progress, 1), -1));
                var n = -180 * r,
                    o = 0,
                    l = -s[0].swiperSlideOffset,
                    d = 0;
                if (e.isHorizontal() ? a && (n = -n) : (d = l, o = -n, n = l = 0), s[0].style.zIndex = -Math.abs(Math.round(r)) + t.length, e.params.flipEffect.slideShadows) {
                    var p = e.isHorizontal() ? s.find(".swiper-slide-shadow-left") : s.find(".swiper-slide-shadow-top"),
                        c = e.isHorizontal() ? s.find(".swiper-slide-shadow-right") : s.find(".swiper-slide-shadow-bottom");
                    0 === p.length && (p = L('<div class="swiper-slide-shadow-' + (e.isHorizontal() ? "left" : "top") + '"></div>'), s.append(p)), 0 === c.length && (c = L('<div class="swiper-slide-shadow-' + (e.isHorizontal() ? "right" : "bottom") + '"></div>'), s.append(c)), p.length && (p[0].style.opacity = Math.max(-r, 0)), c.length && (c[0].style.opacity = Math.max(r, 0));
                }
                s.transform("translate3d(" + l + "px, " + d + "px, 0px) rotateX(" + o + "deg) rotateY(" + n + "deg)");
            }
        },
        setTransition: function setTransition(e) {
            var a = this,
                t = a.slides,
                i = a.activeIndex,
                s = a.$wrapperEl;
            if (t.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), a.params.virtualTranslate && 0 !== e) {
                var r = !1;
                t.eq(i).transitionEnd(function () {
                    if (!r && a && !a.destroyed) {
                        r = !0, a.animating = !1;
                        for (var e = ["webkitTransitionEnd", "transitionend"], t = 0; t < e.length; t += 1) {
                            s.trigger(e[t]);
                        }
                    }
                });
            }
        }
    },
        Q = {
        setTranslate: function setTranslate() {
            for (var e = this, t = e.width, a = e.height, i = e.slides, s = e.$wrapperEl, r = e.slidesSizesGrid, n = e.params.coverflowEffect, o = e.isHorizontal(), l = e.translate, d = o ? t / 2 - l : a / 2 - l, p = o ? n.rotate : -n.rotate, c = n.depth, u = 0, h = i.length; u < h; u += 1) {
                var v = i.eq(u),
                    f = r[u],
                    m = (d - v[0].swiperSlideOffset - f / 2) / f * n.modifier,
                    g = o ? p * m : 0,
                    b = o ? 0 : p * m,
                    w = -c * Math.abs(m),
                    y = o ? 0 : n.stretch * m,
                    x = o ? n.stretch * m : 0;
                Math.abs(x) < .001 && (x = 0), Math.abs(y) < .001 && (y = 0), Math.abs(w) < .001 && (w = 0), Math.abs(g) < .001 && (g = 0), Math.abs(b) < .001 && (b = 0);
                var T = "translate3d(" + x + "px," + y + "px," + w + "px)  rotateX(" + b + "deg) rotateY(" + g + "deg)";
                if (v.transform(T), v[0].style.zIndex = 1 - Math.abs(Math.round(m)), n.slideShadows) {
                    var E = o ? v.find(".swiper-slide-shadow-left") : v.find(".swiper-slide-shadow-top"),
                        S = o ? v.find(".swiper-slide-shadow-right") : v.find(".swiper-slide-shadow-bottom");
                    0 === E.length && (E = L('<div class="swiper-slide-shadow-' + (o ? "left" : "top") + '"></div>'), v.append(E)), 0 === S.length && (S = L('<div class="swiper-slide-shadow-' + (o ? "right" : "bottom") + '"></div>'), v.append(S)), E.length && (E[0].style.opacity = 0 < m ? m : 0), S.length && (S[0].style.opacity = 0 < -m ? -m : 0);
                }
            }
            (te.pointerEvents || te.prefixedPointerEvents) && (s[0].style.perspectiveOrigin = d + "px 50%");
        },
        setTransition: function setTransition(e) {
            this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e);
        }
    },
        ae = {
        init: function init() {
            var e = this,
                t = e.params.thumbs,
                a = e.constructor;
            t.swiper instanceof a ? (e.thumbs.swiper = t.swiper, ee.extend(e.thumbs.swiper.originalParams, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            }), ee.extend(e.thumbs.swiper.params, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            })) : ee.isObject(t.swiper) && (e.thumbs.swiper = new a(ee.extend({}, t.swiper, {
                watchSlidesVisibility: !0,
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            })), e.thumbs.swiperCreated = !0), e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", e.thumbs.onThumbClick);
        },
        onThumbClick: function onThumbClick() {
            var e = this,
                t = e.thumbs.swiper;
            if (t) {
                var a = t.clickedIndex,
                    i = t.clickedSlide;
                if (!(i && L(i).hasClass(e.params.thumbs.slideThumbActiveClass) || null == a)) {
                    var s;
                    if (s = t.params.loop ? parseInt(L(t.clickedSlide).attr("data-swiper-slide-index"), 10) : a, e.params.loop) {
                        var r = e.activeIndex;
                        e.slides.eq(r).hasClass(e.params.slideDuplicateClass) && (e.loopFix(), e._clientLeft = e.$wrapperEl[0].clientLeft, r = e.activeIndex);
                        var n = e.slides.eq(r).prevAll('[data-swiper-slide-index="' + s + '"]').eq(0).index(),
                            o = e.slides.eq(r).nextAll('[data-swiper-slide-index="' + s + '"]').eq(0).index();
                        s = void 0 === n ? o : void 0 === o ? n : o - r < r - n ? o : n;
                    }
                    e.slideTo(s);
                }
            }
        },
        update: function update(e) {
            var t = this,
                a = t.thumbs.swiper;
            if (a) {
                var i = "auto" === a.params.slidesPerView ? a.slidesPerViewDynamic() : a.params.slidesPerView;
                if (t.realIndex !== a.realIndex) {
                    var s,
                        r = a.activeIndex;
                    if (a.params.loop) {
                        a.slides.eq(r).hasClass(a.params.slideDuplicateClass) && (a.loopFix(), a._clientLeft = a.$wrapperEl[0].clientLeft, r = a.activeIndex);
                        var n = a.slides.eq(r).prevAll('[data-swiper-slide-index="' + t.realIndex + '"]').eq(0).index(),
                            o = a.slides.eq(r).nextAll('[data-swiper-slide-index="' + t.realIndex + '"]').eq(0).index();
                        s = void 0 === n ? o : void 0 === o ? n : o - r == r - n ? r : o - r < r - n ? o : n;
                    } else s = t.realIndex;
                    a.visibleSlidesIndexes.indexOf(s) < 0 && (a.params.centeredSlides ? s = r < s ? s - Math.floor(i / 2) + 1 : s + Math.floor(i / 2) - 1 : r < s && (s = s - i + 1), a.slideTo(s, e ? 0 : void 0));
                }
                var l = 1,
                    d = t.params.thumbs.slideThumbActiveClass;
                if (1 < t.params.slidesPerView && !t.params.centeredSlides && (l = t.params.slidesPerView), a.slides.removeClass(d), a.params.loop) for (var p = 0; p < l; p += 1) {
                    a.$wrapperEl.children('[data-swiper-slide-index="' + (t.realIndex + p) + '"]').addClass(d);
                } else for (var c = 0; c < l; c += 1) {
                    a.slides.eq(t.realIndex + c).addClass(d);
                }
            }
        }
    },
        ie = [C, M, k, P, $, O, N, {
        name: "mousewheel",
        params: {
            mousewheel: {
                enabled: !1,
                releaseOnEdges: !1,
                invert: !1,
                forceToAxis: !1,
                sensitivity: 1,
                eventsTarged: "container"
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                mousewheel: {
                    enabled: !1,
                    enable: H.enable.bind(e),
                    disable: H.disable.bind(e),
                    handle: H.handle.bind(e),
                    handleMouseEnter: H.handleMouseEnter.bind(e),
                    handleMouseLeave: H.handleMouseLeave.bind(e),
                    lastScrollTime: ee.now()
                }
            });
        },
        on: {
            init: function init() {
                this.params.mousewheel.enabled && this.mousewheel.enable();
            },
            destroy: function destroy() {
                this.mousewheel.enabled && this.mousewheel.disable();
            }
        }
    }, {
        name: "navigation",
        params: {
            navigation: {
                nextEl: null,
                prevEl: null,
                hideOnClick: !1,
                disabledClass: "swiper-button-disabled",
                hiddenClass: "swiper-button-hidden",
                lockClass: "swiper-button-lock"
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                navigation: {
                    init: G.init.bind(e),
                    update: G.update.bind(e),
                    destroy: G.destroy.bind(e),
                    onNextClick: G.onNextClick.bind(e),
                    onPrevClick: G.onPrevClick.bind(e)
                }
            });
        },
        on: {
            init: function init() {
                this.navigation.init(), this.navigation.update();
            },
            toEdge: function toEdge() {
                this.navigation.update();
            },
            fromEdge: function fromEdge() {
                this.navigation.update();
            },
            destroy: function destroy() {
                this.navigation.destroy();
            },
            click: function click(e) {
                var t = this.navigation,
                    a = t.$nextEl,
                    i = t.$prevEl;
                !this.params.navigation.hideOnClick || L(e.target).is(i) || L(e.target).is(a) || (a && a.toggleClass(this.params.navigation.hiddenClass), i && i.toggleClass(this.params.navigation.hiddenClass));
            }
        }
    }, {
        name: "pagination",
        params: {
            pagination: {
                el: null,
                bulletElement: "span",
                clickable: !1,
                hideOnClick: !1,
                renderBullet: null,
                renderProgressbar: null,
                renderFraction: null,
                renderCustom: null,
                progressbarOpposite: !1,
                type: "bullets",
                dynamicBullets: !1,
                dynamicMainBullets: 1,
                formatFractionCurrent: function formatFractionCurrent(e) {
                    return e;
                },
                formatFractionTotal: function formatFractionTotal(e) {
                    return e;
                },
                bulletClass: "swiper-pagination-bullet",
                bulletActiveClass: "swiper-pagination-bullet-active",
                modifierClass: "swiper-pagination-",
                currentClass: "swiper-pagination-current",
                totalClass: "swiper-pagination-total",
                hiddenClass: "swiper-pagination-hidden",
                progressbarFillClass: "swiper-pagination-progressbar-fill",
                progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
                clickableClass: "swiper-pagination-clickable",
                lockClass: "swiper-pagination-lock"
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                pagination: {
                    init: B.init.bind(e),
                    render: B.render.bind(e),
                    update: B.update.bind(e),
                    destroy: B.destroy.bind(e),
                    dynamicBulletIndex: 0
                }
            });
        },
        on: {
            init: function init() {
                this.pagination.init(), this.pagination.render(), this.pagination.update();
            },
            activeIndexChange: function activeIndexChange() {
                this.params.loop ? this.pagination.update() : void 0 === this.snapIndex && this.pagination.update();
            },
            snapIndexChange: function snapIndexChange() {
                this.params.loop || this.pagination.update();
            },
            slidesLengthChange: function slidesLengthChange() {
                this.params.loop && (this.pagination.render(), this.pagination.update());
            },
            snapGridLengthChange: function snapGridLengthChange() {
                this.params.loop || (this.pagination.render(), this.pagination.update());
            },
            destroy: function destroy() {
                this.pagination.destroy();
            },
            click: function click(e) {
                var t = this;
                t.params.pagination.el && t.params.pagination.hideOnClick && 0 < t.pagination.$el.length && !L(e.target).hasClass(t.params.pagination.bulletClass) && t.pagination.$el.toggleClass(t.params.pagination.hiddenClass);
            }
        }
    }, {
        name: "scrollbar",
        params: {
            scrollbar: {
                el: null,
                dragSize: "auto",
                hide: !1,
                draggable: !1,
                snapOnRelease: !0,
                lockClass: "swiper-scrollbar-lock",
                dragClass: "swiper-scrollbar-drag"
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                scrollbar: {
                    init: X.init.bind(e),
                    destroy: X.destroy.bind(e),
                    updateSize: X.updateSize.bind(e),
                    setTranslate: X.setTranslate.bind(e),
                    setTransition: X.setTransition.bind(e),
                    enableDraggable: X.enableDraggable.bind(e),
                    disableDraggable: X.disableDraggable.bind(e),
                    setDragPosition: X.setDragPosition.bind(e),
                    onDragStart: X.onDragStart.bind(e),
                    onDragMove: X.onDragMove.bind(e),
                    onDragEnd: X.onDragEnd.bind(e),
                    isTouched: !1,
                    timeout: null,
                    dragTimeout: null
                }
            });
        },
        on: {
            init: function init() {
                this.scrollbar.init(), this.scrollbar.updateSize(), this.scrollbar.setTranslate();
            },
            update: function update() {
                this.scrollbar.updateSize();
            },
            resize: function resize() {
                this.scrollbar.updateSize();
            },
            observerUpdate: function observerUpdate() {
                this.scrollbar.updateSize();
            },
            setTranslate: function setTranslate() {
                this.scrollbar.setTranslate();
            },
            setTransition: function setTransition(e) {
                this.scrollbar.setTransition(e);
            },
            destroy: function destroy() {
                this.scrollbar.destroy();
            }
        }
    }, {
        name: "parallax",
        params: {
            parallax: {
                enabled: !1
            }
        },
        create: function create() {
            ee.extend(this, {
                parallax: {
                    setTransform: Y.setTransform.bind(this),
                    setTranslate: Y.setTranslate.bind(this),
                    setTransition: Y.setTransition.bind(this)
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                this.params.parallax.enabled && (this.params.watchSlidesProgress = !0, this.originalParams.watchSlidesProgress = !0);
            },
            init: function init() {
                this.params.parallax && this.parallax.setTranslate();
            },
            setTranslate: function setTranslate() {
                this.params.parallax && this.parallax.setTranslate();
            },
            setTransition: function setTransition(e) {
                this.params.parallax && this.parallax.setTransition(e);
            }
        }
    }, {
        name: "zoom",
        params: {
            zoom: {
                enabled: !1,
                maxRatio: 3,
                minRatio: 1,
                toggle: !0,
                containerClass: "swiper-zoom-container",
                zoomedSlideClass: "swiper-slide-zoomed"
            }
        },
        create: function create() {
            var i = this,
                t = {
                enabled: !1,
                scale: 1,
                currentScale: 1,
                isScaling: !1,
                gesture: {
                    $slideEl: void 0,
                    slideWidth: void 0,
                    slideHeight: void 0,
                    $imageEl: void 0,
                    $imageWrapEl: void 0,
                    maxRatio: 3
                },
                image: {
                    isTouched: void 0,
                    isMoved: void 0,
                    currentX: void 0,
                    currentY: void 0,
                    minX: void 0,
                    minY: void 0,
                    maxX: void 0,
                    maxY: void 0,
                    width: void 0,
                    height: void 0,
                    startX: void 0,
                    startY: void 0,
                    touchesStart: {},
                    touchesCurrent: {}
                },
                velocity: {
                    x: void 0,
                    y: void 0,
                    prevPositionX: void 0,
                    prevPositionY: void 0,
                    prevTime: void 0
                }
            };
            "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach(function (e) {
                t[e] = V[e].bind(i);
            }), ee.extend(i, {
                zoom: t
            });
            var s = 1;
            Object.defineProperty(i.zoom, "scale", {
                get: function get() {
                    return s;
                },
                set: function set(e) {
                    if (s !== e) {
                        var t = i.zoom.gesture.$imageEl ? i.zoom.gesture.$imageEl[0] : void 0,
                            a = i.zoom.gesture.$slideEl ? i.zoom.gesture.$slideEl[0] : void 0;
                        i.emit("zoomChange", e, t, a);
                    }
                    s = e;
                }
            });
        },
        on: {
            init: function init() {
                this.params.zoom.enabled && this.zoom.enable();
            },
            destroy: function destroy() {
                this.zoom.disable();
            },
            touchStart: function touchStart(e) {
                this.zoom.enabled && this.zoom.onTouchStart(e);
            },
            touchEnd: function touchEnd(e) {
                this.zoom.enabled && this.zoom.onTouchEnd(e);
            },
            doubleTap: function doubleTap(e) {
                this.params.zoom.enabled && this.zoom.enabled && this.params.zoom.toggle && this.zoom.toggle(e);
            },
            transitionEnd: function transitionEnd() {
                this.zoom.enabled && this.params.zoom.enabled && this.zoom.onTransitionEnd();
            }
        }
    }, {
        name: "lazy",
        params: {
            lazy: {
                enabled: !1,
                loadPrevNext: !1,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: !1,
                elementClass: "swiper-lazy",
                loadingClass: "swiper-lazy-loading",
                loadedClass: "swiper-lazy-loaded",
                preloaderClass: "swiper-lazy-preloader"
            }
        },
        create: function create() {
            ee.extend(this, {
                lazy: {
                    initialImageLoaded: !1,
                    load: F.load.bind(this),
                    loadInSlide: F.loadInSlide.bind(this)
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                this.params.lazy.enabled && this.params.preloadImages && (this.params.preloadImages = !1);
            },
            init: function init() {
                this.params.lazy.enabled && !this.params.loop && 0 === this.params.initialSlide && this.lazy.load();
            },
            scroll: function scroll() {
                this.params.freeMode && !this.params.freeModeSticky && this.lazy.load();
            },
            resize: function resize() {
                this.params.lazy.enabled && this.lazy.load();
            },
            scrollbarDragMove: function scrollbarDragMove() {
                this.params.lazy.enabled && this.lazy.load();
            },
            transitionStart: function transitionStart() {
                var e = this;
                e.params.lazy.enabled && (e.params.lazy.loadOnTransitionStart || !e.params.lazy.loadOnTransitionStart && !e.lazy.initialImageLoaded) && e.lazy.load();
            },
            transitionEnd: function transitionEnd() {
                this.params.lazy.enabled && !this.params.lazy.loadOnTransitionStart && this.lazy.load();
            }
        }
    }, {
        name: "controller",
        params: {
            controller: {
                control: void 0,
                inverse: !1,
                by: "slide"
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                controller: {
                    control: e.params.controller.control,
                    getInterpolateFunction: R.getInterpolateFunction.bind(e),
                    setTranslate: R.setTranslate.bind(e),
                    setTransition: R.setTransition.bind(e)
                }
            });
        },
        on: {
            update: function update() {
                this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline);
            },
            resize: function resize() {
                this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline);
            },
            observerUpdate: function observerUpdate() {
                this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline);
            },
            setTranslate: function setTranslate(e, t) {
                this.controller.control && this.controller.setTranslate(e, t);
            },
            setTransition: function setTransition(e, t) {
                this.controller.control && this.controller.setTransition(e, t);
            }
        }
    }, {
        name: "a11y",
        params: {
            a11y: {
                enabled: !0,
                notificationClass: "swiper-notification",
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}"
            }
        },
        create: function create() {
            var t = this;
            ee.extend(t, {
                a11y: {
                    liveRegion: L('<span class="' + t.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>')
                }
            }), (0, _keys2.default)(q).forEach(function (e) {
                t.a11y[e] = q[e].bind(t);
            });
        },
        on: {
            init: function init() {
                this.params.a11y.enabled && (this.a11y.init(), this.a11y.updateNavigation());
            },
            toEdge: function toEdge() {
                this.params.a11y.enabled && this.a11y.updateNavigation();
            },
            fromEdge: function fromEdge() {
                this.params.a11y.enabled && this.a11y.updateNavigation();
            },
            paginationUpdate: function paginationUpdate() {
                this.params.a11y.enabled && this.a11y.updatePagination();
            },
            destroy: function destroy() {
                this.params.a11y.enabled && this.a11y.destroy();
            }
        }
    }, {
        name: "history",
        params: {
            history: {
                enabled: !1,
                replaceState: !1,
                key: "slides"
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                history: {
                    init: W.init.bind(e),
                    setHistory: W.setHistory.bind(e),
                    setHistoryPopState: W.setHistoryPopState.bind(e),
                    scrollToSlide: W.scrollToSlide.bind(e),
                    destroy: W.destroy.bind(e)
                }
            });
        },
        on: {
            init: function init() {
                this.params.history.enabled && this.history.init();
            },
            destroy: function destroy() {
                this.params.history.enabled && this.history.destroy();
            },
            transitionEnd: function transitionEnd() {
                this.history.initialized && this.history.setHistory(this.params.history.key, this.activeIndex);
            }
        }
    }, {
        name: "hash-navigation",
        params: {
            hashNavigation: {
                enabled: !1,
                replaceState: !1,
                watchState: !1
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                hashNavigation: {
                    initialized: !1,
                    init: j.init.bind(e),
                    destroy: j.destroy.bind(e),
                    setHash: j.setHash.bind(e),
                    onHashCange: j.onHashCange.bind(e)
                }
            });
        },
        on: {
            init: function init() {
                this.params.hashNavigation.enabled && this.hashNavigation.init();
            },
            destroy: function destroy() {
                this.params.hashNavigation.enabled && this.hashNavigation.destroy();
            },
            transitionEnd: function transitionEnd() {
                this.hashNavigation.initialized && this.hashNavigation.setHash();
            }
        }
    }, {
        name: "autoplay",
        params: {
            autoplay: {
                enabled: !1,
                delay: 3e3,
                waitForTransition: !0,
                disableOnInteraction: !0,
                stopOnLastSlide: !1,
                reverseDirection: !1
            }
        },
        create: function create() {
            var t = this;
            ee.extend(t, {
                autoplay: {
                    running: !1,
                    paused: !1,
                    run: U.run.bind(t),
                    start: U.start.bind(t),
                    stop: U.stop.bind(t),
                    pause: U.pause.bind(t),
                    onTransitionEnd: function onTransitionEnd(e) {
                        t && !t.destroyed && t.$wrapperEl && e.target === this && (t.$wrapperEl[0].removeEventListener("transitionend", t.autoplay.onTransitionEnd), t.$wrapperEl[0].removeEventListener("webkitTransitionEnd", t.autoplay.onTransitionEnd), t.autoplay.paused = !1, t.autoplay.running ? t.autoplay.run() : t.autoplay.stop());
                    }
                }
            });
        },
        on: {
            init: function init() {
                this.params.autoplay.enabled && this.autoplay.start();
            },
            beforeTransitionStart: function beforeTransitionStart(e, t) {
                this.autoplay.running && (t || !this.params.autoplay.disableOnInteraction ? this.autoplay.pause(e) : this.autoplay.stop());
            },
            sliderFirstMove: function sliderFirstMove() {
                this.autoplay.running && (this.params.autoplay.disableOnInteraction ? this.autoplay.stop() : this.autoplay.pause());
            },
            destroy: function destroy() {
                this.autoplay.running && this.autoplay.stop();
            }
        }
    }, {
        name: "effect-fade",
        params: {
            fadeEffect: {
                crossFade: !1
            }
        },
        create: function create() {
            ee.extend(this, {
                fadeEffect: {
                    setTranslate: K.setTranslate.bind(this),
                    setTransition: K.setTransition.bind(this)
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                var e = this;
                if ("fade" === e.params.effect) {
                    e.classNames.push(e.params.containerModifierClass + "fade");
                    var t = {
                        slidesPerView: 1,
                        slidesPerColumn: 1,
                        slidesPerGroup: 1,
                        watchSlidesProgress: !0,
                        spaceBetween: 0,
                        virtualTranslate: !0
                    };
                    ee.extend(e.params, t), ee.extend(e.originalParams, t);
                }
            },
            setTranslate: function setTranslate() {
                "fade" === this.params.effect && this.fadeEffect.setTranslate();
            },
            setTransition: function setTransition(e) {
                "fade" === this.params.effect && this.fadeEffect.setTransition(e);
            }
        }
    }, {
        name: "effect-cube",
        params: {
            cubeEffect: {
                slideShadows: !0,
                shadow: !0,
                shadowOffset: 20,
                shadowScale: .94
            }
        },
        create: function create() {
            ee.extend(this, {
                cubeEffect: {
                    setTranslate: _.setTranslate.bind(this),
                    setTransition: _.setTransition.bind(this)
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                var e = this;
                if ("cube" === e.params.effect) {
                    e.classNames.push(e.params.containerModifierClass + "cube"), e.classNames.push(e.params.containerModifierClass + "3d");
                    var t = {
                        slidesPerView: 1,
                        slidesPerColumn: 1,
                        slidesPerGroup: 1,
                        watchSlidesProgress: !0,
                        resistanceRatio: 0,
                        spaceBetween: 0,
                        centeredSlides: !1,
                        virtualTranslate: !0
                    };
                    ee.extend(e.params, t), ee.extend(e.originalParams, t);
                }
            },
            setTranslate: function setTranslate() {
                "cube" === this.params.effect && this.cubeEffect.setTranslate();
            },
            setTransition: function setTransition(e) {
                "cube" === this.params.effect && this.cubeEffect.setTransition(e);
            }
        }
    }, {
        name: "effect-flip",
        params: {
            flipEffect: {
                slideShadows: !0,
                limitRotation: !0
            }
        },
        create: function create() {
            ee.extend(this, {
                flipEffect: {
                    setTranslate: Z.setTranslate.bind(this),
                    setTransition: Z.setTransition.bind(this)
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                var e = this;
                if ("flip" === e.params.effect) {
                    e.classNames.push(e.params.containerModifierClass + "flip"), e.classNames.push(e.params.containerModifierClass + "3d");
                    var t = {
                        slidesPerView: 1,
                        slidesPerColumn: 1,
                        slidesPerGroup: 1,
                        watchSlidesProgress: !0,
                        spaceBetween: 0,
                        virtualTranslate: !0
                    };
                    ee.extend(e.params, t), ee.extend(e.originalParams, t);
                }
            },
            setTranslate: function setTranslate() {
                "flip" === this.params.effect && this.flipEffect.setTranslate();
            },
            setTransition: function setTransition(e) {
                "flip" === this.params.effect && this.flipEffect.setTransition(e);
            }
        }
    }, {
        name: "effect-coverflow",
        params: {
            coverflowEffect: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: !0
            }
        },
        create: function create() {
            ee.extend(this, {
                coverflowEffect: {
                    setTranslate: Q.setTranslate.bind(this),
                    setTransition: Q.setTransition.bind(this)
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                var e = this;
                "coverflow" === e.params.effect && (e.classNames.push(e.params.containerModifierClass + "coverflow"), e.classNames.push(e.params.containerModifierClass + "3d"), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
            },
            setTranslate: function setTranslate() {
                "coverflow" === this.params.effect && this.coverflowEffect.setTranslate();
            },
            setTransition: function setTransition(e) {
                "coverflow" === this.params.effect && this.coverflowEffect.setTransition(e);
            }
        }
    }, {
        name: "thumbs",
        params: {
            thumbs: {
                swiper: null,
                slideThumbActiveClass: "swiper-slide-thumb-active",
                thumbsContainerClass: "swiper-container-thumbs"
            }
        },
        create: function create() {
            ee.extend(this, {
                thumbs: {
                    swiper: null,
                    init: ae.init.bind(this),
                    update: ae.update.bind(this),
                    onThumbClick: ae.onThumbClick.bind(this)
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                var e = this.params.thumbs;
                e && e.swiper && (this.thumbs.init(), this.thumbs.update(!0));
            },
            slideChange: function slideChange() {
                this.thumbs.swiper && this.thumbs.update();
            },
            update: function update() {
                this.thumbs.swiper && this.thumbs.update();
            },
            resize: function resize() {
                this.thumbs.swiper && this.thumbs.update();
            },
            observerUpdate: function observerUpdate() {
                this.thumbs.swiper && this.thumbs.update();
            },
            setTransition: function setTransition(e) {
                var t = this.thumbs.swiper;
                t && t.setTransition(e);
            },
            beforeDestroy: function beforeDestroy() {
                var e = this.thumbs.swiper;
                e && this.thumbs.swiperCreated && e && e.destroy();
            }
        }
    }];
    return void 0 === S.use && (S.use = S.Class.use, S.installModule = S.Class.installModule), S.use(ie), S;
});
//# sourceMappingURL=swiper.min.js.map

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showPaginate) ? _c('div', {
    staticClass: "swiper-pagination",
    class: _vm.paginateCls
  }) : _vm._e(), _vm._v(" "), (_vm.showScrollbar) ? _c('div', {
    staticClass: "swiper-scrollbar",
    class: _vm.scrollbarCls
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(154);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(157);

var _api2 = _interopRequireDefault(_api);

var _browser = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MESSAGE = '未知服务器错误';
var JS_API_LIST = ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems'];
function noop() {}
var DEFAULT_OPTIONS = {
  title: '野兽派 - The Beast Shop',
  content: 'default content',
  group: '', // 需要分享朋友圈的文案，如果该字段缺省则分享朋友圈为title
  link: 'https://m.thebeastshop.com',
  image: 'https://img.thebeastshop.com/images/mcatlog/banner/share.png',
  success: noop,
  cancel: noop
};

var config = null;

module.exports = function (options) {
  var isShare = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!(0, _browser.weixin)()) {
    return;
  }
  var _option = (0, _assign2.default)(DEFAULT_OPTIONS, options);
  // wx.checkJsApi({
  //   jsApiList: JS_API_LIST,
  //   success: function(res) {
  _getConfig().then(function (_ref) {
    var data = _ref.data;

    config = data;
    // alert(JSON.stringify(data))
    _config(data);
    _ready(_option, isShare);
  });
  //   }
  // })
  // _checkJsApi()
  // .then((_apis) => {
  //   _getConfig()
  //   .then(({data}) => {
  //     _config(data)
  //     _ready(options)
  //   })
  // })
};

// function _checkJsApi(){
//   return new Promise((resolve, reject) => {
//     wx.checkJsApi({
//       jsApiList: JS_API_LIST,
//       success: function(res) {
//         let _result = res.checkResult
//         let weixinApiList = []
//         Object.keys(_result).forEach((name) => {
//           if(_result[name]){
//             weixinApiList.push(name)
//           }
//         })
//         if(weixinApiList.length > 0) {
//           resolve(weixinApiList)
//         }else{
//           reject()
//         }
//       }
//     })
//   })
// }
function _getConfig() {
  if (config) {
    return _promise2.default.resolve({
      data: config
    });
  }
  var data = { url: location.href
    // let postData = JSON.stringify(data)
  };return _api2.default.signature(data);
}

function _config(_ref2) {
  var appId = _ref2.appId,
      timestamp = _ref2.timestamp,
      nonceStr = _ref2.nonceStr,
      signature = _ref2.signature;

  wx.config({
    // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: appId, // 必填，公众号的唯一标识
    timestamp: timestamp, // 必填，生成签名的时间戳
    nonceStr: nonceStr, // 必填，生成签名的随机串
    signature: signature, // 必填，签名，见附录1
    jsApiList: JS_API_LIST // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  });
}

function _ready(_ref3, isShare) {
  var title = _ref3.title,
      content = _ref3.content,
      link = _ref3.link,
      image = _ref3.image,
      group = _ref3.group,
      _success = _ref3.success,
      _cancel = _ref3.cancel;

  wx.ready(function () {
    if (!isShare) {
      wx.hideMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:facebook', 'menuItem:share:QZone', 'menuItem:favorite', 'menuItem:share:weiboApp', 'menuItem:copyUrl', 'menuItem:share:email', 'menuItem:share:brand', 'menuItem:openWithSafari', 'menuItem:originPage']
      });
      return;
    }
    wx.onMenuShareTimeline({ // 分享到朋友圈
      title: group || title, // 分享标题
      link: link, // 分享链接
      imgUrl: image, // 分享图标
      success: function success() {
        _success('Timeline');
      },
      cancel: function cancel() {
        _cancel('Timeline');
      }
    });

    wx.onMenuShareAppMessage({ // 分享给朋友
      title: title, // 分享标题
      desc: content, // 分享描述
      link: link, // 分享链接
      imgUrl: image, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function success() {
        _success('WeChat');
      },
      cancel: function cancel() {
        _cancel('WeChat');
      }
    });
  });
}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  signature: function signature(jsonData) {
    return (0, _axiosMock2.default)({
      url: '/app/weixin/signature',
      method: 'POST',
      json: jsonData
    });
  }
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(161)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(176)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(216),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */,
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'main',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    errorMsg: {
      type: String,
      default: ''
    }
  },
  created: function created() {
    this.loading && this.$showLoading();
  },

  methods: {
    reload: function reload() {
      window.location.reload();
    }
  }
};

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main",
    class: {
      error: _vm.errorMsg
    }
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMsg),
      expression: "errorMsg"
    }],
    staticClass: "page-error"
  }, [_c('img', {
    attrs: {
      "src": "https://img.thebeastshop.com/images/wap/page-error/page-error.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', {
    staticClass: "reload",
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("重新加载")])])], 2)
},staticRenderFns: []}

/***/ }),
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(172)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(169)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(181)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(204),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _price = __webpack_require__(54);

var _price2 = _interopRequireDefault(_price);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _lazyload = __webpack_require__(56);

var _urlUtil = __webpack_require__(21);

var _sdk = __webpack_require__(59);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headers = {}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var vipLevelImages = {
  '0': 'http://img.thebeastshop.com/apppictures/2017-07-12/5f7fdc7bd73dc83f4318a918cfb771ac.jpg',
  '1': 'http://img.thebeastshop.com/apppictures/2017-07-12/9460e395b4ee15b1f8426b9f5d87e1a0.png',
  '2': 'http://img.thebeastshop.com/apppictures/2017-07-12/65decd7cdc9d6f45fd34dfa4aaf2ba8b.png',
  '3': 'http://img.thebeastshop.com/apppictures/2017-07-12/cc963fc32858fbf03e6d9b80d842d8e9.png'
};

exports.default = {
  name: 'simple-product',
  props: {
    data: {
      type: Object,
      require: true
    },
    addToCart: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      sdk: null,
      env: 'm-web'
    };
  },
  components: {
    price: _price2.default,
    beastImage: _image2.default
  },
  mounted: function mounted() {
    (0, _lazyload.lazyload)();
  },
  created: function created() {
    var _this = this;

    (0, _sdk.getEnv)().then(function (sdk) {
      sdk.init({
        vue: _this
      });
      _this.sdk = sdk;
      _this.env = sdk.adapter.env;
    });
  },


  computed: {
    productImage: function productImage() {
      var data = this.data;
      return data.featureImage ? data.featureImage : data.images ? data.images[0] : '';
    },

    offShelfStyle: function offShelfStyle() {
      var img = (0, _urlUtil.ensure_protocol)('http://img.thebeastshop.com/app/product/list/off-shelf-new.png');
      return 'background: url(' + img + ');background-repeat:no-repeat;background-size:cover;';
    },
    soldOutStyle: function soldOutStyle() {
      var img = (0, _urlUtil.ensure_protocol)('http://img.thebeastshop.com/app/product/list/sold-out-new.png');
      return 'background: url(' + img + ');background-repeat:no-repeat;background-size:cover;';
    },


    priceTags: function priceTags() {
      var data = this.data;
      if (data.discount) {
        return {
          vipLevelImage: data.discount.vipLevel !== null && vipLevelImages[data.discount.vipLevel],
          // appOnlyImage: data.discount.appOnly && 'http://img.thebeastshop.com/apppictures/2017-07-12/a139293dcdbcd72afa4d2b77a5698d42.png',
          birthdayImage: data.discount.birthday && 'http://img.thebeastshop.com/apppictures/2017-07-12/7860dfcf031b72f2d3bf0c14b3e6f7c3.png'
        };
      } else {
        return {};
      }
    }
  },
  filters: {
    formatPrice: function formatPrice(value) {
      var v = String(Math.floor(value * Math.pow(10, 1)) / Math.pow(10, 1));
      var temp = v.split('.');
      return temp.length > 1 ? v : v + '.0';
    }
  },
  methods: {
    jump: function jump() {
      var linkData = '';

      switch (this.env) {
        case 'wx-web':
        case 'm-web':
          linkData = '/product/' + this.data.id;
          break;
        case 'miniprogram':
          linkData = {
            url: '/pages/product/detail/detail?code=' + this.data.id,
            mpType: 'navigate'
          };
          break;
        case 'app':
          linkData = 'beastapp://product/' + this.data.id;
          break;
      }

      if (this.env === 'miniprogram') {
        this.sdk.navigate.jumpTo(linkData);
      } else if (this.env === 'app') {
        _bridge2.default.open({
          url: linkData
        });
      } else {
        window.location.href = linkData;
      }
      // window.location.href = `/product/${this.data.id}`
    },
    getVariant: function getVariant() {
      return this.sdk.request({
        url: '/app/product/' + this.data.id + '/spvs',
        method: 'GET'
      });
    },
    selectVariant: function selectVariant() {
      return this.$selectVariant({
        pack: this.transform(this.variant.spvs[0]),
        variant: this.variant,
        selectAmount: true
      }).then(function (result) {
        return _promise2.default.resolve({ result: result });
      });
    },
    transform: function transform(spv) {
      return {
        product: {
          brand: {
            name: spv.brand ? spv.brand.name : ''
          },
          name: spv.name
        },
        count: spv.minAmount || 1,
        variant: spv.id
      };
    },
    toCart: function toCart(result) {
      var _this2 = this;

      this.$showLoading();
      this.add(result.spvId, result.count).then(function (_ref) {
        var code = _ref.code,
            data = _ref.data;

        _this2.$hideLoading();
        _this2.$toast('加入购物车成功！');
        _this2.$emit('after-add');
      }).catch(function (_ref2) {
        var message = _ref2.message;

        _this2.$hideLoading();
        _this2.$alert(message);
      });
    },
    add: function add(spvId) {
      var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      return this.sdk.request({
        url: '/app/cart/packs',
        method: 'POST',
        json: [{
          spvId: spvId,
          count: count,
          source: 'RAW'
        }]
      });
    },
    addCart: function addCart() {
      var _this3 = this;

      this.$showLoading();
      this.getVariant().then(function (_ref3) {
        var data = _ref3.data;

        _this3.$hideLoading();
        _this3.variant = data;
        if (_this3.variant.spvs.length > 1) {
          _this3.selectVariant().then(function (_ref4) {
            var result = _ref4.result;

            if (!result) {
              return;
            }
            _this3.toCart(result);
          });
        } else {
          var spv = _this3.variant.spvs[0];
          _this3.toCart({
            spvId: spv.id,
            count: spv.minAmount || 1
          });
        }
      }).catch(function (_ref5) {
        var message = _ref5.message;

        _this3.$hideLoading();
        _this3.$alert(message);
      });
    }

    // axios({
    //   url: '/app/cart/packs',
    //   method: 'POST',
    //   json: [{
    //     spvId: this.data.spv.id,
    //     count: 1,
    //     source: "RAW"
    //   }]
    // })
    //   .then(() => {
    //     this.$hideLoading()
    //     this.$toast('加入购物车成功！')
    //     this.$emit('after-add', this.data)
    //   })
    //   .catch(({ message }) => {
    //     this.$hideLoading()
    //     this.$alert(message)
    //   })

  }
};

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-product",
    on: {
      "click": _vm.jump
    }
  }, [_c('div', {
    staticClass: "product-image"
  }, [_c('beast-image', {
    attrs: {
      "lazy": true,
      "src": _vm.productImage
    }
  }), _vm._v(" "), (_vm.data.foretell) ? _c('div', {
    staticClass: "foretell-box"
  }, [_c('div', {
    staticClass: "foretell"
  }, [_vm._v("即将开售")])]) : _vm._e(), _vm._v(" "), (_vm.data.activityDesc) ? _c('div', {
    staticClass: "activity-desc"
  }, [_c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.data.activityDesc))])]) : _vm._e(), _vm._v(" "), (_vm.data.offShelf) ? _c('div', {
    staticClass: "corner-box"
  }, [_c('div', {
    staticClass: "corner-label",
    style: (_vm.offShelfStyle)
  })]) : (_vm.data.soldOut) ? _c('div', {
    staticClass: "corner-box"
  }, [_c('div', {
    staticClass: "corner-label",
    style: (_vm.soldOutStyle)
  })]) : _vm._e(), _vm._v(" "), (_vm.addToCart) ? _c('div', {
    staticClass: "add-cart",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addCart.apply(null, arguments)
      }
    }
  }, [_c('beast-image', {
    attrs: {
      "src": "http://img.thebeastshop.com/apppictures/2017-07-12/6066758d9fb8834c2f2f6a9e4a085fa1.png"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_vm._v(_vm._s(_vm.data.summary))]), _vm._v(" "), _c('div', {
    staticClass: "brand-name"
  }, [_vm._v(_vm._s(_vm.data.brand && _vm.data.brand.name))]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), _c('div', {
    staticClass: "prices"
  }, [_c('div', {
    staticClass: "price discount-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.price
    }
  })], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tags-wrap"
  }, [(_vm.priceTags.vipLevelImage) ? _c('div', {
    staticClass: "price-tag"
  }, [_c('beast-image', {
    attrs: {
      "src": _vm.priceTags.vipLevelImage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.priceTags.appOnlyImage) ? _c('div', {
    staticClass: "price-tag"
  }, [_c('beast-image', {
    attrs: {
      "src": _vm.priceTags.appOnlyImage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.priceTags.birthdayImage) ? _c('div', {
    staticClass: "price-tag"
  }, [_c('beast-image', {
    attrs: {
      "src": _vm.priceTags.birthdayImage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.data.rush) ? _c('div', {
    staticClass: "panic-tag"
  }, [_vm._v("抢购")]) : _vm._e()]), _vm._v(" "), (_vm.data.refunds) ? _c('div', {
    staticClass: "refund"
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.data.refunds)) + "元")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _price = __webpack_require__(54);

var _price2 = _interopRequireDefault(_price);

var _index = __webpack_require__(135);

var _index2 = _interopRequireDefault(_index);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _lazyload = __webpack_require__(56);

var _urlUtil = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headers = {};
// if (process.env.NODE_ENV === 'development') {
//   Object.assign(headers, {
//     'Authorization': 'f85abb3c-9304-44de-b8fe-5bebe4055926',
//     'Platform': 'Android/24',
//     'TBS-Source': 1
//   })
// }


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var vipLevelImages = {
  '0': 'http://img.thebeastshop.com/apppictures/2017-07-12/5f7fdc7bd73dc83f4318a918cfb771ac.jpg',
  '1': 'http://img.thebeastshop.com/apppictures/2017-07-12/9460e395b4ee15b1f8426b9f5d87e1a0.png',
  '2': 'http://img.thebeastshop.com/apppictures/2017-07-12/65decd7cdc9d6f45fd34dfa4aaf2ba8b.png',
  '3': 'http://img.thebeastshop.com/apppictures/2017-07-12/cc963fc32858fbf03e6d9b80d842d8e9.png'
};

exports.default = {
  name: 'simple-product',
  props: {
    data: {
      type: Object,
      require: true
    },
    index: {
      type: Number
    },
    addToCart: {
      type: Boolean,
      default: false
    },
    searchKey: {
      type: String
    },
    sdk: Object,
    env: String,
    isJump: {
      type: Boolean,
      default: true
    },
    business: {
      type: String
    }
  },
  data: function data() {
    return {
      _images: [],
      swiperConfig: {
        loop: true
      }
    };
  },

  components: {
    price: _price2.default,
    beastImage: _image2.default,
    swiper: _index2.default
  },

  created: function created() {
    this.data.images.shift();
    this.data.images.unshift(this.data.featureImage);
  },
  mounted: function mounted() {
    (0, _lazyload.lazyload)();
  },

  filters: {
    formatPrice: function formatPrice(value) {
      var v = String(Math.floor(value * Math.pow(10, 1)) / Math.pow(10, 1));
      var temp = v.split('.');
      return temp.length > 1 ? v : v + '.0';
    }
  },
  computed: {
    productImage: function productImage() {
      var data = this.data;
      return data.featureImage ? data.featureImage : data.images ? data.images[0] : '';
    },
    priceTags: function priceTags() {
      var data = this.data;
      if (data.discount) {
        return {
          vipLevelImage: data.discount.vipLevel !== null && vipLevelImages[data.discount.vipLevel],
          // appOnlyImage: data.discount.appOnly && 'http://img.thebeastshop.com/apppictures/2017-07-12/a139293dcdbcd72afa4d2b77a5698d42.png',
          birthdayImage: data.discount.birthday && 'http://img.thebeastshop.com/apppictures/2017-07-12/7860dfcf031b72f2d3bf0c14b3e6f7c3.png'
        };
      } else {
        return {};
      }
    }
  },
  methods: {
    jump: function jump() {

      var _suggestType = this.data.markInfo ? JSON.parse(this.data.markInfo).RecommendType : '';
      if (!this.isJump) return;
      switch (this.env) {
        case 'm-web':
          window.location.href = '/product/' + this.data.id + '?suggestType=' + encodeURIComponent(_suggestType);
          break;
        case 'wx-web':
          window.location.href = '/product/' + this.data.id + '?suggestType=' + encodeURIComponent(_suggestType);
          break;
        case 'miniprogram':
          var linkData = {
            url: '/pages/product/detail/detail?code=' + this.data.id,
            mpType: 'navigate'
          };
          this.sdk.navigate.jumpTo(linkData);
          break;
        case 'app':
          _bridge2.default.open({
            url: 'beastapp://product/' + this.data.id + '?suggestType=' + encodeURIComponent(_suggestType)
          });
          break;
        default:
          window.location.href = '/product/' + this.data.id + '?suggestType=' + encodeURIComponent(_suggestType);
          break;
      }

      if (this.searchKey) {
        sa.track('SearchResultClick', {
          search_word: this.searchKey,
          position_number: this.index - 0 + 1,
          commodity_spu_id: this.data.id,
          commodity_name: this.data.name,
          hot_label: sa.getActivity(this.data.labels),
          original_price: this.data.rawPrice,
          discount_price: this.data.price
        });
      } else {
        var bu = this.data.recommendEngine ? '\u731C\u4F60\u559C\u6B22-' + this.data.recommendEngine : '猜你喜欢';
        sa.track('CommodityClick', {
          position_number: this.index - 0 + 1,
          commodity_spu_id: this.data.id,
          commodity_name: this.data.name,
          hot_label: [],
          original_price: this.data.rawPrice,
          discount_price: this.data.price,
          business_case: this.business === 'suggest' ? bu : '其他'
        });
      }

      if (this.data.markInfo) {
        // this.data.markInfo = JSON.parse(this.data.markInfo) || null

        (0, _track2.default)({
          name: 'click-result-suggest',
          attrs: {
            suggestType: _suggestType
          },
          productId: this.data.id
        });
      }
    },
    getVariant: function getVariant() {
      return (0, _axiosMock2.default)({
        headers: headers,
        url: '/app/product/' + this.data.id + '/spvs',
        method: 'GET'
      });
    },
    selectVariant: function selectVariant() {
      return this.$selectVariant({
        pack: this.transform(this.variant.spvs[0]),
        variant: this.variant,
        selectAmount: true
      }).then(function (result) {
        return _promise2.default.resolve({ result: result });
      });
    },
    transform: function transform(spv) {
      return {
        product: {
          brand: {
            name: spv.brand ? spv.brand.name : ''
          },
          name: spv.name
        },
        count: spv.minAmount || 1,
        variant: spv.id
      };
    },
    toCart: function toCart(result) {
      var _this = this;

      this.$showLoading();
      this.add(result.spvId, result.count).then(function (_ref) {
        var code = _ref.code,
            data = _ref.data;

        _this.$hideLoading();
        _this.$toast('加入购物车成功！');
        if (_browser2.default.app()) {
          _bridge2.default.broadcast({
            type: 'refreshPreview'
          });
          _bridge2.default.notify('cart_size_change');
        }
        _this.$emit('after-add');
      }).catch(function (_ref2) {
        var message = _ref2.message;

        _this.$hideLoading();
        _this.$alert(message);
      });
    },
    add: function add(spvId) {
      var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      return (0, _axiosMock2.default)({
        headers: headers,
        url: '/app/cart/packs',
        method: 'POST',
        json: [{
          spvId: spvId,
          count: count,
          source: 'RAW'
        }]
      });
    },
    addCart: function addCart() {
      var _this2 = this;

      this.$showLoading();
      this.getVariant().then(function (_ref3) {
        var data = _ref3.data;

        _this2.$hideLoading();
        _this2.variant = data;
        if (_this2.variant.spvs.length > 1) {
          _this2.selectVariant().then(function (_ref4) {
            var result = _ref4.result;

            if (!result) {
              return;
            }
            _this2.toCart(result);
          });
        } else {
          var spv = _this2.variant.spvs[0];
          _this2.toCart({
            spvId: spv.id,
            count: spv.minAmount || 1
          });
        }
      }).catch(function (_ref5) {
        var message = _ref5.message;

        _this2.$hideLoading();
        _this2.$alert(message);
      });
    }

    // axios({
    //   url: '/app/cart/packs',
    //   method: 'POST',
    //   json: [{
    //     spvId: this.data.spv.id,
    //     count: 1,
    //     source: "RAW"
    //   }]
    // })
    //   .then(() => {
    //     this.$hideLoading()
    //     this.$toast('加入购物车成功！')
    //     this.$emit('after-add', this.data)
    //   })
    //   .catch(({ message }) => {
    //     this.$hideLoading()
    //     this.$alert(message)
    //   })

  }
};

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-product",
    on: {
      "click": _vm.jump
    }
  }, [_c('swiper', {
    staticClass: "product-image",
    attrs: {
      "config": _vm.swiperConfig
    }
  }, _vm._l((_vm.data.images), function(img, index) {
    return _c('div', {
      directives: [{
        name: "key",
        rawName: "v-key",
        value: (index),
        expression: "index"
      }],
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "cover-line left"
    }), _vm._v(" "), _c('div', {
      staticClass: "cover-line right"
    }), _vm._v(" "), (_vm.data._big) ? _c('beast-image', {
      attrs: {
        "lazy": true,
        "src": _vm.data.bigPic.src
      }
    }) : _c('beast-image', {
      attrs: {
        "lazy": true,
        "src": img
      }
    }), _vm._v(" "), (_vm.data.foretell) ? _c('div', {
      staticClass: "corner-box"
    }, [_c('div', {
      staticClass: "stats-tag",
      class: {
        big: _vm.data._big
      }
    }, [_c('span', [_vm._v("即将开售")])])]) : _vm._e(), _vm._v(" "), (_vm.data.offShelf) ? _c('div', {
      staticClass: "corner-box"
    }, [_c('div', {
      staticClass: "stats-tag",
      class: {
        big: _vm.data._big
      }
    }, [_c('span', [_vm._v("下架")])])]) : (_vm.data.soldOut) ? _c('div', {
      staticClass: "corner-box"
    }, [_c('div', {
      staticClass: "stats-tag",
      class: {
        big: _vm.data._big
      }
    }, [_c('span', [_vm._v("售罄")])])]) : _vm._e(), _vm._v(" "), (_vm.addToCart) ? _c('div', {
      staticClass: "add-cart",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addCart.apply(null, arguments)
        }
      }
    }, [_c('beast-image', {
      attrs: {
        "src": "http://img.thebeastshop.com/apppictures/2017-07-12/6066758d9fb8834c2f2f6a9e4a085fa1.png"
      }
    })], 1) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "product-infos"
  }, [(_vm.data.activityDesc) ? _c('div', {
    staticClass: "summary"
  }, [_vm._v(_vm._s(_vm.data.activityDesc))]) : _vm._e(), _vm._v(" "), (_vm.data.customizable) ? _c('div', {
    staticClass: "tag"
  }, [_vm._v("定制")]) : (_vm.data.isOversea) ? _c('div', {
    staticClass: "tag"
  }, [_vm._v("跨境商品")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brand-name"
  }, [_vm._v(_vm._s(_vm.data.brand && _vm.data.brand.name))]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), (_vm.data.newcomerTag && !_vm.data.newcomerUsed) ? _c('div', {
    staticClass: "prices newn"
  }, [_c('div', {
    staticClass: "price discount-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.price
    }
  }), _c('span', {
    staticClass: "newn-tag"
  }, [_vm._v("新人价")])], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  })], 1) : _vm._e()]) : _c('div', {
    staticClass: "prices"
  }, [_c('div', {
    staticClass: "price discount-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.price
    }
  })], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.data.stockWarn) ? _c('div', {
    staticClass: "stock-warn"
  }, [_vm._v(_vm._s(_vm.data.stockWarn || ''))]) : _vm._e()]), _vm._v(" "), (_vm.data.refunds) ? _c('div', {
    staticClass: "refund"
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.data.refunds)) + "元")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.isIphoneX = isIphoneX;
exports.isWeibo = isWeibo;
exports.isQQ = isQQ;
exports.isMobile = isMobile;
exports.getScrollTop = getScrollTop;
exports.getScrollHeight = getScrollHeight;
exports.getWindowHeight = getWindowHeight;
exports.formatMultiNum = formatMultiNum;
exports.zipImage = zipImage;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isIphoneX() {
  return (/iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375 || screen.height == 896 && screen.width == 414)
  );
}

function isWeibo() {
  var isWeibo = !!u.match(/WeiBo/i);
  return isWeibo;
}

function isQQ() {
  var isQQ = !!u.match(/QQ\//i);
  return isQQ;
}

function isMobile() {
  var isMobile = !!u.match(/AppleWebKit.*Mobile.*/);
  return isMobile;
}

function getScrollTop() {
  var scrollTop = 0,
      bodyScrollTop = 0,
      documentScrollTop = 0;
  if (document.body) {
    bodyScrollTop = document.body.scrollTop;
  }
  if (document.documentElement) {
    documentScrollTop = document.documentElement.scrollTop;
  }
  scrollTop = bodyScrollTop - documentScrollTop > 0 ? bodyScrollTop : documentScrollTop;
  return scrollTop;
}

function getScrollHeight() {
  var scrollHeight = 0,
      bodyScrollHeight = 0,
      documentScrollHeight = 0;
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight;
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight;
  }
  scrollHeight = bodyScrollHeight - documentScrollHeight > 0 ? bodyScrollHeight : documentScrollHeight;
  return scrollHeight;
}

function getWindowHeight() {
  var windowHeight = 0;
  if (document.compatMode == "CSS1Compat") {
    windowHeight = document.documentElement.clientHeight;
  } else {
    windowHeight = document.body.clientHeight;
  }
  return windowHeight;
}

function formatMultiNum(num) {
  if (!num) {
    return 0;
  } else {
    var numArr = num.toString().split(".");
    var intNum = numArr.length > 1 ? numArr[1] : numArr[0];
    var reverseNums = intNum.split("").reverse();
    var len = reverseNums.length;
    var newNums = [];

    reverseNums.forEach(function (n, index) {
      if ((index + 1) % 3 === 0) {
        newNums.push(n);
        if (index + 1 !== len) {
          newNums.push(",");
        }
      } else {
        newNums.push(n);
      }
    });

    return newNums.reverse().join("");
  }
}

function zipImage(image, zipWidth) {
  if (!image || !image.src) {
    return '';
  }

  var baseWidth = 750;
  var src = '';
  var newSrc = '';
  if (typeof image === 'string') {
    src = image;
    var width = zipWidth || baseWidth;
    newSrc = formatZipImage(src, width);
    return newSrc;
  }

  if ((typeof image === "undefined" ? "undefined" : (0, _typeof3.default)(image)) === 'object') {
    src = image.src;
    var imageWidth = image.width;
    var myWidth = imageWidth < baseWidth ? imageWidth : baseWidth;
    var _width = zipWidth || myWidth;
    newSrc = formatZipImage(src, _width);
    return {
      src: newSrc,
      width: image.width,
      height: image.height
    };
  }

  return image;
}

function formatZipImage(src, width) {
  var stuffIndex = src.lastIndexOf('.');
  var stuff = src.substring(stuffIndex);
  var stuffStr = stuff.toLowerCase();

  if (stuffStr == ".jpg" || stuffStr == ".jpeg" || stuffStr == ".png" || stuffStr == ".webp") {
    return src + "@0o_0l_" + width + "w_90q";
  } else if (stuffStr == ".gif") {
    return src + "?x-oss-process=image/resize,w_" + width + "/quality,q_90";
  } else {
    return src;
  }
}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _urlUtil = __webpack_require__(21);

var _main = __webpack_require__(178);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var searchIcon = (0, _urlUtil.ensure_protocol)('http://img.thebeastshop.com/images/menu-tab/menu-search.png');

exports.default = {
  components: {
    search: _main2.default
  },

  props: ['mode', 'searchText', 'show'],

  data: function data() {
    return {
      searchIcon: searchIcon,
      isShow: false
    };
  },


  watch: {
    show: function show(val) {
      sa.setCurrentPage('搜索页');
      if (val) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    }
  },

  methods: {
    goSearch: function goSearch(e) {
      this.isShow = true;
      this.$emit('showsearch');
      sa.track('SearchButtonClick', {});
      sa.setCurrentPage('搜索页');
    },
    close: function close() {
      this.isShow = false;
      this.$emit('hidesearch');
    }
  }

};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(179)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(214),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _appMain = __webpack_require__(158);

var _appMain2 = _interopRequireDefault(_appMain);

var _navbar = __webpack_require__(168);

var _navbar2 = _interopRequireDefault(_navbar);

var _simpleProduct = __webpack_require__(167);

var _simpleProduct2 = _interopRequireDefault(_simpleProduct);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _list = __webpack_require__(205);

var _list2 = _interopRequireDefault(_list);

var _associateList = __webpack_require__(209);

var _associateList2 = _interopRequireDefault(_associateList);

var _util = __webpack_require__(137);

var _link2 = __webpack_require__(55);

var _apis = __webpack_require__(213);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY_CODE = {
  13: 'iOS'
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var MIN_HEIGHT = 35;

exports.default = {
  components: {
    beastMain: _appMain2.default,
    navBar: _navbar2.default,
    searchList: _list2.default,
    associateList: _associateList2.default
  },

  props: ['isShow'],

  data: function data() {
    return {
      ipt: null,
      query: '',
      key: '',
      aKey: '',
      items: [],
      banners: [],
      associateList: null,
      defaultKey: '',
      suggest: null,
      hotItem: null,
      history: [],
      isSearch: false,
      increase: 0,
      loaded: false,
      isDefault: false,
      isAssociate: false,
      enable: true,
      hideMore: false,
      maxIndex: 7,
      seaching: false,
      searchType: '搜索词',
      sortField: 'SYNTHESIS', // PRICE
      sortOrder: 'DESC' // ASC
    };
  },
  created: function created() {
    var _this = this;

    this.getHotSearch();
    this.history = this.getKeys().split('-');

    this.$nextTick(function () {
      var hist = document.querySelector('#history-key');
      console.log(hist, '11');
      if (!hist) return;
      console.log(hist.clientHeight, 'hhs');
      if (hist.clientHeight >= MIN_HEIGHT * 2) {
        _this.hideMore = true;
      } else {
        _this.hideMore = false;
      }
    });
  },
  mounted: function mounted() {
    this.ipt = document.querySelector('input[name="search-input"]');
    this.ipt.focus();
  },


  watch: {
    defaultKey: function defaultKey(val) {
      var _this2 = this;

      if (!val) {
        this.reset();
        this.isSearch = false;
        this.isAssociate = false;
        return;
      }

      if ((typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) !== 'object') {
        this.isDefault = false;
      }

      if (this.enable && (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) !== 'object') {
        setTimeout(function () {
          _this2.getAssociate(val);
        }, 50);
      } else {
        this.isAssociate = false;
      }
    }
  },

  methods: {
    init: function init() {
      var bd = document.body;
      var vm = this;

      this.ipt.value = '';

      bd.addEventListener('keyup', function (e) {
        if (!(e.keyCode in KEY_CODE)) return;
        vm.reset();
        vm.isAssociate = false;

        if (vm.isDefault) {
          sa.track('SearchClick', (0, _extends3.default)({}, sa.getReferPageName(), {
            search_type: '默认词',
            search_word: vm.defaultKey.name,
            if_directional_skip: true
          }));
          vm.goLink(vm.defaultKey);
          (0, _track2.default)({
            name: 'default-search',
            attrs: {
              keyword: vm.defaultKey.name,
              type: vm.defaultKey.linkType
            },
            wait: false
          });
        } else {
          vm.key = vm.ipt.value || vm.defaultKey.name;
          vm.getResult(vm.key);
        }
      });
    },
    getAssociate: function getAssociate(keyword) {
      var _this3 = this;

      (0, _apis.getAssociate)(keyword).then(function (_ref) {
        var data = _ref.data;

        _this3.associateList = data;

        if (data.length) {
          _this3.aKey = keyword;
          _this3.isAssociate = true;
        } else {
          _this3.isAssociate = false;
        }
      }).catch(function (err) {});
    },
    showMoreHist: function showMoreHist() {
      this.hideMore = false;
      this.maxIndex = this.history.length;
    },
    onScroll: function onScroll(e) {
      var tar = e.currentTarget;
      var height = tar.clientHeight;
      var scrollTop = tar.scrollTop;
      var scrollHeight = tar.scrollHeight;

      if (scrollTop + height >= scrollHeight) {
        this.getResult(this.key, this.query);
      }
    },
    focusInput: function focusInput() {
      this.searchType = '搜索词';
      this.getAssociate(this.key);
    },
    search: function search(item) {
      console.log('search11');
      this.reset();
      this.enable = false;
      this.goLink(item, false, '联想词');
    },
    action: function action(type, sort) {
      var _this4 = this;

      this.sortField = type;
      this.sortOrder = sort;
      this.reset();
      this.$nextTick(function () {
        _this4.getResult(_this4.key, _this4.query);
      });
    },
    list: function list(query, selected) {
      var _this5 = this;

      this.showlist = true;
      this.clearFilter = false;

      if (!query) return;

      this.reset();

      this.$nextTick(function () {
        _this5.getResult(_this5.key, query);
      });
    },
    navshow: function navshow(select) {
      this.showlist = false;
    },
    reset: function reset() {
      this.items = [];
      this.increase = 0;
      // this.finish = false
      // this.netError = false
      // this.isEnded = false
    },
    goLink: function goLink(item, flag, searchType) {
      console.log('search22', searchType);
      if (flag) {
        (0, _track2.default)({
          name: 'hot-search',
          attrs: {
            keyword: item.name,
            type: item.linkType
          },
          wait: false
        });
      }

      this.searchType = searchType || '搜索词';

      if (!item.deeplink) {
        this.getResult(item.name);
        return;
      }

      var link = (0, _util.getLink)(item.deeplink);
      sa.track('SearchClick', (0, _extends3.default)({}, sa.getReferPageName(), {
        search_type: this.searchType,
        search_word: item.name,
        if_directional_skip: true
      }));
      window.location.href = link;
    },
    jumpBanner: function jumpBanner(link) {
      var _link = (0, _link2.transformLink)({ link: link });

      window.location.href = _link;
    },
    getResult: function getResult(key, query) {
      var _this6 = this;

      if (!key) return;

      this.ipt.blur();
      this.enable = false;
      this.defaultKey = key;
      this.key = key;
      this.setKeys(key);

      (0, _track2.default)({
        name: 'search',
        attrs: {
          keyword: key
        },
        wait: false
      });

      this.$showLoading();

      var que = query;

      if (!que) {
        que = 'keyword=' + key;
      }

      this.query = '' + que;

      (0, _apis.searchByKeywords)(this.query + '&sortField=' + this.sortField + '&sortOrder=' + this.sortOrder, this.increase).then(function (_ref2) {
        var data = _ref2.data;

        _this6.$hideLoading();

        var list = data.list,
            suggest = data.suggest,
            jump = data.jump;

        // 发起搜索请求

        sa.track('SearchClick', (0, _extends3.default)({}, sa.getReferPageName(), {
          search_type: _this6.searchType,
          search_word: key,
          if_directional_skip: jump ? true : false
        }));

        if (jump) {
          var link = (0, _link2.transformLink)({
            link: jump
          });
          window.location.href = link;
          return;
        }

        if (!list) return;

        _this6.isSearch = true;

        var items = list.items;


        _this6.increase++;

        _this6.items = _this6.items.concat(items);

        _this6.enable = true;
        _this6.seaching = false;
        _this6.suggest = suggest;
      }).catch(function (err) {
        _this6.$hideLoading();
        _this6.$alert(err.message || '系统异常');
      });
      this.isAssociate = false;
    },
    getHotSearch: function getHotSearch() {
      var _this7 = this;

      (0, _apis.getHotSearch)().then(function (data) {
        _this7.hotItem = data;
        _this7.defaultKey = data.defaultKeyword;
        _this7.banners = data.banners;

        if (_this7.defaultKey && _this7.defaultKey.deeplink) {
          _this7.isDefault = true;
        }

        _this7.$nextTick(function () {
          _this7.init();
        });
      });
    },
    goSearch: function goSearch(key, searchType) {
      this.key = key;
      this.searchType = searchType;
      this.getResult(key);
    },
    getKeys: function getKeys() {
      var history = localStorage.getItem('__bstkeys') || '';
      return history;
    },
    setKeys: function setKeys(val) {
      var history = this.getKeys();
      var temp = history.split('-');

      if (~temp.indexOf(val)) {
        return;
      }

      history += val + '-';

      localStorage.setItem('__bstkeys', history);
    },
    clearSearch: function clearSearch() {
      var _this8 = this;

      localStorage.removeItem('__bstkeys');
      this.history = [];

      this.$nextTick(function () {
        _this8.ipt.value = '';
      });
    },
    cancel: function cancel() {
      this.isSearch = false;
      this.$emit('close');
    },
    goCart: function goCart() {
      window.location.href = '/cart';
    }
  }
};

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slide = __webpack_require__(8);

var _slide2 = _interopRequireDefault(_slide);

var _nav = __webpack_require__(183);

var _nav2 = _interopRequireDefault(_nav);

var _apis = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAV_NAME = ['综合', '新品', '价格', '筛选']; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var NAV_TYPE = ['SYNTHESIS', 'RELEASE', 'PRICE', 'FILTER'];
var ENUM_SORT = ['DEFAULT', 'ASC', 'DESC', ''];

exports.default = {
  name: 'navBar',

  components: {
    Slide: _slide2.default,
    navList: _nav2.default
  },

  props: ['query', 'clearFilter', 'type', 'new', 'label', 'discountSelected', 'tips', 'sortField'],

  data: function data() {
    return {
      navName: NAV_NAME,
      navType: NAV_TYPE,
      logined: false,
      level: 0,
      isDesc: false,
      showSlide: false,
      sort: 1,
      curActive: NAV_TYPE.indexOf(this.sortField) || 0,
      sortField: this.sortField || 'SYNTHESIS',
      sortOrder: 'DEFAULT',
      isKindActive: false,
      selected: {},
      selectObject: null,
      selectQuery: {
        cateSelected: '',
        brandSelected: '',
        hotSelected: ''
      }
    };
  },
  created: function created() {
    if (this.new == 1) {
      this.sortField = 'RELEASE';
      this.curActive = 1;
    }
  },


  methods: {
    show: function show(selected) {
      var _this = this;

      this.selectObject = {
        que: this.query,
        selected: selected
      };

      this.$nextTick(function () {
        _this.showSlide = true;
      });

      this.$emit('navshow', selected);
    },
    selectNav: function selectNav(type, index, e) {
      var _this2 = this;

      var tar = e.currentTarget;

      if (type === 'FILTER') {
        if (this.clearFilter) {
          this.selectQuery = {
            cateSelected: '',
            brandSelected: '',
            hotSelected: ''
          };
        }

        var _selectQuery = this.selectQuery,
            cateSelected = _selectQuery.cateSelected,
            brandSelected = _selectQuery.brandSelected,
            hotSelected = _selectQuery.hotSelected;


        this.show(cateSelected + ',' + brandSelected + ',' + hotSelected);
      } else {
        // init sort
        if (type === this.sortField && type !== 'PRICE') return;
        if (type !== this.sortField) {
          this.sortField = type;
          this.sort = 2;
        } else if (type === this.sortField && type !== 'PRICE') {
          this.sort = 2;
          // if (this.type === 'search' && this.sortField) {
          //   this.sortField = ''
          //   this.sort = 3
          //   type = ''
          //   index = -1
          // }
          // else {

          // }
        }

        this.curActive = index;

        this.$nextTick(function () {
          if (type === 'PRICE') {
            _this2.sort = _this2.sort - 1;

            if (_this2.sort === 3) {
              type = '';
              _this2.curActive = -1;
            }
            // set sort
            tar.classList.remove('DESC');
            tar.classList.remove('ASC');
            if (ENUM_SORT[_this2.sort]) {
              tar.classList.add(ENUM_SORT[_this2.sort]);
            }
          }

          _this2.$emit('action', type, ENUM_SORT[_this2.sort]);

          if (_this2.type !== 'search') {
            _this2.sort = _this2.sort == 1 ? 3 : _this2.sort;
          } else {
            if (_this2.sort == 2) {
              _this2.sort = 2;
            } else if (_this2.sort == 3) {
              _this2.sort = 2;
            } else {
              _this2.sort = _this2.sort == 1 ? 3 : _this2.sort;
            }
          }
        });
      }
    },
    labelJump: function labelJump(label) {
      var title = '';

      if (label.linkDesc) {
        title = label.linkDesc.replace(/查看/, '');
      }

      window.location.href = label.link + '&title=' + encodeURIComponent(title);
    },
    onSelect: function onSelect(query, selected, saleSelected, isSelected) {
      if (query) {
        this.isKindActive = true;
      } else {
        this.isKindActive = false;
      }

      var _filter = document.querySelectorAll('.nav-item')[3];
      console.log(isSelected, '123');
      if (isSelected || saleSelected) {
        _filter.classList.add('active');
      } else {
        _filter.classList.remove('active');
      }

      this.showSlide = false;
      this.$emit('list', query, saleSelected);
    }
  }
};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(184)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(203),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(27);

var _keys2 = _interopRequireDefault(_keys);

var _appHeader = __webpack_require__(136);

var _appHeader2 = _interopRequireDefault(_appHeader);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _moreList = __webpack_require__(199);

var _moreList2 = _interopRequireDefault(_moreList);

var _apis = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    cateList: _moreList2.default,
    AppHeader: _appHeader2.default
  },

  props: ['selectObject', 'clearFilter', 'discountSelected'],

  data: function data() {
    return {
      query: '',
      categories: null,
      brands: null,
      hots: null,
      selected: {},
      nameSelected: {},
      isReset: false,
      hideCate: false,
      hideBrand: false,
      isSale: false,
      saleSelected: false,
      isWechat: _browser2.default.weixin()
    };
  },
  created: function created() {
    this.initQuery();
    this.getCateg(this.query);
  },


  watch: {
    selectObject: function selectObject() {
      this.saleSelected = this.discountSelected;
      if (this.clearFilter) {
        this.initQuery();
        this.getCateg(this.query);
      }
    }
  },

  methods: {
    initQuery: function initQuery() {
      var _selectObject = this.selectObject,
          selected = _selectObject.selected,
          que = _selectObject.que;


      var tempSel = {};
      if (selected) {
        var cate = selected.split(',');
        cate.forEach(function (item, index) {
          var select = item.split('_');
          select.forEach(function (sel) {
            if (sel) {
              var tag = 'hot';
              switch (index) {
                case 0:
                  tag = 'cate';
                  break;
                case 1:
                  tag = 'brand';
                  break;
              }
              tempSel[sel] = tag;
            }
          });
        });
      }

      // 
      que = que.replace(/(&)+$/, '');

      this.query = que + '&selected=' + selected;
      this.selected = tempSel;
      this.isReset = (0, _keys2.default)(tempSel).length;
    },
    getCateg: function getCateg(query, notDel) {
      var _this = this;

      this.$showLoading();
      (0, _apis.getFilter)(query).then(function (_ref) {
        var data = _ref.data;

        _this.$hideLoading();
        _this.categories = data[1].items;
        _this.brands = data[2].items, // 品牌
        _this.hots = data[3].items; // 热门

        _this.isSale = data[0].items.length ? true : false;

        if (!notDel) {
          _this.delSelected();
        }

        if (_this.categories.length > 9 && !_this.getIsSelected('cate')) {
          _this.hideCate = true;
        }

        if (_this.brands.length > 9 && !_this.getIsSelected('brand')) {
          _this.hideBrand = true;
        }
      });
    },
    delSelected: function delSelected() {
      var categories = this.categories,
          brands = this.brands,
          hots = this.hots,
          selected = this.selected,
          nameSelected = this.nameSelected;


      var collects = [];
      var temp = {};

      categories.forEach(function (el) {
        collects.push(el.id);
      });

      brands.forEach(function (el) {
        collects.push(el.id);
      });

      hots.forEach(function (el) {
        collects.push(el.id);
      });

      for (var k in selected) {
        var sel = selected[k];

        if (~collects.indexOf(k)) {
          temp[k] = sel;
        } else {
          delete nameSelected[k];
        }
      }

      this.selected = temp;
      this.nameSelected = nameSelected;
      this.isReset = (0, _keys2.default)(temp).length;
    },
    getIsSelected: function getIsSelected(type) {
      for (var key in this.selected) {
        if (this.selected[key] === type) {
          return true;
        }
      }

      return false;
    },
    goSelect: function goSelect() {
      var _this2 = this;

      var query = this.query;
      var cateSelected = '';
      var brandSelected = '';
      var hotSelected = '';

      (0, _keys2.default)(this.selected).forEach(function (i) {
        var type = _this2.selected[i];
        if (type === 'cate') {
          cateSelected += i + '_';
        }
        if (type === 'brand') {
          brandSelected += i + '_';
        }

        if (type == 'hot') {
          hotSelected += i + '_';
        }
      });

      var selected = {
        cateSelected: cateSelected,
        brandSelected: brandSelected,
        hotSelected: hotSelected
      };

      query = query.replace(/(&)+$/, '');
      var tempQuery = query.replace(/selected=[A-Za-z0-9_,]+&?/g, '').replace(/(discountOnly=true&)$/, '');

      if (this.saleSelected) {
        query = tempQuery + 'discountOnly=true&';
      } else {
        query = tempQuery + 'selected=' + cateSelected + ',' + brandSelected + ',' + hotSelected + '&';
      }

      var _cateSelected = '';
      var _brandSelected = '';
      var _hotSelected = '';

      (0, _keys2.default)(this.nameSelected).forEach(function (i) {
        var obj = _this2.nameSelected[i];
        var type = obj.type;
        var name = obj.name;

        if (type === 'cate') {
          _cateSelected += name + '_';
        }
        if (type === 'brand') {
          _brandSelected += name + '_';
        }

        if (type == 'hot') {
          _hotSelected += name + '_';
        }
      });

      sa.track('CommodityScreen', {
        screen_classify: _cateSelected.split('_'),
        screen_brand_commodity: _brandSelected.split('_'),
        hot_label: _hotSelected.split('_')
      });

      this.$emit('select', query, selected, this.saleSelected, (0, _keys2.default)(this.selected).length);
    },
    goSale: function goSale() {
      this.saleSelected = !this.saleSelected;

      this.isReset = this.saleSelected;
      if (this.saleSelected) {
        this.selected = {};
        this.getCateg('&selected=,,,&' + this.query, true);
      }
    },
    selectItem: function selectItem(id, type, name, e) {
      var tar = e.currentTarget;
      var isActive = tar.dataset.active;

      var selected = this.selected,
          nameSelected = this.nameSelected,
          query = this.query;


      if (id in selected) {
        delete selected[id];
        delete nameSelected[id];
        tar.classList.remove('active');
      } else {
        selected[id] = type;
        nameSelected[id] = {
          type: type,
          name: name
        };
        tar.classList.add('active');
      }

      this.selected = selected;
      this.nameSelected = nameSelected;
      this.isReset = (0, _keys2.default)(selected);

      this.saleSelected = false;

      var selQue = this.formatSeled();

      this.getCateg('&selected=' + selQue + '&' + query);
    },


    goReset: function goReset() {
      var isReset = this.isReset,
          query = this.query;


      if (isReset) {
        this.getCateg('&selected=,,,&' + query);
      }

      this.selected = {};
      this.nameSelected = {};
      this.isReset = false;
      this.saleSelected = false;
    },

    getMore: function getMore(type) {
      if (type === 'brand') {
        this.hideBrand = !this.hideBrand;
      } else {
        this.hideCate = !this.hideCate;
      }
    },


    formatSeled: function formatSeled() {
      var _this3 = this;

      var cateQue = '';
      var brandQue = '';
      var hotQue = '';

      (0, _keys2.default)(this.selected).forEach(function (i) {
        var type = _this3.selected[i];

        if (type === 'cate') {
          cateQue += i + '_';
        }
        if (type === 'brand') {
          brandQue += i + '_';
        }
        if (type === 'hot') {
          hotQue += i + '_';
        }
      });

      return cateQue + ',' + brandQue + ',' + hotQue;
    }
  }
};

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _browser = __webpack_require__(1);

var _appMenu = __webpack_require__(188);

var _appMenu2 = _interopRequireDefault(_appMenu);

var _search = __webpack_require__(159);

var _search2 = _interopRequireDefault(_search);

var _events = __webpack_require__(25);

var _events2 = _interopRequireDefault(_events);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _api = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_events2.default);
exports.default = {
  components: {
    AppMenu: _appMenu2.default,
    Search: _search2.default
  },
  name: 'header',
  props: {
    cart: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Boolean,
      default: false
    },
    isHidden: { // hide navbar or not
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '加载中...'
    }
  },

  data: function data() {
    return {
      isApp: (0, _browser.app)(),
      isWechat: (0, _browser.weixin)(),
      cartNum: 0
    };
  },
  created: function created() {
    var _this = this;

    console.log(this._on, 'o');
    this._on('change-title', function (data) {
      console.log(data, 'tsr');
      _this.title = data;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    // if (this.isWechat) {
    //   const searchWrap = document.querySelector('.detail-icon .search-wrap')

    //   if (searchWrap) {
    //     searchWrap.parentElement.style.display = 'none'
    //   }
    // }

    if (this.cart) {
      (0, _api.getCartNum)().then(function (data) {
        _this2.cartNum = data || 0;
      });
    }
  },


  computed: {
    headerClass: function headerClass() {
      return this.isWechat && this.isHidden ? 'header-wechat' : 'header-wap';
    }
  },

  methods: {
    goCarts: function goCarts() {
      window.location.href = '/cart';
    }
  }
};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(189)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(196),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _main = __webpack_require__(191);

var _main2 = _interopRequireDefault(_main);

var _apis = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//

exports.default = {
  components: {
    appMenu: _main2.default
  },

  data: function data() {
    return {
      isShow: false,
      config: null
    };
  },


  methods: {
    getConfig: function getConfig() {
      var cfg = this.getStorage();

      if (cfg) {
        this.config = cfg;
        this.reqConfig();
      } else {
        this.reqConfig(true);
      }
    },
    reqConfig: function reqConfig(flag) {
      var _this = this;

      (0, _apis.getConfig)().then(function (data) {
        if (flag) {
          _this.config = data.modules;
        }
        _this.setStorage(data.modules);
      });
    },
    goMenu: function goMenu() {
      this.getConfig();
      this.isShow = !this.isShow;
    },
    close: function close() {
      this.isShow = false;
    },
    getStorage: function getStorage() {
      var config = window.localStorage.getItem('__beast_config');

      return config ? JSON.parse(config) : null;
    },
    setStorage: function setStorage(cfg) {
      window.localStorage.setItem('__beast_config', (0, _stringify2.default)(cfg));
    }
  }
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(192)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(194),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _queryString = __webpack_require__(13);

var _queryString2 = _interopRequireDefault(_queryString);

var _util = __webpack_require__(137);

var _apis = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['data'],

  data: function data() {
    return {
      menu: this.data,
      member: null,
      isShow: false
    };
  },
  created: function created() {
    var _this = this;

    if (!this.member) {
      (0, _apis.getMember)().then(function (data) {
        _this.member = data;
      }).catch(function (err) {});
    }
  },


  methods: {
    jump: function jump(expand, link, e) {
      if (expand && expand.length) {
        this.showChild(e);
      } else {
        link = this.formatLink(link);

        var url = (0, _util.getLink)(link);
        window.location.href = url;
      }
    },
    closeMenu: function closeMenu() {
      this.$emit('close');
    },
    showChild: function showChild(e) {
      var tar = e.currentTarget;
      var item = tar.nextElementSibling;
      var isShow = item.dataset.show;

      if (isShow !== 'block') {
        isShow = 'block';
      } else {
        isShow = 'none';
      }

      tar.dataset.show = isShow;
      item.dataset.show = isShow;
      item.style.display = isShow;
    },
    formatLink: function formatLink(link) {
      var type = link.type,
          value = link.value;


      if (type == 'none') return false;

      var deeplink = 'beastapp://';

      switch (type) {
        case 'article':
          deeplink = deeplink + 'article/' + value;
          break;
        case 'shop':
          deeplink = deeplink + 'shop/' + value;
          break;
        case 'shop-story':
          deeplink = deeplink + 'entry?name=shop-story&shopId=' + value;
          break;
        case 'list':
          deeplink = deeplink + 'search?listId=' + value;
          break;
        case 'category':
          deeplink = deeplink + 'search?categoryId=' + value;
          break;
        case 'product':
          deeplink = deeplink + 'product/' + value;
          break;
        case 'oversea':
          deeplink = deeplink + 'search?overseasOnly=true';
          break;
        case 'categoryOversea':
          deeplink = deeplink + 'search?overseasOnly=true&categoryId=' + value;
          break;
        case 'deeplink':
          deeplink = '' + value;
          break;
        case 'brand':
          deeplink = deeplink + 'search?brandId=' + value;
          break;
        case 'tag':
          deeplink = deeplink + 'search?labelId=' + value;
          break;
        case 'group':
          deeplink = deeplink + 'entry?name=group-purchase&productId=' + value;
          break;
        case 'new':
          deeplink = deeplink + 'search?new=1';
          break;
        case 'custom':
          deeplink = deeplink + 'entry?name=customization-list';
          break;
        case 'discount':
          deeplink = deeplink + 'search?param=discount&title=\u6298\u6263';
          break;
        case 'retail':
          deeplink = deeplink + 'entry?name=retail&title=\u5B9E\u4F53\u5E97';
          break;
        case 'index':
          deeplink = deeplink + 'index';
          break;
      }

      return deeplink;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "beast-menu"
  }, [_c('div', {
    staticClass: "menu-wrap"
  }, [_c('div', {
    staticClass: "menu-member"
  }, [_c('div', {
    staticClass: "member-logo"
  }, [(_vm.member) ? _c('img', {
    attrs: {
      "src": _vm.member && _vm.member.level.avatarUrl
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(195)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "member-infos"
  }, [_c('div', {
    staticClass: "member-name"
  }, [_vm._v(_vm._s(_vm.member && _vm.member.profile.nickName))]), _vm._v(" "), (_vm.member) ? _c('div', {
    staticClass: "member-account"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "member-account no-login"
  }, [_vm._m(1)])]), _vm._v(" "), _c('span', {
    staticClass: "close-member",
    on: {
      "click": _vm.closeMenu
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-list"
  }, [_c('div', {
    staticClass: "menu-group"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        return _vm.jump(null, {
          type: 'index',
          value: ''
        }, $event)
      }
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _vm._l((_vm.menu), function(item) {
    return _c('div', {
      staticClass: "menu-item"
    }, [_c('h2', {
      on: {
        "click": function($event) {
          return _vm.jump(item.data.subCategory, item.data.link, $event)
        }
      }
    }, [_vm._v(_vm._s(item.data.title)), (item.data.subCategory.length) ? _c('i') : _vm._e()]), _vm._v(" "), (item.data.subCategory.length) ? _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.expand),
        expression: "item.expand"
      }],
      staticClass: "menu-item-child",
      attrs: {
        "data-show": item.expand && 'block'
      }
    }, _vm._l((item.data.subCategory), function(child) {
      return _c('li', {
        staticClass: "menu-child-item",
        on: {
          "click": function($event) {
            return _vm.jump(null, child.link, $event)
          }
        }
      }, [_vm._v("\n              " + _vm._s(child.title) + "\n            ")])
    }), 0) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-item"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        return _vm.jump(null, {
          type: 'custom',
          value: ''
        }, $event)
      }
    }
  }, [_vm._v("高级定制")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        return _vm.jump(null, {
          type: 'discount',
          value: ''
        }, $event)
      }
    }
  }, [_vm._v("折扣优惠")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        return _vm.jump(null, {
          type: 'retail',
          value: ''
        }, $event)
      }
    }
  }, [_vm._v("实体店")])])], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/my"
    }
  }, [_vm._v("我的账号"), _c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/my"
    }
  }, [_vm._v("登录/快速注册"), _c('i')])
}]}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "beast-menu-wrap"
  }, [_c('div', {
    staticClass: "menu-icon",
    on: {
      "click": _vm.goMenu
    }
  }), _vm._v(" "), (_vm.config && _vm.isShow) ? _c('app-menu', {
    attrs: {
      "show": _vm.isShow,
      "data": _vm.config
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

exports.getCartNum = getCartNum;

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headers = {};

function getCartNum() {
  return (0, _axiosMock2.default)({
    url: '/app/cart/packs/size'
  }).then(function (_ref) {
    var code = _ref.code,
        data = _ref.data;

    return _promise2.default.resolve(data);
  }).catch(function (err) {
    return _promise2.default.reject(err);
  });
}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isApp) ? _c('div', {
    class: _vm.headerClass
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "z-index": "2000"
    }
  }, [_c('div', {
    staticClass: "header-left"
  }, [(_vm.menu) ? _c('app-menu', {
    staticClass: "header-left-menu"
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.isWechat) ? _c('p', {
    staticClass: "header-title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_vm._t("default"), _vm._v(" "), (_vm.cart) ? _c('div', {
    staticClass: "detail-icon detail-group"
  }, [_c('div', {
    staticClass: "carts-icon",
    on: {
      "click": _vm.goCarts
    }
  }, [_c('i'), _vm._v(" "), (_vm.cartNum > 0) ? _c('div', {
    staticClass: "fix-num"
  }, [_c('div', {
    staticClass: "cart-num"
  }, [_vm._v(_vm._s(_vm.cartNum))]), _vm._v(" "), _c('div', {
    staticClass: "triangle-right"
  })]) : _vm._e()])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(200)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(202),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appHeader = __webpack_require__(136);

var _appHeader2 = _interopRequireDefault(_appHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    AppHeader: _appHeader2.default
  },

  props: ['data']
}; //
//
//
//
//
//
//
//

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "more-list"
  }, _vm._l((_vm.data), function(item) {
    return _c('li', {
      attrs: {
        "data-id": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kind-wrap"
  }, [(_vm.isSale) ? _c('div', {
    staticClass: "sale",
    class: {
      'active': _vm.saleSelected
    },
    on: {
      "click": _vm.goSale
    }
  }, [_vm._v("查看折扣商品")]) : _vm._e(), _vm._v(" "), (_vm.categories && _vm.categories.length) ? _c('div', {
    staticClass: "kind-list"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("分类\n      "), (_vm.categories.length > 9) ? _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.getMore('cate')
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.hideCate ? '更多' : '收起'))]), _c('div', {
    staticClass: "icon",
    class: {
      'hide': !_vm.hideCate
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ul-list",
    class: {
      'hide-cate': _vm.hideCate
    }
  }, _vm._l((_vm.categories), function(item, index) {
    return _c('div', {
      staticClass: "list",
      class: {
        'cancel-margin': (index + 1) % 3 == 0,
        'active': _vm.selected[item.id]
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(item.id, 'cate', item.name, $event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.brands && _vm.brands.length) ? _c('div', {
    staticClass: "kind-list"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("品牌\n      "), (_vm.brands.length > 9) ? _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.getMore('brand')
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.hideBrand ? '更多' : '收起'))]), _c('div', {
    staticClass: "icon",
    class: {
      'hide': !_vm.hideBrand
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ul-list",
    class: {
      'hide-cate': _vm.hideBrand
    }
  }, _vm._l((_vm.brands), function(item, index) {
    return _c('div', {
      staticClass: "list",
      class: {
        'cancel-margin': (index + 1) % 3 == 0,
        'active': _vm.selected[item.id]
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(item.id, 'brand', item.name, $event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.hots && _vm.hots.length) ? _c('div', {
    staticClass: "kind-list"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ul-list"
  }, _vm._l((_vm.hots), function(item, index) {
    return _c('div', {
      staticClass: "list",
      class: {
        'cancel-margin': (index + 1) % 3 == 0,
        'active': _vm.selected[item.id]
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(item.id, 'hot', item.name, $event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kind-footer"
  }, [_c('span', {
    staticClass: "reset",
    class: {
      'active': _vm.isReset
    },
    on: {
      "click": _vm.goReset
    }
  }, [_vm._v("重置筛选项")]), _vm._v(" "), _c('span', {
    staticClass: "select",
    on: {
      "click": _vm.goSelect
    }
  }, [_vm._v("确定")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tit"
  }, [_vm._v("热门标签\n      "), _c('p')])
}]}

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-wrap"
  }, [_c('div', {
    staticClass: "nav-bar"
  }, [_c('div', {
    staticClass: "nav-kinds",
    class: 'no-member'
  }, _vm._l((_vm.navName), function(item, index) {
    return _c('div', {
      staticClass: "nav-item",
      class: {
        active: index == _vm.curActive
      },
      on: {
        "click": function($event) {
          return _vm.selectNav(_vm.navType[index], index, $event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n        "), (_vm.navType[index] === 'PRICE') ? _c('span', {
      staticClass: "icon-sort"
    }, [_c('i', {
      class: {
        'icon-kinds': _vm.navType[index] == 'FILTER',
        'active': _vm.isKindActive
      }
    })]) : _vm._e()])
  }), 0), _vm._v(" "), _c('slide', {
    attrs: {
      "from": "right",
      "height": "100%",
      "show": _vm.showSlide,
      "maskOpacity": 0
    }
  }, [(_vm.selectObject) ? _c('nav-list', {
    attrs: {
      "discountSelected": _vm.discountSelected,
      "selectObject": _vm.selectObject,
      "clearFilter": _vm.clearFilter
    },
    on: {
      "select": _vm.onSelect
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.tips) ? _c('div', {
    staticClass: "top-tip"
  }, [_vm._v(_vm._s(_vm.tips))]) : _vm._e(), _vm._v(" "), (_vm.label) ? _c('div', {
    staticClass: "label-tag",
    class: {
      valid: !_vm.label.valid
    }
  }, [_c('div', {
    staticClass: "tag-name",
    style: ({
      'background-color': _vm.label.typeBgColor,
      'color': _vm.label.typeColor
    })
  }, [_vm._v(_vm._s(_vm.label.type))]), _vm._v(" "), _c('div', {
    staticClass: "tag-desc"
  }, [_vm._v(_vm._s(_vm.label.summary))]), _vm._v(" "), (_vm.label.jump) ? _c('div', {
    staticClass: "tag-link",
    on: {
      "click": function($event) {
        return _vm.labelJump(_vm.label)
      }
    }
  }, [_vm._v(_vm._s(_vm.label.linkDesc)), _c('i')]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(208),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleProductNew = __webpack_require__(166);

var _simpleProductNew2 = _interopRequireDefault(_simpleProductNew);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _sdk = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    simpleProduct: _simpleProductNew2.default
  },

  props: ['data', 'keys', 'suggest'],

  data: function data() {
    return {
      list: null,
      sdk: null,
      env: 'm-web'
    };
  },
  created: function created() {
    var _this = this;

    (0, _sdk.getEnv)().then(function (sdk) {
      sdk.init({
        vue: _this
      });
      _this.sdk = sdk;
      _this.env = sdk.adapter.env;
    });
  },


  methods: {
    goPro: function goPro(pid) {
      if (this.enable) {
        return;
      }
      location.href = '/product/' + pid;
    },
    trackData: function trackData(index) {
      (0, _track2.default)({
        name: 'click-result',
        attrs: {
          index: index
        },
        wait: true
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data.length) ? _c('div', {
    staticClass: "product-list"
  }, [(_vm.suggest) ? _c('div', {
    staticClass: "suggest"
  }, [_c('p', [_vm._v("没找到\"" + _vm._s(_vm.keys) + "\"的搜索结果\"")]), _vm._v(" "), _c('p', [_vm._v("为你推荐\"" + _vm._s(_vm.suggest.keyword) + "\"的相关商品")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return (_vm.data.length) ? _c('simple-product', {
      class: {
        'no-margin': (index + 1) % 2 === 0
      },
      attrs: {
        "sdk": _vm.sdk,
        "env": _vm.env,
        "index": index,
        "searchKey": _vm.keys,
        "data": item
      },
      on: {
        "click": function($event) {
          return _vm.trackData(index)
        }
      }
    }) : _vm._e()
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(210)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(212),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    list: {
      type: Array
    },
    aKey: {
      type: String
    }
  },

  methods: {
    selectKey: function selectKey(item) {
      this.$emit('selectItem', item);
    },
    output: function output(item) {
      var reg = new RegExp('(' + this.aKey + ')', 'i');

      return item.name.replace(reg, '<span class="associate-key">$1</span>');
    }
  }
};

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "associate"
  }, [_c('ul', {
    staticClass: "associate-list"
  }, _vm._l((_vm.list), function(item) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(_vm.output(item))
      },
      on: {
        "click": function($event) {
          return _vm.selectKey(item)
        }
      }
    })
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

exports.searchByKeywords = searchByKeywords;
exports.getHotSearch = getHotSearch;
exports.getAssociate = getAssociate;

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headers = {};

function searchByKeywords(query) {
  var increase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var limit = 20;
  var offset = increase * limit;

  return (0, _axiosMock2.default)({
    headers: headers,
    url: '/app/search/product?' + query + '&limit=' + limit + '&offset=' + offset
  });
}

function getHotSearch() {
  return (0, _axiosMock2.default)({
    headers: headers,
    url: '/app/search/suggest'
  }).then(function (_ref) {
    var code = _ref.code,
        data = _ref.data;

    return _promise2.default.resolve(data);
  });
}

function getAssociate(keyword) {
  return (0, _axiosMock2.default)({
    url: '/app/search/associate?keyword=' + keyword
  });
}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search",
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('div', {
    staticClass: "search-top"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultKey),
      expression: "defaultKey"
    }],
    attrs: {
      "type": "search",
      "name": "search-input",
      "placeholder": (typeof _vm.defaultKey == 'object' && _vm.defaultKey && _vm.defaultKey.name) || '搜索全网商品'
    },
    domProps: {
      "value": (_vm.defaultKey)
    },
    on: {
      "focus": _vm.focusInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.defaultKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "search-cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])]), _vm._v(" "), (_vm.isSearch) ? _c('div', {
    staticClass: "result-list"
  }, [_c('nav-bar', {
    staticClass: "p-nav-bar",
    attrs: {
      "query": ("keyword=" + _vm.key),
      "type": 'search'
    },
    on: {
      "navshow": _vm.navshow,
      "action": _vm.action,
      "list": _vm.list
    }
  }), _vm._v(" "), (!_vm.seaching && !_vm.items.length) ? _c('div', {
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(215)
    }
  }), _vm._v(" "), _c('p', [_vm._v("没有搜索到你要的结果")])]) : _vm._e(), _vm._v(" "), _c('search-list', {
    attrs: {
      "data": _vm.items,
      "keys": _vm.key,
      "suggest": _vm.suggest
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "go-cart",
    on: {
      "click": _vm.goCart
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAssociate) ? _c('associate-list', {
    attrs: {
      "list": _vm.associateList,
      "aKey": _vm.aKey
    },
    on: {
      "selectItem": _vm.search
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isSearch) ? _c('div', {
    staticClass: "search-key"
  }, [(_vm.history.length > 1) ? _c('div', {
    staticClass: "latest-key"
  }, [_c('span', {
    staticClass: "search-clear",
    on: {
      "click": _vm.clearSearch
    }
  }), _vm._v(" "), _c('h2', [_vm._v("搜索历史")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "history-key"
    }
  }, [_vm._l((_vm.history), function(item, index) {
    return (item && index < _vm.maxIndex) ? _c('li', {
      on: {
        "click": function($event) {
          return _vm.goSearch(item, '历史词')
        }
      }
    }, [_vm._v(_vm._s(item) + " ")]) : _vm._e()
  }), _vm._v(" "), (_vm.hideMore && _vm.history.length > 6) ? _c('li', {
    staticClass: "item-more",
    on: {
      "click": _vm.showMoreHist
    }
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.hotItem && _vm.hotItem.hotKeys.length > 0) ? _c('div', {
    staticClass: "hot-key"
  }, [_c('h2', [_vm._v("热门发现")]), _vm._v(" "), _c('ul', _vm._l((_vm.hotItem.hotKeys), function(item) {
    return _c('li', {
      class: {
        'high-light': item.highlight
      },
      on: {
        "click": function($event) {
          return _vm.goLink(item, true, '热门搜索')
        }
      }
    }, [_c('i'), _vm._v(_vm._s(item.name) + " ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.banners.length) ? _c('div', {
    staticClass: "search-banner"
  }, _vm._l((_vm.banners), function(banner) {
    return _c('div', {
      staticClass: "img-item",
      on: {
        "click": function($event) {
          return _vm.jumpBanner(banner.link)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": banner.src
      }
    })])
  }), 0) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "s/img/icon-empty.eb42237.png";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-wrap"
  }, [(_vm.mode === 'input') ? _c('div', {
    staticClass: "search-input"
  }, [_c('input', {
    attrs: {
      "placeholder": "点击搜索"
    },
    on: {
      "click": _vm.goSearch
    }
  })]) : (_vm.mode === 'line-input') ? _c('div', {
    staticClass: "line-search-wrap"
  }, [_c('div', {
    staticClass: "line-search-box",
    on: {
      "click": _vm.goSearch
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "search-pa search-text"
  }, [_vm._v(_vm._s(_vm.searchText))])])]) : _c('div', {
    staticClass: "search-icon",
    on: {
      "click": _vm.goSearch
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.searchIcon
    }
  })]), _vm._v(" "), (_vm.isShow) ? _c('search', {
    attrs: {
      "show": _vm.isShow
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-pa search-icon"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": __webpack_require__(217)
    }
  })])
}]}

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAMAAADUivDaAAAAS1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADmYDp0AAAAGHRSTlMA0hORsyro+rLw1szHvqaZa2RPRT4c3YYni5VJAAABOklEQVRYw+2W626DMAyFA7lSCFAohfd/0tWk1bQJHHdnqiqV84/Y+Uh8SaIOHXqtRh1q510d9Pin+Ze2Wr5VtZdnAdYsv2XsUwS9bEnLAWV8TCpMN3emeHzGUrqJa5rQ9NN9ZOqbNHS1sjUkwmn4MTqcEkO0jrizb532Io2kP29Yzl4WU7uQiLDBWG3ZcJj0J2aFJleTayR3zWtMM3Xaks+wax7I3PKIiuqBsTfUL3xv0l96xqEnhzGb0YlxmLJ5DdQXihP1S+AcakpaNuk15+BuDh2L6G4ejnOgEp5ZxEzl/3+rwGOBZwSvC7w68R7BOxU/L/BTCz874RM8wPeIL0rsNiMRA7hT7wzgZvcMQ/a+CAWzDuErp2QY0rcWz8i/+HhGXgfjgxhRoQxnFcggAsYgAsaIVh16V30Bv1o1NG/U1poAAAAASUVORK5CYII="

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(224)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(234),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */,
/* 220 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _dialog = __webpack_require__(10);

var _dialog2 = _interopRequireDefault(_dialog);

var _controller = __webpack_require__(226);

var _controller2 = _interopRequireDefault(_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var winWidth = window.innerWidth; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    BDialog: _dialog2.default,
    controller: _controller2.default
  },

  props: {
    wrap: {
      default: ''
    },
    videoId: {
      default: ''
    },
    videoIndex: {
      default: 0
    },
    totalVideo: {
      default: 0
    },
    width: {
      default: 'auto'
    },
    height: {
      default: 'auto'
    },
    controls: {
      default: true
    },
    poster: {
      default: './assets/poster.jpeg'
    },
    source: String,
    autoplay: {
      default: false
    },
    videoFormat: {
      default: ''
    },
    muted: {
      default: 'muted'
    },
    radius: {
      default: '0'
    },
    multiVideo: {
      default: false
    },
    videoPopData: {
      default: null
    },
    playVideo: {
      default: false
    }
  },

  data: function data() {
    return {
      w: 0,
      h: 0,
      // showControls: false,
      showControls: true, //视频controls一直展示，controls字段用来控制进度条是否展示
      container: null,
      added: false,
      video: null,
      videoPop: null,
      video_wrap: null,
      poster_dom: null,
      loading: null,
      loading_dom: null,
      updateTime: 0,
      duration: 0,
      showLoading: false,
      isShowContr: false,
      isFullScreen: false,
      loop: this.autoplay && !this.controls ? true : false,
      wxAndroidFlag: _browser2.default.weixin() && _browser2.default.android()
      // wxAndroidFlag: true
    };
  },


  // watch: {
  //   videoIndex: function(){
  //     console.log(this.videoId, this.totalVideo, this.videoIndex, '$$$$$$$$$$$$$$$$')
  //     for(var i = 0; i<this.totalVideo; i++) {
  //       if(this.videoId) {
  //         this.pause()
  //       }
  //     }
  //   }
  // },

  mounted: function mounted() {
    var wrap = document.querySelector('.' + this.wrap);
    // console.log(wrap, 'wrap')
    this.container = wrap.querySelector('.video-container');
    this.video = this.container.querySelector('.j_video');
    // this.videoPop = this.container.querySelector('.j_video_pop')
    this.video_wrap = this.container.querySelector('.j_video_wrap');
    this.poster_dom = this.container.querySelector('.poster');
    this.loading_dom = this.container.querySelector('.j_loading');
    this.loading = this.container.querySelector('.j_loading_img');

    this.container.style.height = this.height + 'px';
    this.w = this.container.clientWidth || this.width + 'px';
    this.h = this.height;

    //默认都有自定义controls  通过controlsFlag控制是否展示播放暂停 进度调节等按钮
    // if (this.controls) {
    //   this.showControls = true
    // }
    if (this.wxAndroidFlag) {
      // this.video.muted = false
      this.showControls = false;
    }

    if (this.autoplay && _browser2.default.app() || this.playVideo) {
      this.onPlay();
    }
    // if ((this.autoplay && browser.app()) || (this.autoplay && this.muted) || this.playVideo) {
    //   this.onPlay()//app里面可以自动播放  非app但是静音模式可以自动播放 
    // }

    if (_browser2.default.app() && _browser2.default.android()) {
      if (this.muted) {
        this.video.muted = true;
      }
    }
  },


  methods: {
    onPlay: function onPlay() {
      if (this.wxAndroidFlag && this.multiVideo) {
        //安卓的微信环境且是多视频 触发浮层视频
        this.$emit('video-pop', this.videoPopData);
      } else {
        if (!this.added) {
          this._showLoading();
          this._addVideo();
        } else {
          this.play();
        }
      }
    },
    play: function play() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.video.currentTime = time;
      this.poster_dom.style.display = 'none';
      this.video.play();
    },
    pause: function pause() {
      this.video.pause();
      // if (this.controls) {
      //   this.controls.set('pause')
      // }
    },
    cPlay: function cPlay() {
      this.play(this.video.currentTime);
      this.isShowContr = false;
    },
    cPause: function cPause() {
      // console.log(this.video.paused, '###########')
      if (this.videoId) {
        !this.video.paused && this.pause();
      } else {
        this.pause();
      }
    },
    cJump: function cJump(time) {
      this.video.currentTime = time;
    },
    cFull: function cFull() {
      if (_browser2.default.ios()) {
        this.isFullScreen = true;
      } else {
        this.controls && (this.showControls = false);
        this.video.requestFullScreen && this.video.requestFullScreen();
        this.video.webkitRequestFullScreen && this.video.webkitRequestFullScreen();
      }
    },
    cExitFull: function cExitFull() {
      if (_browser2.default.ios()) {
        this.isFullScreen = false;
      }
    },
    cMuted: function cMuted() {
      this.video.muted = true;
    },
    cVoice: function cVoice() {
      this.video.muted = false;
    },
    posterLoaded: function posterLoaded(e) {
      var posterImg = e.currentTarget;

      this.fit(posterImg);
      posterImg.style.pointerEvents = 'all';
    },
    fit: function fit(el) {
      this._scale(el);

      el.style.visibility = 'visible';
    },
    toggleContr: function toggleContr() {
      if (document.webkitIsFullScreen) {
        return;
      }
      // this.controls && (this.isShowContr = true)
      this.isShowContr = true;
    },
    controlAction: function controlAction() {
      if (document.webkitIsFullScreen) {
        return;
      }
      this.isShowContr = !this.isShowContr;
    },
    _scale: function _scale(el) {
      this.w = parseInt(this.w);
      this.h = parseInt(this.h);

      if (this.w && !this.h) {
        el.style.width = '100%';
        this.container.style.height = el.clientHeight + 'px';
        this.h = el.clientHeight + 'px';
        // this.controls && this.controls.setMask(this.height - (Math.round(16 * winWidth / 375) + Math.round(26 * winWidth / 375)))
        return;
      }

      if (!this.w && this.h) {
        el.style.height = this.h + 'px';
        el.style.position = 'absolute';
        el.style.webkitTransform = 'translateX(-50%)';
        el.style.transform = 'translateX(-50%)';
        el.style.left = '50%';
        el.style.top = 0;

        this.container.style.width = el.clientWidth + 'px';
        this.w = el.clientWidth + 'px';
        // this.controls && this.controls.setMask(this.h - (Math.round(16 * winWidth / 375) + Math.round(26 * winWidth / 375)))
        return;
      }

      if (this.w && this.h) {
        var containerScale = this.w / this.h;
        var elScale = el.clientWidth / el.clientHeight;

        el.style.position = 'absolute';

        if (containerScale > elScale) {
          el.style.height = this.h + 'px';
          el.style.webkitTransform = 'translateX(-50%)';
          el.style.transform = 'translateX(-50%)';
          el.style.left = '50%';
          el.style.top = 0;
        } else {
          el.style.width = this.w + 2 + 'px';
          el.style.height = '100%';
          // el.style.webkitTransform = 'translateY(-50%)'
          // el.style.transform = 'translateY(-50%)'
          // el.style.top = '50%'
          el.style.transform = 'translateY(0)';
          el.style.top = '-1px';
          el.style.left = '-1px';
        }
        // this.controls && this.controls.setMask(this.h - (Math.round(16 * winWidth / 375) + Math.round(26 * winWidth / 375)))
        return;
      }
      // this.controls && this.controls.setMask(this.h - (Math.round(16 * winWidth / 375) + Math.round(26 * winWidth / 375)))
    },
    _addVideo: function _addVideo() {
      var _this = this;

      // this.video.controls = false
      this.added = true;

      this.video.on = function (event, callback) {
        _this.video.addEventListener(event, callback);
        return _this.video;
      };

      this.video.removeAttribute('controls');
      //fuck ios10, onresize only works in ios10
      this.video.onresize = function (e) {
        if (e.srcElement === window) {
          _this.video.removeAttribute('controls');
        }
      };

      this.video.on('play', function () {
        // this.controls && this.controls.set('play')
        _this.$emit('play');
      }).on('pause', function () {
        // this.controls && this.controls.set('pause')
        _this.$emit('pause');
      }).on('waiting', function () {
        _this._showLoading();
      }).on('canplay', function () {
        _this._hideLoading();
      }).on('loadedmetadata', function () {
        _this.fit(_this.video, _this.video_wrap);
        _this.controls && (_this.duration = _this.video.duration);
      }).on('loadeddata', function () {
        _this.play();
      }).on('timeupdate', function () {
        _this.updateTime = _this.video.currentTime + '-' + _this.video.duration;
        _this.$emit('playing', _this.video.currentTime);
      }).on('ended', function () {
        _this.$emit('ended');
        if (_this.controls) {
          _this.isShowContr = false;
          _this.updateTime = '0-' + _this.video.duration;
        }
        _this.poster_dom.style.display = '';
      }).on('error', function (e) {
        console.log('error', e);
        _this.$emit('error', e);
      }).on('abort', function (e) {
        console.log('abort', e);
        _this.$emit('abort', e);
      });

      this.video.src = this.source;
      this.play();
    },
    _showLoading: function _showLoading() {
      // this.showControls = false
      this.showLoading = true;
      this.loading_dom.style.display = 'block';
      this.loading.style.display = 'block';
    },
    _hideLoading: function _hideLoading() {
      this.showLoading = false;
      this.loading_dom.style.display = 'none';
    },
    resume: function resume() {
      this.video.currentTime = 0;
      this.video.pause();
      this.poster_dom.style.display = 'block';
      this.$emit('resume');
    },
    isPaused: function isPaused() {
      return this.video.paused;
    }
  }
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(227)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(229),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var winWidth = window.innerWidth; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['updateTime', 'duration', 'width', 'wrap', 'mutedD', 'controlsFlag', 'videoId', 'videoIndex', 'totalVideo', 'autoplay', 'loop'],

  data: function data() {
    return {
      container: null,
      progress_bar: null,
      controls: null,
      startTime: null,
      endTime: null,
      played: false,
      isFullScreen: false,
      bar: null,
      c_wrap: null,
      mutedData: this.mutedD
    };
  },


  watch: {
    updateTime: function updateTime(time) {
      var t = time.split('-');

      this._updateTime(t[0], t[1]);
    },
    duration: function duration(_duration) {
      var t = this._format(_duration);

      this.endTime.innerHTML = t.m + ':' + t.s;
    },
    width: function width() {
      //65 padding15*2+voice20+voicepadding15*2
      // console.log(this.width, '$$$$$$$$$width')
      this.bar.style.width = this.width - 4 - (winWidth / 375 * 80 + this.startTime.clientWidth + this.endTime.clientWidth) + 'px';
    },
    videoIndex: function videoIndex(_videoIndex) {
      console.log(this.videoId, this.totalVideo, this.videoIndex, '$$$$$$$$$$$$$$$$');
      if (!this.autoplay || !this.loop) {
        //非背景自动播放模式 swiper滑动暂停视频播放
        for (var i = 0; i < this.totalVideo; i++) {
          if (this.videoId) {
            this.pause();

            // const videoIndex = this.videoIndex || 1
            // this.controls.style.zIndex=videoIndex+6
          }
        }
      }
    }
  },

  mounted: function mounted() {
    this.c_wrap = document.querySelector('.' + this.wrap);
    this.container = this.c_wrap.querySelector('.controls');
    this.progress_bar = this.container.querySelector('.j_progress_bar');
    this.controls = this.container.querySelector('.j_controls');
    this.playBtn = this.container.querySelector('.j_play');
    this.pauseBtn = this.container.querySelector('.j_pause');
    this.full_btn = this.container.querySelector('.j_full');
    this.exitFullBtn = this.container.querySelector('.j_exit_full');
    this.voiceBtn = this.container.querySelector('.j_voice');
    this.mutedBtn = this.container.querySelector('.j_muted');
    this.startTime = this.container.querySelector('.j_start_time');
    this.endTime = this.container.querySelector('.j_end_time');
    this.bar = this.container.querySelector('.j_bar');
  },


  methods: {
    controlAction: function controlAction() {
      this.$emit('control-action');
    },
    play: function play() {
      this.played = false;
      this.$emit('play');
    },
    pause: function pause() {
      this.played = true;
      this.$emit('pause');
    },
    jumpTime: function jumpTime(e) {
      var bar = e.currentTarget;
      var pos = e.layerX;
      var total = bar.clientWidth;
      var time = this.computeTime(pos, total);

      this.$emit('jump', time);
      this._updateTime(time, this.duration);
    },
    fullScreen: function fullScreen() {
      this._fullScreen();
      this.$emit('full');
    },
    exitFullScreen: function exitFullScreen() {
      this._exitFullScreen();
      this.$emit('exitfull');
    },
    _fullScreen: function _fullScreen() {
      if (_browser2.default.ios) {
        this.isFullScreen = true;
      }
    },
    _exitFullScreen: function _exitFullScreen() {
      if (_browser2.default.ios) {
        this.isFullScreen = false;
      }
    },
    muted: function muted() {
      this.mutedData = true;
      this.$emit('mutedA');
    },
    voice: function voice() {
      this.mutedData = false;
      this.$emit('voice');
    },
    computeTime: function computeTime(cur, total) {
      return (cur / total).toFixed(2) * this.duration;
    },
    _updateTime: function _updateTime(time, duration) {
      var t = this._format(time);
      this.startTime.innerHTML = t.m + ':' + t.s;

      if (duration) {
        this.progress_bar.style.width = time / duration * 100 + '%';
      }
    },
    _format: function _format(time) {
      var t = Math.floor(time);
      var m = Math.floor(t / 60);
      var s = t - m * 60;
      return {
        m: m < 10 ? '0' + m : m,
        s: s < 10 ? '0' + s : s
      };
    }
  }
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controls j_controls",
    on: {
      "click": _vm.controlAction
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.played),
      expression: "played"
    }],
    staticClass: "play-icon j_play",
    class: {
      'disnone': !_vm.controlsFlag
    },
    staticStyle: {
      "display": "none"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.play.apply(null, arguments)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(230)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.played),
      expression: "!played"
    }],
    staticClass: "pause-icon j_pause",
    class: {
      'disnone': !_vm.controlsFlag
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.pause.apply(null, arguments)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(231)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mask1 j_mask1"
  }), _vm._v(" "), _c('div', {
    staticClass: "mask2 j_mask2"
  }), _vm._v(" "), _c('div', {
    staticClass: "mask3 j_mask3"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "left",
    class: {
      'opa0': !_vm.controlsFlag
    }
  }, [_c('div', {
    staticClass: "time j_start_time"
  }, [_vm._v("00:00")]), _vm._v(" "), _c('div', {
    staticClass: "bar-wrap j_bar"
  }, [_c('div', {
    staticClass: "bar",
    on: {
      "click": _vm.jumpTime
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "time j_end_time"
  }, [_vm._v("00:00")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mutedData),
      expression: "!mutedData"
    }],
    staticClass: "voice j_voice",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.muted.apply(null, arguments)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(232)
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mutedData),
      expression: "mutedData"
    }],
    staticClass: "exit voice j_muted",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.voice.apply(null, arguments)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(233)
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar j_progress_bar"
  }, [_c('div', {
    staticClass: "bar-circle"
  })])
}]}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAA6CAYAAADP/mu6AAAABGdBTUEAALGPC/xhBQAAAn1JREFUaAXVmk8uBEEUxqdFLK25ADcwFg5gwSGmD8ACwRFIcASzcAMk7CWMG7BkQWIjsWMxvjeZN6lUurvqddffTp7q+kP/3jdVn+qe7vVyPsbj8RViObscAP2NeEMMEEU2CUzBCZ7iDrGaBbwGTvBfiEPEQqoJTKYFgdcAvqJ9pyiKp5r+aM1zhiuvoJ+mzjli0TA2aLcJnGFKnDwDfosbYpe24MS5hCDbTMI6JeAsMqk+QgJRrdO0OBm2rqRFu4vF+1I3wFd7G8VVlnVUHqD+ESKodXZVXE0iqHV2VVwFD2qdLsE5iRIn3q3TBzgl4N06fYGz+mydJRav012ny8XJsHXlCB2073Finb4VV5Poo+LMOkMqribR2TpDKq6Cd7bOWOCcRIkTss5tbrAtY02VKr4bNB5g8X5UdeptsRVXecg6SX0r60xJcTUJo3WmpLgKbrTOVBVXk6i0zlQVV8HZOi8w/2c37DmAcxIDnMysMydwTmBS5gQ+BHEfPn9N5PP0I/GDFifdkD+qnCkr/gfQU8SGDk0JpKp4dv+AfiDmHmITKjfecKSk+C2A9wFstclKAfwTwLQrnLgFzq2O2ItzCMqZxVkRTwfFUrzS4lIGJ4s7R5xhavxKQPWxIRU3WpwO11QPMcetLa4JVO/zrbjI4nS4prov8FYW1wSq9/mYKpe4SCuL0+Ga6i4Vr7zFarp4lz4XipPFnSBoFxfsi9yuiju1OMkn0FZxLxYnAW+juOhRmQRGMlYC7t3iJOC2U4Usbk269ZSASMeaFA9qcVL4Hp4Q8dtBXNKLNseIoN8WdwW/B3BWrza9A9jq2bRYGV+/AOAk3kHxlV9Sf/cfk4hP2K18hugAAAAASUVORK5CYII="

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAA6CAYAAADybArcAAAABGdBTUEAALGPC/xhBQAAALtJREFUaAXtksENgCAAxMQJ3H9KN8C4QrHGmPrvCS3b9pNv3PeYc54r9xljHCv8E//fVw7wJbaLfKnGfZaKVEQy0NOSxOLZimB1ElgRSSyerQhWJ4EVkcTi2YpgdRJYEUksnq0IVieBFZHE4tmKYHUSWBFJLJ6tCFYngRWRxOLZimB1ElgRSSyerQhWJ4EVkcTi2YpgdRJYEUksnq0IVieBFZHE4tmKYHUSWBFJLJ6tCFYngb8pIvl5f/YCAuMIcFqvJvcAAAAASUVORK5CYII="

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container",
    class: {
      'full-screen': _vm.isFullScreen
    }
  }, [(_vm.wxAndroidFlag) ? _c('div', {
    staticClass: "video-wrap j_video_wrap",
    attrs: {
      "id": _vm.videoId
    }
  }, [(_vm.muted) ? _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "loop": "loop",
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true",
      "muted": "muted"
    },
    domProps: {
      "muted": true
    },
    on: {
      "click": _vm.toggleContr
    }
  }) : _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "loop": "loop",
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true"
    },
    on: {
      "click": _vm.toggleContr
    }
  })]) : _c('div', {
    staticClass: "video-wrap j_video_wrap",
    attrs: {
      "id": _vm.videoId
    }
  }, [(_vm.loop && _vm.muted) ? _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "loop": "loop",
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true",
      "muted": "muted"
    },
    domProps: {
      "muted": true
    },
    on: {
      "click": _vm.toggleContr
    }
  }) : (_vm.loop && !_vm.muted) ? _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "loop": "loop",
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true"
    },
    on: {
      "click": _vm.toggleContr
    }
  }) : (!_vm.loop && _vm.muted) ? _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true",
      "muted": "muted"
    },
    domProps: {
      "muted": true
    },
    on: {
      "click": _vm.toggleContr
    }
  }) : (!_vm.loop && !_vm.muted) ? _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true"
    },
    on: {
      "click": _vm.toggleContr
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "poster j_poster"
  }, [_c('img', {
    staticClass: "poster-img j_poster_img",
    attrs: {
      "src": _vm.poster
    },
    on: {
      "load": _vm.posterLoaded
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "play-mask"
  }, [_c('img', {
    staticClass: "play-icon j_play_btn",
    attrs: {
      "src": __webpack_require__(235)
    },
    on: {
      "click": _vm.onPlay
    }
  })])]), _vm._v(" "), (_vm.showControls) ? _c('controller', {
    class: {
      'c-hidden': !_vm.isShowContr
    },
    attrs: {
      "updateTime": _vm.updateTime,
      "duration": _vm.duration,
      "width": _vm.w,
      "wrap": _vm.wrap,
      "mutedD": _vm.muted,
      "controlsFlag": _vm.controls,
      "videoId": _vm.videoId,
      "videoIndex": _vm.videoIndex,
      "totalVideo": _vm.totalVideo,
      "autoplay": _vm.autoplay,
      "loop": _vm.loop
    },
    on: {
      "play": _vm.cPlay,
      "pause": _vm.cPause,
      "jump": _vm.cJump,
      "full": _vm.cFull,
      "exitfull": _vm.cExitFull,
      "mutedA": _vm.cMuted,
      "voice": _vm.cVoice,
      "control-action": _vm.controlAction
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading j_loading"
  }, [_c('div', {
    staticClass: "img-wrap j_loading_img"
  }, [_c('span')])])
}]}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var dataStr = '[{"name":"华北","value":[{"name":"北京","value":[{"name":"北京市","value":["东城区","西城区","朝阳区","海淀区","丰台区","石景山区","通州区","顺义区","大兴区","昌平区"]}]},{"name":"天津","value":[{"name":"天津市","value":["和平区","河东区","河西区","南开区","河北区","红桥区","北辰区","东丽区","津南区","西青区","武清区","滨海新区"]}]},{"name":"山东","value":[{"name":"滨州市","value":["滨城区"]},{"name":"淄博市","value":["淄川区","张店区","周村区"]},{"name":"济南市","value":["历下区","市中区","槐荫区","天桥区","历城区","长清区"]},{"name":"烟台市","value":["芝罘区","福山区","牟平区","莱山区"]},{"name":"泰安市","value":["岱岳区","泰山区"]},{"name":"临沂市","value":["罗庄区","河东区","兰山区"]},{"name":"聊城市","value":["东昌府区"]},{"name":"潍坊市","value":["坊子区","奎文区","潍城区","开发区","寒亭区"]},{"name":"青岛市","value":["市南区","市北区","四方区","崂山区","李沧区"]},{"name":"枣庄市","value":["市中区","峄城区","滕州市","薛城区"]},{"name":"德州市","value":["德城区"]},{"name":"莱芜市","value":["莱城区"]},{"name":"东营市","value":["东营区","西城区","东城区"]},{"name":"威海市","value":["环翠区"]},{"name":"济宁市","value":["任城区","市中区"]},{"name":"日照市","value":["东港区"]},{"name":"菏泽市","value":["牡丹区"]}]},{"name":"河北","value":[{"name":"秦皇岛市","value":["海港区","经济技术开发区"]},{"name":"张家口市","value":["桥东区","桥西区"]},{"name":"保定市","value":["北市区","南市区","新市区","高开区"]},{"name":"唐山市","value":["丰南区","开平区","路北区","路南区"]},{"name":"廊坊市","value":["安次区","广阳区"]},{"name":"沧州市","value":["新华区","运河区"]},{"name":"邯郸市","value":["邯山区","丛台区","复兴区","邯郸县"]},{"name":"衡水市","value":["桃城区"]},{"name":"邢台市","value":["桥东区","桥西区"]},{"name":"石家庄市","value":["长安区","桥东区","桥西区","新华区","裕华区"]}]},{"name":"山西","value":[{"name":"运城市","value":["盐湖区"]},{"name":"晋中市","value":["榆次区"]},{"name":"长治市","value":["城区","郊区"]},{"name":"晋城市","value":["城区","泽州县"]},{"name":"临汾市","value":["尧都区"]},{"name":"太原市","value":["小店区","迎泽区","杏花岭区","尖草坪区","万柏林区","晋源区"]}]},{"name":"内蒙古自治区","value":[{"name":"包头市","value":["昆都仑区","东河区","青山区","石拐区","九原区"]},{"name":"鄂尔多斯市","value":["东胜区","伊金霍洛旗"]},{"name":"呼和浩特市","value":["回民区","新城区","玉泉区","赛罕区"]},{"name":"赤峰市","value":["红山区","松山区"]}]}]},{"name":"华东","value":[{"name":"上海","value":[{"name":"上海市","value":["黄浦区","徐汇区","长宁区","静安区","普陀区","闸北区","虹口区","杨浦区","闵行区","奉贤区","青浦区","宝山区","嘉定区","浦东新区","松江区","金山区"]}]},{"name":"浙江","value":[{"name":"杭州市","value":["上城区","下城区","西湖区","拱墅区","滨江区","江干区","余杭区","萧山区"]},{"name":"湖州市","value":["吴兴区"]},{"name":"绍兴市","value":["越城区"]},{"name":"温州市","value":["鹿城区","瓯海区","龙湾区"]},{"name":"台州市","value":["椒江区","黄岩区","路桥区"]},{"name":"舟山市","value":["定海区","普陀区"]},{"name":"金华市","value":["婺城区","金东区"]},{"name":"丽水市","value":["莲都区"]},{"name":"宁波市","value":["海曙区","江北区","江东区","镇海区","鄞州区"]},{"name":"嘉兴市","value":["南湖区","秀洲区"]},{"name":"衢州市","value":["柯城区","衢江区"]}]},{"name":"江苏","value":[{"name":"南京市","value":["玄武区","白下区","建邺区","鼓楼区","下关区","栖霞区","江宁区","雨花台区","秦淮区"]},{"name":"徐州市","value":["鼓楼区","云龙区","泉山区","铜山区"]},{"name":"泰州市","value":["海陵区","高港区"]},{"name":"常州市","value":["天宁区","钟楼区","戚墅堰区","新北区","武进区"]},{"name":"镇江市","value":["京口区","润州区","丹徒区"]},{"name":"宿迁市","value":["宿城区","宿豫区"]},{"name":"苏州市","value":["沧浪区","平江区","金阊区","虎丘区","吴中区","相城区","园区","新区","姑苏区"]},{"name":"无锡市","value":["崇安区","南长区","北塘区","锡山区","惠山区","滨湖区","新区"]},{"name":"连云港市","value":["连云区","新浦区","海州区"]},{"name":"盐城市","value":["亭湖区"]},{"name":"扬州市","value":["广陵区","邗江区","经济开发区","维扬区"]},{"name":"淮安市","value":["清河区","淮阴区","清浦区"]},{"name":"南通市","value":["崇川区","港闸区","通州区","开发区"]}]},{"name":"江西","value":[{"name":"吉安市","value":["吉州区","青原区"]},{"name":"鹰潭市","value":["月湖区"]},{"name":"九江市","value":["庐山区","浔阳区"]},{"name":"萍乡市","value":["安源区"]},{"name":"抚州市","value":["临川区"]},{"name":"南昌市","value":["东湖区","西湖区","青云谱区","湾里区","青山湖区","红谷滩新区","经济技术开发区"]},{"name":"上饶市","value":["信州区"]},{"name":"新余市","value":["渝水区"]},{"name":"赣州市","value":["章贡区","赣县"]},{"name":"景德镇市","value":["昌江区","珠山区"]},{"name":"宜春市","value":["袁州区"]}]},{"name":"安徽","value":[{"name":"淮南市","value":["大通区","田家庵区"]},{"name":"黄山市","value":["屯溪区","徽州区"]},{"name":"安庆市","value":["迎江区","大观区"]},{"name":"蚌埠市","value":["龙子湖区","蚌山区","禹会区","淮上区"]},{"name":"六安市","value":["金安区","裕安区"]},{"name":"马鞍山市","value":["金家庄区","花山区","雨山区"]},{"name":"合肥市","value":["瑶海区","庐阳区","蜀山区","包河区","高新区"]},{"name":"滁州市","value":["琅琊区","南谯区"]},{"name":"阜阳市","value":["颍州区","颍东区","颍泉区"]},{"name":"芜湖市","value":["镜湖区","鸠江区","弋江区"]}]}]},{"name":"华南","value":[{"name":"广东","value":[{"name":"潮州市","value":["湘桥区","枫溪区"]},{"name":"珠海市","value":["香洲区","斗门区","金唐区","金湾区","南湾区"]},{"name":"阳江市","value":["江城区"]},{"name":"东莞市","value":["全境"]},{"name":"茂名市","value":["茂南区"]},{"name":"韶关市","value":["武江区","浈江区","曲江区"]},{"name":"梅州市","value":["梅江区"]},{"name":"肇庆市","value":["端州区","鼎湖区"]},{"name":"中山市","value":["全境"]},{"name":"湛江市","value":["赤坎区"]},{"name":"清远市","value":["清城区"]},{"name":"佛山市","value":["禅城区","南海区","顺德区","三水区","高明区"]},{"name":"广州市","value":["荔湾区","越秀区","海珠区","天河区","白云区","黄埔区","花都区","番禺区","南沙区","萝岗区"]},{"name":"汕尾市","value":["城区"]},{"name":"惠州市","value":["惠城区"]},{"name":"深圳市","value":["罗湖区","福田区","南山区","宝安区","龙岗区","龙华新区","盐田区"]},{"name":"汕头市","value":["龙湖区","金平区"]},{"name":"江门市","value":["蓬江区","江海区"]},{"name":"云浮市","value":["云城区"]},{"name":"河源市","value":["源城区"]},{"name":"揭阳市","value":["东山区"]}]},{"name":"广西","value":[{"name":"钦州市","value":["钦南区","钦北区"]},{"name":"柳州市","value":["城中区","柳北区","柳南区","鱼峰区"]},{"name":"桂林市","value":["叠彩区","七星区","象山区","秀峰区","雁山区"]},{"name":"玉林市","value":["玉州区"]},{"name":"梧州市","value":["万秀区","长洲区"]},{"name":"南宁市","value":["兴宁区","青秀区","江南区","西乡塘区","良庆区","邕宁区"]},{"name":"北海市","value":["海城区","银海区"]}]},{"name":"福建","value":[{"name":"福州市","value":["鼓楼区","台江区","仓山区","马尾区","晋安区"]},{"name":"厦门市","value":["思明区","海沧区","湖里区","同安区","翔安区","集美区"]},{"name":"泉州市","value":["鲤城区","丰泽区"]},{"name":"漳州市","value":["芗城区","龙文区"]},{"name":"龙岩市","value":["新罗区"]},{"name":"莆田市","value":["城厢区","涵江区","荔城区","秀屿区"]}]},{"name":"海南省","value":[{"name":"三亚市","value":["吉阳区","天涯区"]},{"name":"海口市","value":["秀英区","龙华区","琼山区","美兰区"]}]}]},{"name":"华中","value":[{"name":"湖北","value":[{"name":"黄石市","value":["黄石港区","西塞山区","下陆区"]},{"name":"襄阳市","value":["樊城区","襄城区","襄州区"]},{"name":"武汉市","value":["江岸区","江汉区","硚口区","武昌区","洪山区","青山区","东西湖区","汉阳区"]},{"name":"宜昌市","value":["西陵区","伍家岗区","点军区","夷陵区","葛洲坝区"]},{"name":"黄冈市","value":["黄州区"]},{"name":"荆州市","value":["沙市区","荆州区"]}]},{"name":"湖南","value":[{"name":"常德市","value":["武陵区","鼎城区"]},{"name":"长沙市","value":["芙蓉区","天心区","开福区","雨花区","长沙县","岳麓区"]},{"name":"永州市","value":["冷水滩区"]},{"name":"岳阳市","value":["岳阳楼区","云溪区","君山区"]},{"name":"郴州市","value":["北湖区","苏仙区"]},{"name":"衡阳市","value":["石鼓区","雁峰区","珠晖区"]},{"name":"怀化市","value":["鹤城区"]},{"name":"益阳市","value":["资阳区","赫山区"]},{"name":"娄底市","value":["娄星区"]},{"name":"邵阳市","value":["双清区","大祥区","北塔区"]},{"name":"湘潭市","value":["雨湖区","岳塘区"]},{"name":"株洲市","value":["荷塘区","芦淞区","石峰区","天元区"]}]},{"name":"河南","value":[{"name":"洛阳市","value":["老城区","西工区","涧西区","洛龙区","瀍河回族区","高新区"]},{"name":"周口市","value":["川汇区"]},{"name":"安阳市","value":["文峰区","北关区","殷都区","龙安区"]},{"name":"商丘市","value":["梁园区","睢阳区"]},{"name":"平顶山市","value":["新华区","卫东区"]},{"name":"濮阳市","value":["华龙区"]},{"name":"郑州市","value":["中原区","二七区","管城回族区","金水区","惠济区","郑东新区","高新区","上街区"]},{"name":"驻马店市","value":["驿城区"]},{"name":"信阳市","value":["浉河区"]},{"name":"南阳市","value":["宛城区","卧龙区"]},{"name":"焦作市","value":["解放区","中站区","山阳区"]},{"name":"新乡市","value":["红旗区","卫滨区","凤泉区","牧野区"]},{"name":"开封市","value":["龙亭区","顺河回族区","鼓楼区","禹王台区"]}]}]},{"name":"西北","value":[{"name":"陕西","value":[{"name":"咸阳市","value":["秦都区","渭城区"]},{"name":"西安市","value":["碑林区","莲湖区","灞桥区","未央区","雁塔区","长安区","新城区"]}]},{"name":"甘肃","value":[{"name":"兰州市","value":["城关区"]}]},{"name":"宁夏","value":[{"name":"银川市","value":["兴庆区","西夏区","金凤区"]}]}]},{"name":"西南","value":[{"name":"云南","value":[{"name":"昆明市","value":["五华区","盘龙区","官渡区","西山区"]}]},{"name":"贵州","value":[{"name":"贵阳市","value":["南明区","云岩区","小河区","白云区","乌当区"]}]},{"name":"四川","value":[{"name":"成都市","value":["锦江区","青羊区","金牛区","武侯区","成华区","龙泉驿区","新都区","温江区","成都高新区","成都天府新区"]},{"name":"绵阳市","value":["涪城区","游仙区"]},{"name":"南充市","value":["高坪区","嘉陵区","顺庆区"]}]},{"name":"重庆","value":[{"name":"重庆市","value":["渝中区","大渡口区","江北区","沙坪坝区","九龙坡区","南岸区","巴南区","渝北区"]}]}]},{"name":"东北","value":[{"name":"黑龙江省","value":[{"name":"哈尔滨市","value":["道里区","南岗区","道外区","松北区","香坊区"]}]},{"name":"吉林","value":[{"name":"长春市","value":["南关区","宽城区","朝阳区","二道区","经济技术开发区"]}]},{"name":"辽宁","value":[{"name":"沈阳市","value":["大东区","皇姑区","铁西区","沈河区","和平区","于洪区"]},{"name":"大连市","value":["中山区","西岗区","沙河口区","甘井子区",null]}]}]}]';

exports.default = JSON.parse(dataStr);

/***/ }),
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(244)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(246),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */,
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _queryString = __webpack_require__(13);

var _queryString2 = _interopRequireDefault(_queryString);

var _jsCookie = __webpack_require__(58);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _browser = __webpack_require__(1);

var _b2a = __webpack_require__(23);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PROTOCOL = location.protocol; //
//
//
//
//
//
//
//

var IOS_LINK = PROTOCOL + '//a.app.qq.com/o/simple.jsp?pkgname=com.thebeastshop.thebeast';
var TD_PREFIX = PROTOCOL + '//lnk0.com/';

var hostname = location.hostname;
var search = location.search.slice(1);
var urlParams = _queryString2.default.parse(search);
var tdMap = {
  'index': {
    'i': 'JxdoMh',
    'a': '1UNxBd'
  },
  'article': {
    'i': 'JZN9k4',
    'a': 'wpE5ss'
  },
  'story': {
    'i': 'c8ABVd',
    'a': 'J5gU9g'
  },
  'list': {
    'i': 'wNV9At',
    'a': 'dE5IZt'
  },
  'product': {
    'i': '10UtQd',
    'a': 'xJFBxt'
  }
  // const dParam = urlParams._d
};var iParam = urlParams._i || _jsCookie2.default.get('_b_i');
var aParam = urlParams._a || _jsCookie2.default.get('_b_a');

exports.default = {
  name: 'open-app',
  props: {
    cls: {
      type: String,
      default: 'open-app-area'
    },
    text: {
      type: String,
      default: '打开APP'
    },
    link: {
      type: String,
      default: ''
    },
    talkingData: {
      type: Object,
      default: null
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      formatLink: null
    };
  },

  computed: {
    iosShow: function iosShow() {
      if ((0, _browser.ios)()) {
        return true;
      } else {
        return false;
      }
    },
    iosLink: function iosLink() {
      // const il = iParam?`${TD_PREFIX}${iParam}`:IOS_LINK
      var il = iParam ? (0, _browser.weixin)() ? IOS_LINK : '' + TD_PREFIX + iParam : IOS_LINK; //微信无法打开我们的appstore短链 所以微信浏览器里面打开应用宝 这样会丢失一部分短链打点
      return PROTOCOL + '//' + "app.thebeastshop.com" + '/r?r=' + (0, _b2a.btoa)(il) + '&_d=' + (0, _b2a.btoa)(this.formatLink);
      // return `beastapp://${this.formatLink}`
    }
  },
  created: function created() {
    if (!iParam) {
      iParam = tdMap[this.pageType] ? tdMap[this.pageType]['i'] : '';
    }
    if (!aParam) {
      aParam = tdMap[this.pageType] ? tdMap[this.pageType]['a'] : '';
    }
    this.initLink();
  },

  methods: {
    initLink: function initLink() {
      if (!iParam && this.talkingData) {
        iParam = this.talkingData._i;
      }
      if (!aParam && this.talkingData) {
        aParam = this.talkingData._a;
      }
      var link = this.link;
      var redirectLink = "";
      if (!link) {
        if (iParam || aParam) {
          redirectLink = 'index?_i=' + iParam + '&_a=' + aParam;
        } else {
          redirectLink = 'index';
        }
      } else {
        var index = link.indexOf("?");
        if (iParam || aParam) {
          if (index !== -1) {
            if (link.indexOf("_i=") !== -1 || link.indexOf("_a=") !== -1) {
              redirectLink = link;
            } else {
              redirectLink = link + '&_i=' + iParam + '&_a=' + aParam;
            }
          } else {
            redirectLink = link + '?_i=' + iParam + '&_a=' + aParam;
          }
        } else {
          redirectLink = link;
        }
      }
      this.formatLink = redirectLink;
    },
    recordIosTrack: function recordIosTrack() {
      this.trackData('ios');
    },
    toDownloadPage: function toDownloadPage() {
      var _this = this;

      this.trackData('android');

      setTimeout(function () {
        window.location.href = 'https://m.thebeastshop.com/dl?_d=' + (0, _b2a.btoa)(_this.formatLink) + '&_i=' + iParam + '&_a=' + aParam;
      }, 200);
    },
    trackData: function trackData(devide) {
      var trackData = {
        name: 'download-banner',
        attrs: {
          pageType: this.pageType,
          device: devide
        },
        wait: false
      };
      console.log(trackData, "trackData");

      (0, _track2.default)(trackData);
    }
  }
};

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.cls
  }, [(_vm.iosShow) ? _c('a', {
    attrs: {
      "href": _vm.iosLink
    },
    on: {
      "click": _vm.recordIosTrack
    }
  }, [_vm._v(_vm._s(_vm.text))]) : _c('span', {
    on: {
      "click": _vm.toDownloadPage
    }
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ }),
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

exports.get = get;

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _util = __webpack_require__(256);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var is_app = _browser2.default.app();

var PRODUCT_FETCH_DEBOUNCE_INTERVAL = 100;
var _productFetchQueue = [];
var _productCallbacks = [];

var _productTimer = null;
var _productCache = {};

var isError = false;

var api = '/app/product/simple';

function get(ids, callback) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'LIST';

  if (type === 'DETAIL') {
    api = '/app/product/list';
  }

  ids = _util2.default.isArray(ids) ? ids : [ids];

  var not_fetched = _filterProductIds(ids);
  var returned = void 0;

  function done_once(err, data) {
    if (!returned) {
      returned = true;
      callback(err, data);
    }
  }

  function done() {
    var products = {};
    ids.forEach(function (id) {
      products[id] = _productCache[id] || null;
    });
    done_once(isError, products);
  }

  if (!not_fetched.length) {
    return done();
  }

  _registerQueue(ids, function () {
    done();
  });
}

function _registerQueue(ids, callback) {
  ids.forEach(function (id) {
    _productFetchQueue.push(id);
  });

  _productCallbacks.push(callback);

  if (_productTimer) {
    clearTimeout(_productTimer);
  }

  _productTimer = setTimeout(function () {
    _getProductData();
  }, PRODUCT_FETCH_DEBOUNCE_INTERVAL);
}

function _filterProductIds(ids) {
  return ids.filter(function (id) {
    return !(id in _productCache);
  });
}

function getDomain() {
  if (is_app) {
    return '';
  }
  switch (window.location.hostname) {
    case 'static.thebeastshop.com':
      return '//api.thebeastshop.com';
      break;
    case 'scm.thebeastshop.com':
      return '//api.thebeastshop.com';
      break;
    case 'static-test.thebeastshop.com':
      return 'http://api-test.thebeastshop.com';
      break;
    case 'scm-test.thebeastshop.com':
      return 'http://api-test.thebeastshop.com';
      break;
    default:
      return '//api.thebeastshop.com';
  }
}

var MAX_PRODUCTS = 30;

function _getProductData() {
  // clone
  var callbacks = [].concat(_productCallbacks);
  var ids = _filterProductIds(_productFetchQueue);
  _productCallbacks.length = 0;
  _productFetchQueue.length = 0;

  var pieces = Math.ceil(ids.length / MAX_PRODUCTS);
  var counter = 0;
  var i = 0;

  do {
    _fetchProducts(ids.slice(i * MAX_PRODUCTS, (i + 1) * MAX_PRODUCTS)).then(function (data) {
      done(data);
    }).catch(function (err) {
      done();
    });
  } while (++i < pieces);

  function done() {
    if (++counter === pieces) {
      run_callbacks();
    }
  }

  function run_callbacks() {
    callbacks.forEach(function (callback) {
      callback();
    });
  }
}

function _fetchProducts(ids, callback) {
  return (0, _axiosMock2.default)({
    url: api,
    json: ids,
    method: 'POST'
  }).then(function (_ref) {
    var code = _ref.code,
        data = _ref.data;

    if (code == '500') {
      isError = true;
    }
    data.forEach(function (product) {
      if (!product) {
        return;
      }

      _productCache[product.id] = product;
    });
    return _promise2.default.resolve(data);
  }).catch(function (err) {
    isError = true;
    return _promise2.default.reject(err);
  });
}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(273)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(275),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _queryString = __webpack_require__(13);

var _queryString2 = _interopRequireDefault(_queryString);

var _browser = __webpack_require__(1);

var _urlUtil = __webpack_require__(21);

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _openApp = __webpack_require__(242);

var _openApp2 = _interopRequireDefault(_openApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { testData } from './test/data.js'


var search = location.search.slice(1); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var urlParams = _queryString2.default.parse(search);
var iParam = urlParams._i;
var aParam = urlParams._a;
var logoImage = (0, _urlUtil.ensure_protocol)("http://img.thebeastshop.com/app/activity/download/download-logo.png");
var pageData = {
  index: {
    _i: 'JxdoMh',
    _a: '1UNxBd'
  },
  list: {
    _i: 'wNV9At',
    _a: 'dE5IZt'
  },
  product: {
    _i: '10UtQd',
    _a: 'xJFBxt'
  },
  article: {
    _i: 'JZN9k4',
    _a: 'wpE5ss'
  },
  story: {
    _i: 'c8ABVd',
    _a: 'J5gU9g'
  }
};

exports.default = {
  name: 'download-banner',
  props: {
    position: {
      type: String,
      default: 'bottom'
    },
    pageType: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: '立即下载'
    }
    // talkingData: {
    //   type: Object,
    //   default: null
    // }
  },

  data: function data() {
    return {
      showFlag: false,
      logoImage: logoImage,
      downloadData: null,
      talkingData: null
    };
  },


  components: {
    openApp: _openApp2.default
  },

  mounted: function mounted() {},
  created: function created() {
    if ((0, _browser.app)()) {
      this.showFlag = false;
      return;
    }

    //抖音环境 关闭下载条
    var dySession = sessionStorage.getItem('dy-downloader');
    console.log(dySession, 'dysession');
    if (dySession === 'close') {
      this.showFlag = false;
      this.$emit('banner-close');
      return;
    }

    var storage = this.getStorage("time");
    if (!storage) {
      //过期或者没缓存
      this.getBanner();
    } else {
      this.$emit('banner-close');
    }
    // this.formatData(testData)
  },


  computed: {
    positionCls: function positionCls() {
      if (this.position === 'top') {
        return {
          'top': true
        };
      }
      if (this.position === 'bottom') {
        return {
          'bottom': true
        };
      }
    }
  },

  methods: {
    getBanner: function getBanner() {
      var _this = this;

      this.getBannerData().then(function (data) {
        if (data) {
          _this.formatData(data);
        }
      }).catch(function (err) {
        console.log(err);
        return;
      });
    },
    formatData: function formatData(data) {
      this.downloadData = data;
      var pageObj = pageData[this.pageType];
      if (!iParam && pageObj) {
        iParam = pageObj['_i'];
      }
      if (!aParam && pageObj) {
        aParam = pageObj['_a'];
      }
      this.talkingData = {
        _i: iParam,
        _a: aParam
      };
      this.showFlag = true;
    },
    getBannerData: function getBannerData() {
      return (0, _axiosMock2.default)({
        url: '/app/config/downloadContext',
        method: 'GET'
      }).then(function (_ref) {
        var code = _ref.code,
            data = _ref.data;

        return _promise2.default.resolve(data);
      }).catch(function (err) {
        return _promise2.default.reject(err);
      });
    },
    closeBannerAction: function closeBannerAction() {
      this.showFlag = false;
      this.setStorage("time", "close");
      this.$emit('close-banner');
    },
    setStorage: function setStorage(key, stringVal, time) {
      try {
        // if(!localStorage){return false;}
        if (!time || isNaN(time)) {
          // time=2*60
          time = 1 * 24 * 60 * 60;
        }
        var cacheExpireDate = new Date() - 1 + time * 1000;
        var cacheVal = {
          val: stringVal,
          exp: cacheExpireDate
        };
        localStorage.setItem(key, (0, _stringify2.default)(cacheVal)); //存入缓存值
        //console.log(key+":存入缓存，"+new Date(cacheExpireDate)+"到期");
      } catch (e) {}
    },
    getStorage: function getStorage(key) {
      try {
        // if(!localStorage){return false;}
        var cacheVal = localStorage.getItem(key);
        var result = JSON.parse(cacheVal);
        var now = new Date() - 1;
        if (!result) {
          //缓存不存在
          return null;
        }
        if (now > result.exp) {
          //缓存过期
          this.removeStorage(key);
          return "";
        }
        //console.log("get cache:"+key);
        return result.val;
      } catch (e) {
        this.removeStorage(key);
        return null;
      }
    },
    removeStorage: function removeStorage(key) {
      // if(!localStorage){return false;}
      localStorage.removeItem(key);
    },
    permissionAction: function permissionAction() {
      window.location.href = '/article?articleId=1048753';
    },
    ruleAction: function ruleAction() {
      window.location.href = '/rule';
    }
  }
};

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showFlag) ? _c('div', {
    staticClass: "download-banner-box",
    class: _vm.positionCls
  }, [_c('div', {
    staticClass: "download-banner"
  }, [_c('div', {
    staticClass: "fix-l",
    on: {
      "click": _vm.closeBannerAction
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "fluid-wrap"
  }, [_c('div', {
    staticClass: "fluid-box"
  }, [_c('div', {
    staticClass: "logo-box"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logoImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('p', {
    staticClass: "text title"
  }, [_vm._v(_vm._s(_vm.downloadData.title))]), _vm._v(" "), _c('p', {
    staticClass: "text content"
  }, [_vm._v(_vm._s(_vm.downloadData.describe))])])])]), _vm._v(" "), _c('div', {
    staticClass: "fix-r"
  }, [_c('open-app', {
    staticClass: "download-btn",
    attrs: {
      "text": _vm.text,
      "link": _vm.link,
      "pageType": _vm.pageType
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "download-prompt"
  }, [_vm._v("开发者: Shanghai Yi-pai E-commerce Co.,Ltd   版本号: 5.2.2   "), _c('span', {
    staticClass: "prompt-link",
    on: {
      "click": _vm.permissionAction
    }
  }, [_vm._v("用户权限")]), _vm._v("   "), _c('span', {
    staticClass: "prompt-link",
    on: {
      "click": _vm.ruleAction
    }
  }, [_vm._v("隐私条款")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "close-box"
  }, [_c('div', {
    staticClass: "close"
  })])
}]}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(42);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $vm = void 0;

var Exposure = function () {
    function Exposure(callback) {
        var _this = this;

        (0, _classCallCheck3.default)(this, Exposure);

        if (!callback || typeof callback !== 'function') {
            throw new Error("need callback or selector param");
            return;
        }
        this.intersectionObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (item) {
                if (item.intersectionRatio > 0) {
                    if (item.target) {
                        callback(item.target, item);
                        _this.intersectionObserver.unobserve(item.target);
                    }
                }
            });
        });
    }

    (0, _createClass3.default)(Exposure, [{
        key: 'observe',
        value: function observe(selector, ignoreExposured) {
            var _this2 = this;

            if (!this.intersectionObserver || !selector) {
                return;
            }
            var nodes = [];
            if (this.isDOM(selector)) {
                // dom节点
                nodes = [selector];
            } else {
                // 选择器
                nodes = document.querySelectorAll(selector);
            }
            if (!nodes.length) {
                return;
            }
            nodes.forEach(function (node) {
                if (!ignoreExposured && node.__wg__tracker__exposured__) {
                    return;
                }
                node.__wg__tracker__exposured__ = true;
                // 开始观察
                _this2.intersectionObserver.observe(node);
            });
        }
    }, {
        key: 'disconnect',
        value: function disconnect() {
            if (!this.intersectionObserver) {
                return;
            }
            this.intersectionObserver.disconnect();
        }
    }, {
        key: 'isDOM',
        value: function isDOM(obj) {
            if (!obj) {
                return false;
            }
            if ((typeof HTMLElement === 'undefined' ? 'undefined' : (0, _typeof3.default)(HTMLElement)) === 'object') {
                return obj instanceof HTMLElement;
            }
            if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string') {
                return true;
            }
            return false;
        }
    }]);
    return Exposure;
}();

(function () {
    function install(Vue) {
        Vue.mixin({
            created: function created() {
                this.$exposure = Exposure;
            }
        });
    }

    if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
        module.exports = install;
    } else if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return install;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (window.Vue) {
        Vue.use(install);
    }
})();

/***/ }),
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCommentTime = formatCommentTime;
exports.formatTime = formatTime;
exports.getCountDown = getCountDown;
exports.transformTime = transformTime;
exports.addZero = addZero;
exports.transformFutureCalenderNew = transformFutureCalenderNew;
exports.transformFutureCalender = transformFutureCalender;
function formatCommentTime(time) {
  //格式化 晒单 评论 日期展示格式
  var actionTime = "";
  if (time) {
    var nowTime = new Date().getTime();
    var timeObj = formatTime(time);
    var nowTimeObj = formatTime(nowTime);
    // console.log(timeObj, nowTimeObj)

    if (!timeObj || !nowTimeObj) {
      actionTime = "";
    } else {
      if (nowTimeObj.year !== timeObj.year) {
        //不同年
        actionTime = timeObj.year + "\u5E74" + timeObj.month + "\u6708" + timeObj.day + "\u65E5";
      } else {
        if (nowTimeObj.month !== timeObj.month) {
          //不同月
          actionTime = timeObj.month + "\u6708" + timeObj.day + "\u65E5";
        } else {
          if (nowTimeObj.day !== timeObj.day) {
            if (nowTimeObj.day - timeObj.day === 1) {
              //相差一天
              actionTime = "\u6628\u5929";
            } else {
              //大于一天
              actionTime = timeObj.month + "\u6708" + timeObj.day + "\u65E5";
            }
          } else {
            //同年 同月 同日
            if (nowTimeObj.hh === timeObj.hh) {
              //同一个小时内
              if (nowTimeObj.mm - timeObj.mm > 1) {
                actionTime = nowTimeObj.mm - timeObj.mm + "\u5206\u949F\u524D";
              } else {
                actionTime = "\u521A\u521A";
              }
            } else {
              actionTime = nowTimeObj.hh - timeObj.hh + "\u5C0F\u65F6\u524D";
            }
          }
        }
      }
    }
  }

  // this.actionTime = actionTime
  return actionTime;
}

function formatTime(time) {
  //返回 年月日 时分秒
  if (!time) {
    return '';
  }

  var date = new Date(parseInt(time, 10));
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();

  return {
    year: year,
    month: month,
    day: day,
    hour: hour,
    minute: minute,
    second: second
  };
}

function getCountDown(time) {
  var diffTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  //返回 倒计时天时分秒  或者总小时分秒
  if (!time) {
    return null;
  }
  var now = new Date().getTime();
  var endDate = new Date(time),

  // _now = new Date()
  _now = new Date(now - diffTime);

  var leftTime = endDate.getTime() / 1000 - _now.getTime() / 1000,
      leftsecond = parseInt(leftTime),
      day = Math.floor(leftsecond / (60 * 60 * 24)),
      hour = Math.floor((leftsecond - day * 24 * 60 * 60) / 3600),
      minute = Math.floor((leftsecond - day * 24 * 60 * 60 - hour * 3600) / 60),
      second = Math.floor(leftsecond - day * 24 * 60 * 60 - hour * 3600 - minute * 60),
      totalHour = hour + day * 24;

  return {
    day: day,
    hour: hour,
    minute: minute,
    second: second,
    totalHour: totalHour
  };
}

function transformTime(time) {
  //2018-01-01 12:00:00  IOS中不支持 - 连接日期 返回valid Date
  if (!time) {
    return 0;
  }
  var date = new Date(time.replace(/-/g, '/'));
  return date.getTime();
}

function addZero(time) {
  if (time < 10) {
    return "0" + time;
  } else {
    return time;
  }
}

function transformFutureCalenderNew(_ref) {
  var dateArr = _ref.dateArr;
  //格式化
  var DAY31 = [1, 31];
  var DAY30 = [1, 30];
  var DAY29 = [1, 29];
  var DAY28 = [1, 28];
  var oneyearFlag = true;
  if (dateArr[0].year !== dateArr[1].year) {
    oneyearFlag = false;
  }

  var yearArr = [];
  dateArr.forEach(function (d, index) {
    var y = d.year;
    var yObj = {
      c: d.year,
      n: d.year,
      cns: []
    };

    var monthMap = {
      1: DAY31,
      2: y % 4 ? DAY28 : DAY29,
      3: DAY31,
      4: DAY30,
      5: DAY31,
      6: DAY30,
      7: DAY31,
      8: DAY31,
      9: DAY30,
      10: DAY31,
      11: DAY30,
      12: DAY31
    };

    var monthArr = [];
    var m = d.month;
    var monthObj = {
      c: m,
      n: m < 10 ? "0" + m : "" + m,
      pc: y
    };

    var dayGap = monthMap[m];
    var dayArr = [];
    for (var _d = dayGap[0]; _d <= dayGap[1]; _d++) {
      var dayObj = {
        c: _d,
        n: _d < 10 ? "0" + _d : "" + _d,
        pc: m
      };
      dayArr.push(dayObj);
    }

    monthObj.cns = dayArr;

    if (index == 0) {
      yObj.cns.push(monthObj);
      yearArr.push(yObj);
    } else {
      if (oneyearFlag) {
        yearArr[0].cns.push(monthObj);
      } else {
        yObj.cns.push(monthObj);
        yearArr.push(yObj);
      }
    }
  });

  console.log(yearArr, "yearArr");
  return yearArr;
}

function transformFutureCalender(_ref2) {
  var _ref2$startDate = _ref2.startDate,
      startDate = _ref2$startDate === undefined ? null : _ref2$startDate,
      _ref2$yearGap = _ref2.yearGap,
      yearGap = _ref2$yearGap === undefined ? 1 : _ref2$yearGap;
  //格式化
  var DAY31 = [1, 31];
  var DAY30 = [1, 30];
  var DAY29 = [1, 29];
  var DAY28 = [1, 28];

  startDate = startDate || new Date();
  var year = startDate.getFullYear();
  var month = startDate.getMonth() + 1;
  var day = startDate.getDate();

  var yearDatas = [];
  for (var t = 0; t <= yearGap; t++) {
    yearDatas.push(year + t);
  }

  var yearArr = [];
  yearDatas.forEach(function (y, index) {
    var yObj = {
      c: y,
      n: y
    };

    var monthMap = {
      1: DAY31,
      2: y % 4 ? DAY28 : DAY29,
      3: DAY31,
      4: DAY30,
      5: DAY31,
      6: DAY30,
      7: DAY31,
      8: DAY31,
      9: DAY30,
      10: DAY31,
      11: DAY30,
      12: DAY31
    };

    var monthArr = [];
    for (var m = 1; m <= 12; m++) {
      if (index === 0 && month > m) {
        //当年的前几个月
        continue;
      }
      var monthObj = {
        c: m,
        n: m < 10 ? "0" + m : "" + m,
        pc: y
      };

      var dayGap = monthMap[m];
      if (index === 0 && month === m) {
        //当年 当月
        dayGap = [day, dayGap[1]];
      }

      var dayArr = [];
      for (var d = dayGap[0]; d <= dayGap[1]; d++) {
        var dayObj = {
          c: d,
          n: d < 10 ? "0" + d : "" + d,
          pc: m
        };
        dayArr.push(dayObj);
      }

      monthObj.cns = dayArr;
      monthArr.push(monthObj);
    }

    yObj.cns = monthArr;
    yearArr.push(yObj);
  });

  console.log(yearArr, "yearArr");
  return yearArr;
}

/***/ }),
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(492)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(494),
  /* scopeId */
  "data-v-26810880",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(462)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(465),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _link = __webpack_require__(55);

var _util = __webpack_require__(175);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//

var app = _browser2.default.app();

exports.default = {
  name: 'navbar-bottom',
  props: ['activeIndex'],
  data: function data() {
    return {
      navs: [],
      dataLoaded: false,
      iphoneX: (0, _util.isIphoneX)()
    };
  },

  components: {
    beastImage: _image2.default
  },
  created: function created() {
    var _this = this;

    if (_browser2.default.app()) {
      return;
    }
    this.getData().then(function (_ref) {
      var data = _ref.data;

      _this.navs = data.navs;
      _this.dataLoaded = true;
    });

    if (this.iphoneX) {
      if (!_browser2.default.app()) {
        this.iphoneX = false;
      }
      window.onresize = function () {
        _this.iphoneX = !_this.iphoneX;
      };
    }
  },

  methods: {
    getData: function getData() {
      return _promise2.default.resolve(__webpack_require__(464));
      return (0, _axiosMock2.default)({
        url: ''
      });
    },
    jump: function jump(nav) {
      // sa.track('NavigationBar', {
      //   navigation_location: '底部'
      // })
      var link = (0, _link.transformLink)({
        link: nav.link,
        title: nav.title
      });
      if (link === '' || link === '#') {
        return;
      } else {
        window.location.href = link;
      }
    }
  }
};

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  data: {
    navs: [{
      normalIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/index.png',
      activeIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/index-active.png',
      link: {
        type: 'deeplink',
        value: 'beastapp://index'
      },
      title: '首页'
    }, {
      normalIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/category.png',
      activeIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/category-active.png',
      link: {
        type: 'deeplink',
        value: 'beastapp://entry?name=category-v2'
      },
      title: '选购'
    }, {
      normalIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/discovery.png',
      activeIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/discovery-active.png',
      link: {
        type: 'deeplink',
        value: 'beastapp://entry?name=funny'
        // value: 'beastapp://entry?name=discovery'
      },
      title: '有趣'
    }, {
      normalIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/store.png',
      activeIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/store-active.png',
      link: {
        type: 'deeplink',
        value: 'beastapp://entry?name=store'
      },
      title: '门店'
    }, {
      normalIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/my.png',
      activeIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/my-active.png',
      link: {
        type: 'deeplink',
        value: 'beastapp://entry?name=member'
      },
      title: '我的'
    }]
  }
};

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataLoaded) ? _c('div', {
    staticClass: "navbar-bottom",
    class: {
      'iphone-x': _vm.iphoneX
    }
  }, _vm._l((_vm.navs), function(nav, index) {
    return _c('div', {
      staticClass: "nav",
      class: {
        'active': index == _vm.activeIndex
      },
      on: {
        "click": function($event) {
          return _vm.jump(nav)
        }
      }
    }, [_c('div', {
      staticClass: "nav-image"
    }, [_c('beast-image', {
      staticClass: "normal-img",
      attrs: {
        "src": nav.normalIcon
      }
    }), _vm._v(" "), _c('beast-image', {
      staticClass: "active-img",
      attrs: {
        "src": nav.activeIcon
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "nav-text"
    }, [_vm._v(_vm._s(nav.title))])])
  }), 0) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(491),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _util = __webpack_require__(143);

var _link = __webpack_require__(55);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clientWidth = (0, _util.getClientWidth)(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ratio = clientWidth / 375;

exports.default = {
  name: 'article-image',
  // props: ['data'],
  props: ['data', 'pageType', 'miniEnv', 'isApp'],
  components: {
    beastImage: _image2.default
  },
  data: function data() {
    return {
      ratio: ratio,
      positionFlag: false,
      position1Flag: false,
      containerWidth: 0,
      plr: 0,
      left: 0,
      left1: 0,
      positionArr: null,
      imageRadius: Number(this.data.radius || 0),
      tData: (0, _stringify2.default)(this.data.trackData || {})
    };
  },
  mounted: function mounted() {},


  computed: {
    classObj: function classObj() {
      var clsObj = {};
      var mbFlag = true;
      var plrFlag = true;
      var ptFlag = false;
      if (this.data.noBottomGap) {
        mbFlag = false;
      }
      if (this.data.fullWidth) {
        plrFlag = false;
      }
      if (this.data.topGap) {
        ptFlag = true;
      }

      // if(this.pageType === "article" || this.pageType === "index") {
      //   clsObj = {
      //     'mb15': mbFlag,
      //     'plr15': plrFlag,
      //     'pt15': ptFlag
      //   }
      // }

      if (this.pageType === "shop") {
        clsObj = {
          'pb20': true,
          'mb15': true,
          'plr25': plrFlag,
          'pt25': ptFlag
        };
      }

      return clsObj;
    },
    imageWrapStyl: function imageWrapStyl() {
      var image = this.data.image;
      var height = this.containerWidth / image.width * image.height;
      var stylObj = {
        'height': height + 'px',
        'margin-top': -height + 'px'
      };
      if (this.data.qrcodeFlag) {
        stylObj = {
          'height': height + 'px',
          'margin-top': -height + 'px',
          'z-index': -1
        };
      }
      return stylObj;
    }
  },

  created: function created() {
    this.getContainerWidth();
    if (!this.data.hotItems || !this.data.hotItems.length) {
      this.checkPosition();
    }
  },


  methods: {
    getContainerWidth: function getContainerWidth() {
      var cw = void 0;
      var pageWidth = 375;
      var _data$paddingData = this.data.paddingData,
          pl = _data$paddingData.pl,
          pr = _data$paddingData.pr;


      if (this.data.fullWidth) {
        cw = clientWidth;
      } else {
        if (this.pageType === "article") {
          // this.plr = 30
          this.plr = pl + pr;
        }
        if (this.pageType === "shop-story") {
          this.plr = 80;
        }
        if (this.pageType === "shop") {
          this.plr = 50;
        }
        pageWidth -= this.plr;
        cw = pageWidth / 375 * clientWidth;
      }
      this.containerWidth = cw;
    },
    checkPosition: function checkPosition() {
      var position = this.data.position;
      var position1 = this.data.position1;
      // console.log(position, position1, "position-position1")
      if (position && position > 0 && position < 365) {
        this.positionFlag = true;
        this.left = position / 375 * this.containerWidth;
      }
      if (position1 && position1 > 0 && position1 < 365) {
        this.position1Flag = true;
        this.left1 = position1 / 375 * this.containerWidth;
      }

      var positionArr = [];
      if (!this.positionFlag && !this.position1Flag) {
        positionArr.push({
          width: this.containerWidth + 'px',
          left: '0px',
          link: this.data.link,
          title: this.data.title,
          toMiniProgram: this.data.toMiniProgram
        });
      } else if (this.positionFlag && !this.position1Flag) {
        positionArr.push({
          width: this.left + 'px',
          left: '0px',
          link: this.data.link,
          title: this.data.title,
          toMiniProgram: this.data.toMiniProgram
        });
        positionArr.push({
          width: this.containerWidth - this.left + 'px',
          left: this.left + 'px',
          link: this.data.link2,
          title: this.data.title2,
          toMiniProgram: this.data.toMiniProgram2
        });
      } else if (!this.positionFlag && this.position1Flag) {
        positionArr.push({
          width: this.left1 + 'px',
          left: '0px',
          link: this.data.link2,
          title: this.data.title2,
          toMiniProgram: this.data.toMiniProgram2
        });
        positionArr.push({
          width: this.containerWidth - this.left1 + 'px',
          left: this.left1 + 'px',
          link: this.data.link3,
          title: this.data.title3,
          toMiniProgram: this.data.toMiniProgram3
        });
      } else if (this.positionFlag && this.position1Flag) {
        positionArr.push({
          width: this.left + 'px',
          left: '0px',
          link: this.data.link,
          title: this.data.title,
          toMiniProgram: this.data.toMiniProgram
        });
        positionArr.push({
          width: this.left1 - this.left + 'px',
          left: this.left + 'px',
          link: this.data.link2,
          title: this.data.title2,
          toMiniProgram: this.data.toMiniProgram2
        });
        positionArr.push({
          width: this.containerWidth - this.left1 + 'px',
          left: this.left1 + 'px',
          link: this.data.link3,
          title: this.data.title3,
          toMiniProgram: this.data.toMiniProgram3
        });
      }
      // console.log(positionArr, "positionArr")
      this.positionArr = positionArr;
    },
    imageAction: function imageAction(p) {
      // this.$alert("test click")
      var trackData = this.data.trackData;
      if (!this.positionFlag && !this.position1Flag) {
        this.skipLink({
          link: this.data.link,
          title: this.data.title,
          trackData: trackData,
          toMiniProgram: this.data.toMiniProgram
        });
      } else {
        this.skipLink({
          link: p.link,
          title: p.title,
          trackData: trackData,
          toMiniProgram: p.toMiniProgram
        });
      }
    },
    imageSingleAction: function imageSingleAction() {
      if (this.data.linkCheck === 'SINGLE') {
        this.skipLink({
          link: this.data.link,
          title: '',
          trackData: this.data.trackData,
          toMiniProgram: this.data.toMiniProgram
        });
      }
    },
    hotAreaAction: function hotAreaAction(item, index) {
      var trackData = this.data.trackData;
      trackData.module_number = index - 0 + 1;
      trackData.operation_name = item.trackTitle || '';
      trackData.operation_type = item.trackServiceType || '';
      this.skipLink({
        link: item.link,
        title: '',
        trackData: trackData,
        toMiniProgram: item.toMiniProgram
      });
    },
    skipLink: function skipLink(_ref) {
      var link = _ref.link,
          title = _ref.title,
          trackData = _ref.trackData,
          toMiniProgram = _ref.toMiniProgram;

      // console.log(link, "link")
      if (!link || link.type === 'none') {
        return;
      }

      var myLink = '';
      var toMiniFlag = false;
      if (this.isApp && toMiniProgram) {
        //app环境 且 在app打开小程序页面
        myLink = (0, _link.getToMiniLink)({
          link: link,
          title: title
        });
      }
      if (myLink) {
        toMiniFlag = true;
      }
      if (!myLink) {
        myLink = (0, _link.transformLink)({
          link: link,
          title: title,
          isMini: this.miniEnv
        });
      }

      (0, _util.trackAction)({
        trackData: trackData,
        pageObj: (0, _link.getLinkPageData)({ link: link, title: title })
      });

      (0, _link.normalSkip)({
        link: myLink,
        isMini: this.miniEnv,
        toMiniProgram: toMiniFlag
      });
    }
  }
};

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-item-box j_client_item",
    class: _vm.classObj,
    attrs: {
      "id": 'nofixNav' + _vm.data.nofixNavId + '-' + _vm.data.nofixNavIndex,
      "data-trackdata": _vm.tData
    }
  }, [_c('div', {
    staticClass: "img-box",
    on: {
      "click": _vm.imageSingleAction
    }
  }, [(_vm.containerWidth) ? _c('beast-image', {
    staticClass: "img",
    attrs: {
      "lazy": true,
      "image": _vm.data.image,
      "containerWidth": _vm.containerWidth,
      "radius": _vm.imageRadius * _vm.ratio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.linkCheck === 'MULTI' && _vm.data.hotItems && _vm.data.hotItems.length) ? _c('div', {
    staticClass: "hot-areas"
  }, _vm._l((_vm.data.hotItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "hot-area",
      style: ({
        'width': ((item.area.w*_vm.ratio) + "px"),
        'height': ((item.area.h*_vm.ratio) + "px"),
        'left': ((item.area.x*_vm.ratio) + "px"),
        'top': ((item.area.y*_vm.ratio) + "px")
      }),
      on: {
        "click": function($event) {
          return _vm.hotAreaAction(item, index)
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.data.linkCheck && _vm.positionArr && _vm.positionArr.length) ? _c('div', {
    staticClass: "image-wrap",
    style: (_vm.imageWrapStyl)
  }, _vm._l((_vm.positionArr), function(p, index) {
    return _c('div', {
      key: index,
      staticClass: "position-wrap",
      style: ({
        'width': p.width,
        'left': p.left
      }),
      on: {
        "click": function($event) {
          return _vm.imageAction(p)
        }
      }
    })
  }), 0) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _util = __webpack_require__(143);

var _dialog = __webpack_require__(10);

var _dialog2 = _interopRequireDefault(_dialog);

var _video = __webpack_require__(218);

var _video2 = _interopRequireDefault(_video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clientWidth = (0, _util.getClientWidth)(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var clientHeight = (0, _util.getClientHeight)();

exports.default = {
  name: 'video-pop',
  props: ['data', 'radius'],
  components: {
    BDialog: _dialog2.default,
    beastVideo: _video2.default
  },
  data: function data() {
    console.log(this.data, "video pop data");
    return {
      videoWidth: parseInt(clientWidth) || 300,
      videoHeight: parseInt(clientHeight * 0.8) || 600,
      tData: (0, _stringify2.default)(this.data.trackData || {})
    };
  },
  mounted: function mounted() {},

  computed: {},
  methods: {
    closeAction: function closeAction() {
      this.$emit('close');
    }
  }
};

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-item-box video-pop-box",
    attrs: {
      "data-trackdata": _vm.tData
    }
  }, [_c('div', {
    staticClass: "video-pop",
    class: _vm.data.wrapPopIndex
  }, [_c('beast-video', {
    ref: "popVideo",
    attrs: {
      "wrap": _vm.data.wrapPopIndex,
      "width": _vm.videoWidth,
      "height": _vm.videoHeight,
      "poster": _vm.data.poster,
      "autoplay": true,
      "source": _vm.data.source,
      "controls": _vm.data.controls,
      "videoFormat": _vm.data.videoFormat,
      "muted": _vm.data.muted,
      "radius": _vm.radius,
      "playVideo": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "close-box",
    on: {
      "click": _vm.closeAction
    }
  }, [_c('div', {
    staticClass: "close"
  })])])
},staticRenderFns: []}

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(496)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(499),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apis = __webpack_require__(498);

exports.default = {
  data: function data() {
    return {
      cartNum: 0
    };
  },
  created: function created() {
    var _this = this;

    (0, _apis.getCartNum)().then(function (_ref) {
      var data = _ref.data;

      _this.cartNum = data || 0;
    });
  },


  methods: {
    goCarts: function goCarts() {
      window.location.href = '/cart';
    }
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCartNum = getCartNum;

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCartNum() {
  return (0, _axiosMock2.default)({
    url: '/app/cart/packs/size'
  });
}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carts-icon",
    on: {
      "click": _vm.goCarts
    }
  }, [_c('i'), _vm._v(" "), (_vm.cartNum > 0) ? _c('div', {
    staticClass: "fix-num"
  }, [_c('div', {
    staticClass: "cart-num"
  }, [_vm._v(_vm._s(_vm.cartNum))]), _vm._v(" "), _c('div', {
    staticClass: "triangle-right"
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(538),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _urlUtil = __webpack_require__(21);

var _util = __webpack_require__(143);

var _link = __webpack_require__(55);

var _index = __webpack_require__(135);

var _index2 = _interopRequireDefault(_index);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _video = __webpack_require__(218);

var _video2 = _interopRequireDefault(_video);

var _videoPop = __webpack_require__(460);

var _videoPop2 = _interopRequireDefault(_videoPop);

var _util2 = __webpack_require__(175);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var clientWidth = (0, _util.getClientWidth)();
var ratio = clientWidth / 375;

exports.default = {
  name: 'image-banner',
  // props: ['data'],
  props: ['data', 'memberTags', 'modIndex', 'sdk', 'miniEnv', 'multiVideo', 'isApp', 'pageType'],
  data: function data() {
    return {
      ratio: ratio,
      items: [],
      swiper: null,
      // paginateCls: (!this.data.hideIdentification && this.paginateType==='number')?paginateCls:{},
      paginateCls: {},
      scrollbarCls: {},
      showPaginate: false,
      showScrollbar: false,
      pl: 0,
      pr: 0,
      pt: 0,
      pb: 0,
      radius: 0,
      videoPopData: null,
      videoPopFlag: false,
      videoIndex: 0,
      tData: (0, _stringify2.default)(this.data.trackData || {})
    };
  },

  components: {
    Swiper: _index2.default,
    beastImage: _image2.default,
    beastVideo: _video2.default,
    videoPop: _videoPop2.default
  },
  mounted: function mounted() {},

  computed: {
    // styleObj () {
    //   return {
    //     'padding-left': `${ratio*this.pl}px`,
    //     'padding-right': `${ratio*this.pr}px`,
    //     'padding-top': `${ratio*this.pt}px`,
    //     'padding-bottom': `${ratio*this.pb}px`
    //   }
    // }
  },
  created: function created() {
    this.formatData();
  },

  methods: {
    videowrap: function videowrap(index) {
      return 'wrap' + this.modIndex + '-' + index;
    },
    formatData: function formatData() {
      var _this = this;

      // const pl = this.data.leftPadding?Number(this.data.leftPadding):0
      // const pr = this.data.rightPadding?Number(this.data.rightPadding):0
      // const pt = this.data.topPadding?Number(this.data.topPadding):0
      // const pb = this.data.bottomPadding?Number(this.data.bottomPadding):0
      // this.pl = pl
      // this.pr = pr
      // this.pt = pt
      // this.pb = pb
      var _data$paddingData = this.data.paddingData,
          pl = _data$paddingData.pl,
          pr = _data$paddingData.pr;

      this.radius = this.data.radius ? Number(this.data.radius) * ratio + 'px' : 0;

      var items = [];
      var tags = this.memberTags || [];
      if (!tags.length) {
        //不校验新老客
        items = this.data.items;
      } else {
        this.data.items && this.data.items.forEach(function (item) {
          // if(item.customer === 'ALL' || tags.indexOf(item.customer) !== -1) {
          //   items.push(item)
          // }
          if (item.customer === 'ALL' || tags.indexOf(item.customer) !== -1 || item.customer === 'DELINEATION' && tags.indexOf(item.customerCode) !== -1) {
            items.push(item);
          }
        });
      }

      // const widthNum = (375-pl-pr)*ratio
      var widthNum = (375 - pl - pr) * ratio;
      var newItems = [];
      items.forEach(function (item, index) {
        var url = item.media.src;
        var stuffIndex = url.lastIndexOf('.');
        var stuff = url.substring(stuffIndex).toLowerCase();
        var type = stuff === '.mp4' ? 'video' : 'image';

        var image = {
          type: type,
          image: item.media,
          toMiniProgram: item.toMiniProgram,
          link: item.link,
          trackTitle: item.trackTitle,
          trackServiceType: item.trackServiceType,
          linkCheck: item.linkCheck || 'SINGLE',
          hotItems: item.hotItems || []
        };
        if (type === 'video') {
          var videoMode = _this.data.videoMode;
          image['wrapIndex'] = 'wrap' + _this.modIndex + '-' + index;
          image['wrapPopIndex'] = 'wrap' + _this.modIndex + '-' + index + '-1';
          var poster = (0, _util2.zipImage)(item.poster);
          image['poster'] = poster && (0, _urlUtil.ensure_protocol)(poster.src);
          image['source'] = item.media && (0, _urlUtil.ensure_protocol)(item.media.src);
          image['heightNum'] = item.poster ? widthNum / item.poster.width * item.poster.height : widthNum / item.media.width * item.media.height;
          // image['height'] = (widthNum/item.poster.width)*item.poster.height//弹框视频
          image['muted'] = _this.data.videoVoice === 'OPEN' ? '' : 'muted', image['videoMode'] = videoMode;
          image['videoFormat'] = _this.data.videoFormat;
          image['autoplay'] = videoMode === 'AUTO' || videoMode === 'CONTROL' ? true : false;
          image['controls'] = videoMode === 'AUTO' ? false : true;
        }

        newItems.push(image);
      });

      var that = this;
      var swiperOption = {
        paginationClickable: true,
        spaceBetween: 30,
        centeredSlides: true,
        // autoplay: 4000,
        // autoplay: false,
        // autoplayDisableOnInteraction: false,
        autoplay: this.data.autoPlay === 'YES' ? {
          delay: this.data.loopTime ? Number(this.data.loopTime) * 1000 : 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        } : false,
        on: {
          slideChange: function slideChange() {
            // alert('改变了，activeIndex为'+this.activeIndex);

            that.videoIndex = this.activeIndex;
          }
        }
      };

      var identificationType = this.data.identificationType;
      // const identificationType = 'VERTICAL'
      this.showPaginate = identificationType === 'NONE' || identificationType === 'SCROLLBAR' ? false : true;
      this.showScrollbar = identificationType === 'SCROLLBAR' ? true : false;

      if (this.showPaginate) {
        if (identificationType === 'DOT') {
          //圆点轮播
          this.paginateCls = { 'dot-paginate': true };
          swiperOption['pagination'] = {
            el: '.swiper-pagination',
            type: 'bullets'
          };
        }

        if (identificationType === 'ALIGN') {
          //短横线轮播
          this.paginateCls = { 'align-paginate': true };
          swiperOption['pagination'] = {
            el: '.swiper-pagination',
            type: 'bullets'
          };
        }

        if (identificationType === 'NUMBER') {
          //数字轮播
          this.paginateCls = { 'number-paginate': true };
          swiperOption['pagination'] = {
            el: '.swiper-pagination',
            type: 'fraction'
          };
        }

        if (identificationType === 'VERTICAL') {
          //竖线轮播
          this.paginateCls = { 'vertical-paginate': true };
          swiperOption['pagination'] = {
            el: '.swiper-pagination',
            type: 'bullets'
          };
        }
      }

      if (identificationType === 'SCROLLBAR') {
        //滚动条轮播
        this.scrollbarCls = { 'scrollbar-custom': true };
        swiperOption['scrollbar'] = {
          el: '.swiper-scrollbar'
        };
      }

      this.swiper = swiperOption;
      console.log(this.swiper, "swiper");
      console.log(newItems, "newItems");

      this.items = newItems;
    },
    ensureImage: function ensureImage(src) {
      return (0, _urlUtil.ensure_protocol)(src);
    },
    mediaAction: function mediaAction(item, index) {
      // console.log(item, 'new banner imageAction item')
      // return
      if (this.pageType === 'index' && item.type === 'video') {
        //首页视频 不允许跳转
        return;
      }
      if (this.pageType === 'article' && item.type === 'video' && item.videoMode !== 'AUTO') {
        //专题页 非背景自动播放视频 不允许跳转
        return;
      }

      // if(!item.link.type || item.link.type === 'none') {
      //   return
      // }

      var trackData = this.data.trackData;
      trackData.module_number = index - 0 + 1;
      trackData.operation_name = item.trackTitle;
      trackData.operation_type = item.trackServiceType || '';

      this.skipAction({
        link: item.link,
        toMiniProgram: item.toMiniProgram,
        trackData: trackData
      });
    },
    hotAreaAction: function hotAreaAction(hotItem, index) {
      var trackData = this.data.trackData;
      trackData.module_number = index - 0 + 1;
      trackData.operation_name = hotItem.trackTitle || '';
      trackData.operation_type = hotItem.trackServiceType || '';

      this.skipAction({
        link: hotItem.link,
        toMiniProgram: hotItem.toMiniProgram,
        trackData: trackData
      });

      // this.skipLink({
      //   link: hotItem.link,
      //   title: '',
      //   trackData,
      //   toMiniProgram: hotItem.toMiniProgram
      // })
    },
    skipAction: function skipAction(_ref) {
      var link = _ref.link,
          toMiniProgram = _ref.toMiniProgram,
          trackData = _ref.trackData;

      if (!link.type || link.type === 'none') {
        return;
      }

      var myLink = '';
      var toMiniFlag = false;
      if (this.isApp && toMiniProgram) {
        //app环境 且 在app打开小程序页面
        myLink = (0, _link.getToMiniLink)({
          link: link
        });
      }
      if (myLink) {
        toMiniFlag = true;
      }
      if (!myLink) {
        myLink = (0, _link.transformLink)({
          link: link,
          isMini: this.miniEnv
        });
      }

      (0, _util.trackAction)({
        trackData: trackData,
        pageObj: (0, _link.getLinkPageData)({
          link: link
        })
      });

      (0, _link.normalSkip)({
        link: myLink,
        isMini: this.miniEnv,
        toMiniProgram: toMiniFlag
      });
    },
    videoPopAction: function videoPopAction(data) {
      this.videoPopData = data;
      this.videoPopFlag = true;
    },
    closeAction: function closeAction() {
      this.videoPopFlag = false;
    }
  }
};

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items && _vm.items.length) ? _c('div', {
    staticClass: "client-item-box new-banner",
    attrs: {
      "data-trackdata": _vm.tData
    }
  }, [_c('div', {
    staticClass: "new-banner-box"
  }, [(_vm.swiper) ? _c('div', {
    staticClass: "images"
  }, [_c('swiper', {
    attrs: {
      "config": _vm.swiper,
      "paginateCls": _vm.paginateCls,
      "scrollbarCls": _vm.scrollbarCls,
      "showPaginate": _vm.showPaginate,
      "showScrollbar": _vm.showScrollbar
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide new-banner-item",
      class: _vm.videowrap(index),
      style: ({
        borderRadius: ("" + _vm.radius)
      }),
      on: {
        "click": function($event) {
          return _vm.mediaAction(item, index)
        }
      }
    }, [(item.type === 'image' && (!item.linkCheck || item.linkCheck === 'SINGLE')) ? _c('img', {
      attrs: {
        "src": _vm.ensureImage(item.image.src)
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'image' && item.linkCheck === 'MULTI') ? _c('div', {
      staticClass: "swiper-hot"
    }, [_c('img', {
      attrs: {
        "src": _vm.ensureImage(item.image.src)
      }
    }), _vm._v(" "), (item.hotItems && item.hotItems.length) ? _c('div', {
      staticClass: "hot-areas"
    }, _vm._l((item.hotItems), function(hotItem, hotIndex) {
      return _c('div', {
        key: hotIndex,
        staticClass: "hot-area",
        style: ({
          'width': ((hotItem.area.w*_vm.ratio) + "px"),
          'height': ((hotItem.area.h*_vm.ratio) + "px"),
          'left': ((hotItem.area.x*_vm.ratio) + "px"),
          'top': ((hotItem.area.y*_vm.ratio) + "px")
        }),
        on: {
          "click": function($event) {
            return _vm.hotAreaAction(hotItem, index)
          }
        }
      })
    }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.type === 'video') ? _c('beast-video', {
      attrs: {
        "videoId": ("newbanner" + _vm.modIndex + "-" + index),
        "videoIndex": _vm.videoIndex,
        "totalVideo": _vm.items.length,
        "wrap": _vm.videowrap(index),
        "height": item.heightNum,
        "poster": item.poster,
        "autoplay": item.autoplay,
        "source": item.source,
        "controls": item.controls,
        "videoFormat": item.videoFormat,
        "muted": item.muted,
        "radius": _vm.radius,
        "multiVideo": _vm.multiVideo,
        "videoPopData": item
      },
      on: {
        "video-pop": _vm.videoPopAction
      }
    }) : _vm._e()], 1)
  }), 0)], 1) : _vm._e()]), _vm._v(" "), (_vm.videoPopFlag) ? _c('video-pop', {
    attrs: {
      "data": _vm.videoPopData,
      "radius": _vm.radius
    },
    on: {
      "close": _vm.closeAction
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(541),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _urlUtil = __webpack_require__(21);

var _util = __webpack_require__(143);

var _link = __webpack_require__(55);

var _util2 = __webpack_require__(175);

var _video = __webpack_require__(218);

var _video2 = _interopRequireDefault(_video);

var _videoPop = __webpack_require__(460);

var _videoPop2 = _interopRequireDefault(_videoPop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var clientWidth = (0, _util.getClientWidth)();

exports.default = {
  name: 'article-video',
  props: ['data', 'pageType', 'modIndex', 'multiVideo', 'miniEnv', 'isApp'],
  components: {
    beastVideo: _video2.default,
    videoPop: _videoPop2.default
  },
  data: function data() {
    return {
      videoPopFlag: false,
      videoPopData: null,
      formatData: null,
      tData: (0, _stringify2.default)(this.data.trackData || {})
    };
  },
  mounted: function mounted() {},


  computed: {
    videowrap: function videowrap() {
      return 'wrap' + this.modIndex;
    }
  },

  created: function created() {
    this.formatVideoData();
  },


  methods: {
    containerWidth: function containerWidth() {
      var cw = void 0;
      var pageWidth = clientWidth;
      var _data$paddingData = this.data.paddingData,
          pl = _data$paddingData.pl,
          pr = _data$paddingData.pr;

      // if(this.data.fullWidth) {
      //   cw = clientWidth
      // } else {
      //   if(this.pageType === "article") {
      //     pageWidth = 375-30
      //   }
      //   if(this.pageType === "shop-story") {
      //     pageWidth = 375-80
      //   }
      //   if(this.pageType === "shop") {
      //     pageWidth = 375-50
      //   }
      //   cw = (pageWidth/375)*clientWidth
      // }
      // if(this.data.fullWidth) {
      //   cw = pageWidth
      // } else {
      //   cw = pageWidth-pl-pr
      // }

      cw = pageWidth - pl - pr;
      return cw;
    },
    formatVideoData: function formatVideoData() {
      var _this = this;

      var formatData = {};
      var poster = (0, _util2.zipImage)(this.data.poster);
      formatData.poster = poster && (0, _urlUtil.ensure_protocol)(poster.src);
      formatData.source = this.data.src && (0, _urlUtil.ensure_protocol)(this.data.src);
      if (this.data.poster && this.data.poster.width) {
        var height = this.data.poster.height / this.data.poster.width * this.containerWidth();
        // formatData.height = height
        formatData.height = parseInt(height);
        formatData.videoHeight = parseInt(height) + 2;
      }
      formatData.link = this.data.link || { type: 'none', value: '' };
      formatData.toMiniProgram = this.data.toMiniProgram || false;

      var videoMode = this.data.videoMode;
      formatData['muted'] = this.data.videoVoice === 'OPEN' ? '' : 'muted', formatData['videoMode'] = videoMode;
      formatData['videoFormat'] = this.data.videoFormat;
      // formatData['videoFormat'] = 'COVER'
      formatData['autoplay'] = videoMode === 'AUTO' || videoMode === 'CONTROL' ? true : false;
      formatData['controls'] = videoMode === 'AUTO' ? false : true;

      var videoPopData = {
        wrapPopIndex: 'wrap' + this.modIndex + '-1',
        height: formatData.height,
        videoHeight: formatData.videoHeight,
        poster: formatData.poster,
        source: formatData.source,
        controls: formatData.controls,
        videoFormat: formatData.videoFormat,
        muted: formatData.muted
        // controls: true
      };
      formatData.videoPopData = videoPopData;

      // return formatData
      // this.formatData = formatData
      setTimeout(function () {
        _this.formatData = formatData;
      }, 200);
    },
    videoPopAction: function videoPopAction(data) {
      console.log(data, "videoPopAction data");
      (0, _util.trackAction)({
        trackData: this.data.trackData
      });

      this.videoPopData = data;
      this.videoPopFlag = true;
    },
    videoAction: function videoAction() {
      var formatData = this.formatData;
      if (this.pageType === 'index') {
        //首页视频 不支持跳转
        return;
      }

      if (this.pageType === 'article' && formatData.videoMode !== 'AUTO') {
        //专题页视频 非背景自动播放 无法跳转
        return;
      }

      var link = formatData.link;
      if (!link.type || link.type === 'none') {
        return;
      }

      var myLink = '';
      var toMiniFlag = false;
      if (this.isApp && formatData.toMiniProgram) {
        //app环境 且 在app打开小程序页面
        myLink = (0, _link.getToMiniLink)({
          link: formatData.link
        });
      }
      if (myLink) {
        toMiniFlag = true;
      }
      if (!myLink) {
        myLink = (0, _link.transformLink)({
          link: formatData.link,
          isMini: this.miniEnv
        });
      }

      var trackData = this.data.trackData;
      (0, _util.trackAction)({
        trackData: trackData,
        pageObj: (0, _link.getLinkPageData)({
          link: formatData.link
        })
      });

      (0, _link.normalSkip)({
        link: myLink,
        isMini: this.miniEnv,
        toMiniProgram: toMiniFlag
      });
    },
    closeAction: function closeAction() {
      this.videoPopFlag = false;
    }
  }
};

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.formatData) ? _c('div', {
    staticClass: "client-item-box",
    attrs: {
      "data-trackdata": _vm.tData
    },
    on: {
      "click": _vm.videoAction
    }
  }, [_c('div', {
    class: _vm.videowrap,
    style: ({
      height: ((_vm.formatData.height) + "px"),
      overflow: 'hidden'
    })
  }, [_c('beast-video', {
    attrs: {
      "wrap": _vm.videowrap,
      "height": _vm.formatData.videoHeight,
      "poster": _vm.formatData.poster,
      "autoplay": _vm.formatData.autoplay,
      "source": _vm.formatData.source,
      "controls": _vm.formatData.controls,
      "videoFormat": _vm.formatData.videoFormat,
      "muted": _vm.formatData.muted,
      "videoPopData": _vm.formatData.videoPopData,
      "multiVideo": _vm.multiVideo
    },
    on: {
      "video-pop": _vm.videoPopAction
    }
  })], 1), _vm._v(" "), (_vm.videoPopFlag) ? _c('video-pop', {
    attrs: {
      "data": _vm.videoPopData
    },
    on: {
      "close": _vm.closeAction
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(653)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(660),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(638),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _urlUtil = __webpack_require__(21);

var _util = __webpack_require__(143);

var _link = __webpack_require__(55);

var _index = __webpack_require__(135);

var _index2 = _interopRequireDefault(_index);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Swiper from '@/swiper/swiper-3.4/index.vue'
// import Swiper from '@/swiper/swiper-4.2/index.vue'
var clientWidth = (0, _util.getClientWidth)(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var paginateCls = { 'number-paginate': true };

exports.default = {
  name: 'image-banner',
  // props: ['data'],
  props: ['data', 'memberTags', 'paginateType', 'isApp'],
  data: function data() {
    return {
      items: [],
      swiper: null,
      paginateCls: !this.data.hideIdentification && this.paginateType === 'number' ? paginateCls : {},
      // paginateCls: {},
      showPaginate: this.data.hideIdentification ? false : true,
      tData: (0, _stringify2.default)(this.data.trackData || {})
    };
  },

  components: {
    Swiper: _index2.default,
    beastImage: _image2.default
  },
  mounted: function mounted() {},

  computed: {
    renderSlideSize: function renderSlideSize() {}
  },
  created: function created() {
    this.formatData();
  },

  methods: {
    formatData: function formatData() {
      // if(this.member === 'OLD') {
      //   this.data.items && this.data.items.forEach(item => {
      //     if(item.customer !== 'NEW') {
      //       items.push(item)
      //     }
      //   })
      // } else if (this.member === 'NEW') {
      //   this.data.items && this.data.items.forEach(item => {
      //     if(item.customer !== 'OLD') {
      //       items.push(item)
      //     }
      //   })
      // } else {
      //   items = this.data.items
      // }
      var items = [];
      var tags = this.memberTags || [];
      if (!tags.length) {
        //不校验新老客
        items = this.data.items;
      } else {
        this.data.items && this.data.items.forEach(function (item) {
          if (item.customer === 'ALL' || tags.indexOf(item.customer) !== -1 || item.customer === 'DELINEATION' && tags.indexOf(item.customerCode) !== -1) {
            items.push(item);
          }
        });
      }

      this.swiper = {
        pagination: this.data.hideIdentification ? '' : this.paginateType === 'number' ? {
          el: '.swiper-pagination',
          type: 'fraction'
        } : {
          el: '.swiper-pagination',
          type: 'bullets'
        },
        paginationClickable: true,
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: 4000,
        autoplayDisableOnInteraction: false
        // onPaginationRendered: this.paginationRendered

        // console.log(this.swiper, "swiper")

      };this.items = items;
    },
    ensureImage: function ensureImage(src) {
      return (0, _urlUtil.ensure_protocol)(src);
    },
    imageAction: function imageAction(item, index) {
      var myLink = '';
      var toMiniFlag = false;
      if (this.isApp && item.toMiniProgram) {
        //app环境 且 在app打开小程序页面
        myLink = (0, _link.getToMiniLink)({
          link: item.link,
          title: item.title
        });
      }
      if (myLink) {
        toMiniFlag = true;
      }
      if (!myLink) {
        myLink = (0, _link.transformLink)({
          link: item.link,
          title: item.title
        });
      }

      var trackData = this.data.trackData;
      trackData.module_number = index - 0 + 1;
      trackData.operation_name = item.trackTitle;
      trackData.operation_type = item.trackServiceType || '';
      (0, _util.trackAction)({
        trackData: trackData,
        pageObj: (0, _link.getLinkPageData)({
          link: item.link,
          title: item.title
        })
      });

      (0, _link.normalSkip)({
        link: myLink,
        toMiniProgram: toMiniFlag
      });
    }
  }
};

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-item-box",
    class: {
      'plr15': !_vm.data.fullWidth,
      'mb15': !_vm.data.hideBottomGap
    },
    attrs: {
      "data-trackdata": _vm.tData
    }
  }, [_c('div', {
    staticClass: "image-banner-box"
  }, [(_vm.swiper) ? _c('div', {
    staticClass: "images"
  }, [_c('swiper', {
    attrs: {
      "config": _vm.swiper,
      "paginateCls": _vm.paginateCls,
      "showPaginate": _vm.showPaginate
    }
  }, _vm._l((_vm.items), function(item, index) {
    return (item.image.src) ? _c('div', {
      staticClass: "swiper-slide",
      on: {
        "click": function($event) {
          return _vm.imageAction(item, index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.ensureImage(item.image.src)
      }
    })]) : _vm._e()
  }), 0)], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(641),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _betterScroll = __webpack_require__(488);

var _betterScroll2 = _interopRequireDefault(_betterScroll);

var _lazyload = __webpack_require__(56);

var _urlUtil = __webpack_require__(21);

var _util = __webpack_require__(143);

var _link = __webpack_require__(55);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import iScroll from '@/iscroll'
var images = (0, _util.getImages)();

exports.default = {
  name: 'article-new',
  props: ['data', 'modIndex', 'hideTitle'],
  data: function data() {
    return {
      defaultImage: (0, _urlUtil.ensure_protocol)(images['defaultImage']),
      products: null,
      showMoreFlag: false,
      tData: (0, _stringify2.default)(this.data.trackData || {})
    };
  },

  components: {
    beastImage: _image2.default
  },
  mounted: function mounted() {},

  computed: {},
  created: function created() {
    this.getProductData();
  },

  methods: {
    getProductData: function getProductData() {
      var _this = this;

      var arr = [];
      for (var i = 0; i < 5; i++) {
        arr.push(i);
      }
      this.products = arr;

      // console.log(this.products, "getProductData")
      return (0, _util.axiosAction)({
        url: '/app/article/newProduct',
        method: 'POST',
        param: this.data.codes || []
      }).then(function (data) {
        // console.log(data, "getProductData data")
        if (data) {
          var products = data.products;
          products.forEach(function (p, index) {
            products[index].featureImage = (0, _urlUtil.ensure_protocol)(p.cropFeatureImage || p.featureImage || p.images[0]);
            products[index].brandName = p.brand ? p.brand.name ? p.brand.name : '' : '';
          });
          _this.$nextTick(function () {
            _this.products = products;
            _this.showMoreFlag = data.showMore;

            // this.$nextTick(() => {
            //   lazyload()
            // })
            setTimeout(function () {
              (0, _lazyload.lazyload)();
            }, 100);

            // let scroll = new BScroll(`#newBox${this.newIndex}`, {
            //   scrollY: false,
            //   scrollX: true,
            //   click: true,
            //   bounce: {
            //     left: false,
            //     right: false
            //   }
            // })
          });
        }
      }).catch(function (err) {
        console.log(err || 'getProductData出错啦');
        return;
      });
    },
    productAction: function productAction(p, index) {
      if (!p.id) {
        return;
      }
      // this.skipLink({
      //   link: {
      //     type: 'product',
      //     value: p.id
      //   },
      //   trackAttr: {
      //     name: 'new-product',
      //     attrs: {
      //       index: `${this.newIndex}-${index}`,
      //       name: p.name
      //     },
      //     wait: false
      //   }
      // })

      sa.track('CommodityClick', {
        position_number: index - 0 + 1,
        commodity_spu_id: p.id,
        commodity_name: p.name,
        original_price: p.rawPrice,
        discount_price: p.price,
        commodity_need_point: p.point || 0,
        business_case: '其他'
      });

      var link = {
        type: 'product',
        value: p.id
      };
      var myLink = (0, _link.transformLink)({
        link: link,
        title: p.name
      });
      var trackData = this.data.trackData;
      trackData.module_number = index - 0 + 1;
      trackData.operation_name = p.name;
      (0, _util.trackAction)({
        trackData: trackData,
        pageObj: (0, _link.getLinkPageData)({ link: link, title: p.name })
      });

      (0, _link.normalSkip)({
        link: myLink
      });
    },
    showMoreAction: function showMoreAction() {
      // this.skipLink({
      //   link: {
      //     type: 'new',
      //     value: ''
      //   },
      //   trackAttr: {
      //     name: 'new-product-show-more',
      //     attrs: {
      //       index: `${this.newIndex}-${this.products.length}`,
      //       name: '查看全部'
      //     },
      //     wait: false
      //   }
      // })
      var link = {
        type: 'new',
        value: ''
      };
      var myLink = (0, _link.transformLink)({
        link: link,
        title: '新鲜上架'
      });
      var trackData = this.data.trackData;
      trackData.module_number = this.products.length + 1;
      trackData.operation_name = '查看更多';
      (0, _util.trackAction)({
        trackData: trackData,
        pageObj: (0, _link.getLinkPageData)({ link: link, title: '新鲜上架' })
      });

      (0, _link.normalSkip)({
        link: myLink
      });
    }
  }
};

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-item-box new-product-box",
    attrs: {
      "data-trackdata": _vm.tData
    }
  }, [(_vm.data.showTitle === 'SHOW') ? _c('div', {
    staticClass: "new-title"
  }, [_vm._v("NEW ARRIVAL")]) : _vm._e(), _vm._v(" "), (_vm.products) ? _c('div', {
    staticClass: "products-wrap"
  }, [_c('div', {
    staticClass: "items-wrap",
    attrs: {
      "id": 'newBox' + _vm.modIndex
    }
  }, [_c('div', {
    staticClass: "items"
  }, [_vm._l((_vm.products), function(p, index) {
    return _c('div', {
      key: p.id,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.productAction(p, index)
        }
      }
    }, [_c('div', {
      staticClass: "single-img-box"
    }, [_c('beast-image', {
      staticClass: "single-img",
      attrs: {
        "lazy": true,
        "defaultImage": _vm.defaultImage,
        "src": p.featureImage
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "brand"
    }, [_vm._v(_vm._s(p.brand ? p.brand.name : ''))])])
  }), _vm._v(" "), (_vm.showMoreFlag) ? _c('div', {
    staticClass: "show-more-box"
  }, [(_vm.showMoreFlag) ? _c('div', {
    staticClass: "show-more",
    on: {
      "click": _vm.showMoreAction
    }
  }, [_vm._v("查看更多"), _c('span', {
    staticClass: "arrow"
  })]) : _vm._e()]) : _vm._e()], 2)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(644),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _util = __webpack_require__(143);

var _link = __webpack_require__(55);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clientWidth = (0, _util.getClientWidth)(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'image-index',
  // props: ['data'],
  props: ['data', 'memberTags', 'isApp'],
  components: {
    beastImage: _image2.default
  },
  data: function data() {
    return {
      dataLoaded: false,
      containerWidth: clientWidth,
      items: [],
      blockColor: null,
      tData: (0, _stringify2.default)(this.data.trackData || {})
    };
  },
  mounted: function mounted() {},

  computed: {},
  created: function created() {
    this.checkMember();
  },

  methods: {
    checkMember: function checkMember() {
      var tags = this.memberTags || [];
      if (!tags.length || this.data.customer === 'ALL') {
        this.dataLoaded = true;
      } else if (tags.indexOf(this.data.customer) !== -1) {
        this.dataLoaded = true;
      } else if (this.data.customer === 'DELINEATION' && tags.indexOf(this.data.customerCode) !== -1) {
        this.dataLoaded = true;
      }
      // if(this.member === 'OLD') {
      //   if(this.data.customer !== 'NEW') {
      //     this.dataLoaded = true
      //   }
      // } else if(this.member === 'NEW') {
      //   if(this.data.customer !== 'OLD') {
      //     this.dataLoaded = true
      //   }
      // } else {
      //   this.dataLoaded = true
      // }

      console.log(this.dataLoaded, "dataLoaded");

      if (this.dataLoaded) {
        this.formatData();
      }
    },
    formatData: function formatData() {
      var items = this.data.items;
      var newItems = [];
      items.forEach(function (item) {
        item.text && newItems.push(item);
      });
      console.log(newItems, "newItems");
      this.blockColor = newItems[0] ? newItems[0].textColor : '';
      this.items = newItems;
    },
    imageAction: function imageAction() {
      this.skipLink(this.data.link, this.data.title);
    },
    skipLink: function skipLink(link, title) {
      var myLink = '';
      var toMiniFlag = false;
      if (this.isApp && this.data.toMiniProgram) {
        //app环境 且 在app打开小程序页面
        myLink = (0, _link.getToMiniLink)({
          link: link,
          title: title
        });
      }
      if (myLink) {
        toMiniFlag = true;
      }
      if (!myLink) {
        myLink = (0, _link.transformLink)({
          link: link,
          title: title
        });
      }

      (0, _util.trackAction)({
        trackData: this.data.trackData,
        pageObj: (0, _link.getLinkPageData)({ link: link, title: title })
      });

      (0, _link.normalSkip)({
        // trackData: {
        //   name: 'image-index',
        //   attrs: {
        //     index: this.imageIndex,
        //     trackTitle: this.data.trackTitle
        //   },
        //   wait: false
        // },
        link: myLink,
        toMiniProgram: toMiniFlag
      });
    }
  }
};

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataLoaded) ? _c('div', {
    staticClass: "client-item-box j_client_item",
    attrs: {
      "data-trackdata": _vm.tData
    }
  }, [_c('div', {
    staticClass: "image-index-box",
    on: {
      "click": _vm.imageAction
    }
  }, [(_vm.containerWidth) ? _c('beast-image', {
    staticClass: "img",
    attrs: {
      "lazy": true,
      "image": _vm.data.image,
      "containerWidth": _vm.containerWidth
    }
  }) : _vm._e(), _vm._v(" "), (_vm.blockColor) ? _c('div', {
    staticClass: "block-box",
    style: ({
      'background': _vm.blockColor
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, _vm._l((_vm.items), function(item) {
    return _c('p', {
      staticClass: "text-item",
      style: ({
        'color': item.textColor
      })
    }, [_vm._v(_vm._s(item.text))])
  }), 0)], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(647),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _urlUtil = __webpack_require__(21);

var _util = __webpack_require__(143);

var _link = __webpack_require__(55);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _video = __webpack_require__(218);

var _video2 = _interopRequireDefault(_video);

var _videoPop = __webpack_require__(460);

var _videoPop2 = _interopRequireDefault(_videoPop);

var _util2 = __webpack_require__(175);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clientWidth = (0, _util.getClientWidth)(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ratio = clientWidth / 375;

exports.default = {
  name: 'new-image',
  // props: ['data'],
  props: ['data', 'modIndex', 'memberTags', 'sdk', 'miniEnv', 'multiVideo', 'isApp', 'pageType'],
  components: {
    beastImage: _image2.default,
    beastVideo: _video2.default,
    videoPop: _videoPop2.default
  },
  data: function data() {
    return {
      lineGap: 0,
      imgBoxWidth: 0,
      images: null,
      maxHeight: 0,
      pl: 0,
      pr: 0,
      pt: 0,
      pb: 0,
      radius: 0,
      videoPopData: null,
      videoPopFlag: false,
      tData: (0, _stringify2.default)(this.data.trackData || {})
    };
  },
  mounted: function mounted() {},

  computed: {
    // styleObj () {
    //   return {
    //     'padding-left': `${ratio*this.pl}px`,
    //     'padding-right': `${ratio*this.pr}px`,
    //     'padding-top': `${ratio*this.pt}px`,
    //     'padding-bottom': `${ratio*this.pb}px`
    //   }
    // }
  },
  created: function created() {
    this.getImages();
  },

  methods: {
    videowrap: function videowrap(index) {
      return 'wrap' + this.modIndex + '-' + index;
    },
    getImages: function getImages() {
      var _this = this;

      console.log('new-image');
      var tags = this.memberTags || [];
      if (this.data.customer !== 'ALL' && this.data.customer !== 'DELINEATION' && tags.indexOf(this.data.customer) === -1 || this.data.customer === 'DELINEATION' && tags.indexOf(this.data.customerCode) === -1) {
        return;
      }

      // const pl = this.data.leftPadding?Number(this.data.leftPadding):0
      // const pr = this.data.rightPadding?Number(this.data.rightPadding):0
      // const pt = this.data.topPadding?Number(this.data.topPadding):0
      // const pb = this.data.bottomPadding?Number(this.data.bottomPadding):0
      // this.pl = pl
      // this.pr = pr
      // this.pt = pt
      // this.pb = pb
      var _data$paddingData = this.data.paddingData,
          pl = _data$paddingData.pl,
          pr = _data$paddingData.pr;


      var items = this.data.items || [];
      if (!items || items.length === 0) {
        return [];
      }

      var newItems = [];
      var widthItems = [];
      var widthValue = 0;
      items.forEach(function (item) {
        if (item.media && item.media.src) {
          if (item.imageWidth) {
            widthItems.push(Number(item.imageWidth));
          }
          newItems.push(item);
        }
      });

      widthItems.forEach(function (width) {
        widthValue += width;
      });

      this.lineGap = this.data.lineGap ? Number(this.data.lineGap) : 0;
      this.imgBoxWidth = 375 - pl - pr;
      this.radius = this.data.radius ? Number(this.data.radius) * ratio + 'px' : 0;

      var len = newItems.length;
      var widthLen = widthItems.length;
      var perWidth = 0;
      if (len - widthLen > 0) {
        //未填写宽度的图片宽度
        perWidth = (this.imgBoxWidth - (len - 1) * this.lineGap - widthValue) / (len - widthLen);
      }
      if (perWidth <= 0) {
        perWidth = 0;
      }

      var images = [];
      var maxHeight = 0;
      newItems.forEach(function (item, index) {
        var url = item.media.src;
        var stuffIndex = url.lastIndexOf('.');
        var stuff = url.substring(stuffIndex).toLowerCase();
        var type = stuff === '.mp4' ? 'video' : 'image';

        var image = {
          type: type,
          image: item.media,
          toMiniProgram: item.toMiniProgram,
          link: item.link,
          trackTitle: item.trackTitle,
          trackServiceType: item.trackServiceType
        };
        var widthNum = item.imageWidth ? Number(item.imageWidth) * ratio : perWidth * ratio;
        image['widthNum'] = widthNum;

        if (type === 'image') {
          image['heightNum'] = widthNum / item.media.width * item.media.height;
          image['width'] = item.imageWidth ? Number(item.imageWidth) * ratio + 'px' : perWidth * ratio + 'px';
        }

        if (type === 'video') {
          var videoMode = _this.data.videoMode;
          image['wrapIndex'] = 'wrap' + _this.modIndex + '-' + index;
          image['wrapPopIndex'] = 'wrap' + _this.modIndex + '-' + index + '-1';
          var poster = (0, _util2.zipImage)(item.poster);
          image['poster'] = poster && (0, _urlUtil.ensure_protocol)(poster.src);
          image['source'] = item.media && (0, _urlUtil.ensure_protocol)(item.media.src);
          image['heightNum'] = item.poster ? widthNum / item.poster.width * item.poster.height : widthNum / item.media.width * item.media.height;
          // image['height'] = (widthNum/item.poster.width)*item.poster.height//弹框视频
          image['muted'] = _this.data.videoVoice === 'OPEN' ? '' : 'muted', image['videoMode'] = videoMode;
          image['videoFormat'] = _this.data.videoFormat;
          image['autoplay'] = videoMode === 'AUTO' || videoMode === 'CONTROL' ? true : false;
          image['controls'] = videoMode === 'AUTO' ? false : true;
        }

        var leftNum = 0;
        if (index > 0) {
          for (var i = index; i > 0; i--) {
            leftNum += images[i - 1] ? images[i - 1].widthNum + _this.lineGap * ratio : 0;
          }
        }
        image['leftNum'] = leftNum;
        image['left'] = leftNum + 'px';

        if (image.heightNum > maxHeight) {
          maxHeight = image.heightNum;
        }

        images.push(image);
      });

      console.log(images, "images");
      this.maxHeight = maxHeight;
      this.images = images;
    },
    mediaAction: function mediaAction(item, index) {
      if (this.pageType === 'index' && item.type === 'video') {
        //首页视频 不允许跳转
        return;
      }
      if (this.pageType === 'article' && item.type === 'video' && item.videoMode !== 'AUTO') {
        //专题页 非背景自动播放视频 不允许跳转
        return;
      }

      var link = item.link;
      if (!link.type || link.type === 'none') {
        return;
      }

      var myLink = '';
      var toMiniFlag = false;
      if (this.isApp && item.toMiniProgram) {
        //app环境 且 在app打开小程序页面
        myLink = (0, _link.getToMiniLink)({
          link: item.link
        });
      }
      if (myLink) {
        toMiniFlag = true;
      }
      if (!myLink) {
        myLink = (0, _link.transformLink)({
          link: item.link,
          isMini: this.miniEnv
        });
      }
      // console.log(item, '#######item')
      var trackData = this.data.trackData;
      trackData.module_number = index - 0 + 1;
      trackData.operation_name = item.trackTitle;
      trackData.operation_type = item.trackServiceType || '';
      (0, _util.trackAction)({
        trackData: trackData,
        pageObj: (0, _link.getLinkPageData)({
          link: item.link
        })
      });
      // console.log(trackData, '#######')

      (0, _link.normalSkip)({
        link: myLink,
        isMini: this.miniEnv,
        toMiniProgram: toMiniFlag
      });
    },
    videoPopAction: function videoPopAction(data) {
      this.videoPopData = data;
      this.videoPopFlag = true;
    },
    closeAction: function closeAction() {
      this.videoPopFlag = false;
    }
  }
};

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.images && _vm.images.length) ? _c('div', {
    staticClass: "client-item-box new-image",
    attrs: {
      "data-trackdata": _vm.tData
    }
  }, [_c('div', {
    staticClass: "new-image-box"
  }, [_c('div', {
    staticClass: "new-image-items",
    style: ({
      height: (_vm.maxHeight + "px")
    })
  }, _vm._l((_vm.images), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "img-box",
      style: ({
        width: ((item.widthNum) + "px"),
        height: (_vm.maxHeight + "px"),
        left: ("" + (item.left))
      })
    }, [_c('div', {
      staticClass: "img-item",
      class: _vm.videowrap(index),
      style: ({
        width: ((item.widthNum) + "px"),
        height: ((item.heightNum) + "px"),
        borderRadius: ("" + _vm.radius)
      }),
      on: {
        "click": function($event) {
          return _vm.mediaAction(item, index)
        }
      }
    }, [(item.type === 'image') ? _c('beast-image', {
      staticClass: "img",
      attrs: {
        "lazy": true,
        "image": item.image,
        "containerWidth": item.widthNum
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'video') ? _c('beast-video', {
      attrs: {
        "wrap": item.wrapIndex,
        "height": item.heightNum,
        "poster": item.poster,
        "autoplay": item.autoplay,
        "source": item.source,
        "controls": item.controls,
        "videoFormat": item.videoFormat,
        "muted": item.muted,
        "radius": _vm.radius,
        "multiVideo": _vm.multiVideo,
        "videoPopData": item
      },
      on: {
        "video-pop": _vm.videoPopAction
      }
    }) : _vm._e()], 1)])
  }), 0)]), _vm._v(" "), (_vm.videoPopFlag) ? _c('video-pop', {
    attrs: {
      "data": _vm.videoPopData,
      "radius": _vm.radius
    },
    on: {
      "close": _vm.closeAction
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(650),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _util = __webpack_require__(143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clientWidth = (0, _util.getClientWidth)(); //
//
//
//
//
//


var ratio = clientWidth / 375;

exports.default = {
  name: 'line',
  props: ['data'],
  data: function data() {
    return {
      pl: 0,
      pr: 0,
      pt: 0,
      pb: 0,
      lineHeight: 0,
      tData: (0, _stringify2.default)(this.data.trackData || {})
    };
  },

  components: {},
  mounted: function mounted() {},
  created: function created() {
    this.formatData();
  },

  computed: {
    // styleObj () {
    //   return {
    //     'padding-left': `${ratio*this.pl}px`,
    //     'padding-right': `${ratio*this.pr}px`,
    //     'padding-top': `${ratio*this.pt}px`,
    //     'padding-bottom': `${ratio*this.pb}px`
    //   }
    // }
  },
  methods: {
    formatData: function formatData() {
      // const pl = this.data.leftPadding?Number(this.data.leftPadding):0
      // const pr = this.data.rightPadding?Number(this.data.rightPadding):0
      // const pt = this.data.topPadding?Number(this.data.topPadding):0
      // const pb = this.data.bottomPadding?Number(this.data.bottomPadding):0
      // this.pl = pl
      // this.pr = pr
      // this.pt = pt
      // this.pb = pb

      this.lineHeight = this.data.lineHeight ? Number(this.data.lineHeight) * ratio : 0;
    }
  }
};

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-item-box new-line",
    attrs: {
      "data-trackdata": _vm.tData
    }
  }, [_c('div', {
    staticClass: "new-line-box",
    style: ({
      'height': (_vm.lineHeight + "px"),
      'background': ("" + (_vm.data.lineColor))
    })
  })])
},staticRenderFns: []}

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(661),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _dynamicProductList = __webpack_require__(604);

var _dynamicProductList2 = _interopRequireDefault(_dynamicProductList);

var _util = __webpack_require__(143);

var _link = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var clientWidth = (0, _util.getClientWidth)();
var ratio = clientWidth / 375;

exports.default = {
  name: 'list',
  props: ['data', 'sdk', 'miniEnv'],
  components: {
    beastImage: _image2.default,
    dynamicList: _dynamicProductList2.default
  },
  data: function data() {
    return {
      styleCondition: null,
      title: null,
      banner: null,
      bannerGap: null,
      buttonName: null,
      boxWidth: 0,
      listCondition: null,
      tData: (0, _stringify2.default)(this.data.trackData || {})
    };
  },
  created: function created() {
    this.formatData();
  },
  mounted: function mounted() {},

  computed: {
    // styleObj () {
    //   return {
    //     'padding-left': `${ratio*this.pl}px`,
    //     'padding-right': `${ratio*this.pr}px`,
    //     'padding-top': `${ratio*this.pt}px`,
    //     'padding-bottom': `${ratio*this.pb}px`
    //   }
    // }
  },
  methods: {
    formatData: function formatData() {
      // const pl = this.data.leftPadding?Number(this.data.leftPadding):0
      // const pr = this.data.rightPadding?Number(this.data.rightPadding):0
      // const pt = this.data.topPadding?Number(this.data.topPadding):0
      // const pb = this.data.bottomPadding?Number(this.data.bottomPadding):0
      // this.pl = pl
      // this.pr = pr
      // this.pt = pt
      // this.pb = pb
      var _data$paddingData = this.data.paddingData,
          pl = _data$paddingData.pl,
          pr = _data$paddingData.pr;


      this.boxWidth = (375 - pl - pr) * ratio;
      this.title = this.data.title;
      if (this.data.banner && this.data.banner.src) {
        this.bannerGap = this.data.bannerGap ? Number(this.data.bannerGap) * ratio : 0;
        this.banner = this.data.banner;
      }
      this.buttonName = this.data.moreButton || '';

      this.listCondition = {
        listWidth: this.boxWidth,
        lineGap: this.data.lineGap ? Number(this.data.lineGap) * ratio : 2,
        rowGap: this.data.rowGap ? Number(this.data.rowGap) * ratio : 34,
        rowNum: this.data.rowNum ? Number(this.data.rowNum) : 2,
        soldOutCondition: this.data.soldOutCondition || 'BOTTOM',
        productName: this.data.productName,
        brandName: this.data.brandName,
        rawPrice: this.data.rawPrice,
        nowPrice: this.data.nowPrice,
        ratio: ratio
      };
    },
    moreAction: function moreAction() {
      var link = this.data.link;
      if (!link.type || link.type === 'none') {
        return;
      }

      var trackData = this.data.trackData;
      trackData.operation_name = this.buttonName;
      (0, _util.trackAction)({
        trackData: trackData,
        pageObj: (0, _link.getLinkPageData)({ link: link })
      });

      (0, _link.normalSkip)({
        // trackData: {
        //   name: 'new-list-more',
        //   attrs: {
        //     index: this.newListIndex
        //   },
        //   wait: false
        // },
        link: (0, _link.transformLink)({
          link: link,
          isMini: this.miniEnv
        }),
        isMini: this.miniEnv
      });
    },
    productSimpleJump: function productSimpleJump(product, index) {
      var trackData = this.data.trackData;
      var link = {
        type: 'product',
        value: product.id
      };
      trackData.module_number = index - 0 + 1;

      sa.track('CommodityClick', {
        position_number: index - 0 + 1,
        commodity_spu_id: product.id,
        commodity_name: product.name,
        original_price: product.rawPrice,
        discount_price: product.price,
        commodity_need_point: product.point || 0,
        business_case: '其他'
      });

      (0, _util.trackAction)({
        trackData: trackData,
        pageObj: (0, _link.getLinkPageData)({
          link: link,
          title: product ? product.name : ''
        })
      });
    }
  }
};

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dynamicProductSimple = __webpack_require__(655);

var _dynamicProductSimple2 = _interopRequireDefault(_dynamicProductSimple);

var _product = __webpack_require__(271);

var _productActivity = __webpack_require__(659);

var _lazyload = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    dynamicProduct: _dynamicProductSimple2.default
  },

  props: {
    dataOrigin: {
      type: String,
      default: 'PRODUCT'
    },
    ids: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    listCondition: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    miniEnv: {
      default: false
    },
    originProducts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    listPl: { //仅对部分模块有作用 比如新列表模块
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      productRatio: 330 / 345, //w/h
      products: null,
      dataLoaded: false,
      productWidth: 0,
      defaultStyle: null,
      productImageHeight: 0
    };
  },
  created: function created() {
    this.formatData();
  },


  methods: {
    formatData: function formatData() {
      var listCondition = this.listCondition;
      console.log(listCondition, "listCondition");
      this.productWidth = (listCondition.listWidth - (listCondition.rowNum - 1) * listCondition.lineGap) / listCondition.rowNum;
      var productHeight = this.productWidth / 330 * 345;

      this.productImageHeight = productHeight;
      var ratio = this.listCondition.ratio;
      var heightObj = {
        imageGap: 10 * ratio,
        brandH: 17 * ratio,
        productH1: 17 * ratio,
        productH2: 34 * ratio,
        priceH: 17 * ratio
        // let defaultStyle = {
        //   'width': `${this.productWidth}px`,
        //   'height': `${productHeight+imageGap}px`
        // }

      };var defaultProductHeight = productHeight + heightObj.imgGap;
      if (this.listCondition.brandName === 'SHOW') {
        defaultProductHeight += heightObj.brandH;
      }
      if (this.listCondition.productName === 'ONE') {
        defaultProductHeight += heightObj.productH1;
      }
      if (this.listCondition.productName === 'TWO') {
        defaultProductHeight += heightObj.productH2;
      }
      if (this.listCondition.rawPrice || this.listCondition.nowPrice) {
        defaultProductHeight += heightObj.priceH;
      }

      this.defaultStyle = {
        'width': this.productWidth + 'px',
        'min-height': this.defaultProductHeight + 'px',
        'margin-bottom': this.listCondition.rowGap + 'px',
        'margin-left': this.listCondition.lineGap + 'px'
      };

      if (this.originProducts && this.originProducts.length) {
        this.dataLoaded = true;
        this.products = this.originProducts;
      } else {
        if (this.dataOrigin === 'ACTIVITY') {
          this.getProductsByActivity();
        } else {
          this.getProducts();
        }
      }
    },
    getProductsByActivity: function getProductsByActivity() {
      var _this = this;

      this.products = this.ids;

      if (!this.ids || this.ids.length === 0) {
        return;
      }

      var newIds = [];
      this.ids.forEach(function (id) {
        if (id && !~newIds.indexOf(id)) {
          newIds.push(id);
        }
      });

      var allArr = [];
      var normalArr = [];
      var soldOutArr = [];
      var offShelfArr = [];
      var newProducts = [];

      (0, _productActivity.getActivity)(newIds, function (err, dataMap) {
        if (err) {
          return;
        }
        _this.dataLoaded = true;

        var products = [];
        newIds.forEach(function (key) {
          var activity = dataMap[key];
          if (!activity) {
            return;
          }

          if (activity.products && activity.products.length) {
            products = products.concat(activity.products);
          }
        });

        products.forEach(function (product) {
          if (!product || product.invisible) {
            return;
          }

          if (_this.listCondition.soldOutCondition === 'ORIGIN' && !product.offShelf) {
            allArr.push(product);
          } else {
            if (product.offShelf) {
              offShelfArr.push(product);
            } else if (product.soldOut) {
              soldOutArr.push(product);
            } else {
              normalArr.push(product);
            }
          }
        });
        if (_this.listCondition.soldOutCondition === 'FILTER') {
          newProducts = normalArr;
        } else if (_this.listCondition.soldOutCondition === 'ORIGIN') {
          newProducts = allArr;
        } else {
          newProducts = normalArr.concat(soldOutArr);
        }

        _this.$nextTick(function () {
          _this.products = newProducts;
          _this.$nextTick(function () {
            (0, _lazyload.lazyload)();
          });
        });
      });
    },
    getProducts: function getProducts() {
      var _this2 = this;

      this.products = this.ids;

      if (!this.ids || this.ids.length === 0) {
        return;
      }

      var newIds = [];
      this.ids.forEach(function (id) {
        if (id && !~newIds.indexOf(id)) {
          newIds.push(id);
        }
      });

      var allArr = [];
      var normalArr = [];
      var soldOutArr = [];
      var offShelfArr = [];
      var newProducts = [];

      (0, _product.get)(newIds, function (err, productMap) {
        if (err) {
          return;
        }
        _this2.dataLoaded = true;

        newIds.forEach(function (id) {
          var product = productMap[id];
          if (!product || product.invisible) {
            return;
          }
          product.id = id;

          if (_this2.listCondition.soldOutCondition === 'ORIGIN' && !product.offShelf) {
            allArr.push(product);
          } else {
            if (product.offShelf) {
              offShelfArr.push(product);
            } else if (product.soldOut) {
              soldOutArr.push(product);
            } else {
              normalArr.push(product);
            }
          }
        });
        if (_this2.listCondition.soldOutCondition === 'FILTER') {
          newProducts = normalArr;
        } else if (_this2.listCondition.soldOutCondition === 'ORIGIN') {
          newProducts = allArr;
        } else {
          newProducts = normalArr.concat(soldOutArr);
        }

        _this2.$nextTick(function () {
          _this2.products = newProducts;
          _this2.$nextTick(function () {
            (0, _lazyload.lazyload)();
          });
        });
      });
    },
    checkInfoPadding: function checkInfoPadding(index) {
      var hidePadFlag = false;
      if (!this.listPl) {
        //模块没有边距，则不隐藏默认的15边距
        hidePadFlag = false;
      } else if (this.listCondition.rowNum === 2 && index % 2 === 0) {
        //模块有边距，每行的第一个隐藏边距
        hidePadFlag = true;
      } else if (this.listCondition.rowNum === 3 && index % 3 === 0) {
        //模块有边距，每行的第一个隐藏边距
        hidePadFlag = true;
      }
      // console.log(this.listPl, index, hidePadFlag)
      return hidePadFlag;
    },
    productSimpleJump: function productSimpleJump(product, index) {
      console.log(product, index);
      this.$emit('product-simple', product, index);
    }
  }
};

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(656)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(658),
  /* scopeId */
  "data-v-23404ff3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(63);

var _from2 = _interopRequireDefault(_from);

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _price = __webpack_require__(54);

var _price2 = _interopRequireDefault(_price);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _urlUtil = __webpack_require__(21);

var _link = __webpack_require__(55);

var _data = __webpack_require__(238);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { lazyload } from '@/lazyload'
var defaultImage = (0, _urlUtil.ensure_protocol)("http://img.thebeastshop.com/images/mcatlog/banner/p.png"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var cornerImg = {
  foretell: (0, _urlUtil.ensure_protocol)("http://img.thebeastshop.com/app/list/foretell.png"),
  offshelf: (0, _urlUtil.ensure_protocol)("http://img.thebeastshop.com/app/list/offshelf.png"),
  soldout: (0, _urlUtil.ensure_protocol)("http://img.thebeastshop.com/app/list/soldout.png")
};

exports.default = {
  name: 'list-v1',

  props: {
    data: {
      require: true
    },
    index: {
      type: Number,
      default: 0
    },
    productCondition: {
      type: Object,
      default: {}
    },
    miniEnv: {
      default: false
    },
    productImageHeight: {
      type: Number,
      default: 0
    },
    hideInfoPadding: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      defaultImage: defaultImage,
      productData: this.data,
      cornerImg: cornerImg
    };
  },

  components: {
    price: _price2.default,
    beastImage: _image2.default
  },

  mounted: function mounted() {},


  watch: {
    data: function data(d) {
      if ((typeof d === 'undefined' ? 'undefined' : (0, _typeof3.default)(d)) === 'object') {
        // this.fit()
      }
    }
  },

  filters: {
    formatPrice: function formatPrice(value) {
      var v = String(Math.floor(value * Math.pow(10, 1)) / Math.pow(10, 1));
      var temp = v.split('.');
      return temp.length > 1 ? v : v + '.0';
    }
  },

  computed: {
    productImage: function productImage() {
      var data = this.data;
      return data.featureImage ? data.featureImage : data.images ? data.images[0] : '';
    }
  },
  methods: {
    jump: function jump(e) {
      // const tar = e.currentTarget
      // const pindex = tar.dataset.index
      var pindex = this.index;
      console.log(pindex, '#########index');

      if (!this.data || !this.data.id) {
        return;
      }

      this.$emit('product-simple', this.data, pindex);

      var link = (0, _link.transformLink)({
        link: {
          type: "product",
          value: this.data.id
        },
        isMini: this.miniEnv
      });

      var trackData = {
        trackData: {
          name: this.source === 'CART' ? 'cart-suggest-product-more' : 'click-result',
          attrs: {
            value: this.data.id,
            index: pindex
          }
        },
        link: link,
        isMini: this.miniEnv
      };

      (0, _link.trackSkip)(trackData);
    },
    fit: function fit() {
      var tagItem = document.querySelectorAll('.prices');
      var tagArr = (0, _from2.default)(tagItem);
      tagArr.forEach(function (elem) {
        var discount = elem.querySelector('.discount-price');
        var rawcount = elem.querySelector('.raw-price');
        var tags = elem.querySelector('.tags-wrap');

        var dw = discount && discount.clientWidth || 0;
        var rw = rawcount ? rawcount.clientWidth : 0;
        var tw = tags && tags.clientWidth || 0;

        if (dw + rw + tw > elem.clientWidth) {
          tags.style.display = 'none';
        }
      });
    }
  }
};

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dynamic-product-simple",
    on: {
      "click": _vm.jump
    }
  }, [(_vm.productImage) ? _c('div', {
    staticClass: "product-image",
    style: ({
      'height': (_vm.productImageHeight + "px")
    })
  }, [_c('beast-image', {
    attrs: {
      "lazy": true,
      "defaultImage": _vm.defaultImage,
      "src": _vm.productImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-state",
    style: ({
      'height': (_vm.productImageHeight + "px"),
      'top': ((-_vm.productImageHeight) + "px")
    })
  }, [(_vm.data.foretell) ? _c('div', {
    staticClass: "corner-box"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.data.offShelf) ? _c('div', {
    staticClass: "corner-box"
  }, [_vm._m(1)]) : (_vm.data.soldOut) ? _c('div', {
    staticClass: "corner-box"
  }, [_vm._m(2)]) : _vm._e()])], 1) : _c('div', {
    staticClass: "product-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.defaultImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-infos",
    class: {
      'hide-pad': _vm.hideInfoPadding
    }
  }, [(_vm.data.activityDesc) ? _c('div', {
    staticClass: "summary"
  }, [_vm._v(_vm._s(_vm.data.activityDesc))]) : _vm._e(), _vm._v(" "), (_vm.data.customizable) ? _c('div', {
    staticClass: "tag"
  }, [_vm._v("定制")]) : (_vm.data.isOversea) ? _c('div', {
    staticClass: "tag"
  }, [_vm._v("跨境商品")]) : _vm._e(), _vm._v(" "), (_vm.productCondition.brandName === 'SHOW' && _vm.data.brand) ? _c('div', {
    staticClass: "brand-name gro-book"
  }, [_vm._v(_vm._s(_vm.data.brand && _vm.data.brand.name))]) : _vm._e(), _vm._v(" "), (_vm.productCondition.productName !== 'HIDE') ? _c('div', {
    staticClass: "name",
    class: {
      'one': _vm.productCondition.productName === 'ONE',
      'two': _vm.productCondition.productName === 'TWO'
    }
  }, [_vm._v(_vm._s(_vm.data.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "price-box"
  }, [(_vm.productCondition.rawPrice !== 'HIDE' || _vm.productCondition.nowPrice !== 'HIDE') ? _c('div', {
    staticClass: "prices",
    class: {
      'newn': _vm.data.newcomerTag
    }
  }, [(_vm.productCondition.nowPrice !== 'HIDE') ? _c('div', {
    staticClass: "price discount-price gro-demi"
  }, [(_vm.data.price) ? _c('price', {
    attrs: {
      "data": _vm.data.price
    }
  }) : _vm._e(), _c('span', {
    staticClass: "newn-tag"
  }, [_vm._v("新人价")])], 1) : _vm._e(), _vm._v(" "), (_vm.productCondition.rawPrice !== 'HIDE' && _vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price grotesk"
  }, [(_vm.data.rawPrice) ? _c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.data.stockWarn) ? _c('div', {
    staticClass: "stock-warn"
  }, [_vm._v(_vm._s(_vm.data.stockWarn || ''))]) : _vm._e()]), _vm._v(" "), (_vm.data.refunds) ? _c('div', {
    staticClass: "refund-box"
  }, [_c('div', {
    staticClass: "refund"
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.data.refunds)) + "元")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-tag"
  }, [_c('span', [_vm._v("即将开售")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-tag"
  }, [_c('span', [_vm._v("下架")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-tag"
  }, [_c('span', [_vm._v("售罄")])])
}]}

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

exports.getActivity = getActivity;

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _util = __webpack_require__(256);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var is_app = _browser2.default.app();

var PRODUCT_FETCH_DEBOUNCE_INTERVAL = 100;
var _productFetchQueue = [];
var _productCallbacks = [];

var _productTimer = null;
var _productCache = {};

var isError = false;

function getActivity(codes, callback) {
  codes = _util2.default.isArray(codes) ? codes : [codes];

  var not_fetched = _filterProductIds(codes);
  var returned = void 0;

  function done_once(err, data) {
    if (!returned) {
      returned = true;
      callback(err, data);
    }
  }

  function done() {
    var products = {};
    codes.forEach(function (code) {
      products[code] = _productCache[code] || null;
    });
    done_once(isError, products);
  }

  if (!not_fetched.length) {
    return done();
  }

  _registerQueue(codes, function () {
    done();
  });
}

function _registerQueue(codes, callback) {
  codes.forEach(function (code) {
    _productFetchQueue.push(code);
  });

  _productCallbacks.push(callback);

  if (_productTimer) {
    clearTimeout(_productTimer);
  }

  _productTimer = setTimeout(function () {
    _getProductData();
  }, PRODUCT_FETCH_DEBOUNCE_INTERVAL);
}

function _filterProductIds(codes) {
  return codes.filter(function (code) {
    return !(code in _productCache);
  });
}

function getDomain() {
  if (is_app) {
    return '';
  }
  switch (window.location.hostname) {
    case 'static.thebeastshop.com':
      return '//api.thebeastshop.com';
      break;
    case 'scm.thebeastshop.com':
      return '//api.thebeastshop.com';
      break;
    case 'static-test.thebeastshop.com':
      return 'http://api-test.thebeastshop.com';
      break;
    case 'scm-test.thebeastshop.com':
      return 'http://api-test.thebeastshop.com';
      break;
    default:
      return '//api.thebeastshop.com';
  }
}

var MAX_PRODUCTS = 50;

function _getProductData() {
  // clone
  var callbacks = [].concat(_productCallbacks);
  var codes = _filterProductIds(_productFetchQueue);
  _productCallbacks.length = 0;
  _productFetchQueue.length = 0;

  var pieces = Math.ceil(codes.length / MAX_PRODUCTS);
  var counter = 0;
  var i = 0;

  do {
    _fetchProducts(codes.slice(i * MAX_PRODUCTS, (i + 1) * MAX_PRODUCTS)).then(function (data) {
      done(data);
    }).catch(function (err) {
      done();
    });
  } while (++i < pieces);

  function done() {
    if (++counter === pieces) {
      run_callbacks();
    }
  }

  function run_callbacks() {
    callbacks.forEach(function (callback) {
      callback();
    });
  }
}

function _fetchProducts(codes) {
  return (0, _axiosMock2.default)({
    url: '/app/product/simple/campaign',
    json: codes,
    method: 'POST'
  }).then(function (_ref) {
    var code = _ref.code,
        data = _ref.data;

    if (code == '500') {
      isError = true;
    }
    data.forEach(function (activity) {
      if (!activity) {
        return;
      }

      _productCache[activity.code] = activity;
    });
    return _promise2.default.resolve(data);
  }).catch(function (err) {
    isError = true;
    return _promise2.default.reject(err);
  });
}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataLoaded) ? _c('div', {
    staticClass: "dynamic-product-list",
    style: ({
      'margin-left': ((-_vm.listCondition.lineGap) + "px")
    })
  }, _vm._l((_vm.products), function(item, index) {
    return _c('dynamic-product', {
      key: item.id,
      style: (_vm.defaultStyle),
      attrs: {
        "data": item,
        "index": index,
        "productCondition": _vm.listCondition,
        "miniEnv": _vm.miniEnv,
        "productImageHeight": _vm.productImageHeight,
        "hideInfoPadding": _vm.checkInfoPadding(index)
      },
      on: {
        "product-simple": _vm.productSimpleJump
      }
    })
  }), 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-item-box new-list",
    attrs: {
      "data-trackdata": _vm.tData
    }
  }, [(_vm.title) ? _c('div', {
    staticClass: "new-list-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.banner) ? _c('div', {
    staticClass: "new-list-banner",
    style: ({
      'marginBottom': (_vm.bannerGap + "px")
    }),
    on: {
      "click": _vm.moreAction
    }
  }, [_c('beast-image', {
    staticClass: "img",
    attrs: {
      "lazy": true,
      "image": _vm.banner,
      "containerWidth": _vm.boxWidth
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "new-list-box"
  }, [_c('dynamic-list', {
    attrs: {
      "dataOrigin": _vm.data.dataOrigin,
      "ids": _vm.data.ids || [],
      "listCondition": _vm.listCondition,
      "miniEnv": _vm.miniEnv,
      "listPl": _vm.data.paddingData.pl
    },
    on: {
      "product-simple": _vm.productSimpleJump
    }
  })], 1), _vm._v(" "), (_vm.buttonName) ? _c('div', {
    staticClass: "new-list-button",
    on: {
      "click": _vm.moreAction
    }
  }, [_vm._v(_vm._s(_vm.buttonName))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(663),
  /* template */
  __webpack_require__(664),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _util = __webpack_require__(143);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var clientWidth = (0, _util.getClientWidth)();
var _rush_count_down = null;

exports.default = {
  name: 'article-time',
  props: ['data'],
  data: function data() {
    console.log(this.data, "time data");
    return {
      title: null,
      showTime: null,
      // showFlag: false,
      actionTime: null,
      showImage: true,
      containerWidth: clientWidth,
      ratio: clientWidth / 375,
      tData: (0, _stringify2.default)(this.data.trackData || {})
    };
  },
  mounted: function mounted() {},

  components: {
    beastImage: _image2.default
  },
  computed: {
    renderPositionStyl: function renderPositionStyl() {
      return {
        'left': Number(this.data.positionX * this.ratio) + 'px',
        'top': Number(this.data.positionY * this.ratio) + 'px'
      };
    },
    renderTitleStyl: function renderTitleStyl() {
      return {
        'color': '' + this.data.titleColor,
        'fontSize': Number(this.data.titleSize * this.ratio) + 'px'
      };
    },
    renderTimeStyl: function renderTimeStyl() {
      return {
        'color': '' + this.data.timeColor,
        'fontSize': Number(this.data.timeSize * this.ratio) + 'px'
      };
    }
  },
  created: function created() {
    this.checkTime();
  },

  methods: {
    checkTime: function checkTime() {
      var time1Str = this.data.time1;
      var time2Str = this.data.time2;
      var startTimeShow = this.data.startTimeShow;
      var endTimeShow = this.data.endTimeShow;
      if (!time1Str && !time2Str) {
        return;
      }
      var curTime = new Date().getTime();
      var time1 = this.getTime(time1Str);
      var time2 = this.getTime(time2Str);
      console.log(curTime, time1, time2);
      if (startTimeShow !== 'HIDE' && time1 && curTime < time1) {
        this.checkTimeCount({
          time1: time1,
          time2: time2,
          curTimeStr: "time1"
        });
      } else if (endTimeShow !== 'HIDE' && time2 && curTime < time2) {
        this.checkTimeCount({
          time1: null,
          time2: time2,
          curTimeStr: "time2"
        });
      }

      // this.showFlag = true
    },
    checkTimeCount: function checkTimeCount(_ref) {
      var _this = this;

      var time1 = _ref.time1,
          time2 = _ref.time2,
          curTimeStr = _ref.curTimeStr;

      // console.log(time1, time2)
      var timeObj = null;
      if (curTimeStr === "time1") {
        this.title = this.data.title1;
        timeObj = (0, _util.getCountDown)(time1);
      }
      if (curTimeStr === "time2") {
        this.title = this.data.title2;
        timeObj = (0, _util.getCountDown)(time2);
      }
      // console.log(timeObj, "timeObj")
      if (!timeObj) {
        return;
      }
      var _timeObj = timeObj,
          day = _timeObj.day,
          hour = _timeObj.hour,
          minute = _timeObj.minute,
          second = _timeObj.second;


      if (hour == 0 && minute == 0 && second == 0) {
        this.actionTime = null;
        clearTimeout(_rush_count_down);

        if (curTimeStr === "time1" && time2) {
          var curTime = new Date().getTime();
          if (curTime < time2) {
            this.checkTimeCount({
              time1: null,
              time2: time2,
              curTimeStr: "time2"
            });
          }
          // else {
          //   this.showFlag = false
          // }
        }
        // else {
        //   this.showFlag = false
        // }
        // return false
      } else {
        // this.actionTime = `${this.addZero(hour)}小时${this.addZero(minute)}分${this.addZero(second)}秒`
        this.actionTime = {
          day: this.formatDateArr(day, false),
          hour: this.formatDateArr(hour),
          minute: this.formatDateArr(minute),
          second: this.formatDateArr(second)
          // console.log(this.actionTime, "actionTime")
        };_rush_count_down = setTimeout(function () {
          _this.checkTimeCount({
            time1: time1,
            time2: time2,
            curTimeStr: curTimeStr
          });
        }, 1000);
      }
    },
    getTime: function getTime(time) {
      if (!time) {
        return 0;
      }
      var date = new Date(time.replace(/\s/, 'T'));
      // let date = new Date(time.replace(/-/g,'/'))
      // console.log(date, "getTime date")
      return date.getTime();
    },
    formatDateArr: function formatDateArr(date) {
      var isAddZero = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      date += "";
      if (date && date.length > 0) {
        var dateStr = isAddZero ? this.addZero(date) : date + "";
        return dateStr.split("");
      } else {
        return [];
      }
    },
    addZero: function addZero(time) {
      if (time < 10) {
        return '0' + time;
      } else {
        return time;
      }
    }
  }
};

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.actionTime || _vm.data.showImage === 'SHOW') ? _c('div', {
    staticClass: "client-item-box new-time-box",
    attrs: {
      "data-trackdata": _vm.tData
    }
  }, [_c('beast-image', {
    staticClass: "time-image",
    attrs: {
      "image": _vm.data.bgImage,
      "lazy": true,
      "containerWidth": _vm.containerWidth
    }
  }), _vm._v(" "), (_vm.actionTime) ? _c('div', {
    staticClass: "time",
    style: (_vm.renderPositionStyl)
  }, [_c('span', {
    staticClass: "title-block mr",
    style: (_vm.renderTitleStyl)
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._l((_vm.actionTime.day), function(item) {
    return (_vm.actionTime.day != '0') ? _c('span', {
      staticClass: "time-block",
      style: (_vm.renderTimeStyl)
    }, [_vm._v(_vm._s(item))]) : _vm._e()
  }), _vm._v(" "), (_vm.actionTime.day.length && _vm.actionTime.day != '0') ? _c('span', {
    staticClass: "title-block mr ml",
    style: ({
      color: _vm.data.titleColor
    })
  }, [_vm._v("天")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.actionTime.hour), function(item, index) {
    return _c('span', {
      staticClass: "time-block",
      class: {
        'two': index === 1
      },
      style: (_vm.renderTimeStyl)
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('span', {
    staticClass: "title-block mr ml",
    style: (_vm.renderTitleStyl)
  }, [_vm._v("时")]), _vm._v(" "), _vm._l((_vm.actionTime.minute), function(item, index) {
    return _c('span', {
      staticClass: "time-block",
      class: {
        'two': index === 1
      },
      style: (_vm.renderTimeStyl)
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('span', {
    staticClass: "title-block mr ml",
    style: (_vm.renderTitleStyl)
  }, [_vm._v("分")]), _vm._v(" "), _vm._l((_vm.actionTime.second), function(item, index) {
    return _c('span', {
      staticClass: "time-block",
      class: {
        'two': index === 1
      },
      style: (_vm.renderTimeStyl)
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('span', {
    staticClass: "title-block ml",
    style: (_vm.renderTitleStyl)
  }, [_vm._v("秒")])], 2) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(667),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _urlUtil = __webpack_require__(21);

var _util = __webpack_require__(143);

var _link = __webpack_require__(55);

var _util2 = __webpack_require__(175);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var clientWidth = (0, _util.getClientWidth)();
var ratio = clientWidth / 375;

exports.default = {
  name: 'buoy',
  props: ['data', 'modIndex', 'memberTags', 'sdk', 'miniEnv', 'isApp', 'pageType'],
  components: {},
  data: function data() {
    return {
      ratio: ratio,
      buoyImage: null,
      imageWidth: 0,
      imageBottom: 0,
      stylObj: null,
      tData: (0, _stringify2.default)(this.data.trackData || {})
    };
  },
  mounted: function mounted() {},

  computed: {},
  created: function created() {
    this.formatData();
  },

  methods: {
    formatData: function formatData() {
      console.log('buoy', this.pageType);
      var ratio = this.ratio;
      var tags = this.memberTags || [];
      if (this.data.customer !== 'ALL' && this.data.customer !== 'DELINEATION' && tags.indexOf(this.data.customer) === -1 || this.data.customer === 'DELINEATION' && tags.indexOf(this.data.customerCode) === -1) {
        return;
      }

      this.buoyImage = (0, _urlUtil.ensure_protocol)(this.data.image.src);
      // this.imageWidth = (this.data.image.width/3)*this.ratio

      var iphoneX = (0, _util2.isIphoneX)();
      var navbarHeight = 50 * ratio;
      if (iphoneX) {
        navbarHeight = 84 * ratio;
      }

      var imageWidth = this.data.image.width / 3 * this.ratio;
      var imageHeight = this.data.image.height / 3 * this.ratio;

      if (this.pageType === 'index') {
        this.imageBottom = this.data.bottom * this.ratio + navbarHeight;
        this.stylObj = {
          'width': imageWidth + 'px',
          'height': imageHeight + 'px',
          'bottom': this.imageBottom + 'px',
          'right': this.data.right * ratio + 'px'
        };
      }
      if (this.pageType === 'article') {
        // this.imageBottom = articleBottom
        this.imageBottom = 0;
        this.stylObj = {
          'width': imageWidth + 'px',
          'height': imageHeight + 'px',
          'right': this.data.right * ratio + 'px'
        };
      }
    },
    buoyAction: function buoyAction() {
      var link = this.data.link;
      if (!link.type || link.type === 'none') {
        return;
      }

      var myLink = '';
      var toMiniFlag = false;
      if (this.isApp && this.data.toMiniProgram) {
        //app环境 且 在app打开小程序页面
        myLink = (0, _link.getToMiniLink)({
          link: link
        });
      }
      if (myLink) {
        toMiniFlag = true;
      }
      if (!myLink) {
        myLink = (0, _link.transformLink)({
          link: link,
          isMini: this.miniEnv
        });
      }

      var trackData = this.data.trackData;
      // trackData.operation_module_number = -1
      (0, _util.trackAction)({
        trackData: trackData,
        pageObj: (0, _link.getLinkPageData)({
          link: link
        })
      });
      // console.log(trackData, '#######')

      (0, _link.normalSkip)({
        link: myLink,
        isMini: this.miniEnv,
        toMiniProgram: toMiniFlag
      });
    }
  }
};

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.buoyImage) ? _c('div', {
    staticClass: "client-item-box buoy",
    class: {
      'buoy-article': _vm.pageType === 'article'
    },
    style: (_vm.stylObj),
    attrs: {
      "data-trackdata": _vm.tData
    },
    on: {
      "click": _vm.buoyAction
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.buoyImage
    }
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _page = __webpack_require__(51);

var _index = __webpack_require__(957);

var _index2 = _interopRequireDefault(_index);

var _exposure = __webpack_require__(276);

var _exposure2 = _interopRequireDefault(_exposure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

sa.setCurrentPage('首页');
sa.clickNavBar('首页');

_vue2.default.use(_exposure2.default);

(0, _page.Page)('index', {
  el: '#app',
  template: '<index />',
  components: {
    index: _index2.default
  }
});

/***/ }),
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(958)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(959),
  /* template */
  __webpack_require__(1001),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _page = __webpack_require__(51);

var _lazyload = __webpack_require__(56);

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _queryString = __webpack_require__(13);

var _queryString2 = _interopRequireDefault(_queryString);

var _wechatShare = __webpack_require__(156);

var _wechatShare2 = _interopRequireDefault(_wechatShare);

var _util = __webpack_require__(143);

var _util2 = __webpack_require__(175);

var _time = __webpack_require__(430);

var _imageBanner = __webpack_require__(636);

var _imageBanner2 = _interopRequireDefault(_imageBanner);

var _new = __webpack_require__(639);

var _new2 = _interopRequireDefault(_new);

var _imageIndex = __webpack_require__(642);

var _imageIndex2 = _interopRequireDefault(_imageIndex);

var _image = __webpack_require__(489);

var _image2 = _interopRequireDefault(_image);

var _newImage = __webpack_require__(645);

var _newImage2 = _interopRequireDefault(_newImage);

var _newBanner = __webpack_require__(536);

var _newBanner2 = _interopRequireDefault(_newBanner);

var _newLine = __webpack_require__(648);

var _newLine2 = _interopRequireDefault(_newLine);

var _newList = __webpack_require__(651);

var _newList2 = _interopRequireDefault(_newList);

var _newTime = __webpack_require__(662);

var _newTime2 = _interopRequireDefault(_newTime);

var _video = __webpack_require__(539);

var _video2 = _interopRequireDefault(_video);

var _buoy = __webpack_require__(665);

var _buoy2 = _interopRequireDefault(_buoy);

var _search = __webpack_require__(159);

var _search2 = _interopRequireDefault(_search);

var _cart = __webpack_require__(495);

var _cart2 = _interopRequireDefault(_cart);

var _downloadBanner = __webpack_require__(272);

var _downloadBanner2 = _interopRequireDefault(_downloadBanner);

var _index = __webpack_require__(461);

var _index2 = _interopRequireDefault(_index);

var _pop = __webpack_require__(992);

var _pop2 = _interopRequireDefault(_pop);

var _upgradePop = __webpack_require__(996);

var _upgradePop2 = _interopRequireDefault(_upgradePop);

var _observe = __webpack_require__(1000);

var _observe2 = _interopRequireDefault(_observe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import fakeVideo from './components/fake-video.vue'

// import track from '@/track'
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var search = location.search.slice(1);
// import { scmAjax } from './lib/util.js'

var urlParams = _queryString2.default.parse(search);
var clientWidth = (0, _util.getClientWidth)();
var baseWidth = 375;

exports.default = {
  name: 'index',
  data: function data() {
    return {
      pageType: 'index',
      data: {},
      dataLoaded: false,
      iphoneX: (0, _util2.isIphoneX)(),
      showDownBanner: false,
      popId: null,
      popName: '',
      popImage: null,
      popLink: null,
      showPopFlag: false,
      dialog: {
        mask: true,
        show: true,
        maskOpacity: '0.7'
      },
      upgradePopData: null,
      multiVideo: false
    };
  },
  created: function created() {
    var env = urlParams.env || '';
    if (env === 'dy') {
      sessionStorage.setItem('dy-downloader', 'close');
    }

    this.$showLoading();
    this.getIndexData();
  },


  components: {
    imageBanner: _imageBanner2.default,
    articleNew: _new2.default,
    imageIndex: _imageIndex2.default,
    // fakeVideo,
    Search: _search2.default,
    Cart: _cart2.default,
    downloadBanner: _downloadBanner2.default,
    navbarBottom: _index2.default,
    articleImage: _image2.default,
    popCom: _pop2.default,
    newImage: _newImage2.default,
    newBanner: _newBanner2.default,
    newLine: _newLine2.default,
    newList: _newList2.default,
    newTime: _newTime2.default,
    articleVideo: _video2.default,
    upgradePop: _upgradePop2.default,
    articleBuoy: _buoy2.default
  },

  methods: {
    getIndexData: function getIndexData() {
      var _this = this;

      this.getIndex().then(function (_ref) {
        var data = _ref.data;

        _this.$hideLoading();
        // data.modules = formatModules(data.modules)
        var modules = (0, _util.formatModules)(data.modules, data.memberTags);

        var videoNum = 0;
        modules.forEach(function (mod, index) {
          var modType = mod.type;
          var modData = mod.data;
          mod.data.paddingData = {
            pl: modData.leftPadding ? Number(modData.leftPadding) : 0,
            pr: modData.rightPadding ? Number(modData.rightPadding) : 0,
            pt: modData.topPadding ? Number(modData.topPadding) : 0,
            pb: modData.bottomPadding ? Number(modData.bottomPadding) : 0
          };

          if (modType === 'video' && mod.showFlag) {
            if (modData.src) {
              videoNum++;
            }
          }

          if ((modType === 'new-image' || modType === 'new-banner') && mod.showFlag) {
            modData.items.forEach(function (item) {
              var url = item.media && item.media.src;
              if (url && url.substring(url.lastIndexOf('.')).toLowerCase() === '.mp4') {
                videoNum++;
              }
            });
          }
        });
        if (videoNum > 1) {
          _this.multiVideo = true;
        }

        data.modules = (0, _util.formatTrackDataModules)(modules, _this.pageType);
        _this.data = data;
        _this.dataLoaded = true;
        _this.$nextTick(function () {
          (0, _lazyload.lazyload)();
          // 神策曝光打点
          var exposurer = new _this.$exposure(function (node) {
            // console.log(node, '曝光啦')
            var trackData = node.getAttribute('data-trackdata') || "{}";
            trackData = JSON.parse(trackData);
            sa.track('HomePageAdvertiseExposure', trackData);
          });

          exposurer.observe('.client-item-box');
        });

        // this.getPopData()
        _this.getUpgradePopData();
      }).catch(function (_ref2) {
        var message = _ref2.message;

        _this.$hideLoading();
        _this.$alert(message);
      });
    },
    renderModStyl: function renderModStyl(mod) {
      var ratio = clientWidth / baseWidth;
      var data = mod.data;
      var _data$paddingData = data.paddingData,
          pl = _data$paddingData.pl,
          pr = _data$paddingData.pr,
          pt = _data$paddingData.pt,
          pb = _data$paddingData.pb;

      var modStyl = {
        'padding-left': ratio * pl + 'px',
        'padding-right': ratio * pr + 'px',
        'padding-top': ratio * pt + 'px',
        'padding-bottom': ratio * pb + 'px'
      };

      return modStyl;
    },
    getUpgradePopData: function getUpgradePopData() {
      var _this2 = this;

      this.getUpgradePop().then(function (_ref3) {
        var data = _ref3.data;

        // this.upgradePopData = {
        //   levelIcon: 'http://img.thebeastshop.com/member/privilege/upgrade-icon/level-one.jpg',
        //   level: 0,
        //   title: 'dsjsdjkdkjskdkd',
        //   desc: 'dsjjfdsjkdjkdsjkdskkdskdsksdk',
        //   vipBenefits: [
        //     {
        //       icon: 'http://img.thebeastshop.com/member/privilege/upgrade-icon/level-one.jpg',
        //       name: '生日折扣'
        //     },
        //     {
        //       icon: 'http://img.thebeastshop.com/member/privilege/upgrade-icon/level-one.jpg',
        //       name: '生日到店礼'
        //     },
        //     {
        //       icon: 'http://img.thebeastshop.com/member/privilege/upgrade-icon/level-one.jpg',
        //       name: '松鼠礼包'
        //     }
        //   ]
        // }
        // return

        if (data && data.notices && data.notices.length) {
          _this2.upgradePopData = data.notices[0];
          console.log(_this2.upgradePopData, 'upgradePopData');
        } else {
          _this2.getPopData();
        }
      }).catch(function (err) {
        console.log(err, "getPop发生了错误");
      });
    },
    getPopData: function getPopData() {
      var _this3 = this;

      this.getPop().then(function (_ref4) {
        var data = _ref4.data;

        if (data) {
          // this.popData = data
          _this3.popId = data.id;
          _this3.popName = data.name;
          _this3.popImage = data.openImageInfoObj.image || {};
          _this3.popLink = data.openImageInfoObj.links.m || {};

          _this3.formatPopData(data);
        }
      }).catch(function (err) {
        // this.$alert(message)
        console.log(err, "getPop发生了错误");
      });
    },
    formatPopData: function formatPopData(data) {
      var id = data.id || '';
      var popId = localStorage.getItem('pop-id');
      if (popId !== id + '') {
        //更换弹框
        localStorage.setItem('pop-id', id);
        localStorage.removeItem('only-one');
        localStorage.removeItem('day-one');
      }

      var showWay = data.showWay;
      if (showWay === 0) {
        //仅弹一次
        var onlyOne = localStorage.getItem('only-one');
        if (!onlyOne) {
          //没弹过
          localStorage.setItem('only-one', 'one');
          this.showPopFlag = true;
        }
      }
      if (showWay === 1) {
        //一天一次
        var dayOne = localStorage.getItem('day-one');
        dayOne = parseInt(dayOne || 0);
        var now = (0, _time.formatTime)(new Date().getTime());
        var nowDate = parseInt(now.year + '' + (0, _time.addZero)(now.month) + '' + (0, _time.addZero)(now.day));
        if (nowDate > dayOne) {
          localStorage.setItem('day-one', nowDate);
          this.showPopFlag = true;
        }
      }

      console.log(this.showPopFlag);
    },
    getIndex: function getIndex() {
      return (0, _axiosMock2.default)({
        url: '/app/index/getNewIndex'
      });
    },
    getUpgradePop: function getUpgradePop() {
      return (0, _axiosMock2.default)({
        url: '/app/notice/level_upgrade'
      });
    },
    getPop: function getPop() {
      return (0, _axiosMock2.default)({
        url: '/appadmin/store/getPopupByPlatform'
      });
    },
    closeBanner: function closeBanner() {
      this.showDownBanner = false;
    },
    closeUpgradePopAction: function closeUpgradePopAction() {
      this.upgradePopData = null;
    },
    closePopAction: function closePopAction() {
      this.showPopFlag = false;
    }
  }
};

/***/ }),
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(993)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(994),
  /* template */
  __webpack_require__(995),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dialog = __webpack_require__(10);

var _dialog2 = _interopRequireDefault(_dialog);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _urlUtil = __webpack_require__(21);

var _link = __webpack_require__(55);

var _lazyload = __webpack_require__(56);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

exports.default = {
  name: ['pop-com'],
  props: {
    id: Number,
    name: String,
    image: {
      type: Object,
      default: {}
    },
    link: {
      type: Object,
      default: {}
    },
    dialog: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      containerWidth: clientWidth / 375 * 275,
      maskClass: {
        'pop-anima': true
      },
      dialogData: {
        mask: this.dialog.mask === undefined ? true : this.dialog.mask,
        show: this.dialog.show === undefined ? true : this.dialog.show,
        maskOpacity: this.dialog.maskOpacity === undefined ? '0.4' : this.dialog.maskOpacity,
        maskBackground: this.dialog.maskBackground === undefined ? '#000000' : this.dialog.maskBackground
      }
    };
  },

  components: {
    BDialog: _dialog2.default,
    beastImage: _image2.default
  },
  computed: {
    renderImage: function renderImage() {
      return (0, _urlUtil.ensure_protocol)(this.image.src || '');
    }
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {

      sa.track('PopupAdExposure', {
        'PopupAd_id': this.id,
        'PopupAd_name': this.name
      });

      (0, _track2.default)({
        name: 'index-pop-expose',
        attrs: {
          id: this.id
        },
        wait: false
      });
    },
    imageAction: function imageAction() {
      sa.track('PopupAdClick', {
        'PopupAd_id': this.id,
        'PopupAd_name': this.name
      });

      (0, _link.trackSkip)({
        trackData: {
          name: 'index-pop-click',
          attrs: {
            id: this.id
          },
          wait: false
        },
        link: (0, _link.transformLink)({
          link: this.link
        })
      });
    },
    popClose: function popClose() {
      (0, _track2.default)({
        name: 'index-pop-close',
        attrs: {
          id: this.id
        },
        wait: false
      });
      this.$emit('pop-close');
    }
  }
};

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.image) ? _c('div', {
    staticClass: "dialog-wrap"
  }, [_c('b-dialog', {
    attrs: {
      "mask": _vm.dialogData.mask,
      "mshow": _vm.dialogData.show,
      "maskOpacity": _vm.dialogData.maskOpacity,
      "maskBackground": _vm.dialogData.maskBackground,
      "maskClass": _vm.maskClass
    }
  }, [_c('div', {
    staticClass: "pop-box"
  }, [_c('div', {
    staticClass: "pop-image",
    on: {
      "click": _vm.imageAction
    }
  }, [_c('beast-image', {
    attrs: {
      "image": _vm.image,
      "containerWidth": _vm.containerWidth
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "close-box",
    on: {
      "click": _vm.popClose
    }
  }, [_c('div', {
    staticClass: "close"
  })])])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(997)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(998),
  /* template */
  __webpack_require__(999),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dialog = __webpack_require__(10);

var _dialog2 = _interopRequireDefault(_dialog);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _urlUtil = __webpack_require__(21);

var _link = __webpack_require__(55);

var _lazyload = __webpack_require__(56);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'upgrade-pop',
  props: {
    id: Number,
    data: {
      type: Object,
      default: {}
    },
    dialog: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      maskClass: {
        'pop-anima': true
      },
      dialogData: {
        mask: this.dialog.mask === undefined ? true : this.dialog.mask,
        show: this.dialog.show === undefined ? true : this.dialog.show,
        maskOpacity: this.dialog.maskOpacity === undefined ? '0.4' : this.dialog.maskOpacity,
        maskBackground: this.dialog.maskBackground === undefined ? '#000000' : this.dialog.maskBackground
      }
    };
  },

  components: {
    BDialog: _dialog2.default,
    beastImage: _image2.default
  },
  computed: {
    renderCls: function renderCls() {
      var level = this.data.level;
      var cls = {};
      if (level === 1) {
        cls.one = true;
      }
      if (level === 2) {
        cls.two = true;
      }
      if (level === 3) {
        cls.three = true;
      }
      if (level === 4) {
        cls.four = true;
      }
      return cls;
    }
  },
  created: function created() {},

  methods: {
    benefitAction: function benefitAction() {
      (0, _track2.default)({
        name: 'upgrade-pop-click',
        attrs: {},
        wait: false
      });

      this.$emit('upgrade-close');

      if (_browser2.default.app()) {
        _bridge2.default.open({
          url: 'beastapp://entry?name=benefit'
        });
      } else {
        window.location.href = '/my/benefit';
      }
    },
    upgradePopClose: function upgradePopClose() {
      this.$emit('upgrade-close');
    }
  }
};

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "dialog-wrap"
  }, [_c('b-dialog', {
    attrs: {
      "mask": _vm.dialogData.mask,
      "mshow": _vm.dialogData.show,
      "maskOpacity": _vm.dialogData.maskOpacity,
      "maskBackground": _vm.dialogData.maskBackground,
      "maskClass": _vm.maskClass
    }
  }, [_c('div', {
    staticClass: "upgrade-pop-box",
    class: _vm.renderCls
  }, [_c('div', {
    staticClass: "block"
  }), _vm._v(" "), _c('div', {
    staticClass: "level-icon"
  }, [_c('beast-image', {
    attrs: {
      "src": _vm.data.levelIcon
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pop-title"
  }, [_vm._v(_vm._s(_vm.data.title))]), _vm._v(" "), _c('div', {
    staticClass: "pop-desc"
  }, [_vm._v(_vm._s(_vm.data.desc))]), _vm._v(" "), _c('div', {
    staticClass: "pop-items"
  }, _vm._l((_vm.data.vipBenefits), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pop-item"
    }, [_c('div', {
      staticClass: "pop-icon"
    }, [_c('beast-image', {
      attrs: {
        "src": item.icon
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "pop-name"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "pop-btn",
    class: _vm.renderCls,
    on: {
      "click": _vm.benefitAction
    }
  }, [_vm._v("查看更多专属特权")]), _vm._v(" "), _c('div', {
    staticClass: "upgrade-close-box",
    on: {
      "click": _vm.upgradePopClose
    }
  }, [_c('div', {
    staticClass: "upgrade-close"
  })])])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(42);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Exposure = function () {
    function Exposure(callback) {
        var _this = this;

        (0, _classCallCheck3.default)(this, Exposure);

        if (!callback || typeof callback !== 'function') {
            throw new Error("need callback or selector param");
            return;
        }
        this.intersectionObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (item) {
                if (item.intersectionRatio > 0) {
                    if (item.target) {
                        callback(item.target, item);
                        _this.intersectionObserver.unobserve(item.target);
                    }
                }
            });
        });
    }

    (0, _createClass3.default)(Exposure, [{
        key: 'observe',
        value: function observe(selector, ignoreExposured) {
            var _this2 = this;

            if (!this.intersectionObserver || !selector) {
                return;
            }
            var nodes = [];
            if (this.isDOM(selector)) {
                // dom节点
                nodes = [selector];
            } else {
                // 选择器
                nodes = document.querySelectorAll(selector);
            }
            if (!nodes.length) {
                return;
            }
            nodes.forEach(function (node) {
                if (!ignoreExposured && node.__wg__tracker__exposured__) {
                    return;
                }
                node.__wg__tracker__exposured__ = true;
                // 开始观察
                _this2.intersectionObserver.observe(node);
            });
        }
    }, {
        key: 'disconnect',
        value: function disconnect() {
            if (!this.intersectionObserver) {
                return;
            }
            this.intersectionObserver.disconnect();
        }
    }, {
        key: 'isDOM',
        value: function isDOM(obj) {
            if (!obj) {
                return false;
            }
            if ((typeof HTMLElement === 'undefined' ? 'undefined' : (0, _typeof3.default)(HTMLElement)) === 'object') {
                return obj instanceof HTMLElement;
            }
            if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string') {
                return true;
            }
            return false;
        }
    }]);
    return Exposure;
}();

exports.default = Exposure;

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataLoaded) ? _c('div', {
    staticClass: "index",
    class: {
      'iphone-x': _vm.iphoneX,
      'show-banner': _vm.showDownBanner
    }
  }, [_c('download-banner', {
    attrs: {
      "pageType": 'index',
      "link": 'index',
      "position": 'top'
    },
    on: {
      "close-banner": _vm.closeBanner,
      "banner-close": _vm.closeBanner
    }
  }), _vm._v(" "), _c('search', {
    staticClass: "i-search"
  }), _vm._v(" "), _c('cart'), _vm._v(" "), (_vm.data.modules) ? _c('div', _vm._l((_vm.data.modules), function(mod, index) {
    return _c('div', {
      key: index,
      style: (_vm.renderModStyl(mod))
    }, [(mod.type === 'image-banner' && mod.showFlag) ? _c('image-banner', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType,
        "memberTags": _vm.data.memberTags,
        "paginateType": "number"
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'image-index' && mod.showFlag) ? _c('image-index', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType,
        "memberTags": _vm.data.memberTags
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'new' && mod.showFlag) ? _c('article-new', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType,
        "hideTitle": true,
        "memberTags": _vm.data.memberTags
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'video' && mod.showFlag) ? _c('article-video', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType,
        "multiVideo": _vm.multiVideo
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'image' && mod.showFlag) ? _c('article-image', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'new-image' && mod.showFlag) ? _c('new-image', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType,
        "memberTags": _vm.data.memberTags
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'new-banner' && mod.showFlag) ? _c('new-banner', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType,
        "memberTags": _vm.data.memberTags
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'new-line' && mod.showFlag) ? _c('new-line', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'new-list' && mod.showFlag) ? _c('new-list', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'new-time' && mod.showFlag) ? _c('new-time', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'buoy' && mod.showFlag) ? _c('article-buoy', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType,
        "memberTags": _vm.data.memberTags
      }
    }) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('navbar-bottom', {
    attrs: {
      "activeIndex": "0"
    }
  }), _vm._v(" "), (_vm.upgradePopData) ? _c('upgrade-pop', {
    attrs: {
      "data": _vm.upgradePopData,
      "dialog": _vm.dialog
    },
    on: {
      "upgrade-close": _vm.closeUpgradePopAction
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPopFlag) ? _c('pop-com', {
    attrs: {
      "id": _vm.popId,
      "name": _vm.popName,
      "image": _vm.popImage,
      "link": _vm.popLink,
      "dialog": _vm.dialog
    },
    on: {
      "pop-close": _vm.closePopAction
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ })
],[891]);


// WEBPACK FOOTER //
// s/js/index.1b40ba82c789e3b866a2.js